import * as se from "react";
import Ut, { useCallback as an, createContext as Zr, useLayoutEffect as Ky, useEffect as mt, useContext as It, useRef as un, useInsertionEffect as nd, useMemo as Wt, forwardRef as Tr, createElement as Zy, useId as Il, useState as nt, cloneElement as Xy, Children as Jy, isValidElement as Qy, useImperativeHandle as ex, PureComponent as tx } from "react";
import V, { css as U, keyframes as Ul, ThemeProvider as nx } from "styled-components";
import rd, { createPortal as rx } from "react-dom";
var ki = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ix(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Di = {}, ox = {
  get exports() {
    return Di;
  },
  set exports(e) {
    Di = e;
  }
}, Ti = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ef;
function sx() {
  if (Ef)
    return Ti;
  Ef = 1;
  var e = Ut, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(h, f, m) {
    var g, x = {}, T = null, E = null;
    m !== void 0 && (T = "" + m), f.key !== void 0 && (T = "" + f.key), f.ref !== void 0 && (E = f.ref);
    for (g in f)
      o.call(f, g) && !c.hasOwnProperty(g) && (x[g] = f[g]);
    if (h && h.defaultProps)
      for (g in f = h.defaultProps, f)
        x[g] === void 0 && (x[g] = f[g]);
    return { $$typeof: n, type: h, key: T, ref: E, props: x, _owner: a.current };
  }
  return Ti.Fragment = i, Ti.jsx = u, Ti.jsxs = u, Ti;
}
var _i = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pf;
function ax() {
  return Pf || (Pf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ut, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), h = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), I = Symbol.iterator, D = "@@iterator";
    function W(_) {
      if (_ === null || typeof _ != "object")
        return null;
      var Y = I && _[I] || _[D];
      return typeof Y == "function" ? Y : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function z(_) {
      {
        for (var Y = arguments.length, te = new Array(Y > 1 ? Y - 1 : 0), Te = 1; Te < Y; Te++)
          te[Te - 1] = arguments[Te];
        L("error", _, te);
      }
    }
    function L(_, Y, te) {
      {
        var Te = F.ReactDebugCurrentFrame, ze = Te.getStackAddendum();
        ze !== "" && (Y += "%s", te = te.concat([ze]));
        var Ye = te.map(function(Ve) {
          return String(Ve);
        });
        Ye.unshift("Warning: " + Y), Function.prototype.apply.call(console[_], console, Ye);
      }
    }
    var G = !1, Q = !1, fe = !1, ge = !1, he = !1, $e;
    $e = Symbol.for("react.module.reference");
    function Qe(_) {
      return !!(typeof _ == "string" || typeof _ == "function" || _ === o || _ === c || he || _ === a || _ === m || _ === g || ge || _ === E || G || Q || fe || typeof _ == "object" && _ !== null && (_.$$typeof === T || _.$$typeof === x || _.$$typeof === u || _.$$typeof === h || _.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      _.$$typeof === $e || _.getModuleId !== void 0));
    }
    function Ge(_, Y, te) {
      var Te = _.displayName;
      if (Te)
        return Te;
      var ze = Y.displayName || Y.name || "";
      return ze !== "" ? te + "(" + ze + ")" : te;
    }
    function _e(_) {
      return _.displayName || "Context";
    }
    function re(_) {
      if (_ == null)
        return null;
      if (typeof _.tag == "number" && z("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof _ == "function")
        return _.displayName || _.name || null;
      if (typeof _ == "string")
        return _;
      switch (_) {
        case o:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof _ == "object")
        switch (_.$$typeof) {
          case h:
            var Y = _;
            return _e(Y) + ".Consumer";
          case u:
            var te = _;
            return _e(te._context) + ".Provider";
          case f:
            return Ge(_, _.render, "ForwardRef");
          case x:
            var Te = _.displayName || null;
            return Te !== null ? Te : re(_.type) || "Memo";
          case T: {
            var ze = _, Ye = ze._payload, Ve = ze._init;
            try {
              return re(Ve(Ye));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ve = Object.assign, le = 0, We, je, Se, y, k, $, S;
    function p() {
    }
    p.__reactDisabledLog = !0;
    function H() {
      {
        if (le === 0) {
          We = console.log, je = console.info, Se = console.warn, y = console.error, k = console.group, $ = console.groupCollapsed, S = console.groupEnd;
          var _ = {
            configurable: !0,
            enumerable: !0,
            value: p,
            writable: !0
          };
          Object.defineProperties(console, {
            info: _,
            log: _,
            warn: _,
            error: _,
            group: _,
            groupCollapsed: _,
            groupEnd: _
          });
        }
        le++;
      }
    }
    function ae() {
      {
        if (le--, le === 0) {
          var _ = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ve({}, _, {
              value: We
            }),
            info: ve({}, _, {
              value: je
            }),
            warn: ve({}, _, {
              value: Se
            }),
            error: ve({}, _, {
              value: y
            }),
            group: ve({}, _, {
              value: k
            }),
            groupCollapsed: ve({}, _, {
              value: $
            }),
            groupEnd: ve({}, _, {
              value: S
            })
          });
        }
        le < 0 && z("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = F.ReactCurrentDispatcher, K;
    function ee(_, Y, te) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (ze) {
            var Te = ze.stack.trim().match(/\n( *(at )?)/);
            K = Te && Te[1] || "";
          }
        return `
` + K + _;
      }
    }
    var ie = !1, oe;
    {
      var Z = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new Z();
    }
    function Ce(_, Y) {
      if (!_ || ie)
        return "";
      {
        var te = oe.get(_);
        if (te !== void 0)
          return te;
      }
      var Te;
      ie = !0;
      var ze = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ye;
      Ye = be.current, be.current = null, H();
      try {
        if (Y) {
          var Ve = function() {
            throw Error();
          };
          if (Object.defineProperty(Ve.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ve, []);
            } catch (Lt) {
              Te = Lt;
            }
            Reflect.construct(_, [], Ve);
          } else {
            try {
              Ve.call();
            } catch (Lt) {
              Te = Lt;
            }
            _.call(Ve.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Lt) {
            Te = Lt;
          }
          _();
        }
      } catch (Lt) {
        if (Lt && Te && typeof Lt.stack == "string") {
          for (var Oe = Lt.stack.split(`
`), kt = Te.stack.split(`
`), st = Oe.length - 1, ct = kt.length - 1; st >= 1 && ct >= 0 && Oe[st] !== kt[ct]; )
            ct--;
          for (; st >= 1 && ct >= 0; st--, ct--)
            if (Oe[st] !== kt[ct]) {
              if (st !== 1 || ct !== 1)
                do
                  if (st--, ct--, ct < 0 || Oe[st] !== kt[ct]) {
                    var Ot = `
` + Oe[st].replace(" at new ", " at ");
                    return _.displayName && Ot.includes("<anonymous>") && (Ot = Ot.replace("<anonymous>", _.displayName)), typeof _ == "function" && oe.set(_, Ot), Ot;
                  }
                while (st >= 1 && ct >= 0);
              break;
            }
        }
      } finally {
        ie = !1, be.current = Ye, ae(), Error.prepareStackTrace = ze;
      }
      var cn = _ ? _.displayName || _.name : "", eo = cn ? ee(cn) : "";
      return typeof _ == "function" && oe.set(_, eo), eo;
    }
    function X(_, Y, te) {
      return Ce(_, !1);
    }
    function j(_) {
      var Y = _.prototype;
      return !!(Y && Y.isReactComponent);
    }
    function J(_, Y, te) {
      if (_ == null)
        return "";
      if (typeof _ == "function")
        return Ce(_, j(_));
      if (typeof _ == "string")
        return ee(_);
      switch (_) {
        case m:
          return ee("Suspense");
        case g:
          return ee("SuspenseList");
      }
      if (typeof _ == "object")
        switch (_.$$typeof) {
          case f:
            return X(_.render);
          case x:
            return J(_.type, Y, te);
          case T: {
            var Te = _, ze = Te._payload, Ye = Te._init;
            try {
              return J(Ye(ze), Y, te);
            } catch {
            }
          }
        }
      return "";
    }
    var pe = Object.prototype.hasOwnProperty, ce = {}, Ee = F.ReactDebugCurrentFrame;
    function Ue(_) {
      if (_) {
        var Y = _._owner, te = J(_.type, _._source, Y ? Y.type : null);
        Ee.setExtraStackFrame(te);
      } else
        Ee.setExtraStackFrame(null);
    }
    function Le(_, Y, te, Te, ze) {
      {
        var Ye = Function.call.bind(pe);
        for (var Ve in _)
          if (Ye(_, Ve)) {
            var Oe = void 0;
            try {
              if (typeof _[Ve] != "function") {
                var kt = Error((Te || "React class") + ": " + te + " type `" + Ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _[Ve] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw kt.name = "Invariant Violation", kt;
              }
              Oe = _[Ve](Y, Ve, Te, te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (st) {
              Oe = st;
            }
            Oe && !(Oe instanceof Error) && (Ue(ze), z("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Te || "React class", te, Ve, typeof Oe), Ue(null)), Oe instanceof Error && !(Oe.message in ce) && (ce[Oe.message] = !0, Ue(ze), z("Failed %s type: %s", te, Oe.message), Ue(null));
          }
      }
    }
    var He = Array.isArray;
    function Xe(_) {
      return He(_);
    }
    function ut(_) {
      {
        var Y = typeof Symbol == "function" && Symbol.toStringTag, te = Y && _[Symbol.toStringTag] || _.constructor.name || "Object";
        return te;
      }
    }
    function Dt(_) {
      try {
        return yt(_), !1;
      } catch {
        return !0;
      }
    }
    function yt(_) {
      return "" + _;
    }
    function Bn(_) {
      if (Dt(_))
        return z("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ut(_)), yt(_);
    }
    var Mt = F.ReactCurrentOwner, Nn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Cr, $r, sr;
    sr = {};
    function Xr(_) {
      if (pe.call(_, "ref")) {
        var Y = Object.getOwnPropertyDescriptor(_, "ref").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return _.ref !== void 0;
    }
    function Jr(_) {
      if (pe.call(_, "key")) {
        var Y = Object.getOwnPropertyDescriptor(_, "key").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return _.key !== void 0;
    }
    function Qr(_, Y) {
      if (typeof _.ref == "string" && Mt.current && Y && Mt.current.stateNode !== Y) {
        var te = re(Mt.current.type);
        sr[te] || (z('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', re(Mt.current.type), _.ref), sr[te] = !0);
      }
    }
    function ei(_, Y) {
      {
        var te = function() {
          Cr || (Cr = !0, z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        te.isReactWarning = !0, Object.defineProperty(_, "key", {
          get: te,
          configurable: !0
        });
      }
    }
    function ti(_, Y) {
      {
        var te = function() {
          $r || ($r = !0, z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        te.isReactWarning = !0, Object.defineProperty(_, "ref", {
          get: te,
          configurable: !0
        });
      }
    }
    var ni = function(_, Y, te, Te, ze, Ye, Ve) {
      var Oe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: _,
        key: Y,
        ref: te,
        props: Ve,
        // Record the component responsible for creating this element.
        _owner: Ye
      };
      return Oe._store = {}, Object.defineProperty(Oe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Oe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Te
      }), Object.defineProperty(Oe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ze
      }), Object.freeze && (Object.freeze(Oe.props), Object.freeze(Oe)), Oe;
    };
    function ws(_, Y, te, Te, ze) {
      {
        var Ye, Ve = {}, Oe = null, kt = null;
        te !== void 0 && (Bn(te), Oe = "" + te), Jr(Y) && (Bn(Y.key), Oe = "" + Y.key), Xr(Y) && (kt = Y.ref, Qr(Y, ze));
        for (Ye in Y)
          pe.call(Y, Ye) && !Nn.hasOwnProperty(Ye) && (Ve[Ye] = Y[Ye]);
        if (_ && _.defaultProps) {
          var st = _.defaultProps;
          for (Ye in st)
            Ve[Ye] === void 0 && (Ve[Ye] = st[Ye]);
        }
        if (Oe || kt) {
          var ct = typeof _ == "function" ? _.displayName || _.name || "Unknown" : _;
          Oe && ei(Ve, ct), kt && ti(Ve, ct);
        }
        return ni(_, Oe, kt, ze, Te, Mt.current, Ve);
      }
    }
    var ri = F.ReactCurrentOwner, qi = F.ReactDebugCurrentFrame;
    function Sn(_) {
      if (_) {
        var Y = _._owner, te = J(_.type, _._source, Y ? Y.type : null);
        qi.setExtraStackFrame(te);
      } else
        qi.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function ii(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === n;
    }
    function Yi() {
      {
        if (ri.current) {
          var _ = re(ri.current.type);
          if (_)
            return `

Check the render method of \`` + _ + "`.";
        }
        return "";
      }
    }
    function ks(_) {
      {
        if (_ !== void 0) {
          var Y = _.fileName.replace(/^.*[\\\/]/, ""), te = _.lineNumber;
          return `

Check your code at ` + Y + ":" + te + ".";
        }
        return "";
      }
    }
    var Ki = {};
    function Zi(_) {
      {
        var Y = Yi();
        if (!Y) {
          var te = typeof _ == "string" ? _ : _.displayName || _.name;
          te && (Y = `

Check the top-level render call using <` + te + ">.");
        }
        return Y;
      }
    }
    function Xi(_, Y) {
      {
        if (!_._store || _._store.validated || _.key != null)
          return;
        _._store.validated = !0;
        var te = Zi(Y);
        if (Ki[te])
          return;
        Ki[te] = !0;
        var Te = "";
        _ && _._owner && _._owner !== ri.current && (Te = " It was passed a child from " + re(_._owner.type) + "."), Sn(_), z('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', te, Te), Sn(null);
      }
    }
    function Ji(_, Y) {
      {
        if (typeof _ != "object")
          return;
        if (Xe(_))
          for (var te = 0; te < _.length; te++) {
            var Te = _[te];
            ii(Te) && Xi(Te, Y);
          }
        else if (ii(_))
          _._store && (_._store.validated = !0);
        else if (_) {
          var ze = W(_);
          if (typeof ze == "function" && ze !== _.entries)
            for (var Ye = ze.call(_), Ve; !(Ve = Ye.next()).done; )
              ii(Ve.value) && Xi(Ve.value, Y);
        }
      }
    }
    function Ts(_) {
      {
        var Y = _.type;
        if (Y == null || typeof Y == "string")
          return;
        var te;
        if (typeof Y == "function")
          te = Y.propTypes;
        else if (typeof Y == "object" && (Y.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Y.$$typeof === x))
          te = Y.propTypes;
        else
          return;
        if (te) {
          var Te = re(Y);
          Le(te, _.props, "prop", Te, _);
        } else if (Y.PropTypes !== void 0 && !Er) {
          Er = !0;
          var ze = re(Y);
          z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ze || "Unknown");
        }
        typeof Y.getDefaultProps == "function" && !Y.getDefaultProps.isReactClassApproved && z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function oi(_) {
      {
        for (var Y = Object.keys(_.props), te = 0; te < Y.length; te++) {
          var Te = Y[te];
          if (Te !== "children" && Te !== "key") {
            Sn(_), z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Te), Sn(null);
            break;
          }
        }
        _.ref !== null && (Sn(_), z("Invalid attribute `ref` supplied to `React.Fragment`."), Sn(null));
      }
    }
    function Qi(_, Y, te, Te, ze, Ye) {
      {
        var Ve = Qe(_);
        if (!Ve) {
          var Oe = "";
          (_ === void 0 || typeof _ == "object" && _ !== null && Object.keys(_).length === 0) && (Oe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var kt = ks(ze);
          kt ? Oe += kt : Oe += Yi();
          var st;
          _ === null ? st = "null" : Xe(_) ? st = "array" : _ !== void 0 && _.$$typeof === n ? (st = "<" + (re(_.type) || "Unknown") + " />", Oe = " Did you accidentally export a JSX literal instead of a component?") : st = typeof _, z("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", st, Oe);
        }
        var ct = ws(_, Y, te, ze, Ye);
        if (ct == null)
          return ct;
        if (Ve) {
          var Ot = Y.children;
          if (Ot !== void 0)
            if (Te)
              if (Xe(Ot)) {
                for (var cn = 0; cn < Ot.length; cn++)
                  Ji(Ot[cn], _);
                Object.freeze && Object.freeze(Ot);
              } else
                z("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ji(Ot, _);
        }
        return _ === o ? oi(ct) : Ts(ct), ct;
      }
    }
    function si(_, Y, te) {
      return Qi(_, Y, te, !0);
    }
    function _s(_, Y, te) {
      return Qi(_, Y, te, !1);
    }
    var Ss = _s, Cs = si;
    _i.Fragment = o, _i.jsx = Ss, _i.jsxs = Cs;
  }()), _i;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = sx() : e.exports = ax();
})(ox);
const id = Di.Fragment, R = Di.jsx, me = Di.jsxs;
function Ni() {
  const e = an(
    (a) => n(a),
    []
  ), n = an(
    (a, c) => {
      const u = Object.keys(a).map((f) => typeof a[f] == "object" ? c ? n(
        a[f],
        `${c + f}.`
      ) : n(a[f], `${f}.`) : c ? c + f : f).filter(Boolean), h = [];
      return u.forEach((f) => {
        if (Array.isArray(f)) {
          const m = f;
          h.push(...m);
        } else
          h.push(f);
      }), h;
    },
    []
  ), i = an(
    (a) => o(a),
    []
  ), o = an(
    (a, c) => {
      const u = Object.keys(a).map((f) => typeof a[f] == "object" ? c ? o(
        a[f],
        `${c + f}.`
      ) : o(
        a[f],
        `${f}.`
      ) : c ? { [`${c + f}`]: a[f] } : { [f]: a[f] });
      let h = {};
      return u.forEach((f, m) => {
        if (Array.isArray(f)) {
          const g = f;
          u.splice(m, 1), u.push(...g);
        }
        h = { ...h, ...u[m] };
      }), h;
    },
    []
  );
  return { convertKeys: e, convertChildrenKeys: i };
}
const od = Zr({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), fs = Zr({}), hs = Zr(null), ds = typeof document < "u", Xo = ds ? Ky : mt, sd = Zr({ strict: !1 });
function lx(e, n, i, o) {
  const { visualElement: a } = It(fs), c = It(sd), u = It(hs), h = It(od).reducedMotion, f = un();
  o = o || c.renderer, !f.current && o && (f.current = o(e, {
    visualState: n,
    parent: a,
    props: i,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: h
  }));
  const m = f.current;
  return nd(() => {
    m && m.update(i, u);
  }), Xo(() => {
    m && m.render();
  }), mt(() => {
    m && m.updateFeatures();
  }), (window.HandoffAppearAnimations ? Xo : mt)(() => {
    m && m.animationState && m.animationState.animateChanges();
  }), m;
}
function jr(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function ux(e, n, i) {
  return an(
    (o) => {
      o && e.mount && e.mount(o), n && (o ? n.mount(o) : n.unmount()), i && (typeof i == "function" ? i(o) : jr(i) && (i.current = o));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [n]
  );
}
function Mi(e) {
  return typeof e == "string" || Array.isArray(e);
}
function ps(e) {
  return typeof e == "object" && typeof e.start == "function";
}
const Dl = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ml = ["initial", ...Dl];
function ms(e) {
  return ps(e.animate) || Ml.some((n) => Mi(e[n]));
}
function ad(e) {
  return !!(ms(e) || e.variants);
}
function cx(e, n) {
  if (ms(e)) {
    const { initial: i, animate: o } = e;
    return {
      initial: i === !1 || Mi(i) ? i : void 0,
      animate: Mi(o) ? o : void 0
    };
  }
  return e.inherit !== !1 ? n : {};
}
function fx(e) {
  const { initial: n, animate: i } = cx(e, It(fs));
  return Wt(() => ({ initial: n, animate: i }), [Af(n), Af(i)]);
}
function Af(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Rf = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Oi = {};
for (const e in Rf)
  Oi[e] = {
    isEnabled: (n) => Rf[e].some((i) => !!n[i])
  };
function hx(e) {
  for (const n in e)
    Oi[n] = {
      ...Oi[n],
      ...e[n]
    };
}
function Ol(e) {
  const n = un(null);
  return n.current === null && (n.current = e()), n.current;
}
const Ei = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
let dx = 1;
function px() {
  return Ol(() => {
    if (Ei.hasEverUpdated)
      return dx++;
  });
}
const Ll = Zr({}), ld = Zr({}), mx = Symbol.for("motionComponentSymbol");
function gx({ preloadedFeatures: e, createVisualElement: n, useRender: i, useVisualState: o, Component: a }) {
  e && hx(e);
  function c(h, f) {
    let m;
    const g = {
      ...It(od),
      ...h,
      layoutId: vx(h)
    }, { isStatic: x } = g, T = fx(h), E = x ? void 0 : px(), I = o(h, x);
    if (!x && ds) {
      T.visualElement = lx(a, I, g, n);
      const D = It(ld), W = It(sd).strict;
      T.visualElement && (m = T.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        g,
        W,
        e,
        E,
        D
      ));
    }
    return se.createElement(
      fs.Provider,
      { value: T },
      m && T.visualElement ? se.createElement(m, { visualElement: T.visualElement, ...g }) : null,
      i(a, h, E, ux(I, T.visualElement, f), I, x, T.visualElement)
    );
  }
  const u = Tr(c);
  return u[mx] = a, u;
}
function vx({ layoutId: e }) {
  const n = It(Ll).id;
  return n && e !== void 0 ? n + "-" + e : e;
}
function bx(e) {
  function n(o, a = {}) {
    return gx(e(o, a));
  }
  if (typeof Proxy > "u")
    return n;
  const i = /* @__PURE__ */ new Map();
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, a) => (i.has(a) || i.set(a, n(a)), i.get(a))
  });
}
const yx = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Fl(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(yx.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const Jo = {};
function xx(e) {
  Object.assign(Jo, e);
}
const Wi = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], _r = new Set(Wi);
function ud(e, { layout: n, layoutId: i }) {
  return _r.has(e) || e.startsWith("origin") || (n || i !== void 0) && (!!Jo[e] || e === "opacity");
}
const zt = (e) => !!(e && e.getVelocity), wx = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, kx = Wi.length;
function Tx(e, { enableHardwareAcceleration: n = !0, allowTransformNone: i = !0 }, o, a) {
  let c = "";
  for (let u = 0; u < kx; u++) {
    const h = Wi[u];
    if (e[h] !== void 0) {
      const f = wx[h] || h;
      c += `${f}(${e[h]}) `;
    }
  }
  return n && !e.z && (c += "translateZ(0)"), c = c.trim(), a ? c = a(e, o ? "" : c) : i && o && (c = "none"), c;
}
const cd = (e) => (n) => typeof n == "string" && n.startsWith(e), fd = cd("--"), sl = cd("var(--"), _x = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, Sx = (e, n) => n && typeof e == "number" ? n.transform(e) : e, kr = (e, n, i) => Math.min(Math.max(i, e), n), Sr = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Pi = {
  ...Sr,
  transform: (e) => kr(0, 1, e)
}, Wo = {
  ...Sr,
  default: 1
}, Ai = (e) => Math.round(e * 1e5) / 1e5, gs = /(-)?([\d]*\.?[\d])+/g, hd = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, Cx = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function zi(e) {
  return typeof e == "string";
}
const ji = (e) => ({
  test: (n) => zi(n) && n.endsWith(e) && n.split(" ").length === 1,
  parse: parseFloat,
  transform: (n) => `${n}${e}`
}), Xn = ji("deg"), Tn = ji("%"), ke = ji("px"), $x = ji("vh"), Ex = ji("vw"), If = {
  ...Tn,
  parse: (e) => Tn.parse(e) / 100,
  transform: (e) => Tn.transform(e * 100)
}, Uf = {
  ...Sr,
  transform: Math.round
}, dd = {
  // Border props
  borderWidth: ke,
  borderTopWidth: ke,
  borderRightWidth: ke,
  borderBottomWidth: ke,
  borderLeftWidth: ke,
  borderRadius: ke,
  radius: ke,
  borderTopLeftRadius: ke,
  borderTopRightRadius: ke,
  borderBottomRightRadius: ke,
  borderBottomLeftRadius: ke,
  // Positioning props
  width: ke,
  maxWidth: ke,
  height: ke,
  maxHeight: ke,
  size: ke,
  top: ke,
  right: ke,
  bottom: ke,
  left: ke,
  // Spacing props
  padding: ke,
  paddingTop: ke,
  paddingRight: ke,
  paddingBottom: ke,
  paddingLeft: ke,
  margin: ke,
  marginTop: ke,
  marginRight: ke,
  marginBottom: ke,
  marginLeft: ke,
  // Transform props
  rotate: Xn,
  rotateX: Xn,
  rotateY: Xn,
  rotateZ: Xn,
  scale: Wo,
  scaleX: Wo,
  scaleY: Wo,
  scaleZ: Wo,
  skew: Xn,
  skewX: Xn,
  skewY: Xn,
  distance: ke,
  translateX: ke,
  translateY: ke,
  translateZ: ke,
  x: ke,
  y: ke,
  z: ke,
  perspective: ke,
  transformPerspective: ke,
  opacity: Pi,
  originX: If,
  originY: If,
  originZ: ke,
  // Misc
  zIndex: Uf,
  // SVG
  fillOpacity: Pi,
  strokeOpacity: Pi,
  numOctaves: Uf
};
function Vl(e, n, i, o) {
  const { style: a, vars: c, transform: u, transformOrigin: h } = e;
  let f = !1, m = !1, g = !0;
  for (const x in n) {
    const T = n[x];
    if (fd(x)) {
      c[x] = T;
      continue;
    }
    const E = dd[x], I = Sx(T, E);
    if (_r.has(x)) {
      if (f = !0, u[x] = I, !g)
        continue;
      T !== (E.default || 0) && (g = !1);
    } else
      x.startsWith("origin") ? (m = !0, h[x] = I) : a[x] = I;
  }
  if (n.transform || (f || o ? a.transform = Tx(e.transform, i, g, o) : a.transform && (a.transform = "none")), m) {
    const { originX: x = "50%", originY: T = "50%", originZ: E = 0 } = h;
    a.transformOrigin = `${x} ${T} ${E}`;
  }
}
const Bl = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function pd(e, n, i) {
  for (const o in n)
    !zt(n[o]) && !ud(o, i) && (e[o] = n[o]);
}
function Px({ transformTemplate: e }, n, i) {
  return Wt(() => {
    const o = Bl();
    return Vl(o, n, { enableHardwareAcceleration: !i }, e), Object.assign({}, o.vars, o.style);
  }, [n]);
}
function Ax(e, n, i) {
  const o = e.style || {}, a = {};
  return pd(a, o, e), Object.assign(a, Px(e, n, i)), e.transformValues ? e.transformValues(a) : a;
}
function Rx(e, n, i) {
  const o = {}, a = Ax(e, n, i);
  return e.drag && e.dragListener !== !1 && (o.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (o.tabIndex = 0), o.style = a, o;
}
const Ix = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function Qo(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || Ix.has(e);
}
let md = (e) => !Qo(e);
function Ux(e) {
  e && (md = (n) => n.startsWith("on") ? !Qo(n) : e(n));
}
try {
  Ux(require("@emotion/is-prop-valid").default);
} catch {
}
function Dx(e, n, i) {
  const o = {};
  for (const a in e)
    a === "values" && typeof e.values == "object" || (md(a) || i === !0 && Qo(a) || !n && !Qo(a) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && a.startsWith("onDrag")) && (o[a] = e[a]);
  return o;
}
function Df(e, n, i) {
  return typeof e == "string" ? e : ke.transform(n + i * e);
}
function Mx(e, n, i) {
  const o = Df(n, e.x, e.width), a = Df(i, e.y, e.height);
  return `${o} ${a}`;
}
const Ox = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Lx = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Fx(e, n, i = 1, o = 0, a = !0) {
  e.pathLength = 1;
  const c = a ? Ox : Lx;
  e[c.offset] = ke.transform(-o);
  const u = ke.transform(n), h = ke.transform(i);
  e[c.array] = `${u} ${h}`;
}
function Nl(e, {
  attrX: n,
  attrY: i,
  attrScale: o,
  originX: a,
  originY: c,
  pathLength: u,
  pathSpacing: h = 1,
  pathOffset: f = 0,
  // This is object creation, which we try to avoid per-frame.
  ...m
}, g, x, T) {
  if (Vl(e, m, g, T), x) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: E, style: I, dimensions: D } = e;
  E.transform && (D && (I.transform = E.transform), delete E.transform), D && (a !== void 0 || c !== void 0 || I.transform) && (I.transformOrigin = Mx(D, a !== void 0 ? a : 0.5, c !== void 0 ? c : 0.5)), n !== void 0 && (E.x = n), i !== void 0 && (E.y = i), o !== void 0 && (E.scale = o), u !== void 0 && Fx(E, u, h, f, !1);
}
const gd = () => ({
  ...Bl(),
  attrs: {}
}), Wl = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Vx(e, n, i, o) {
  const a = Wt(() => {
    const c = gd();
    return Nl(c, n, { enableHardwareAcceleration: !1 }, Wl(o), e.transformTemplate), {
      ...c.attrs,
      style: { ...c.style }
    };
  }, [n]);
  if (e.style) {
    const c = {};
    pd(c, e.style, e), a.style = { ...c, ...a.style };
  }
  return a;
}
function Bx(e = !1) {
  return (i, o, a, c, { latestValues: u }, h) => {
    const m = (Fl(i) ? Vx : Rx)(o, u, h, i), x = {
      ...Dx(o, typeof i == "string", e),
      ...m,
      ref: c
    }, { children: T } = o, E = Wt(() => zt(T) ? T.get() : T, [T]);
    return a && (x["data-projection-id"] = a), Zy(i, {
      ...x,
      children: E
    });
  };
}
const zl = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function vd(e, { style: n, vars: i }, o, a) {
  Object.assign(e.style, n, a && a.getProjectionStyles(o));
  for (const c in i)
    e.style.setProperty(c, i[c]);
}
const bd = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function yd(e, n, i, o) {
  vd(e, n, void 0, o);
  for (const a in n.attrs)
    e.setAttribute(bd.has(a) ? a : zl(a), n.attrs[a]);
}
function jl(e, n) {
  const { style: i } = e, o = {};
  for (const a in i)
    (zt(i[a]) || n.style && zt(n.style[a]) || ud(a, e)) && (o[a] = i[a]);
  return o;
}
function xd(e, n) {
  const i = jl(e, n);
  for (const o in e)
    if (zt(e[o]) || zt(n[o])) {
      const a = Wi.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      i[a] = e[o];
    }
  return i;
}
function Gl(e, n, i, o = {}, a = {}) {
  return typeof n == "function" && (n = n(i !== void 0 ? i : e.custom, o, a)), typeof n == "string" && (n = e.variants && e.variants[n]), typeof n == "function" && (n = n(i !== void 0 ? i : e.custom, o, a)), n;
}
const es = (e) => Array.isArray(e), Nx = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), Wx = (e) => es(e) ? e[e.length - 1] || 0 : e;
function Ko(e) {
  const n = zt(e) ? e.get() : e;
  return Nx(n) ? n.toValue() : n;
}
function zx({ scrapeMotionValuesFromProps: e, createRenderState: n, onMount: i }, o, a, c) {
  const u = {
    latestValues: jx(o, a, c, e),
    renderState: n()
  };
  return i && (u.mount = (h) => i(o, h, u)), u;
}
const wd = (e) => (n, i) => {
  const o = It(fs), a = It(hs), c = () => zx(e, n, o, a);
  return i ? c() : Ol(c);
};
function jx(e, n, i, o) {
  const a = {}, c = o(e, {});
  for (const T in c)
    a[T] = Ko(c[T]);
  let { initial: u, animate: h } = e;
  const f = ms(e), m = ad(e);
  n && m && !f && e.inherit !== !1 && (u === void 0 && (u = n.initial), h === void 0 && (h = n.animate));
  let g = i ? i.initial === !1 : !1;
  g = g || u === !1;
  const x = g ? h : u;
  return x && typeof x != "boolean" && !ps(x) && (Array.isArray(x) ? x : [x]).forEach((E) => {
    const I = Gl(e, E);
    if (!I)
      return;
    const { transitionEnd: D, transition: W, ...F } = I;
    for (const z in F) {
      let L = F[z];
      if (Array.isArray(L)) {
        const G = g ? L.length - 1 : 0;
        L = L[G];
      }
      L !== null && (a[z] = L);
    }
    for (const z in D)
      a[z] = D[z];
  }), a;
}
const Gx = {
  useVisualState: wd({
    scrapeMotionValuesFromProps: xd,
    createRenderState: gd,
    onMount: (e, n, { renderState: i, latestValues: o }) => {
      try {
        i.dimensions = typeof n.getBBox == "function" ? n.getBBox() : n.getBoundingClientRect();
      } catch {
        i.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Nl(i, o, { enableHardwareAcceleration: !1 }, Wl(n.tagName), e.transformTemplate), yd(n, i);
    }
  })
}, Hx = {
  useVisualState: wd({
    scrapeMotionValuesFromProps: jl,
    createRenderState: Bl
  })
};
function qx(e, { forwardMotionProps: n = !1 }, i, o) {
  return {
    ...Fl(e) ? Gx : Hx,
    preloadedFeatures: i,
    useRender: Bx(n),
    createVisualElement: o,
    Component: e
  };
}
function On(e, n, i, o = { passive: !0 }) {
  return e.addEventListener(n, i, o), () => e.removeEventListener(n, i);
}
const kd = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function vs(e, n = "page") {
  return {
    point: {
      x: e[n + "X"],
      y: e[n + "Y"]
    }
  };
}
const Yx = (e) => (n) => kd(n) && e(n, vs(n));
function Ln(e, n, i, o) {
  return On(e, n, Yx(i), o);
}
const Kx = (e, n) => (i) => n(e(i)), er = (...e) => e.reduce(Kx);
function Td(e) {
  let n = null;
  return () => {
    const i = () => {
      n = null;
    };
    return n === null ? (n = e, i) : !1;
  };
}
const Mf = Td("dragHorizontal"), Of = Td("dragVertical");
function _d(e) {
  let n = !1;
  if (e === "y")
    n = Of();
  else if (e === "x")
    n = Mf();
  else {
    const i = Mf(), o = Of();
    i && o ? n = () => {
      i(), o();
    } : (i && i(), o && o());
  }
  return n;
}
function Sd() {
  const e = _d(!0);
  return e ? (e(), !1) : !0;
}
class ir {
  constructor(n) {
    this.isMounted = !1, this.node = n;
  }
  update() {
  }
}
function Zx(e) {
  let n = [], i = [], o = 0, a = !1, c = !1;
  const u = /* @__PURE__ */ new WeakSet(), h = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, m = !1, g = !1) => {
      const x = g && a, T = x ? n : i;
      return m && u.add(f), T.indexOf(f) === -1 && (T.push(f), x && a && (o = n.length)), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      const m = i.indexOf(f);
      m !== -1 && i.splice(m, 1), u.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (a) {
        c = !0;
        return;
      }
      if (a = !0, [n, i] = [i, n], i.length = 0, o = n.length, o)
        for (let m = 0; m < o; m++) {
          const g = n[m];
          g(f), u.has(g) && (h.schedule(g), e());
        }
      a = !1, c && (c = !1, h.process(f));
    }
  };
  return h;
}
const wt = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
}, Xx = 40;
let al = !0, Li = !1;
const bs = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], qr = bs.reduce((e, n) => (e[n] = Zx(() => Li = !0), e), {}), Jx = (e) => qr[e].process(wt), Cd = (e) => {
  Li = !1, wt.delta = al ? 1e3 / 60 : Math.max(Math.min(e - wt.timestamp, Xx), 1), wt.timestamp = e, wt.isProcessing = !0, bs.forEach(Jx), wt.isProcessing = !1, Li && (al = !1, requestAnimationFrame(Cd));
}, Qx = () => {
  Li = !0, al = !0, wt.isProcessing || requestAnimationFrame(Cd);
}, ot = bs.reduce((e, n) => {
  const i = qr[n];
  return e[n] = (o, a = !1, c = !1) => (Li || Qx(), i.schedule(o, a, c)), e;
}, {});
function Vn(e) {
  bs.forEach((n) => qr[n].cancel(e));
}
function Lf(e, n) {
  const i = "pointer" + (n ? "enter" : "leave"), o = "onHover" + (n ? "Start" : "End"), a = (c, u) => {
    if (c.type === "touch" || Sd())
      return;
    const h = e.getProps();
    e.animationState && h.whileHover && e.animationState.setActive("whileHover", n), h[o] && ot.update(() => h[o](c, u));
  };
  return Ln(e.current, i, a, {
    passive: !e.getProps()[o]
  });
}
class ew extends ir {
  mount() {
    this.unmount = er(Lf(this.node, !0), Lf(this.node, !1));
  }
  unmount() {
  }
}
class tw extends ir {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let n = !1;
    try {
      n = this.node.current.matches(":focus-visible");
    } catch {
      n = !0;
    }
    !n || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = er(On(this.node.current, "focus", () => this.onFocus()), On(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const $d = (e, n) => n ? e === n ? !0 : $d(e, n.parentElement) : !1, bt = (e) => e;
function La(e, n) {
  if (!n)
    return;
  const i = new PointerEvent("pointer" + e);
  n(i, vs(i));
}
class nw extends ir {
  constructor() {
    super(...arguments), this.removeStartListeners = bt, this.removeEndListeners = bt, this.removeAccessibleListeners = bt, this.startPointerPress = (n, i) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const o = this.node.getProps(), c = Ln(window, "pointerup", (h, f) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: m, onTapCancel: g } = this.node.getProps();
        ot.update(() => {
          $d(this.node.current, h.target) ? m && m(h, f) : g && g(h, f);
        });
      }, { passive: !(o.onTap || o.onPointerUp) }), u = Ln(window, "pointercancel", (h, f) => this.cancelPress(h, f), { passive: !(o.onTapCancel || o.onPointerCancel) });
      this.removeEndListeners = er(c, u), this.startPress(n, i);
    }, this.startAccessiblePress = () => {
      const n = (c) => {
        if (c.key !== "Enter" || this.isPressing)
          return;
        const u = (h) => {
          h.key !== "Enter" || !this.checkPressEnd() || La("up", (f, m) => {
            const { onTap: g } = this.node.getProps();
            g && ot.update(() => g(f, m));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = On(this.node.current, "keyup", u), La("down", (h, f) => {
          this.startPress(h, f);
        });
      }, i = On(this.node.current, "keydown", n), o = () => {
        this.isPressing && La("cancel", (c, u) => this.cancelPress(c, u));
      }, a = On(this.node.current, "blur", o);
      this.removeAccessibleListeners = er(i, a);
    };
  }
  startPress(n, i) {
    this.isPressing = !0;
    const { onTapStart: o, whileTap: a } = this.node.getProps();
    a && this.node.animationState && this.node.animationState.setActive("whileTap", !0), o && ot.update(() => o(n, i));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Sd();
  }
  cancelPress(n, i) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: o } = this.node.getProps();
    o && ot.update(() => o(n, i));
  }
  mount() {
    const n = this.node.getProps(), i = Ln(this.node.current, "pointerdown", this.startPointerPress, { passive: !(n.onTapStart || n.onPointerStart) }), o = On(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = er(i, o);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const ll = /* @__PURE__ */ new WeakMap(), Fa = /* @__PURE__ */ new WeakMap(), rw = (e) => {
  const n = ll.get(e.target);
  n && n(e);
}, iw = (e) => {
  e.forEach(rw);
};
function ow({ root: e, ...n }) {
  const i = e || document;
  Fa.has(i) || Fa.set(i, {});
  const o = Fa.get(i), a = JSON.stringify(n);
  return o[a] || (o[a] = new IntersectionObserver(iw, { root: e, ...n })), o[a];
}
function sw(e, n, i) {
  const o = ow(n);
  return ll.set(e, i), o.observe(e), () => {
    ll.delete(e), o.unobserve(e);
  };
}
const aw = {
  some: 0,
  all: 1
};
class lw extends ir {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: n = {} } = this.node.getProps(), { root: i, margin: o, amount: a = "some", once: c } = n, u = {
      root: i ? i.current : void 0,
      rootMargin: o,
      threshold: typeof a == "number" ? a : aw[a]
    }, h = (f) => {
      const { isIntersecting: m } = f;
      if (this.isInView === m || (this.isInView = m, c && !m && this.hasEnteredView))
        return;
      m && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", m);
      const { onViewportEnter: g, onViewportLeave: x } = this.node.getProps(), T = m ? g : x;
      T && T(f);
    };
    return sw(this.node.current, u, h);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: n, prevProps: i } = this.node;
    ["amount", "margin", "root"].some(uw(n, i)) && this.startObserver();
  }
  unmount() {
  }
}
function uw({ viewport: e = {} }, { viewport: n = {} } = {}) {
  return (i) => e[i] !== n[i];
}
const cw = {
  inView: {
    Feature: lw
  },
  tap: {
    Feature: nw
  },
  focus: {
    Feature: tw
  },
  hover: {
    Feature: ew
  }
};
function Ed(e, n) {
  if (!Array.isArray(n))
    return !1;
  const i = n.length;
  if (i !== e.length)
    return !1;
  for (let o = 0; o < i; o++)
    if (n[o] !== e[o])
      return !1;
  return !0;
}
function fw(e) {
  const n = {};
  return e.values.forEach((i, o) => n[o] = i.get()), n;
}
function hw(e) {
  const n = {};
  return e.values.forEach((i, o) => n[o] = i.getVelocity()), n;
}
function ys(e, n, i) {
  const o = e.getProps();
  return Gl(o, n, i !== void 0 ? i : o.custom, fw(e), hw(e));
}
const dw = "framerAppearId", pw = "data-" + zl(dw);
let Gi = bt, gn = bt;
process.env.NODE_ENV !== "production" && (Gi = (e, n) => {
  !e && typeof console < "u" && console.warn(n);
}, gn = (e, n) => {
  if (!e)
    throw new Error(n);
});
const tr = (e) => e * 1e3, Fn = (e) => e / 1e3, mw = {
  current: !1
}, Pd = (e) => Array.isArray(e) && typeof e[0] == "number";
function Ad(e) {
  return !!(!e || typeof e == "string" && Rd[e] || Pd(e) || Array.isArray(e) && e.every(Ad));
}
const $i = ([e, n, i, o]) => `cubic-bezier(${e}, ${n}, ${i}, ${o})`, Rd = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: $i([0, 0.65, 0.55, 1]),
  circOut: $i([0.55, 0, 1, 0.45]),
  backIn: $i([0.31, 0.01, 0.66, -0.59]),
  backOut: $i([0.33, 1.53, 0.69, 0.99])
};
function Id(e) {
  if (e)
    return Pd(e) ? $i(e) : Array.isArray(e) ? e.map(Id) : Rd[e];
}
function gw(e, n, i, { delay: o = 0, duration: a, repeat: c = 0, repeatType: u = "loop", ease: h, times: f } = {}) {
  const m = { [n]: i };
  f && (m.offset = f);
  const g = Id(h);
  return Array.isArray(g) && (m.easing = g), e.animate(m, {
    delay: o,
    duration: a,
    easing: Array.isArray(g) ? "linear" : g,
    fill: "both",
    iterations: c + 1,
    direction: u === "reverse" ? "alternate" : "normal"
  });
}
const Ff = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, Va = {}, Ud = {};
for (const e in Ff)
  Ud[e] = () => (Va[e] === void 0 && (Va[e] = Ff[e]()), Va[e]);
function vw(e, { repeat: n, repeatType: i = "loop" }) {
  const o = n && i !== "loop" && n % 2 === 1 ? 0 : e.length - 1;
  return e[o];
}
const Dd = (e, n, i) => (((1 - 3 * i + 3 * n) * e + (3 * i - 6 * n)) * e + 3 * n) * e, bw = 1e-7, yw = 12;
function xw(e, n, i, o, a) {
  let c, u, h = 0;
  do
    u = n + (i - n) / 2, c = Dd(u, o, a) - e, c > 0 ? i = u : n = u;
  while (Math.abs(c) > bw && ++h < yw);
  return u;
}
function Hi(e, n, i, o) {
  if (e === n && i === o)
    return bt;
  const a = (c) => xw(c, 0, 1, e, i);
  return (c) => c === 0 || c === 1 ? c : Dd(a(c), n, o);
}
const ww = Hi(0.42, 0, 1, 1), kw = Hi(0, 0, 0.58, 1), Md = Hi(0.42, 0, 0.58, 1), Tw = (e) => Array.isArray(e) && typeof e[0] != "number", Od = (e) => (n) => n <= 0.5 ? e(2 * n) / 2 : (2 - e(2 * (1 - n))) / 2, Ld = (e) => (n) => 1 - e(1 - n), Fd = (e) => 1 - Math.sin(Math.acos(e)), Hl = Ld(Fd), _w = Od(Hl), Vd = Hi(0.33, 1.53, 0.69, 0.99), ql = Ld(Vd), Sw = Od(ql), Cw = (e) => (e *= 2) < 1 ? 0.5 * ql(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Vf = {
  linear: bt,
  easeIn: ww,
  easeInOut: Md,
  easeOut: kw,
  circIn: Fd,
  circInOut: _w,
  circOut: Hl,
  backIn: ql,
  backInOut: Sw,
  backOut: Vd,
  anticipate: Cw
}, Bf = (e) => {
  if (Array.isArray(e)) {
    gn(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [n, i, o, a] = e;
    return Hi(n, i, o, a);
  } else if (typeof e == "string")
    return gn(Vf[e] !== void 0, `Invalid easing type '${e}'`), Vf[e];
  return e;
}, Yl = (e, n) => (i) => !!(zi(i) && Cx.test(i) && i.startsWith(e) || n && Object.prototype.hasOwnProperty.call(i, n)), Bd = (e, n, i) => (o) => {
  if (!zi(o))
    return o;
  const [a, c, u, h] = o.match(gs);
  return {
    [e]: parseFloat(a),
    [n]: parseFloat(c),
    [i]: parseFloat(u),
    alpha: h !== void 0 ? parseFloat(h) : 1
  };
}, $w = (e) => kr(0, 255, e), Ba = {
  ...Sr,
  transform: (e) => Math.round($w(e))
}, xr = {
  test: Yl("rgb", "red"),
  parse: Bd("red", "green", "blue"),
  transform: ({ red: e, green: n, blue: i, alpha: o = 1 }) => "rgba(" + Ba.transform(e) + ", " + Ba.transform(n) + ", " + Ba.transform(i) + ", " + Ai(Pi.transform(o)) + ")"
};
function Ew(e) {
  let n = "", i = "", o = "", a = "";
  return e.length > 5 ? (n = e.substring(1, 3), i = e.substring(3, 5), o = e.substring(5, 7), a = e.substring(7, 9)) : (n = e.substring(1, 2), i = e.substring(2, 3), o = e.substring(3, 4), a = e.substring(4, 5), n += n, i += i, o += o, a += a), {
    red: parseInt(n, 16),
    green: parseInt(i, 16),
    blue: parseInt(o, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const ul = {
  test: Yl("#"),
  parse: Ew,
  transform: xr.transform
}, Gr = {
  test: Yl("hsl", "hue"),
  parse: Bd("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: n, lightness: i, alpha: o = 1 }) => "hsla(" + Math.round(e) + ", " + Tn.transform(Ai(n)) + ", " + Tn.transform(Ai(i)) + ", " + Ai(Pi.transform(o)) + ")"
}, Rt = {
  test: (e) => xr.test(e) || ul.test(e) || Gr.test(e),
  parse: (e) => xr.test(e) ? xr.parse(e) : Gr.test(e) ? Gr.parse(e) : ul.parse(e),
  transform: (e) => zi(e) ? e : e.hasOwnProperty("red") ? xr.transform(e) : Gr.transform(e)
}, lt = (e, n, i) => -i * e + i * n + e;
function Na(e, n, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + (n - e) * 6 * i : i < 1 / 2 ? n : i < 2 / 3 ? e + (n - e) * (2 / 3 - i) * 6 : e;
}
function Pw({ hue: e, saturation: n, lightness: i, alpha: o }) {
  e /= 360, n /= 100, i /= 100;
  let a = 0, c = 0, u = 0;
  if (!n)
    a = c = u = i;
  else {
    const h = i < 0.5 ? i * (1 + n) : i + n - i * n, f = 2 * i - h;
    a = Na(f, h, e + 1 / 3), c = Na(f, h, e), u = Na(f, h, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(c * 255),
    blue: Math.round(u * 255),
    alpha: o
  };
}
const Wa = (e, n, i) => {
  const o = e * e;
  return Math.sqrt(Math.max(0, i * (n * n - o) + o));
}, Aw = [ul, xr, Gr], Rw = (e) => Aw.find((n) => n.test(e));
function Nf(e) {
  const n = Rw(e);
  gn(!!n, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let i = n.parse(e);
  return n === Gr && (i = Pw(i)), i;
}
const Nd = (e, n) => {
  const i = Nf(e), o = Nf(n), a = { ...i };
  return (c) => (a.red = Wa(i.red, o.red, c), a.green = Wa(i.green, o.green, c), a.blue = Wa(i.blue, o.blue, c), a.alpha = lt(i.alpha, o.alpha, c), xr.transform(a));
};
function Iw(e) {
  var n, i;
  return isNaN(e) && zi(e) && (((n = e.match(gs)) === null || n === void 0 ? void 0 : n.length) || 0) + (((i = e.match(hd)) === null || i === void 0 ? void 0 : i.length) || 0) > 0;
}
const Wd = {
  regex: _x,
  countKey: "Vars",
  token: "${v}",
  parse: bt
}, zd = {
  regex: hd,
  countKey: "Colors",
  token: "${c}",
  parse: Rt.parse
}, jd = {
  regex: gs,
  countKey: "Numbers",
  token: "${n}",
  parse: Sr.parse
};
function za(e, { regex: n, countKey: i, token: o, parse: a }) {
  const c = e.tokenised.match(n);
  c && (e["num" + i] = c.length, e.tokenised = e.tokenised.replace(n, o), e.values.push(...c.map(a)));
}
function ts(e) {
  const n = e.toString(), i = {
    value: n,
    tokenised: n,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return i.value.includes("var(--") && za(i, Wd), za(i, zd), za(i, jd), i;
}
function Gd(e) {
  return ts(e).values;
}
function Hd(e) {
  const { values: n, numColors: i, numVars: o, tokenised: a } = ts(e), c = n.length;
  return (u) => {
    let h = a;
    for (let f = 0; f < c; f++)
      f < o ? h = h.replace(Wd.token, u[f]) : f < o + i ? h = h.replace(zd.token, Rt.transform(u[f])) : h = h.replace(jd.token, Ai(u[f]));
    return h;
  };
}
const Uw = (e) => typeof e == "number" ? 0 : e;
function Dw(e) {
  const n = Gd(e);
  return Hd(e)(n.map(Uw));
}
const rr = {
  test: Iw,
  parse: Gd,
  createTransformer: Hd,
  getAnimatableNone: Dw
}, qd = (e, n) => (i) => `${i > 0 ? n : e}`;
function Yd(e, n) {
  return typeof e == "number" ? (i) => lt(e, n, i) : Rt.test(e) ? Nd(e, n) : e.startsWith("var(") ? qd(e, n) : Zd(e, n);
}
const Kd = (e, n) => {
  const i = [...e], o = i.length, a = e.map((c, u) => Yd(c, n[u]));
  return (c) => {
    for (let u = 0; u < o; u++)
      i[u] = a[u](c);
    return i;
  };
}, Mw = (e, n) => {
  const i = { ...e, ...n }, o = {};
  for (const a in i)
    e[a] !== void 0 && n[a] !== void 0 && (o[a] = Yd(e[a], n[a]));
  return (a) => {
    for (const c in o)
      i[c] = o[c](a);
    return i;
  };
}, Zd = (e, n) => {
  const i = rr.createTransformer(n), o = ts(e), a = ts(n);
  return o.numVars === a.numVars && o.numColors === a.numColors && o.numNumbers >= a.numNumbers ? er(Kd(o.values, a.values), i) : (Gi(!0, `Complex values '${e}' and '${n}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), qd(e, n));
}, Fi = (e, n, i) => {
  const o = n - e;
  return o === 0 ? 1 : (i - e) / o;
}, Wf = (e, n) => (i) => lt(e, n, i);
function Ow(e) {
  return typeof e == "number" ? Wf : typeof e == "string" ? Rt.test(e) ? Nd : Zd : Array.isArray(e) ? Kd : typeof e == "object" ? Mw : Wf;
}
function Lw(e, n, i) {
  const o = [], a = i || Ow(e[0]), c = e.length - 1;
  for (let u = 0; u < c; u++) {
    let h = a(e[u], e[u + 1]);
    if (n) {
      const f = Array.isArray(n) ? n[u] || bt : n;
      h = er(f, h);
    }
    o.push(h);
  }
  return o;
}
function Xd(e, n, { clamp: i = !0, ease: o, mixer: a } = {}) {
  const c = e.length;
  if (gn(c === n.length, "Both input and output ranges must be the same length"), c === 1)
    return () => n[0];
  e[0] > e[c - 1] && (e = [...e].reverse(), n = [...n].reverse());
  const u = Lw(n, o, a), h = u.length, f = (m) => {
    let g = 0;
    if (h > 1)
      for (; g < e.length - 2 && !(m < e[g + 1]); g++)
        ;
    const x = Fi(e[g], e[g + 1], m);
    return u[g](x);
  };
  return i ? (m) => f(kr(e[0], e[c - 1], m)) : f;
}
function Fw(e, n) {
  const i = e[e.length - 1];
  for (let o = 1; o <= n; o++) {
    const a = Fi(0, n, o);
    e.push(lt(i, 1, a));
  }
}
function Vw(e) {
  const n = [0];
  return Fw(n, e.length - 1), n;
}
function Bw(e, n) {
  return e.map((i) => i * n);
}
function Nw(e, n) {
  return e.map(() => n || Md).splice(0, e.length - 1);
}
function ns({ duration: e = 300, keyframes: n, times: i, ease: o = "easeInOut" }) {
  const a = Tw(o) ? o.map(Bf) : Bf(o), c = {
    done: !1,
    value: n[0]
  }, u = Bw(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    i && i.length === n.length ? i : Vw(n),
    e
  ), h = Xd(u, n, {
    ease: Array.isArray(a) ? a : Nw(n, a)
  });
  return {
    calculatedDuration: e,
    next: (f) => (c.value = h(f), c.done = f >= e, c)
  };
}
function Jd(e, n) {
  return n ? e * (1e3 / n) : 0;
}
const Ww = 5;
function Qd(e, n, i) {
  const o = Math.max(n - Ww, 0);
  return Jd(i - e(o), n - o);
}
const ja = 1e-3, zw = 0.01, zf = 10, jw = 0.05, Gw = 1;
function Hw({ duration: e = 800, bounce: n = 0.25, velocity: i = 0, mass: o = 1 }) {
  let a, c;
  Gi(e <= tr(zf), "Spring duration must be 10 seconds or less");
  let u = 1 - n;
  u = kr(jw, Gw, u), e = kr(zw, zf, Fn(e)), u < 1 ? (a = (m) => {
    const g = m * u, x = g * e, T = g - i, E = cl(m, u), I = Math.exp(-x);
    return ja - T / E * I;
  }, c = (m) => {
    const x = m * u * e, T = x * i + i, E = Math.pow(u, 2) * Math.pow(m, 2) * e, I = Math.exp(-x), D = cl(Math.pow(m, 2), u);
    return (-a(m) + ja > 0 ? -1 : 1) * ((T - E) * I) / D;
  }) : (a = (m) => {
    const g = Math.exp(-m * e), x = (m - i) * e + 1;
    return -ja + g * x;
  }, c = (m) => {
    const g = Math.exp(-m * e), x = (i - m) * (e * e);
    return g * x;
  });
  const h = 5 / e, f = Yw(a, c, h);
  if (e = tr(e), isNaN(f))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const m = Math.pow(f, 2) * o;
    return {
      stiffness: m,
      damping: u * 2 * Math.sqrt(o * m),
      duration: e
    };
  }
}
const qw = 12;
function Yw(e, n, i) {
  let o = i;
  for (let a = 1; a < qw; a++)
    o = o - e(o) / n(o);
  return o;
}
function cl(e, n) {
  return e * Math.sqrt(1 - n * n);
}
const Kw = ["duration", "bounce"], Zw = ["stiffness", "damping", "mass"];
function jf(e, n) {
  return n.some((i) => e[i] !== void 0);
}
function Xw(e) {
  let n = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!jf(e, Zw) && jf(e, Kw)) {
    const i = Hw(e);
    n = {
      ...n,
      ...i,
      velocity: 0,
      mass: 1
    }, n.isResolvedFromDuration = !0;
  }
  return n;
}
function ep({ keyframes: e, restDelta: n, restSpeed: i, ...o }) {
  const a = e[0], c = e[e.length - 1], u = { done: !1, value: a }, { stiffness: h, damping: f, mass: m, velocity: g, duration: x, isResolvedFromDuration: T } = Xw(o), E = g ? -Fn(g) : 0, I = f / (2 * Math.sqrt(h * m)), D = c - a, W = Fn(Math.sqrt(h / m)), F = Math.abs(D) < 5;
  i || (i = F ? 0.01 : 2), n || (n = F ? 5e-3 : 0.5);
  let z;
  if (I < 1) {
    const L = cl(W, I);
    z = (G) => {
      const Q = Math.exp(-I * W * G);
      return c - Q * ((E + I * W * D) / L * Math.sin(L * G) + D * Math.cos(L * G));
    };
  } else if (I === 1)
    z = (L) => c - Math.exp(-W * L) * (D + (E + W * D) * L);
  else {
    const L = W * Math.sqrt(I * I - 1);
    z = (G) => {
      const Q = Math.exp(-I * W * G), fe = Math.min(L * G, 300);
      return c - Q * ((E + I * W * D) * Math.sinh(fe) + L * D * Math.cosh(fe)) / L;
    };
  }
  return {
    calculatedDuration: T && x || null,
    next: (L) => {
      const G = z(L);
      if (T)
        u.done = L >= x;
      else {
        let Q = E;
        L !== 0 && (I < 1 ? Q = Qd(z, L, G) : Q = 0);
        const fe = Math.abs(Q) <= i, ge = Math.abs(c - G) <= n;
        u.done = fe && ge;
      }
      return u.value = u.done ? c : G, u;
    }
  };
}
function Gf({ keyframes: e, velocity: n = 0, power: i = 0.8, timeConstant: o = 325, bounceDamping: a = 10, bounceStiffness: c = 500, modifyTarget: u, min: h, max: f, restDelta: m = 0.5, restSpeed: g }) {
  const x = e[0], T = {
    done: !1,
    value: x
  }, E = (he) => h !== void 0 && he < h || f !== void 0 && he > f, I = (he) => h === void 0 ? f : f === void 0 || Math.abs(h - he) < Math.abs(f - he) ? h : f;
  let D = i * n;
  const W = x + D, F = u === void 0 ? W : u(W);
  F !== W && (D = F - x);
  const z = (he) => -D * Math.exp(-he / o), L = (he) => F + z(he), G = (he) => {
    const $e = z(he), Qe = L(he);
    T.done = Math.abs($e) <= m, T.value = T.done ? F : Qe;
  };
  let Q, fe;
  const ge = (he) => {
    E(T.value) && (Q = he, fe = ep({
      keyframes: [T.value, I(T.value)],
      velocity: Qd(L, he, T.value),
      damping: a,
      stiffness: c,
      restDelta: m,
      restSpeed: g
    }));
  };
  return ge(0), {
    calculatedDuration: null,
    next: (he) => {
      let $e = !1;
      return !fe && Q === void 0 && ($e = !0, G(he), ge(he)), Q !== void 0 && he > Q ? fe.next(he - Q) : (!$e && G(he), T);
    }
  };
}
const Jw = (e) => {
  const n = ({ timestamp: i }) => e(i);
  return {
    start: () => ot.update(n, !0),
    stop: () => Vn(n),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => wt.isProcessing ? wt.timestamp : performance.now()
  };
}, Hf = 2e4;
function qf(e) {
  let n = 0;
  const i = 50;
  let o = e.next(n);
  for (; !o.done && n < Hf; )
    n += i, o = e.next(n);
  return n >= Hf ? 1 / 0 : n;
}
const Qw = {
  decay: Gf,
  inertia: Gf,
  tween: ns,
  keyframes: ns,
  spring: ep
};
function rs({ autoplay: e = !0, delay: n = 0, driver: i = Jw, keyframes: o, type: a = "keyframes", repeat: c = 0, repeatDelay: u = 0, repeatType: h = "loop", onPlay: f, onStop: m, onComplete: g, onUpdate: x, ...T }) {
  let E = 1, I = !1, D, W;
  const F = () => {
    D && D(), W = new Promise(($) => {
      D = $;
    });
  };
  F();
  let z;
  const L = Qw[a] || ns;
  let G;
  L !== ns && typeof o[0] != "number" && (G = Xd([0, 100], o, {
    clamp: !1
  }), o = [0, 100]);
  const Q = L({ ...T, keyframes: o });
  let fe;
  h === "mirror" && (fe = L({
    ...T,
    keyframes: [...o].reverse(),
    velocity: -(T.velocity || 0)
  }));
  let ge = "idle", he = null, $e = null, Qe = null;
  Q.calculatedDuration === null && c && (Q.calculatedDuration = qf(Q));
  const { calculatedDuration: Ge } = Q;
  let _e = 1 / 0, re = 1 / 0;
  Ge !== null && (_e = Ge + u, re = _e * (c + 1) - u);
  let ve = 0;
  const le = ($) => {
    if ($e === null)
      return;
    E > 0 && ($e = Math.min($e, $)), he !== null ? ve = he : ve = ($ - $e) * E;
    const S = ve - n, p = S < 0;
    ve = Math.max(S, 0), ge === "finished" && he === null && (ve = re);
    let H = ve, ae = Q;
    if (c) {
      const ie = ve / _e;
      let oe = Math.floor(ie), Z = ie % 1;
      !Z && ie >= 1 && (Z = 1), Z === 1 && oe--, oe = Math.min(oe, c + 1);
      const Ce = !!(oe % 2);
      Ce && (h === "reverse" ? (Z = 1 - Z, u && (Z -= u / _e)) : h === "mirror" && (ae = fe));
      let X = kr(0, 1, Z);
      ve > re && (X = h === "reverse" && Ce ? 1 : 0), H = X * _e;
    }
    const be = p ? { done: !1, value: o[0] } : ae.next(H);
    G && (be.value = G(be.value));
    let { done: K } = be;
    !p && Ge !== null && (K = ve >= re);
    const ee = he === null && (ge === "finished" || ge === "running" && K || E < 0 && ve <= 0);
    return x && x(be.value), ee && Se(), be;
  }, We = () => {
    z && z.stop(), z = void 0;
  }, je = () => {
    ge = "idle", We(), F(), $e = Qe = null;
  }, Se = () => {
    ge = "finished", g && g(), We(), F();
  }, y = () => {
    if (I)
      return;
    z || (z = i(le));
    const $ = z.now();
    f && f(), he !== null ? $e = $ - he : (!$e || ge === "finished") && ($e = $), Qe = $e, he = null, ge = "running", z.start();
  };
  e && y();
  const k = {
    then($, S) {
      return W.then($, S);
    },
    get time() {
      return Fn(ve);
    },
    set time($) {
      $ = tr($), ve = $, he !== null || !z || E === 0 ? he = $ : $e = z.now() - $ / E;
    },
    get duration() {
      const $ = Q.calculatedDuration === null ? qf(Q) : Q.calculatedDuration;
      return Fn($);
    },
    get speed() {
      return E;
    },
    set speed($) {
      $ === E || !z || (E = $, k.time = Fn(ve));
    },
    get state() {
      return ge;
    },
    play: y,
    pause: () => {
      ge = "paused", he = ve;
    },
    stop: () => {
      I = !0, ge !== "idle" && (ge = "idle", m && m(), je());
    },
    cancel: () => {
      Qe !== null && le(Qe), je();
    },
    complete: () => {
      ge = "finished";
    },
    sample: ($) => ($e = 0, le($))
  };
  return k;
}
const ek = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), zo = 10, tk = 2e4, nk = (e, n) => n.type === "spring" || e === "backgroundColor" || !Ad(n.ease);
function rk(e, n, { onUpdate: i, onComplete: o, ...a }) {
  if (!(Ud.waapi() && ek.has(n) && !a.repeatDelay && a.repeatType !== "mirror" && a.damping !== 0 && a.type !== "inertia"))
    return !1;
  let u = !1, h, f;
  const m = () => {
    f = new Promise((F) => {
      h = F;
    });
  };
  m();
  let { keyframes: g, duration: x = 300, ease: T, times: E } = a;
  if (nk(n, a)) {
    const F = rs({
      ...a,
      repeat: 0,
      delay: 0
    });
    let z = { done: !1, value: g[0] };
    const L = [];
    let G = 0;
    for (; !z.done && G < tk; )
      z = F.sample(G), L.push(z.value), G += zo;
    E = void 0, g = L, x = G - zo, T = "linear";
  }
  const I = gw(e.owner.current, n, g, {
    ...a,
    duration: x,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: T,
    times: E
  }), D = () => I.cancel(), W = () => {
    ot.update(D), h(), m();
  };
  return I.onfinish = () => {
    e.set(vw(g, a)), o && o(), W();
  }, {
    then(F, z) {
      return f.then(F, z);
    },
    get time() {
      return Fn(I.currentTime || 0);
    },
    set time(F) {
      I.currentTime = tr(F);
    },
    get speed() {
      return I.playbackRate;
    },
    set speed(F) {
      I.playbackRate = F;
    },
    get duration() {
      return Fn(x);
    },
    play: () => {
      u || (I.play(), Vn(D));
    },
    pause: () => I.pause(),
    stop: () => {
      if (u = !0, I.playState === "idle")
        return;
      const { currentTime: F } = I;
      if (F) {
        const z = rs({
          ...a,
          autoplay: !1
        });
        e.setWithVelocity(z.sample(F - zo).value, z.sample(F).value, zo);
      }
      W();
    },
    complete: () => I.finish(),
    cancel: W
  };
}
function ik({ keyframes: e, delay: n, onUpdate: i, onComplete: o }) {
  const a = () => (i && i(e[e.length - 1]), o && o(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: bt,
    pause: bt,
    stop: bt,
    then: (c) => (c(), Promise.resolve()),
    cancel: bt,
    complete: bt
  });
  return n ? rs({
    keyframes: [0, 1],
    duration: 0,
    delay: n,
    onComplete: a
  }) : a();
}
const ok = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, sk = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), ak = {
  type: "keyframes",
  duration: 0.8
}, lk = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, uk = (e, { keyframes: n }) => n.length > 2 ? ak : _r.has(e) ? e.startsWith("scale") ? sk(n[1]) : ok : lk, fl = (e, n) => e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
rr.test(n) && // And it contains numbers and/or colors
!n.startsWith("url(")), ck = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function fk(e) {
  const [n, i] = e.slice(0, -1).split("(");
  if (n === "drop-shadow")
    return e;
  const [o] = i.match(gs) || [];
  if (!o)
    return e;
  const a = i.replace(o, "");
  let c = ck.has(n) ? 1 : 0;
  return o !== i && (c *= 100), n + "(" + c + a + ")";
}
const hk = /([a-z-]*)\(.*?\)/g, hl = {
  ...rr,
  getAnimatableNone: (e) => {
    const n = e.match(hk);
    return n ? n.map(fk).join(" ") : e;
  }
}, dk = {
  ...dd,
  // Color props
  color: Rt,
  backgroundColor: Rt,
  outlineColor: Rt,
  fill: Rt,
  stroke: Rt,
  // Border props
  borderColor: Rt,
  borderTopColor: Rt,
  borderRightColor: Rt,
  borderBottomColor: Rt,
  borderLeftColor: Rt,
  filter: hl,
  WebkitFilter: hl
}, Kl = (e) => dk[e];
function Zl(e, n) {
  let i = Kl(e);
  return i !== hl && (i = rr), i.getAnimatableNone ? i.getAnimatableNone(n) : void 0;
}
function pk({ when: e, delay: n, delayChildren: i, staggerChildren: o, staggerDirection: a, repeat: c, repeatType: u, repeatDelay: h, from: f, elapsed: m, ...g }) {
  return !!Object.keys(g).length;
}
function Yf(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function Kf(e) {
  return typeof e == "number" ? 0 : Zl("", e);
}
function tp(e, n) {
  return e[n] || e.default || e;
}
function mk(e, [...n]) {
  for (let i = 0; i < n.length; i++)
    n[i] === null && (n[i] = i === 0 ? e : n[i - 1]);
  return n;
}
function gk(e, n, i, o) {
  const a = fl(n, i);
  let c = o.from !== void 0 ? o.from : e.get();
  return c === "none" && a && typeof i == "string" ? c = Zl(n, i) : Yf(c) && typeof i == "string" ? c = Kf(i) : !Array.isArray(i) && Yf(i) && typeof c == "string" && (i = Kf(c)), Array.isArray(i) ? mk(c, i) : [c, i];
}
const Xl = (e, n, i, o = {}) => (a) => {
  const c = tp(o, e) || {}, u = c.delay || o.delay || 0;
  let { elapsed: h = 0 } = o;
  h = h - tr(u);
  const f = gk(n, e, i, c), m = f[0], g = f[f.length - 1], x = fl(e, m), T = fl(e, g);
  Gi(x === T, `You are trying to animate ${e} from "${m}" to "${g}". ${m} is not an animatable value - to enable this animation set ${m} to a value animatable to ${g} via the \`style\` property.`);
  let E = {
    keyframes: f,
    velocity: n.getVelocity(),
    ease: "easeOut",
    ...c,
    delay: -h,
    onUpdate: (I) => {
      n.set(I), c.onUpdate && c.onUpdate(I);
    },
    onComplete: () => {
      a(), c.onComplete && c.onComplete();
    }
  };
  if (pk(c) || (E = {
    ...E,
    ...uk(e, E)
  }), E.duration && (E.duration = tr(E.duration)), E.repeatDelay && (E.repeatDelay = tr(E.repeatDelay)), !x || !T || mw.current || c.type === !1)
    return ik(E);
  if (n.owner && n.owner.current instanceof HTMLElement && !n.owner.getProps().onUpdate) {
    const I = rk(n, e, E);
    if (I)
      return I;
  }
  return rs(E);
};
function is(e) {
  return !!(zt(e) && e.add);
}
const vk = (e) => /^\-?\d*\.?\d+$/.test(e), bk = (e) => /^0[^.\s]+$/.test(e);
function Jl(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function Ql(e, n) {
  const i = e.indexOf(n);
  i > -1 && e.splice(i, 1);
}
class eu {
  constructor() {
    this.subscriptions = [];
  }
  add(n) {
    return Jl(this.subscriptions, n), () => Ql(this.subscriptions, n);
  }
  notify(n, i, o) {
    const a = this.subscriptions.length;
    if (a)
      if (a === 1)
        this.subscriptions[0](n, i, o);
      else
        for (let c = 0; c < a; c++) {
          const u = this.subscriptions[c];
          u && u(n, i, o);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Zf = /* @__PURE__ */ new Set();
function tu(e, n, i) {
  e || Zf.has(n) || (console.warn(n), i && console.warn(i), Zf.add(n));
}
const yk = (e) => !isNaN(parseFloat(e));
class xk {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(n, i = {}) {
    this.version = "10.12.4", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (o, a = !0) => {
      this.prev = this.current, this.current = o;
      const { delta: c, timestamp: u } = wt;
      this.lastUpdated !== u && (this.timeDelta = c, this.lastUpdated = u, ot.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), a && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => ot.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: o }) => {
      o !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = n, this.canTrackVelocity = yk(this.current), this.owner = i.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(n) {
    return process.env.NODE_ENV !== "production" && tu(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", n);
  }
  on(n, i) {
    this.events[n] || (this.events[n] = new eu());
    const o = this.events[n].add(i);
    return n === "change" ? () => {
      o(), ot.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : o;
  }
  clearListeners() {
    for (const n in this.events)
      this.events[n].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(n, i) {
    this.passiveEffect = n, this.stopPassiveEffect = i;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(n, i = !0) {
    !i || !this.passiveEffect ? this.updateAndNotify(n, i) : this.passiveEffect(n, this.updateAndNotify);
  }
  setWithVelocity(n, i, o) {
    this.set(i), this.prev = n, this.timeDelta = o;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(n) {
    this.updateAndNotify(n), this.prev = n, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      Jd(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(n) {
    return this.stop(), new Promise((i) => {
      this.hasAnimated = !0, this.animation = n(i), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Kr(e, n) {
  return new xk(e, n);
}
const np = (e) => (n) => n.test(e), wk = {
  test: (e) => e === "auto",
  parse: (e) => e
}, rp = [Sr, ke, Tn, Xn, Ex, $x, wk], Si = (e) => rp.find(np(e)), kk = [...rp, Rt, rr], Tk = (e) => kk.find(np(e));
function _k(e, n, i) {
  e.hasValue(n) ? e.getValue(n).set(i) : e.addValue(n, Kr(i));
}
function Sk(e, n) {
  const i = ys(e, n);
  let { transitionEnd: o = {}, transition: a = {}, ...c } = i ? e.makeTargetAnimatable(i, !1) : {};
  c = { ...c, ...o };
  for (const u in c) {
    const h = Wx(c[u]);
    _k(e, u, h);
  }
}
function Ck(e, n, i) {
  var o, a;
  const c = Object.keys(n).filter((h) => !e.hasValue(h)), u = c.length;
  if (u)
    for (let h = 0; h < u; h++) {
      const f = c[h], m = n[f];
      let g = null;
      Array.isArray(m) && (g = m[0]), g === null && (g = (a = (o = i[f]) !== null && o !== void 0 ? o : e.readValue(f)) !== null && a !== void 0 ? a : n[f]), g != null && (typeof g == "string" && (vk(g) || bk(g)) ? g = parseFloat(g) : !Tk(g) && rr.test(m) && (g = Zl(f, m)), e.addValue(f, Kr(g, { owner: e })), i[f] === void 0 && (i[f] = g), g !== null && e.setBaseTarget(f, g));
    }
}
function $k(e, n) {
  return n ? (n[e] || n.default || n).from : void 0;
}
function Ek(e, n, i) {
  const o = {};
  for (const a in e) {
    const c = $k(a, n);
    if (c !== void 0)
      o[a] = c;
    else {
      const u = i.getValue(a);
      u && (o[a] = u.get());
    }
  }
  return o;
}
function Pk({ protectedKeys: e, needsAnimating: n }, i) {
  const o = e.hasOwnProperty(i) && n[i] !== !0;
  return n[i] = !1, o;
}
function ip(e, n, { delay: i = 0, transitionOverride: o, type: a } = {}) {
  let { transition: c = e.getDefaultTransition(), transitionEnd: u, ...h } = e.makeTargetAnimatable(n);
  const f = e.getValue("willChange");
  o && (c = o);
  const m = [], g = a && e.animationState && e.animationState.getState()[a];
  for (const x in h) {
    const T = e.getValue(x), E = h[x];
    if (!T || E === void 0 || g && Pk(g, x))
      continue;
    const I = { delay: i, elapsed: 0, ...c };
    if (window.HandoffAppearAnimations && !T.hasAnimated) {
      const W = e.getProps()[pw];
      W && (I.elapsed = window.HandoffAppearAnimations(W, x, T, ot));
    }
    T.start(Xl(x, T, E, e.shouldReduceMotion && _r.has(x) ? { type: !1 } : I));
    const D = T.animation;
    is(f) && (f.add(x), D.then(() => f.remove(x))), m.push(D);
  }
  return u && Promise.all(m).then(() => {
    u && Sk(e, u);
  }), m;
}
function dl(e, n, i = {}) {
  const o = ys(e, n, i.custom);
  let { transition: a = e.getDefaultTransition() || {} } = o || {};
  i.transitionOverride && (a = i.transitionOverride);
  const c = o ? () => Promise.all(ip(e, o, i)) : () => Promise.resolve(), u = e.variantChildren && e.variantChildren.size ? (f = 0) => {
    const { delayChildren: m = 0, staggerChildren: g, staggerDirection: x } = a;
    return Ak(e, n, m + f, g, x, i);
  } : () => Promise.resolve(), { when: h } = a;
  if (h) {
    const [f, m] = h === "beforeChildren" ? [c, u] : [u, c];
    return f().then(() => m());
  } else
    return Promise.all([c(), u(i.delay)]);
}
function Ak(e, n, i = 0, o = 0, a = 1, c) {
  const u = [], h = (e.variantChildren.size - 1) * o, f = a === 1 ? (m = 0) => m * o : (m = 0) => h - m * o;
  return Array.from(e.variantChildren).sort(Rk).forEach((m, g) => {
    m.notify("AnimationStart", n), u.push(dl(m, n, {
      ...c,
      delay: i + f(g)
    }).then(() => m.notify("AnimationComplete", n)));
  }), Promise.all(u);
}
function Rk(e, n) {
  return e.sortNodePosition(n);
}
function Ik(e, n, i = {}) {
  e.notify("AnimationStart", n);
  let o;
  if (Array.isArray(n)) {
    const a = n.map((c) => dl(e, c, i));
    o = Promise.all(a);
  } else if (typeof n == "string")
    o = dl(e, n, i);
  else {
    const a = typeof n == "function" ? ys(e, n, i.custom) : n;
    o = Promise.all(ip(e, a, i));
  }
  return o.then(() => e.notify("AnimationComplete", n));
}
const Uk = [...Dl].reverse(), Dk = Dl.length;
function Mk(e) {
  return (n) => Promise.all(n.map(({ animation: i, options: o }) => Ik(e, i, o)));
}
function Ok(e) {
  let n = Mk(e);
  const i = Fk();
  let o = !0;
  const a = (f, m) => {
    const g = ys(e, m);
    if (g) {
      const { transition: x, transitionEnd: T, ...E } = g;
      f = { ...f, ...E, ...T };
    }
    return f;
  };
  function c(f) {
    n = f(e);
  }
  function u(f, m) {
    const g = e.getProps(), x = e.getVariantContext(!0) || {}, T = [], E = /* @__PURE__ */ new Set();
    let I = {}, D = 1 / 0;
    for (let F = 0; F < Dk; F++) {
      const z = Uk[F], L = i[z], G = g[z] !== void 0 ? g[z] : x[z], Q = Mi(G), fe = z === m ? L.isActive : null;
      fe === !1 && (D = F);
      let ge = G === x[z] && G !== g[z] && Q;
      if (ge && o && e.manuallyAnimateOnMount && (ge = !1), L.protectedKeys = { ...I }, // If it isn't active and hasn't *just* been set as inactive
      !L.isActive && fe === null || // If we didn't and don't have any defined prop for this animation type
      !G && !L.prevProp || // Or if the prop doesn't define an animation
      ps(G) || typeof G == "boolean")
        continue;
      const he = Lk(L.prevProp, G);
      let $e = he || // If we're making this variant active, we want to always make it active
      z === m && L.isActive && !ge && Q || // If we removed a higher-priority variant (i is in reverse order)
      F > D && Q;
      const Qe = Array.isArray(G) ? G : [G];
      let Ge = Qe.reduce(a, {});
      fe === !1 && (Ge = {});
      const { prevResolvedValues: _e = {} } = L, re = {
        ..._e,
        ...Ge
      }, ve = (le) => {
        $e = !0, E.delete(le), L.needsAnimating[le] = !0;
      };
      for (const le in re) {
        const We = Ge[le], je = _e[le];
        I.hasOwnProperty(le) || (We !== je ? es(We) && es(je) ? !Ed(We, je) || he ? ve(le) : L.protectedKeys[le] = !0 : We !== void 0 ? ve(le) : E.add(le) : We !== void 0 && E.has(le) ? ve(le) : L.protectedKeys[le] = !0);
      }
      L.prevProp = G, L.prevResolvedValues = Ge, L.isActive && (I = { ...I, ...Ge }), o && e.blockInitialAnimation && ($e = !1), $e && !ge && T.push(...Qe.map((le) => ({
        animation: le,
        options: { type: z, ...f }
      })));
    }
    if (E.size) {
      const F = {};
      E.forEach((z) => {
        const L = e.getBaseTarget(z);
        L !== void 0 && (F[z] = L);
      }), T.push({ animation: F });
    }
    let W = !!T.length;
    return o && g.initial === !1 && !e.manuallyAnimateOnMount && (W = !1), o = !1, W ? n(T) : Promise.resolve();
  }
  function h(f, m, g) {
    var x;
    if (i[f].isActive === m)
      return Promise.resolve();
    (x = e.variantChildren) === null || x === void 0 || x.forEach((E) => {
      var I;
      return (I = E.animationState) === null || I === void 0 ? void 0 : I.setActive(f, m);
    }), i[f].isActive = m;
    const T = u(g, f);
    for (const E in i)
      i[E].protectedKeys = {};
    return T;
  }
  return {
    animateChanges: u,
    setActive: h,
    setAnimateFunction: c,
    getState: () => i
  };
}
function Lk(e, n) {
  return typeof n == "string" ? n !== e : Array.isArray(n) ? !Ed(n, e) : !1;
}
function gr(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Fk() {
  return {
    animate: gr(!0),
    whileInView: gr(),
    whileHover: gr(),
    whileTap: gr(),
    whileDrag: gr(),
    whileFocus: gr(),
    exit: gr()
  };
}
class Vk extends ir {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(n) {
    super(n), n.animationState || (n.animationState = Ok(n));
  }
  updateAnimationControlsSubscription() {
    const { animate: n } = this.node.getProps();
    this.unmount(), ps(n) && (this.unmount = n.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: n } = this.node.getProps(), { animate: i } = this.node.prevProps || {};
    n !== i && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let Bk = 0;
class Nk extends ir {
  constructor() {
    super(...arguments), this.id = Bk++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: n, onExitComplete: i, custom: o } = this.node.presenceContext, { isPresent: a } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || n === a)
      return;
    const c = this.node.animationState.setActive("exit", !n, { custom: o ?? this.node.getProps().custom });
    i && !n && c.then(() => i(this.id));
  }
  mount() {
    const { register: n } = this.node.presenceContext || {};
    n && (this.unmount = n(this.id));
  }
  unmount() {
  }
}
const Wk = {
  animation: {
    Feature: Vk
  },
  exit: {
    Feature: Nk
  }
}, Xf = (e, n) => Math.abs(e - n);
function zk(e, n) {
  const i = Xf(e.x, n.x), o = Xf(e.y, n.y);
  return Math.sqrt(i ** 2 + o ** 2);
}
class op {
  constructor(n, i, { transformPagePoint: o } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const m = Ha(this.lastMoveEventInfo, this.history), g = this.startEvent !== null, x = zk(m.offset, { x: 0, y: 0 }) >= 3;
      if (!g && !x)
        return;
      const { point: T } = m, { timestamp: E } = wt;
      this.history.push({ ...T, timestamp: E });
      const { onStart: I, onMove: D } = this.handlers;
      g || (I && I(this.lastMoveEvent, m), this.startEvent = this.lastMoveEvent), D && D(this.lastMoveEvent, m);
    }, this.handlePointerMove = (m, g) => {
      this.lastMoveEvent = m, this.lastMoveEventInfo = Ga(g, this.transformPagePoint), ot.update(this.updatePoint, !0);
    }, this.handlePointerUp = (m, g) => {
      if (this.end(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const { onEnd: x, onSessionEnd: T } = this.handlers, E = Ha(m.type === "pointercancel" ? this.lastMoveEventInfo : Ga(g, this.transformPagePoint), this.history);
      this.startEvent && x && x(m, E), T && T(m, E);
    }, !kd(n))
      return;
    this.handlers = i, this.transformPagePoint = o;
    const a = vs(n), c = Ga(a, this.transformPagePoint), { point: u } = c, { timestamp: h } = wt;
    this.history = [{ ...u, timestamp: h }];
    const { onSessionStart: f } = i;
    f && f(n, Ha(c, this.history)), this.removeListeners = er(Ln(window, "pointermove", this.handlePointerMove), Ln(window, "pointerup", this.handlePointerUp), Ln(window, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(n) {
    this.handlers = n;
  }
  end() {
    this.removeListeners && this.removeListeners(), Vn(this.updatePoint);
  }
}
function Ga(e, n) {
  return n ? { point: n(e.point) } : e;
}
function Jf(e, n) {
  return { x: e.x - n.x, y: e.y - n.y };
}
function Ha({ point: e }, n) {
  return {
    point: e,
    delta: Jf(e, sp(n)),
    offset: Jf(e, jk(n)),
    velocity: Gk(n, 0.1)
  };
}
function jk(e) {
  return e[0];
}
function sp(e) {
  return e[e.length - 1];
}
function Gk(e, n) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let i = e.length - 1, o = null;
  const a = sp(e);
  for (; i >= 0 && (o = e[i], !(a.timestamp - o.timestamp > tr(n))); )
    i--;
  if (!o)
    return { x: 0, y: 0 };
  const c = Fn(a.timestamp - o.timestamp);
  if (c === 0)
    return { x: 0, y: 0 };
  const u = {
    x: (a.x - o.x) / c,
    y: (a.y - o.y) / c
  };
  return u.x === 1 / 0 && (u.x = 0), u.y === 1 / 0 && (u.y = 0), u;
}
function Zt(e) {
  return e.max - e.min;
}
function pl(e, n = 0, i = 0.01) {
  return Math.abs(e - n) <= i;
}
function Qf(e, n, i, o = 0.5) {
  e.origin = o, e.originPoint = lt(n.min, n.max, e.origin), e.scale = Zt(i) / Zt(n), (pl(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = lt(i.min, i.max, e.origin) - e.originPoint, (pl(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Ri(e, n, i, o) {
  Qf(e.x, n.x, i.x, o ? o.originX : void 0), Qf(e.y, n.y, i.y, o ? o.originY : void 0);
}
function eh(e, n, i) {
  e.min = i.min + n.min, e.max = e.min + Zt(n);
}
function Hk(e, n, i) {
  eh(e.x, n.x, i.x), eh(e.y, n.y, i.y);
}
function th(e, n, i) {
  e.min = n.min - i.min, e.max = e.min + Zt(n);
}
function Ii(e, n, i) {
  th(e.x, n.x, i.x), th(e.y, n.y, i.y);
}
function qk(e, { min: n, max: i }, o) {
  return n !== void 0 && e < n ? e = o ? lt(n, e, o.min) : Math.max(e, n) : i !== void 0 && e > i && (e = o ? lt(i, e, o.max) : Math.min(e, i)), e;
}
function nh(e, n, i) {
  return {
    min: n !== void 0 ? e.min + n : void 0,
    max: i !== void 0 ? e.max + i - (e.max - e.min) : void 0
  };
}
function Yk(e, { top: n, left: i, bottom: o, right: a }) {
  return {
    x: nh(e.x, i, a),
    y: nh(e.y, n, o)
  };
}
function rh(e, n) {
  let i = n.min - e.min, o = n.max - e.max;
  return n.max - n.min < e.max - e.min && ([i, o] = [o, i]), { min: i, max: o };
}
function Kk(e, n) {
  return {
    x: rh(e.x, n.x),
    y: rh(e.y, n.y)
  };
}
function Zk(e, n) {
  let i = 0.5;
  const o = Zt(e), a = Zt(n);
  return a > o ? i = Fi(n.min, n.max - o, e.min) : o > a && (i = Fi(e.min, e.max - a, n.min)), kr(0, 1, i);
}
function Xk(e, n) {
  const i = {};
  return n.min !== void 0 && (i.min = n.min - e.min), n.max !== void 0 && (i.max = n.max - e.min), i;
}
const ml = 0.35;
function Jk(e = ml) {
  return e === !1 ? e = 0 : e === !0 && (e = ml), {
    x: ih(e, "left", "right"),
    y: ih(e, "top", "bottom")
  };
}
function ih(e, n, i) {
  return {
    min: oh(e, n),
    max: oh(e, i)
  };
}
function oh(e, n) {
  return typeof e == "number" ? e : e[n] || 0;
}
const sh = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ui = () => ({
  x: sh(),
  y: sh()
}), ah = () => ({ min: 0, max: 0 }), pt = () => ({
  x: ah(),
  y: ah()
});
function wn(e) {
  return [e("x"), e("y")];
}
function ap({ top: e, left: n, right: i, bottom: o }) {
  return {
    x: { min: n, max: i },
    y: { min: e, max: o }
  };
}
function Qk({ x: e, y: n }) {
  return { top: n.min, right: e.max, bottom: n.max, left: e.min };
}
function e2(e, n) {
  if (!n)
    return e;
  const i = n({ x: e.left, y: e.top }), o = n({ x: e.right, y: e.bottom });
  return {
    top: i.y,
    left: i.x,
    bottom: o.y,
    right: o.x
  };
}
function qa(e) {
  return e === void 0 || e === 1;
}
function gl({ scale: e, scaleX: n, scaleY: i }) {
  return !qa(e) || !qa(n) || !qa(i);
}
function vr(e) {
  return gl(e) || lp(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function lp(e) {
  return lh(e.x) || lh(e.y);
}
function lh(e) {
  return e && e !== "0%";
}
function os(e, n, i) {
  const o = e - i, a = n * o;
  return i + a;
}
function uh(e, n, i, o, a) {
  return a !== void 0 && (e = os(e, a, o)), os(e, i, o) + n;
}
function vl(e, n = 0, i = 1, o, a) {
  e.min = uh(e.min, n, i, o, a), e.max = uh(e.max, n, i, o, a);
}
function up(e, { x: n, y: i }) {
  vl(e.x, n.translate, n.scale, n.originPoint), vl(e.y, i.translate, i.scale, i.originPoint);
}
function t2(e, n, i, o = !1) {
  const a = i.length;
  if (!a)
    return;
  n.x = n.y = 1;
  let c, u;
  for (let h = 0; h < a; h++) {
    c = i[h], u = c.projectionDelta;
    const f = c.instance;
    f && f.style && f.style.display === "contents" || (o && c.options.layoutScroll && c.scroll && c !== c.root && Hr(e, {
      x: -c.scroll.offset.x,
      y: -c.scroll.offset.y
    }), u && (n.x *= u.x.scale, n.y *= u.y.scale, up(e, u)), o && vr(c.latestValues) && Hr(e, c.latestValues));
  }
  n.x = ch(n.x), n.y = ch(n.y);
}
function ch(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function Jn(e, n) {
  e.min = e.min + n, e.max = e.max + n;
}
function fh(e, n, [i, o, a]) {
  const c = n[a] !== void 0 ? n[a] : 0.5, u = lt(e.min, e.max, c);
  vl(e, n[i], n[o], u, n.scale);
}
const n2 = ["x", "scaleX", "originX"], r2 = ["y", "scaleY", "originY"];
function Hr(e, n) {
  fh(e.x, n, n2), fh(e.y, n, r2);
}
function cp(e, n) {
  return ap(e2(e.getBoundingClientRect(), n));
}
function i2(e, n, i) {
  const o = cp(e, i), { scroll: a } = n;
  return a && (Jn(o.x, a.offset.x), Jn(o.y, a.offset.y)), o;
}
const o2 = /* @__PURE__ */ new WeakMap();
class s2 {
  constructor(n) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = pt(), this.visualElement = n;
  }
  start(n, { snapToCursor: i = !1 } = {}) {
    const { presenceContext: o } = this.visualElement;
    if (o && o.isPresent === !1)
      return;
    const a = (f) => {
      this.stopAnimation(), i && this.snapToCursor(vs(f, "page").point);
    }, c = (f, m) => {
      const { drag: g, dragPropagation: x, onDragStart: T } = this.getProps();
      if (g && !x && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = _d(g), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), wn((I) => {
        let D = this.getAxisMotionValue(I).get() || 0;
        if (Tn.test(D)) {
          const { projection: W } = this.visualElement;
          if (W && W.layout) {
            const F = W.layout.layoutBox[I];
            F && (D = Zt(F) * (parseFloat(D) / 100));
          }
        }
        this.originPoint[I] = D;
      }), T && ot.update(() => T(f, m), !1, !0);
      const { animationState: E } = this.visualElement;
      E && E.setActive("whileDrag", !0);
    }, u = (f, m) => {
      const { dragPropagation: g, dragDirectionLock: x, onDirectionLock: T, onDrag: E } = this.getProps();
      if (!g && !this.openGlobalLock)
        return;
      const { offset: I } = m;
      if (x && this.currentDirection === null) {
        this.currentDirection = a2(I), this.currentDirection !== null && T && T(this.currentDirection);
        return;
      }
      this.updateAxis("x", m.point, I), this.updateAxis("y", m.point, I), this.visualElement.render(), E && E(f, m);
    }, h = (f, m) => this.stop(f, m);
    this.panSession = new op(n, {
      onSessionStart: a,
      onStart: c,
      onMove: u,
      onSessionEnd: h
    }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
  }
  stop(n, i) {
    const o = this.isDragging;
    if (this.cancel(), !o)
      return;
    const { velocity: a } = i;
    this.startAnimation(a);
    const { onDragEnd: c } = this.getProps();
    c && ot.update(() => c(n, i));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: n, animationState: i } = this.visualElement;
    n && (n.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: o } = this.getProps();
    !o && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), i && i.setActive("whileDrag", !1);
  }
  updateAxis(n, i, o) {
    const { drag: a } = this.getProps();
    if (!o || !jo(n, a, this.currentDirection))
      return;
    const c = this.getAxisMotionValue(n);
    let u = this.originPoint[n] + o[n];
    this.constraints && this.constraints[n] && (u = qk(u, this.constraints[n], this.elastic[n])), c.set(u);
  }
  resolveConstraints() {
    const { dragConstraints: n, dragElastic: i } = this.getProps(), { layout: o } = this.visualElement.projection || {}, a = this.constraints;
    n && jr(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = Yk(o.layoutBox, n) : this.constraints = !1, this.elastic = Jk(i), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && wn((c) => {
      this.getAxisMotionValue(c) && (this.constraints[c] = Xk(o.layoutBox[c], this.constraints[c]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: n, onMeasureDragConstraints: i } = this.getProps();
    if (!n || !jr(n))
      return !1;
    const o = n.current;
    gn(o !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: a } = this.visualElement;
    if (!a || !a.layout)
      return !1;
    const c = i2(o, a.root, this.visualElement.getTransformPagePoint());
    let u = Kk(a.layout.layoutBox, c);
    if (i) {
      const h = i(Qk(u));
      this.hasMutatedConstraints = !!h, h && (u = ap(h));
    }
    return u;
  }
  startAnimation(n) {
    const { drag: i, dragMomentum: o, dragElastic: a, dragTransition: c, dragSnapToOrigin: u, onDragTransitionEnd: h } = this.getProps(), f = this.constraints || {}, m = wn((g) => {
      if (!jo(g, i, this.currentDirection))
        return;
      let x = f && f[g] || {};
      u && (x = { min: 0, max: 0 });
      const T = a ? 200 : 1e6, E = a ? 40 : 1e7, I = {
        type: "inertia",
        velocity: o ? n[g] : 0,
        bounceStiffness: T,
        bounceDamping: E,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...c,
        ...x
      };
      return this.startAxisValueAnimation(g, I);
    });
    return Promise.all(m).then(h);
  }
  startAxisValueAnimation(n, i) {
    const o = this.getAxisMotionValue(n);
    return o.start(Xl(n, o, 0, i));
  }
  stopAnimation() {
    wn((n) => this.getAxisMotionValue(n).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(n) {
    const i = "_drag" + n.toUpperCase(), o = this.visualElement.getProps(), a = o[i];
    return a || this.visualElement.getValue(n, (o.initial ? o.initial[n] : void 0) || 0);
  }
  snapToCursor(n) {
    wn((i) => {
      const { drag: o } = this.getProps();
      if (!jo(i, o, this.currentDirection))
        return;
      const { projection: a } = this.visualElement, c = this.getAxisMotionValue(i);
      if (a && a.layout) {
        const { min: u, max: h } = a.layout.layoutBox[i];
        c.set(n[i] - lt(u, h, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: n, dragConstraints: i } = this.getProps(), { projection: o } = this.visualElement;
    if (!jr(i) || !o || !this.constraints)
      return;
    this.stopAnimation();
    const a = { x: 0, y: 0 };
    wn((u) => {
      const h = this.getAxisMotionValue(u);
      if (h) {
        const f = h.get();
        a[u] = Zk({ min: f, max: f }, this.constraints[u]);
      }
    });
    const { transformTemplate: c } = this.visualElement.getProps();
    this.visualElement.current.style.transform = c ? c({}, "") : "none", o.root && o.root.updateScroll(), o.updateLayout(), this.resolveConstraints(), wn((u) => {
      if (!jo(u, n, null))
        return;
      const h = this.getAxisMotionValue(u), { min: f, max: m } = this.constraints[u];
      h.set(lt(f, m, a[u]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    o2.set(this.visualElement, this);
    const n = this.visualElement.current, i = Ln(n, "pointerdown", (f) => {
      const { drag: m, dragListener: g = !0 } = this.getProps();
      m && g && this.start(f);
    }), o = () => {
      const { dragConstraints: f } = this.getProps();
      jr(f) && (this.constraints = this.resolveRefConstraints());
    }, { projection: a } = this.visualElement, c = a.addEventListener("measure", o);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), o();
    const u = On(window, "resize", () => this.scalePositionWithinConstraints()), h = a.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: m }) => {
      this.isDragging && m && (wn((g) => {
        const x = this.getAxisMotionValue(g);
        x && (this.originPoint[g] += f[g].translate, x.set(x.get() + f[g].translate));
      }), this.visualElement.render());
    });
    return () => {
      u(), i(), c(), h && h();
    };
  }
  getProps() {
    const n = this.visualElement.getProps(), { drag: i = !1, dragDirectionLock: o = !1, dragPropagation: a = !1, dragConstraints: c = !1, dragElastic: u = ml, dragMomentum: h = !0 } = n;
    return {
      ...n,
      drag: i,
      dragDirectionLock: o,
      dragPropagation: a,
      dragConstraints: c,
      dragElastic: u,
      dragMomentum: h
    };
  }
}
function jo(e, n, i) {
  return (n === !0 || n === e) && (i === null || i === e);
}
function a2(e, n = 10) {
  let i = null;
  return Math.abs(e.y) > n ? i = "y" : Math.abs(e.x) > n && (i = "x"), i;
}
class l2 extends ir {
  constructor(n) {
    super(n), this.removeGroupControls = bt, this.removeListeners = bt, this.controls = new s2(n);
  }
  mount() {
    const { dragControls: n } = this.node.getProps();
    n && (this.removeGroupControls = n.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || bt;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const hh = (e) => (n, i) => {
  e && ot.update(() => e(n, i));
};
class u2 extends ir {
  constructor() {
    super(...arguments), this.removePointerDownListener = bt;
  }
  onPointerDown(n) {
    this.session = new op(n, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
  }
  createPanHandlers() {
    const { onPanSessionStart: n, onPanStart: i, onPan: o, onPanEnd: a } = this.node.getProps();
    return {
      onSessionStart: hh(n),
      onStart: hh(i),
      onMove: o,
      onEnd: (c, u) => {
        delete this.session, a && ot.update(() => a(c, u));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Ln(this.node.current, "pointerdown", (n) => this.onPointerDown(n));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function c2() {
  const e = It(hs);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: i, register: o } = e, a = Il();
  return mt(() => o(a), []), !n && i ? [!1, () => i && i(a)] : [!0];
}
function dh(e, n) {
  return n.max === n.min ? 0 : e / (n.max - n.min) * 100;
}
const Ci = {
  correct: (e, n) => {
    if (!n.target)
      return e;
    if (typeof e == "string")
      if (ke.test(e))
        e = parseFloat(e);
      else
        return e;
    const i = dh(e, n.target.x), o = dh(e, n.target.y);
    return `${i}% ${o}%`;
  }
}, f2 = {
  correct: (e, { treeScale: n, projectionDelta: i }) => {
    const o = e, a = rr.parse(e);
    if (a.length > 5)
      return o;
    const c = rr.createTransformer(e), u = typeof a[0] != "number" ? 1 : 0, h = i.x.scale * n.x, f = i.y.scale * n.y;
    a[0 + u] /= h, a[1 + u] /= f;
    const m = lt(h, f, 0.5);
    return typeof a[2 + u] == "number" && (a[2 + u] /= m), typeof a[3 + u] == "number" && (a[3 + u] /= m), c(a);
  }
};
class h2 extends Ut.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: n, layoutGroup: i, switchLayoutGroup: o, layoutId: a } = this.props, { projection: c } = n;
    xx(d2), c && (i.group && i.group.add(c), o && o.register && a && o.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), c.setOptions({
      ...c.options,
      onExitComplete: () => this.safeToRemove()
    })), Ei.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(n) {
    const { layoutDependency: i, visualElement: o, drag: a, isPresent: c } = this.props, u = o.projection;
    return u && (u.isPresent = c, a || n.layoutDependency !== i || i === void 0 ? u.willUpdate() : this.safeToRemove(), n.isPresent !== c && (c ? u.promote() : u.relegate() || ot.postRender(() => {
      const h = u.getStack();
      (!h || !h.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: n } = this.props.visualElement;
    n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
  }
  componentWillUnmount() {
    const { visualElement: n, layoutGroup: i, switchLayoutGroup: o } = this.props, { projection: a } = n;
    a && (a.scheduleCheckAfterUnmount(), i && i.group && i.group.remove(a), o && o.deregister && o.deregister(a));
  }
  safeToRemove() {
    const { safeToRemove: n } = this.props;
    n && n();
  }
  render() {
    return null;
  }
}
function fp(e) {
  const [n, i] = c2(), o = It(Ll);
  return Ut.createElement(h2, { ...e, layoutGroup: o, switchLayoutGroup: It(ld), isPresent: n, safeToRemove: i });
}
const d2 = {
  borderRadius: {
    ...Ci,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Ci,
  borderTopRightRadius: Ci,
  borderBottomLeftRadius: Ci,
  borderBottomRightRadius: Ci,
  boxShadow: f2
}, hp = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], p2 = hp.length, ph = (e) => typeof e == "string" ? parseFloat(e) : e, mh = (e) => typeof e == "number" || ke.test(e);
function m2(e, n, i, o, a, c) {
  a ? (e.opacity = lt(
    0,
    // TODO Reinstate this if only child
    i.opacity !== void 0 ? i.opacity : 1,
    g2(o)
  ), e.opacityExit = lt(n.opacity !== void 0 ? n.opacity : 1, 0, v2(o))) : c && (e.opacity = lt(n.opacity !== void 0 ? n.opacity : 1, i.opacity !== void 0 ? i.opacity : 1, o));
  for (let u = 0; u < p2; u++) {
    const h = `border${hp[u]}Radius`;
    let f = gh(n, h), m = gh(i, h);
    if (f === void 0 && m === void 0)
      continue;
    f || (f = 0), m || (m = 0), f === 0 || m === 0 || mh(f) === mh(m) ? (e[h] = Math.max(lt(ph(f), ph(m), o), 0), (Tn.test(m) || Tn.test(f)) && (e[h] += "%")) : e[h] = m;
  }
  (n.rotate || i.rotate) && (e.rotate = lt(n.rotate || 0, i.rotate || 0, o));
}
function gh(e, n) {
  return e[n] !== void 0 ? e[n] : e.borderRadius;
}
const g2 = dp(0, 0.5, Hl), v2 = dp(0.5, 0.95, bt);
function dp(e, n, i) {
  return (o) => o < e ? 0 : o > n ? 1 : i(Fi(e, n, o));
}
function vh(e, n) {
  e.min = n.min, e.max = n.max;
}
function sn(e, n) {
  vh(e.x, n.x), vh(e.y, n.y);
}
function bh(e, n, i, o, a) {
  return e -= n, e = os(e, 1 / i, o), a !== void 0 && (e = os(e, 1 / a, o)), e;
}
function b2(e, n = 0, i = 1, o = 0.5, a, c = e, u = e) {
  if (Tn.test(n) && (n = parseFloat(n), n = lt(u.min, u.max, n / 100) - u.min), typeof n != "number")
    return;
  let h = lt(c.min, c.max, o);
  e === c && (h -= n), e.min = bh(e.min, n, i, h, a), e.max = bh(e.max, n, i, h, a);
}
function yh(e, n, [i, o, a], c, u) {
  b2(e, n[i], n[o], n[a], n.scale, c, u);
}
const y2 = ["x", "scaleX", "originX"], x2 = ["y", "scaleY", "originY"];
function xh(e, n, i, o) {
  yh(e.x, n, y2, i ? i.x : void 0, o ? o.x : void 0), yh(e.y, n, x2, i ? i.y : void 0, o ? o.y : void 0);
}
function wh(e) {
  return e.translate === 0 && e.scale === 1;
}
function pp(e) {
  return wh(e.x) && wh(e.y);
}
function bl(e, n) {
  return e.x.min === n.x.min && e.x.max === n.x.max && e.y.min === n.y.min && e.y.max === n.y.max;
}
function kh(e) {
  return Zt(e.x) / Zt(e.y);
}
class w2 {
  constructor() {
    this.members = [];
  }
  add(n) {
    Jl(this.members, n), n.scheduleRender();
  }
  remove(n) {
    if (Ql(this.members, n), n === this.prevLead && (this.prevLead = void 0), n === this.lead) {
      const i = this.members[this.members.length - 1];
      i && this.promote(i);
    }
  }
  relegate(n) {
    const i = this.members.findIndex((a) => n === a);
    if (i === 0)
      return !1;
    let o;
    for (let a = i; a >= 0; a--) {
      const c = this.members[a];
      if (c.isPresent !== !1) {
        o = c;
        break;
      }
    }
    return o ? (this.promote(o), !0) : !1;
  }
  promote(n, i) {
    const o = this.lead;
    if (n !== o && (this.prevLead = o, this.lead = n, n.show(), o)) {
      o.instance && o.scheduleRender(), n.scheduleRender(), n.resumeFrom = o, i && (n.resumeFrom.preserveOpacity = !0), o.snapshot && (n.snapshot = o.snapshot, n.snapshot.latestValues = o.animationValues || o.latestValues), n.root && n.root.isUpdating && (n.isLayoutDirty = !0);
      const { crossfade: a } = n.options;
      a === !1 && o.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((n) => {
      const { options: i, resumingFrom: o } = n;
      i.onExitComplete && i.onExitComplete(), o && o.options.onExitComplete && o.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((n) => {
      n.instance && n.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Th(e, n, i) {
  let o = "";
  const a = e.x.translate / n.x, c = e.y.translate / n.y;
  if ((a || c) && (o = `translate3d(${a}px, ${c}px, 0) `), (n.x !== 1 || n.y !== 1) && (o += `scale(${1 / n.x}, ${1 / n.y}) `), i) {
    const { rotate: f, rotateX: m, rotateY: g } = i;
    f && (o += `rotate(${f}deg) `), m && (o += `rotateX(${m}deg) `), g && (o += `rotateY(${g}deg) `);
  }
  const u = e.x.scale * n.x, h = e.y.scale * n.y;
  return (u !== 1 || h !== 1) && (o += `scale(${u}, ${h})`), o || "none";
}
const k2 = (e, n) => e.depth - n.depth;
class T2 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(n) {
    Jl(this.children, n), this.isDirty = !0;
  }
  remove(n) {
    Ql(this.children, n), this.isDirty = !0;
  }
  forEach(n) {
    this.isDirty && this.children.sort(k2), this.isDirty = !1, this.children.forEach(n);
  }
}
function _2(e, n) {
  const i = performance.now(), o = ({ timestamp: a }) => {
    const c = a - i;
    c >= n && (Vn(o), e(c - n));
  };
  return ot.read(o, !0), () => Vn(o);
}
function S2(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function C2(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function $2(e, n, i) {
  const o = zt(e) ? e : Kr(e);
  return o.start(Xl("", o, n, i)), o.animation;
}
const _h = ["", "X", "Y", "Z"], Sh = 1e3;
let E2 = 0;
const br = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function mp({ attachResizeListener: e, defaultParent: n, measureScroll: i, checkIsScrollRoot: o, resetTransform: a }) {
  return class {
    constructor(u, h = {}, f = n == null ? void 0 : n()) {
      this.id = E2++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        br.totalNodes = br.resolvedTargetDeltas = br.recalculatedProjection = 0, this.nodes.forEach(R2), this.nodes.forEach(M2), this.nodes.forEach(O2), this.nodes.forEach(I2), S2(br);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.elementId = u, this.latestValues = h, this.root = f ? f.root || f : this, this.path = f ? [...f.path, f] : [], this.parent = f, this.depth = f ? f.depth + 1 : 0, u && this.root.registerPotentialNode(u, this);
      for (let m = 0; m < this.path.length; m++)
        this.path[m].shouldResetTransform = !0;
      this.root === this && (this.nodes = new T2());
    }
    addEventListener(u, h) {
      return this.eventHandlers.has(u) || this.eventHandlers.set(u, new eu()), this.eventHandlers.get(u).add(h);
    }
    notifyListeners(u, ...h) {
      const f = this.eventHandlers.get(u);
      f && f.notify(...h);
    }
    hasListeners(u) {
      return this.eventHandlers.has(u);
    }
    registerPotentialNode(u, h) {
      this.potentialNodes.set(u, h);
    }
    /**
     * Lifecycles
     */
    mount(u, h = !1) {
      if (this.instance)
        return;
      this.isSVG = C2(u), this.instance = u;
      const { layoutId: f, layout: m, visualElement: g } = this.options;
      if (g && !g.current && g.mount(u), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.elementId && this.root.potentialNodes.delete(this.elementId), h && (m || f) && (this.isLayoutDirty = !0), e) {
        let x;
        const T = () => this.root.updateBlockedByResize = !1;
        e(u, () => {
          this.root.updateBlockedByResize = !0, x && x(), x = _2(T, 250), Ei.hasAnimatedSinceResize && (Ei.hasAnimatedSinceResize = !1, this.nodes.forEach($h));
        });
      }
      f && this.root.registerSharedNode(f, this), this.options.animate !== !1 && g && (f || m) && this.addEventListener("didUpdate", ({ delta: x, hasLayoutChanged: T, hasRelativeTargetChanged: E, layout: I }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const D = this.options.transition || g.getDefaultTransition() || N2, { onLayoutAnimationStart: W, onLayoutAnimationComplete: F } = g.getProps(), z = !this.targetLayout || !bl(this.targetLayout, I) || E, L = !T && E;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || L || T && (z || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(x, L);
          const G = {
            ...tp(D, "layout"),
            onPlay: W,
            onComplete: F
          };
          (g.shouldReduceMotion || this.options.layoutRoot) && (G.delay = 0, G.type = !1), this.startAnimation(G);
        } else
          !T && this.animationProgress === 0 && $h(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = I;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const u = this.getStack();
      u && u.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Vn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(L2), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: u } = this.options;
      return u && u.getProps().transformTemplate;
    }
    willUpdate(u = !0) {
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let g = 0; g < this.path.length; g++) {
        const x = this.path[g];
        x.shouldResetTransform = !0, x.updateScroll("snapshot"), x.options.layoutRoot && x.willUpdate(!1);
      }
      const { layoutId: h, layout: f } = this.options;
      if (h === void 0 && !f)
        return;
      const m = this.getTransformTemplate();
      this.prevTransformTemplateValue = m ? m(this.latestValues, "") : void 0, this.updateSnapshot(), u && this.notifyListeners("willUpdate");
    }
    // Note: Currently only running on root node
    didUpdate() {
      if (this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Ch);
        return;
      }
      this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(W2), this.potentialNodes.clear()), this.nodes.forEach(D2), this.nodes.forEach(P2), this.nodes.forEach(A2), this.clearAllSnapshots(), qr.update.process(wt), qr.preRender.process(wt), qr.render.process(wt));
    }
    clearAllSnapshots() {
      this.nodes.forEach(U2), this.sharedNodes.forEach(F2);
    }
    scheduleUpdateProjection() {
      ot.preRender(this.updateProjection, !1, !0);
    }
    scheduleCheckAfterUnmount() {
      ot.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let f = 0; f < this.path.length; f++)
          this.path[f].updateScroll();
      const u = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = pt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: h } = this.options;
      h && h.notify("LayoutMeasure", this.layout.layoutBox, u ? u.layoutBox : void 0);
    }
    updateScroll(u = "measure") {
      let h = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === u && (h = !1), h && (this.scroll = {
        animationId: this.root.animationId,
        phase: u,
        isRoot: o(this.instance),
        offset: i(this.instance)
      });
    }
    resetTransform() {
      if (!a)
        return;
      const u = this.isLayoutDirty || this.shouldResetTransform, h = this.projectionDelta && !pp(this.projectionDelta), f = this.getTransformTemplate(), m = f ? f(this.latestValues, "") : void 0, g = m !== this.prevTransformTemplateValue;
      u && (h || vr(this.latestValues) || g) && (a(this.instance, m), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(u = !0) {
      const h = this.measurePageBox();
      let f = this.removeElementScroll(h);
      return u && (f = this.removeTransform(f)), z2(f), {
        animationId: this.root.animationId,
        measuredBox: h,
        layoutBox: f,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: u } = this.options;
      if (!u)
        return pt();
      const h = u.measureViewportBox(), { scroll: f } = this.root;
      return f && (Jn(h.x, f.offset.x), Jn(h.y, f.offset.y)), h;
    }
    removeElementScroll(u) {
      const h = pt();
      sn(h, u);
      for (let f = 0; f < this.path.length; f++) {
        const m = this.path[f], { scroll: g, options: x } = m;
        if (m !== this.root && g && x.layoutScroll) {
          if (g.isRoot) {
            sn(h, u);
            const { scroll: T } = this.root;
            T && (Jn(h.x, -T.offset.x), Jn(h.y, -T.offset.y));
          }
          Jn(h.x, g.offset.x), Jn(h.y, g.offset.y);
        }
      }
      return h;
    }
    applyTransform(u, h = !1) {
      const f = pt();
      sn(f, u);
      for (let m = 0; m < this.path.length; m++) {
        const g = this.path[m];
        !h && g.options.layoutScroll && g.scroll && g !== g.root && Hr(f, {
          x: -g.scroll.offset.x,
          y: -g.scroll.offset.y
        }), vr(g.latestValues) && Hr(f, g.latestValues);
      }
      return vr(this.latestValues) && Hr(f, this.latestValues), f;
    }
    removeTransform(u) {
      const h = pt();
      sn(h, u);
      for (let f = 0; f < this.path.length; f++) {
        const m = this.path[f];
        if (!m.instance || !vr(m.latestValues))
          continue;
        gl(m.latestValues) && m.updateSnapshot();
        const g = pt(), x = m.measurePageBox();
        sn(g, x), xh(h, m.latestValues, m.snapshot ? m.snapshot.layoutBox : void 0, g);
      }
      return vr(this.latestValues) && xh(h, this.latestValues), h;
    }
    setTargetDelta(u) {
      this.targetDelta = u, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(u) {
      this.options = {
        ...this.options,
        ...u,
        crossfade: u.crossfade !== void 0 ? u.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== wt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(u = !1) {
      var h;
      const f = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = f.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = f.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = f.isSharedProjectionDirty);
      const m = !!this.resumingFrom || this !== f;
      if (!(u || m && this.isSharedProjectionDirty || this.isProjectionDirty || !((h = this.parent) === null || h === void 0) && h.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: x, layoutId: T } = this.options;
      if (!(!this.layout || !(x || T))) {
        if (this.resolvedRelativeTargetAt = wt.timestamp, !this.targetDelta && !this.relativeTarget) {
          const E = this.getClosestProjectingParent();
          E && E.layout ? (this.relativeParent = E, this.forceRelativeParentToResolveTarget(), this.relativeTarget = pt(), this.relativeTargetOrigin = pt(), Ii(this.relativeTargetOrigin, this.layout.layoutBox, E.layout.layoutBox), sn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = pt(), this.targetWithTransforms = pt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Hk(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : sn(this.target, this.layout.layoutBox), up(this.target, this.targetDelta)) : sn(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const E = this.getClosestProjectingParent();
            E && !!E.resumingFrom == !!this.resumingFrom && !E.options.layoutScroll && E.target ? (this.relativeParent = E, this.forceRelativeParentToResolveTarget(), this.relativeTarget = pt(), this.relativeTargetOrigin = pt(), Ii(this.relativeTargetOrigin, this.target, E.target), sn(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          br.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || gl(this.parent.latestValues) || lp(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var u;
      const h = this.getLead(), f = !!this.resumingFrom || this !== h;
      let m = !0;
      if ((this.isProjectionDirty || !((u = this.parent) === null || u === void 0) && u.isProjectionDirty) && (m = !1), f && (this.isSharedProjectionDirty || this.isTransformDirty) && (m = !1), this.resolvedRelativeTargetAt === wt.timestamp && (m = !1), m)
        return;
      const { layout: g, layoutId: x } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(g || x))
        return;
      sn(this.layoutCorrected, this.layout.layoutBox), t2(this.layoutCorrected, this.treeScale, this.path, f);
      const { target: T } = h;
      if (!T)
        return;
      this.projectionDelta || (this.projectionDelta = Ui(), this.projectionDeltaWithTransform = Ui());
      const E = this.treeScale.x, I = this.treeScale.y, D = this.projectionTransform;
      Ri(this.projectionDelta, this.layoutCorrected, T, this.latestValues), this.projectionTransform = Th(this.projectionDelta, this.treeScale), (this.projectionTransform !== D || this.treeScale.x !== E || this.treeScale.y !== I) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", T)), br.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(u = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), u) {
        const h = this.getStack();
        h && h.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(u, h = !1) {
      const f = this.snapshot, m = f ? f.latestValues : {}, g = { ...this.latestValues }, x = Ui();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !h;
      const T = pt(), E = f ? f.source : void 0, I = this.layout ? this.layout.source : void 0, D = E !== I, W = this.getStack(), F = !W || W.members.length <= 1, z = !!(D && !F && this.options.crossfade === !0 && !this.path.some(B2));
      this.animationProgress = 0;
      let L;
      this.mixTargetDelta = (G) => {
        const Q = G / 1e3;
        Eh(x.x, u.x, Q), Eh(x.y, u.y, Q), this.setTargetDelta(x), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Ii(T, this.layout.layoutBox, this.relativeParent.layout.layoutBox), V2(this.relativeTarget, this.relativeTargetOrigin, T, Q), L && bl(this.relativeTarget, L) && (this.isProjectionDirty = !1), L || (L = pt()), sn(L, this.relativeTarget)), D && (this.animationValues = g, m2(g, m, this.latestValues, Q, z, F)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = Q;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(u) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Vn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ot.update(() => {
        Ei.hasAnimatedSinceResize = !0, this.currentAnimation = $2(0, Sh, {
          ...u,
          onUpdate: (h) => {
            this.mixTargetDelta(h), u.onUpdate && u.onUpdate(h);
          },
          onComplete: () => {
            u.onComplete && u.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const u = this.getStack();
      u && u.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Sh), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const u = this.getLead();
      let { targetWithTransforms: h, target: f, layout: m, latestValues: g } = u;
      if (!(!h || !f || !m)) {
        if (this !== u && this.layout && m && gp(this.options.animationType, this.layout.layoutBox, m.layoutBox)) {
          f = this.target || pt();
          const x = Zt(this.layout.layoutBox.x);
          f.x.min = u.target.x.min, f.x.max = f.x.min + x;
          const T = Zt(this.layout.layoutBox.y);
          f.y.min = u.target.y.min, f.y.max = f.y.min + T;
        }
        sn(h, f), Hr(h, g), Ri(this.projectionDeltaWithTransform, this.layoutCorrected, h, g);
      }
    }
    registerSharedNode(u, h) {
      this.sharedNodes.has(u) || this.sharedNodes.set(u, new w2()), this.sharedNodes.get(u).add(h);
      const m = h.options.initialPromotionConfig;
      h.promote({
        transition: m ? m.transition : void 0,
        preserveFollowOpacity: m && m.shouldPreserveFollowOpacity ? m.shouldPreserveFollowOpacity(h) : void 0
      });
    }
    isLead() {
      const u = this.getStack();
      return u ? u.lead === this : !0;
    }
    getLead() {
      var u;
      const { layoutId: h } = this.options;
      return h ? ((u = this.getStack()) === null || u === void 0 ? void 0 : u.lead) || this : this;
    }
    getPrevLead() {
      var u;
      const { layoutId: h } = this.options;
      return h ? (u = this.getStack()) === null || u === void 0 ? void 0 : u.prevLead : void 0;
    }
    getStack() {
      const { layoutId: u } = this.options;
      if (u)
        return this.root.sharedNodes.get(u);
    }
    promote({ needsReset: u, transition: h, preserveFollowOpacity: f } = {}) {
      const m = this.getStack();
      m && m.promote(this, f), u && (this.projectionDelta = void 0, this.needsReset = !0), h && this.setOptions({ transition: h });
    }
    relegate() {
      const u = this.getStack();
      return u ? u.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: u } = this.options;
      if (!u)
        return;
      let h = !1;
      const { latestValues: f } = u;
      if ((f.rotate || f.rotateX || f.rotateY || f.rotateZ) && (h = !0), !h)
        return;
      const m = {};
      for (let g = 0; g < _h.length; g++) {
        const x = "rotate" + _h[g];
        f[x] && (m[x] = f[x], u.setStaticValue(x, 0));
      }
      u.render();
      for (const g in m)
        u.setStaticValue(g, m[g]);
      u.scheduleRender();
    }
    getProjectionStyles(u = {}) {
      var h, f;
      const m = {};
      if (!this.instance || this.isSVG)
        return m;
      if (this.isVisible)
        m.visibility = "";
      else
        return { visibility: "hidden" };
      const g = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, m.opacity = "", m.pointerEvents = Ko(u.pointerEvents) || "", m.transform = g ? g(this.latestValues, "") : "none", m;
      const x = this.getLead();
      if (!this.projectionDelta || !this.layout || !x.target) {
        const D = {};
        return this.options.layoutId && (D.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, D.pointerEvents = Ko(u.pointerEvents) || ""), this.hasProjected && !vr(this.latestValues) && (D.transform = g ? g({}, "") : "none", this.hasProjected = !1), D;
      }
      const T = x.animationValues || x.latestValues;
      this.applyTransformsToTarget(), m.transform = Th(this.projectionDeltaWithTransform, this.treeScale, T), g && (m.transform = g(T, m.transform));
      const { x: E, y: I } = this.projectionDelta;
      m.transformOrigin = `${E.origin * 100}% ${I.origin * 100}% 0`, x.animationValues ? m.opacity = x === this ? (f = (h = T.opacity) !== null && h !== void 0 ? h : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : T.opacityExit : m.opacity = x === this ? T.opacity !== void 0 ? T.opacity : "" : T.opacityExit !== void 0 ? T.opacityExit : 0;
      for (const D in Jo) {
        if (T[D] === void 0)
          continue;
        const { correct: W, applyTo: F } = Jo[D], z = m.transform === "none" ? T[D] : W(T[D], x);
        if (F) {
          const L = F.length;
          for (let G = 0; G < L; G++)
            m[F[G]] = z;
        } else
          m[D] = z;
      }
      return this.options.layoutId && (m.pointerEvents = x === this ? Ko(u.pointerEvents) || "" : "none"), m;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((u) => {
        var h;
        return (h = u.currentAnimation) === null || h === void 0 ? void 0 : h.stop();
      }), this.root.nodes.forEach(Ch), this.root.sharedNodes.clear();
    }
  };
}
function P2(e) {
  e.updateLayout();
}
function A2(e) {
  var n;
  const i = ((n = e.resumeFrom) === null || n === void 0 ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && i && e.hasListeners("didUpdate")) {
    const { layoutBox: o, measuredBox: a } = e.layout, { animationType: c } = e.options, u = i.source !== e.layout.source;
    c === "size" ? wn((x) => {
      const T = u ? i.measuredBox[x] : i.layoutBox[x], E = Zt(T);
      T.min = o[x].min, T.max = T.min + E;
    }) : gp(c, i.layoutBox, o) && wn((x) => {
      const T = u ? i.measuredBox[x] : i.layoutBox[x], E = Zt(o[x]);
      T.max = T.min + E, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[x].max = e.relativeTarget[x].min + E);
    });
    const h = Ui();
    Ri(h, o, i.layoutBox);
    const f = Ui();
    u ? Ri(f, e.applyTransform(a, !0), i.measuredBox) : Ri(f, o, i.layoutBox);
    const m = !pp(h);
    let g = !1;
    if (!e.resumeFrom) {
      const x = e.getClosestProjectingParent();
      if (x && !x.resumeFrom) {
        const { snapshot: T, layout: E } = x;
        if (T && E) {
          const I = pt();
          Ii(I, i.layoutBox, T.layoutBox);
          const D = pt();
          Ii(D, o, E.layoutBox), bl(I, D) || (g = !0), x.options.layoutRoot && (e.relativeTarget = D, e.relativeTargetOrigin = I, e.relativeParent = x);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: o,
      snapshot: i,
      delta: f,
      layoutDelta: h,
      hasLayoutChanged: m,
      hasRelativeTargetChanged: g
    });
  } else if (e.isLead()) {
    const { onExitComplete: o } = e.options;
    o && o();
  }
  e.options.transition = void 0;
}
function R2(e) {
  br.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function I2(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function U2(e) {
  e.clearSnapshot();
}
function Ch(e) {
  e.clearMeasurements();
}
function D2(e) {
  const { visualElement: n } = e.options;
  n && n.getProps().onBeforeLayoutMeasure && n.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function $h(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function M2(e) {
  e.resolveTargetDelta();
}
function O2(e) {
  e.calcProjection();
}
function L2(e) {
  e.resetRotation();
}
function F2(e) {
  e.removeLeadSnapshot();
}
function Eh(e, n, i) {
  e.translate = lt(n.translate, 0, i), e.scale = lt(n.scale, 1, i), e.origin = n.origin, e.originPoint = n.originPoint;
}
function Ph(e, n, i, o) {
  e.min = lt(n.min, i.min, o), e.max = lt(n.max, i.max, o);
}
function V2(e, n, i, o) {
  Ph(e.x, n.x, i.x, o), Ph(e.y, n.y, i.y, o);
}
function B2(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const N2 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function W2(e, n) {
  let i = e.root;
  for (let c = e.path.length - 1; c >= 0; c--)
    if (e.path[c].instance) {
      i = e.path[c];
      break;
    }
  const a = (i && i !== e.root ? i.instance : document).querySelector(`[data-projection-id="${n}"]`);
  a && e.mount(a, !0);
}
function Ah(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function z2(e) {
  Ah(e.x), Ah(e.y);
}
function gp(e, n, i) {
  return e === "position" || e === "preserve-aspect" && !pl(kh(n), kh(i), 0.2);
}
const j2 = mp({
  attachResizeListener: (e, n) => On(e, "resize", n),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Ya = {
  current: void 0
}, vp = mp({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Ya.current) {
      const e = new j2(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Ya.current = e;
    }
    return Ya.current;
  },
  resetTransform: (e, n) => {
    e.style.transform = n !== void 0 ? n : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), G2 = {
  pan: {
    Feature: u2
  },
  drag: {
    Feature: l2,
    ProjectionNode: vp,
    MeasureLayout: fp
  }
}, H2 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function q2(e) {
  const n = H2.exec(e);
  if (!n)
    return [,];
  const [, i, o] = n;
  return [i, o];
}
const Y2 = 4;
function yl(e, n, i = 1) {
  gn(i <= Y2, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [o, a] = q2(e);
  if (!o)
    return;
  const c = window.getComputedStyle(n).getPropertyValue(o);
  return c ? c.trim() : sl(a) ? yl(a, n, i + 1) : a;
}
function K2(e, { ...n }, i) {
  const o = e.current;
  if (!(o instanceof Element))
    return { target: n, transitionEnd: i };
  i && (i = { ...i }), e.values.forEach((a) => {
    const c = a.get();
    if (!sl(c))
      return;
    const u = yl(c, o);
    u && a.set(u);
  });
  for (const a in n) {
    const c = n[a];
    if (!sl(c))
      continue;
    const u = yl(c, o);
    u && (n[a] = u, i || (i = {}), i[a] === void 0 && (i[a] = c));
  }
  return { target: n, transitionEnd: i };
}
const Z2 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), bp = (e) => Z2.has(e), X2 = (e) => Object.keys(e).some(bp), Go = (e) => e === Sr || e === ke, Rh = (e, n) => parseFloat(e.split(", ")[n]), Ih = (e, n) => (i, { transform: o }) => {
  if (o === "none" || !o)
    return 0;
  const a = o.match(/^matrix3d\((.+)\)$/);
  if (a)
    return Rh(a[1], n);
  {
    const c = o.match(/^matrix\((.+)\)$/);
    return c ? Rh(c[1], e) : 0;
  }
}, J2 = /* @__PURE__ */ new Set(["x", "y", "z"]), Q2 = Wi.filter((e) => !J2.has(e));
function eT(e) {
  const n = [];
  return Q2.forEach((i) => {
    const o = e.getValue(i);
    o !== void 0 && (n.push([i, o.get()]), o.set(i.startsWith("scale") ? 1 : 0));
  }), n.length && e.render(), n;
}
const Uh = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: n = "0", paddingRight: i = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(i),
  height: ({ y: e }, { paddingTop: n = "0", paddingBottom: i = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(i),
  top: (e, { top: n }) => parseFloat(n),
  left: (e, { left: n }) => parseFloat(n),
  bottom: ({ y: e }, { top: n }) => parseFloat(n) + (e.max - e.min),
  right: ({ x: e }, { left: n }) => parseFloat(n) + (e.max - e.min),
  // Transform
  x: Ih(4, 13),
  y: Ih(5, 14)
}, tT = (e, n, i) => {
  const o = n.measureViewportBox(), a = n.current, c = getComputedStyle(a), { display: u } = c, h = {};
  u === "none" && n.setStaticValue("display", e.display || "block"), i.forEach((m) => {
    h[m] = Uh[m](o, c);
  }), n.render();
  const f = n.measureViewportBox();
  return i.forEach((m) => {
    const g = n.getValue(m);
    g && g.jump(h[m]), e[m] = Uh[m](f, c);
  }), e;
}, nT = (e, n, i = {}, o = {}) => {
  n = { ...n }, o = { ...o };
  const a = Object.keys(n).filter(bp);
  let c = [], u = !1;
  const h = [];
  if (a.forEach((f) => {
    const m = e.getValue(f);
    if (!e.hasValue(f))
      return;
    let g = i[f], x = Si(g);
    const T = n[f];
    let E;
    if (es(T)) {
      const I = T.length, D = T[0] === null ? 1 : 0;
      g = T[D], x = Si(g);
      for (let W = D; W < I && T[W] !== null; W++)
        E ? gn(Si(T[W]) === E, "All keyframes must be of the same type") : (E = Si(T[W]), gn(E === x || Go(x) && Go(E), "Keyframes must be of the same dimension as the current value"));
    } else
      E = Si(T);
    if (x !== E)
      if (Go(x) && Go(E)) {
        const I = m.get();
        typeof I == "string" && m.set(parseFloat(I)), typeof T == "string" ? n[f] = parseFloat(T) : Array.isArray(T) && E === ke && (n[f] = T.map(parseFloat));
      } else
        x != null && x.transform && (E != null && E.transform) && (g === 0 || T === 0) ? g === 0 ? m.set(E.transform(g)) : n[f] = x.transform(T) : (u || (c = eT(e), u = !0), h.push(f), o[f] = o[f] !== void 0 ? o[f] : n[f], m.jump(T));
  }), h.length) {
    const f = h.indexOf("height") >= 0 ? window.pageYOffset : null, m = tT(n, e, h);
    return c.length && c.forEach(([g, x]) => {
      e.getValue(g).set(x);
    }), e.render(), ds && f !== null && window.scrollTo({ top: f }), { target: m, transitionEnd: o };
  } else
    return { target: n, transitionEnd: o };
};
function rT(e, n, i, o) {
  return X2(n) ? nT(e, n, i, o) : { target: n, transitionEnd: o };
}
const iT = (e, n, i, o) => {
  const a = K2(e, n, o);
  return n = a.target, o = a.transitionEnd, rT(e, n, i, o);
}, xl = { current: null }, yp = { current: !1 };
function oT() {
  if (yp.current = !0, !!ds)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), n = () => xl.current = e.matches;
      e.addListener(n), n();
    } else
      xl.current = !1;
}
function sT(e, n, i) {
  const { willChange: o } = n;
  for (const a in n) {
    const c = n[a], u = i[a];
    if (zt(c))
      e.addValue(a, c), is(o) && o.add(a), process.env.NODE_ENV === "development" && tu(c.version === "10.12.4", `Attempting to mix Framer Motion versions ${c.version} with 10.12.4 may not work as expected.`);
    else if (zt(u))
      e.addValue(a, Kr(c, { owner: e })), is(o) && o.remove(a);
    else if (u !== c)
      if (e.hasValue(a)) {
        const h = e.getValue(a);
        !h.hasAnimated && h.set(c);
      } else {
        const h = e.getStaticValue(a);
        e.addValue(a, Kr(h !== void 0 ? h : c, { owner: e }));
      }
  }
  for (const a in i)
    n[a] === void 0 && e.removeValue(a);
  return n;
}
const Dh = /* @__PURE__ */ new WeakMap(), xp = Object.keys(Oi), aT = xp.length, Mh = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], lT = Ml.length;
class uT {
  constructor({ parent: n, props: i, presenceContext: o, reducedMotionConfig: a, visualState: c }, u = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => ot.render(this.render, !1, !0);
    const { latestValues: h, renderState: f } = c;
    this.latestValues = h, this.baseTarget = { ...h }, this.initialValues = i.initial ? { ...h } : {}, this.renderState = f, this.parent = n, this.props = i, this.presenceContext = o, this.depth = n ? n.depth + 1 : 0, this.reducedMotionConfig = a, this.options = u, this.isControllingVariants = ms(i), this.isVariantNode = ad(i), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(n && n.current);
    const { willChange: m, ...g } = this.scrapeMotionValuesFromProps(i, {});
    for (const x in g) {
      const T = g[x];
      h[x] !== void 0 && zt(T) && (T.set(h[x], !1), is(m) && m.add(x));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(n, i) {
    return {};
  }
  mount(n) {
    this.current = n, Dh.set(n, this), this.projection && this.projection.mount(n), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((i, o) => this.bindToMotionValue(o, i)), yp.current || oT(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : xl.current, process.env.NODE_ENV !== "production" && tu(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Dh.delete(this.current), this.projection && this.projection.unmount(), Vn(this.notifyUpdate), Vn(this.render), this.valueSubscriptions.forEach((n) => n()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features)
      this.features[n].unmount();
    this.current = null;
  }
  bindToMotionValue(n, i) {
    const o = _r.has(n), a = i.on("change", (u) => {
      this.latestValues[n] = u, this.props.onUpdate && ot.update(this.notifyUpdate, !1, !0), o && this.projection && (this.projection.isTransformDirty = !0);
    }), c = i.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(n, () => {
      a(), c();
    });
  }
  sortNodePosition(n) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== n.type ? 0 : this.sortInstanceNodePosition(this.current, n.current);
  }
  loadFeatures({ children: n, ...i }, o, a, c, u) {
    let h, f;
    if (process.env.NODE_ENV !== "production" && a && o) {
      const m = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      i.ignoreStrict ? Gi(!1, m) : gn(!1, m);
    }
    for (let m = 0; m < aT; m++) {
      const g = xp[m], { isEnabled: x, Feature: T, ProjectionNode: E, MeasureLayout: I } = Oi[g];
      E && (h = E), x(i) && (!this.features[g] && T && (this.features[g] = new T(this)), I && (f = I));
    }
    if (!this.projection && h) {
      this.projection = new h(c, this.latestValues, this.parent && this.parent.projection);
      const { layoutId: m, layout: g, drag: x, dragConstraints: T, layoutScroll: E, layoutRoot: I } = i;
      this.projection.setOptions({
        layoutId: m,
        layout: g,
        alwaysMeasureLayout: !!x || T && jr(T),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof g == "string" ? g : "both",
        initialPromotionConfig: u,
        layoutScroll: E,
        layoutRoot: I
      });
    }
    return f;
  }
  updateFeatures() {
    for (const n in this.features) {
      const i = this.features[n];
      i.isMounted ? i.update(this.props, this.prevProps) : (i.mount(), i.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : pt();
  }
  getStaticValue(n) {
    return this.latestValues[n];
  }
  setStaticValue(n, i) {
    this.latestValues[n] = i;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(n, i = !0) {
    return this.makeTargetAnimatableFromInstance(n, this.props, i);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(n, i) {
    (n.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = n, this.prevPresenceContext = this.presenceContext, this.presenceContext = i;
    for (let o = 0; o < Mh.length; o++) {
      const a = Mh[o];
      this.propEventSubscriptions[a] && (this.propEventSubscriptions[a](), delete this.propEventSubscriptions[a]);
      const c = n["on" + a];
      c && (this.propEventSubscriptions[a] = this.on(a, c));
    }
    this.prevMotionValues = sT(this, this.scrapeMotionValuesFromProps(n, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(n) {
    return this.props.variants ? this.props.variants[n] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(n = !1) {
    if (n)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const o = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (o.initial = this.props.initial), o;
    }
    const i = {};
    for (let o = 0; o < lT; o++) {
      const a = Ml[o], c = this.props[a];
      (Mi(c) || c === !1) && (i[a] = c);
    }
    return i;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(n) {
    const i = this.getClosestVariantNode();
    if (i)
      return i.variantChildren && i.variantChildren.add(n), () => i.variantChildren.delete(n);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(n, i) {
    i !== this.values.get(n) && (this.removeValue(n), this.bindToMotionValue(n, i)), this.values.set(n, i), this.latestValues[n] = i.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(n) {
    this.values.delete(n);
    const i = this.valueSubscriptions.get(n);
    i && (i(), this.valueSubscriptions.delete(n)), delete this.latestValues[n], this.removeValueFromRenderState(n, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(n) {
    return this.values.has(n);
  }
  getValue(n, i) {
    if (this.props.values && this.props.values[n])
      return this.props.values[n];
    let o = this.values.get(n);
    return o === void 0 && i !== void 0 && (o = Kr(i, { owner: this }), this.addValue(n, o)), o;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(n) {
    return this.latestValues[n] !== void 0 || !this.current ? this.latestValues[n] : this.readValueFromInstance(this.current, n, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(n, i) {
    this.baseTarget[n] = i;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(n) {
    var i;
    const { initial: o } = this.props, a = typeof o == "string" || typeof o == "object" ? (i = Gl(this.props, o)) === null || i === void 0 ? void 0 : i[n] : void 0;
    if (o && a !== void 0)
      return a;
    const c = this.getBaseTargetFromProps(this.props, n);
    return c !== void 0 && !zt(c) ? c : this.initialValues[n] !== void 0 && a === void 0 ? void 0 : this.baseTarget[n];
  }
  on(n, i) {
    return this.events[n] || (this.events[n] = new eu()), this.events[n].add(i);
  }
  notify(n, ...i) {
    this.events[n] && this.events[n].notify(...i);
  }
}
class wp extends uT {
  sortInstanceNodePosition(n, i) {
    return n.compareDocumentPosition(i) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(n, i) {
    return n.style ? n.style[i] : void 0;
  }
  removeValueFromRenderState(n, { vars: i, style: o }) {
    delete i[n], delete o[n];
  }
  makeTargetAnimatableFromInstance({ transition: n, transitionEnd: i, ...o }, { transformValues: a }, c) {
    let u = Ek(o, n || {}, this);
    if (a && (i && (i = a(i)), o && (o = a(o)), u && (u = a(u))), c) {
      Ck(this, o, u);
      const h = iT(this, o, u, i);
      i = h.transitionEnd, o = h.target;
    }
    return {
      transition: n,
      transitionEnd: i,
      ...o
    };
  }
}
function cT(e) {
  return window.getComputedStyle(e);
}
class fT extends wp {
  readValueFromInstance(n, i) {
    if (_r.has(i)) {
      const o = Kl(i);
      return o && o.default || 0;
    } else {
      const o = cT(n), a = (fd(i) ? o.getPropertyValue(i) : o[i]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(n, { transformPagePoint: i }) {
    return cp(n, i);
  }
  build(n, i, o, a) {
    Vl(n, i, o, a.transformTemplate);
  }
  scrapeMotionValuesFromProps(n, i) {
    return jl(n, i);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: n } = this.props;
    zt(n) && (this.childSubscription = n.on("change", (i) => {
      this.current && (this.current.textContent = `${i}`);
    }));
  }
  renderInstance(n, i, o, a) {
    vd(n, i, o, a);
  }
}
class hT extends wp {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(n, i) {
    return n[i];
  }
  readValueFromInstance(n, i) {
    if (_r.has(i)) {
      const o = Kl(i);
      return o && o.default || 0;
    }
    return i = bd.has(i) ? i : zl(i), n.getAttribute(i);
  }
  measureInstanceViewportBox() {
    return pt();
  }
  scrapeMotionValuesFromProps(n, i) {
    return xd(n, i);
  }
  build(n, i, o, a) {
    Nl(n, i, o, this.isSVGTag, a.transformTemplate);
  }
  renderInstance(n, i, o, a) {
    yd(n, i, o, a);
  }
  mount(n) {
    this.isSVGTag = Wl(n.tagName), super.mount(n);
  }
}
const dT = (e, n) => Fl(e) ? new hT(n, { enableHardwareAcceleration: !1 }) : new fT(n, { enableHardwareAcceleration: !0 }), pT = {
  layout: {
    ProjectionNode: vp,
    MeasureLayout: fp
  }
}, mT = {
  ...Wk,
  ...cw,
  ...G2,
  ...pT
}, vn = /* @__PURE__ */ bx((e, n) => qx(e, n, mT, dT));
function kp() {
  const e = un(!1);
  return Xo(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function gT() {
  const e = kp(), [n, i] = nt(0), o = an(() => {
    e.current && i(n + 1);
  }, [n]);
  return [an(() => ot.postRender(o), [o]), n];
}
class vT extends se.Component {
  getSnapshotBeforeUpdate(n) {
    const i = this.props.childRef.current;
    if (i && n.isPresent && !this.props.isPresent) {
      const o = this.props.sizeRef.current;
      o.height = i.offsetHeight || 0, o.width = i.offsetWidth || 0, o.top = i.offsetTop, o.left = i.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function bT({ children: e, isPresent: n }) {
  const i = Il(), o = un(null), a = un({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return nd(() => {
    const { width: c, height: u, top: h, left: f } = a.current;
    if (n || !o.current || !c || !u)
      return;
    o.current.dataset.motionPopId = i;
    const m = document.createElement("style");
    return document.head.appendChild(m), m.sheet && m.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${c}px !important;
            height: ${u}px !important;
            top: ${h}px !important;
            left: ${f}px !important;
          }
        `), () => {
      document.head.removeChild(m);
    };
  }, [n]), se.createElement(vT, { isPresent: n, childRef: o, sizeRef: a }, se.cloneElement(e, { ref: o }));
}
const Ka = ({ children: e, initial: n, isPresent: i, onExitComplete: o, custom: a, presenceAffectsLayout: c, mode: u }) => {
  const h = Ol(yT), f = Il(), m = Wt(
    () => ({
      id: f,
      initial: n,
      isPresent: i,
      custom: a,
      onExitComplete: (g) => {
        h.set(g, !0);
        for (const x of h.values())
          if (!x)
            return;
        o && o();
      },
      register: (g) => (h.set(g, !1), () => h.delete(g))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    c ? void 0 : [i]
  );
  return Wt(() => {
    h.forEach((g, x) => h.set(x, !1));
  }, [i]), se.useEffect(() => {
    !i && !h.size && o && o();
  }, [i]), u === "popLayout" && (e = se.createElement(bT, { isPresent: i }, e)), se.createElement(hs.Provider, { value: m }, e);
};
function yT() {
  return /* @__PURE__ */ new Map();
}
function xT(e) {
  return mt(() => () => e(), []);
}
const zr = (e) => e.key || "";
function wT(e, n) {
  e.forEach((i) => {
    const o = zr(i);
    n.set(o, i);
  });
}
function kT(e) {
  const n = [];
  return Jy.forEach(e, (i) => {
    Qy(i) && n.push(i);
  }), n;
}
const _n = ({ children: e, custom: n, initial: i = !0, onExitComplete: o, exitBeforeEnter: a, presenceAffectsLayout: c = !0, mode: u = "sync" }) => {
  gn(!a, "Replace exitBeforeEnter with mode='wait'");
  let [h] = gT();
  const f = It(Ll).forceRender;
  f && (h = f);
  const m = kp(), g = kT(e);
  let x = g;
  const T = /* @__PURE__ */ new Set(), E = un(x), I = un(/* @__PURE__ */ new Map()).current, D = un(!0);
  if (Xo(() => {
    D.current = !1, wT(g, I), E.current = x;
  }), xT(() => {
    D.current = !0, I.clear(), T.clear();
  }), D.current)
    return se.createElement(se.Fragment, null, x.map((L) => se.createElement(Ka, { key: zr(L), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: c, mode: u }, L)));
  x = [...x];
  const W = E.current.map(zr), F = g.map(zr), z = W.length;
  for (let L = 0; L < z; L++) {
    const G = W[L];
    F.indexOf(G) === -1 && T.add(G);
  }
  return u === "wait" && T.size && (x = []), T.forEach((L) => {
    if (F.indexOf(L) !== -1)
      return;
    const G = I.get(L);
    if (!G)
      return;
    const Q = W.indexOf(L), fe = () => {
      I.delete(L), T.delete(L);
      const ge = E.current.findIndex((he) => he.key === L);
      if (E.current.splice(ge, 1), !T.size) {
        if (E.current = g, m.current === !1)
          return;
        h(), o && o();
      }
    };
    x.splice(Q, 0, se.createElement(Ka, { key: zr(G), isPresent: !1, onExitComplete: fe, custom: n, presenceAffectsLayout: c, mode: u }, G));
  }), x = x.map((L) => {
    const G = L.key;
    return T.has(G) ? L : se.createElement(Ka, { key: zr(L), isPresent: !0, presenceAffectsLayout: c, mode: u }, L);
  }), process.env.NODE_ENV !== "production" && u === "wait" && x.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), se.createElement(se.Fragment, null, T.size ? x : x.map((L) => Xy(L)));
};
function ss() {
  return ss = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
    }
    return e;
  }, ss.apply(this, arguments);
}
function TT(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vi(e, n) {
  return Vi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, a) {
    return o.__proto__ = a, o;
  }, Vi(e, n);
}
function _T(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Vi(e, n);
}
function wl(e) {
  return wl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, wl(e);
}
function ST(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function CT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Zo(e, n, i) {
  return CT() ? Zo = Reflect.construct.bind() : Zo = function(a, c, u) {
    var h = [null];
    h.push.apply(h, c);
    var f = Function.bind.apply(a, h), m = new f();
    return u && Vi(m, u.prototype), m;
  }, Zo.apply(null, arguments);
}
function kl(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return kl = function(o) {
    if (o === null || !ST(o))
      return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(o))
        return n.get(o);
      n.set(o, a);
    }
    function a() {
      return Zo(o, arguments, wl(this).constructor);
    }
    return a.prototype = Object.create(o.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Vi(a, o);
  }, kl(e);
}
var $T = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function ET() {
  for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
    n[i] = arguments[i];
  var o = n[0], a = [], c;
  for (c = 1; c < n.length; c += 1)
    a.push(n[c]);
  return a.forEach(function(u) {
    o = o.replace(/%[a-z]/, u);
  }), o;
}
var kn = /* @__PURE__ */ function(e) {
  _T(n, e);
  function n(i) {
    var o;
    if (process.env.NODE_ENV === "production")
      o = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + i + " for more information.") || this;
    else {
      for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
        c[u - 1] = arguments[u];
      o = e.call(this, ET.apply(void 0, [$T[i]].concat(c))) || this;
    }
    return TT(o);
  }
  return n;
}(/* @__PURE__ */ kl(Error));
function Za(e) {
  return Math.round(e * 255);
}
function PT(e, n, i) {
  return Za(e) + "," + Za(n) + "," + Za(i);
}
function Bi(e, n, i, o) {
  if (o === void 0 && (o = PT), n === 0)
    return o(i, i, i);
  var a = (e % 360 + 360) % 360 / 60, c = (1 - Math.abs(2 * i - 1)) * n, u = c * (1 - Math.abs(a % 2 - 1)), h = 0, f = 0, m = 0;
  a >= 0 && a < 1 ? (h = c, f = u) : a >= 1 && a < 2 ? (h = u, f = c) : a >= 2 && a < 3 ? (f = c, m = u) : a >= 3 && a < 4 ? (f = u, m = c) : a >= 4 && a < 5 ? (h = u, m = c) : a >= 5 && a < 6 && (h = c, m = u);
  var g = i - c / 2, x = h + g, T = f + g, E = m + g;
  return o(x, T, E);
}
var Oh = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function AT(e) {
  if (typeof e != "string")
    return e;
  var n = e.toLowerCase();
  return Oh[n] ? "#" + Oh[n] : e;
}
var RT = /^#[a-fA-F0-9]{6}$/, IT = /^#[a-fA-F0-9]{8}$/, UT = /^#[a-fA-F0-9]{3}$/, DT = /^#[a-fA-F0-9]{4}$/, Xa = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, MT = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, OT = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, LT = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function Tp(e) {
  if (typeof e != "string")
    throw new kn(3);
  var n = AT(e);
  if (n.match(RT))
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16)
    };
  if (n.match(IT)) {
    var i = parseFloat((parseInt("" + n[7] + n[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16),
      alpha: i
    };
  }
  if (n.match(UT))
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16)
    };
  if (n.match(DT)) {
    var o = parseFloat((parseInt("" + n[4] + n[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16),
      alpha: o
    };
  }
  var a = Xa.exec(n);
  if (a)
    return {
      red: parseInt("" + a[1], 10),
      green: parseInt("" + a[2], 10),
      blue: parseInt("" + a[3], 10)
    };
  var c = MT.exec(n.substring(0, 50));
  if (c)
    return {
      red: parseInt("" + c[1], 10),
      green: parseInt("" + c[2], 10),
      blue: parseInt("" + c[3], 10),
      alpha: parseFloat("" + c[4]) > 1 ? parseFloat("" + c[4]) / 100 : parseFloat("" + c[4])
    };
  var u = OT.exec(n);
  if (u) {
    var h = parseInt("" + u[1], 10), f = parseInt("" + u[2], 10) / 100, m = parseInt("" + u[3], 10) / 100, g = "rgb(" + Bi(h, f, m) + ")", x = Xa.exec(g);
    if (!x)
      throw new kn(4, n, g);
    return {
      red: parseInt("" + x[1], 10),
      green: parseInt("" + x[2], 10),
      blue: parseInt("" + x[3], 10)
    };
  }
  var T = LT.exec(n.substring(0, 50));
  if (T) {
    var E = parseInt("" + T[1], 10), I = parseInt("" + T[2], 10) / 100, D = parseInt("" + T[3], 10) / 100, W = "rgb(" + Bi(E, I, D) + ")", F = Xa.exec(W);
    if (!F)
      throw new kn(4, n, W);
    return {
      red: parseInt("" + F[1], 10),
      green: parseInt("" + F[2], 10),
      blue: parseInt("" + F[3], 10),
      alpha: parseFloat("" + T[4]) > 1 ? parseFloat("" + T[4]) / 100 : parseFloat("" + T[4])
    };
  }
  throw new kn(5);
}
function FT(e) {
  var n = e.red / 255, i = e.green / 255, o = e.blue / 255, a = Math.max(n, i, o), c = Math.min(n, i, o), u = (a + c) / 2;
  if (a === c)
    return e.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: u,
      alpha: e.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: u
    };
  var h, f = a - c, m = u > 0.5 ? f / (2 - a - c) : f / (a + c);
  switch (a) {
    case n:
      h = (i - o) / f + (i < o ? 6 : 0);
      break;
    case i:
      h = (o - n) / f + 2;
      break;
    default:
      h = (n - i) / f + 4;
      break;
  }
  return h *= 60, e.alpha !== void 0 ? {
    hue: h,
    saturation: m,
    lightness: u,
    alpha: e.alpha
  } : {
    hue: h,
    saturation: m,
    lightness: u
  };
}
function _p(e) {
  return FT(Tp(e));
}
var VT = function(n) {
  return n.length === 7 && n[1] === n[2] && n[3] === n[4] && n[5] === n[6] ? "#" + n[1] + n[3] + n[5] : n;
}, Tl = VT;
function yr(e) {
  var n = e.toString(16);
  return n.length === 1 ? "0" + n : n;
}
function Ja(e) {
  return yr(Math.round(e * 255));
}
function BT(e, n, i) {
  return Tl("#" + Ja(e) + Ja(n) + Ja(i));
}
function as(e, n, i) {
  return Bi(e, n, i, BT);
}
function NT(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return as(e, n, i);
  if (typeof e == "object" && n === void 0 && i === void 0)
    return as(e.hue, e.saturation, e.lightness);
  throw new kn(1);
}
function WT(e, n, i, o) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof o == "number")
    return o >= 1 ? as(e, n, i) : "rgba(" + Bi(e, n, i) + "," + o + ")";
  if (typeof e == "object" && n === void 0 && i === void 0 && o === void 0)
    return e.alpha >= 1 ? as(e.hue, e.saturation, e.lightness) : "rgba(" + Bi(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
  throw new kn(2);
}
function _l(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return Tl("#" + yr(e) + yr(n) + yr(i));
  if (typeof e == "object" && n === void 0 && i === void 0)
    return Tl("#" + yr(e.red) + yr(e.green) + yr(e.blue));
  throw new kn(6);
}
function zT(e, n, i, o) {
  if (typeof e == "string" && typeof n == "number") {
    var a = Tp(e);
    return "rgba(" + a.red + "," + a.green + "," + a.blue + "," + n + ")";
  } else {
    if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof o == "number")
      return o >= 1 ? _l(e, n, i) : "rgba(" + e + "," + n + "," + i + "," + o + ")";
    if (typeof e == "object" && n === void 0 && i === void 0 && o === void 0)
      return e.alpha >= 1 ? _l(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new kn(7);
}
var jT = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, GT = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && typeof n.alpha == "number";
}, HT = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, qT = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && typeof n.alpha == "number";
};
function Sp(e) {
  if (typeof e != "object")
    throw new kn(8);
  if (GT(e))
    return zT(e);
  if (jT(e))
    return _l(e);
  if (qT(e))
    return WT(e);
  if (HT(e))
    return NT(e);
  throw new kn(8);
}
function Cp(e, n, i) {
  return function() {
    var a = i.concat(Array.prototype.slice.call(arguments));
    return a.length >= n ? e.apply(this, a) : Cp(e, n, a);
  };
}
function $p(e) {
  return Cp(e, e.length, []);
}
function Ep(e, n, i) {
  return Math.max(e, Math.min(n, i));
}
function YT(e, n) {
  if (n === "transparent")
    return n;
  var i = _p(n);
  return Sp(ss({}, i, {
    lightness: Ep(0, 1, i.lightness - parseFloat(e))
  }));
}
var KT = /* @__PURE__ */ $p(YT), Je = KT;
function ZT(e, n) {
  if (n === "transparent")
    return n;
  var i = _p(n);
  return Sp(ss({}, i, {
    lightness: Ep(0, 1, i.lightness + parseFloat(e))
  }));
}
var XT = /* @__PURE__ */ $p(ZT), Pe = XT, Pp = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Lh = Ut.createContext && Ut.createContext(Pp), nr = globalThis && globalThis.__assign || function() {
  return nr = Object.assign || function(e) {
    for (var n, i = 1, o = arguments.length; i < o; i++) {
      n = arguments[i];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, nr.apply(this, arguments);
}, JT = globalThis && globalThis.__rest || function(e, n) {
  var i = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (i[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      n.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (i[o[a]] = e[o[a]]);
  return i;
};
function Ap(e) {
  return e && e.map(function(n, i) {
    return Ut.createElement(n.tag, nr({
      key: i
    }, n.attr), Ap(n.child));
  });
}
function or(e) {
  return function(n) {
    return Ut.createElement(QT, nr({
      attr: nr({}, e.attr)
    }, n), Ap(e.child));
  };
}
function QT(e) {
  var n = function(i) {
    var o = e.attr, a = e.size, c = e.title, u = JT(e, ["attr", "size", "title"]), h = a || i.size || "1em", f;
    return i.className && (f = i.className), e.className && (f = (f ? f + " " : "") + e.className), Ut.createElement("svg", nr({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, i.attr, o, u, {
      className: f,
      style: nr(nr({
        color: e.color || i.color
      }, i.style), e.style),
      height: h,
      width: h,
      xmlns: "http://www.w3.org/2000/svg"
    }), c && Ut.createElement("title", null, c), e.children);
  };
  return Lh !== void 0 ? Ut.createElement(Lh.Consumer, null, function(i) {
    return n(i);
  }) : n(Pp);
}
function Rp(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" } }] })(e);
}
function Ip(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" } }] })(e);
}
const Up = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
    border: 1px solid
      ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
  `
}, e_ = {
  default: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black[200]};
  `,
  outlined: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black[400]};
  `,
  filled: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black[200]};
  `
}, t_ = V.div`
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  height: fit-content;
  position: relative;
`, n_ = V.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0;

  label {
    font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
    color: ${({ color: e }) => e && e};
    ${({ variant: e }) => e_[e]}
  }

  input {
    border: none;
    border-radius: 5px;
    padding: 0.2rem 0.5rem;
    width: 100%;
    font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
    ${({ variant: e }) => Up[e]}
    background: ${({ background: e }) => e};
    color: ${({ color: e }) => e};
    height: 2.2rem;
    box-sizing: border-box;
    padding: 10px 15px;
    margin-top: 5px;
  }

  div {
    display: flex;
    align-items: center;
  }

  small {
    color: #ff3b3b;
    margin-top: 5px;
  }
`, r_ = V.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`, i_ = V.div`
  width: 100%;
`, o_ = {
  default: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, s_ = V(Rp)`
  cursor: pointer;
  position: absolute;
  margin-top: 0.3rem;
  right: 0.3rem;
  transition: all 0.3s ease-in-out;
  transform: ${({ isSuggestionsShown: e }) => e && "rotate(-180deg)"};
  ${({ variant: e }) => o_[e]}
`, a_ = V.input`
  height: ${({ height: e }) => e};
  width: 100%;
`, l_ = V.div`
  width: 100%;
  margin-top: 0.2rem;
  overflow-x: scroll;
  align-self: flex-start;
  gap: 0.4rem;

  &::-webkit-scrollbar {
    background: transparent;
    height: 6px;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: #888;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`, u_ = V(vn.div)`
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  max-height: 8rem;
  overflow-x: scroll;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  ${({ variant: e }) => Up[e]};
  background: ${({ background: e }) => e};
  color: ${({ color: e }) => e};
  width: ${({ suggestionContainerWidth: e }) => e || "100%"};

  &::-webkit-scrollbar {
    display: none;
  }

  p {
    margin: 0;
    font-size: 14px;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-top: 0.5rem;
    width: 100%;
  }

  li {
    margin-bottom: 0.3rem;
    padding: 0.2rem;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      opacity: 0.5;
    }
  }
`, c_ = V.div`
  z-index: 30;
  position: absolute;
  margin-top: 0.2rem;
  width: 92%;
`, f_ = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.black}`};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, h_ = V(vn.p)`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  padding: 0.8rem;
  border-radius: 0.2rem;
  position: absolute;
  top: -1rem;
  width: 100%;
  ${({ variant: e }) => f_[e]}
`, d_ = {
  hidden: {
    height: 0,
    opacity: 0
  },
  show: {
    height: "fit-content",
    opacity: 1,
    transition: {
      height: { duration: 0.3 },
      opacity: { duration: 0.1 }
    }
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      height: { duration: 0.3 },
      opacity: { duration: 0.1 }
    }
  }
}, p_ = {
  hidden: {
    x: -20,
    opacity: 0
  },
  show: {
    x: 0,
    opacity: 1,
    transition: {
      x: { duration: 0.3 },
      opacity: { duration: 0.3 }
    }
  },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      x: { duration: 0.3 },
      opacity: { duration: 0.3 }
    }
  }
}, m_ = V(vn.div)`
  height: 2rem;
  gap: 0.3rem;
  padding: 0.1rem 0.5rem;
  background: ${({ theme: e }) => Je(0.04, e.monkUiThemes.colors.white)};
  border-radius: 0.3rem;

  svg {
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:hover {
      color: ${({ theme: e }) => e.monkUiThemes.colors.error};
    }
  }
`, g_ = V.p`
  font-size: 0.9rem;
  white-space: nowrap;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.sora};
`, v_ = {
  hidden: {
    y: 20,
    opacity: 0
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      opacity: {
        duration: 0.6
      }
    }
  },
  exit: {
    y: 20,
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.6
      }
    }
  }
};
function b_({ onRemoveClick: e, value: n }) {
  return /* @__PURE__ */ R(_n, { children: /* @__PURE__ */ me(
    m_,
    {
      variants: v_,
      initial: "hidden",
      animate: "show",
      exit: "exit",
      children: [
        /* @__PURE__ */ R(g_, { children: n }),
        /* @__PURE__ */ R(Ip, { onClick: e, title: `remove ${n}` })
      ]
    }
  ) });
}
function xs({
  ref: e,
  onClickOutside: n,
  avoidElementHaveClasses: i,
  avoidRenderedClasses: o
}) {
  const a = an(
    (c) => {
      if (i) {
        const f = c.target.classList;
        let m = !0;
        if (Array.from(f).forEach((g) => {
          i != null && i.includes(g) && (m = !1);
        }), !m)
          return;
      }
      let u;
      o && (u = o.map((h) => document.querySelector(`.${h}`)).some((h) => h)), !u && e.current && !e.current.contains(c.target) && n(c);
    },
    [e, n, i, o]
  );
  mt(() => (document.addEventListener("mousedown", a), () => document.removeEventListener("mousedown", a)), [a]);
}
let Ho;
const y_ = new Uint8Array(16);
function x_() {
  if (!Ho && (Ho = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ho))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ho(y_);
}
const St = [];
for (let e = 0; e < 256; ++e)
  St.push((e + 256).toString(16).slice(1));
function w_(e, n = 0) {
  return (St[e[n + 0]] + St[e[n + 1]] + St[e[n + 2]] + St[e[n + 3]] + "-" + St[e[n + 4]] + St[e[n + 5]] + "-" + St[e[n + 6]] + St[e[n + 7]] + "-" + St[e[n + 8]] + St[e[n + 9]] + "-" + St[e[n + 10]] + St[e[n + 11]] + St[e[n + 12]] + St[e[n + 13]] + St[e[n + 14]] + St[e[n + 15]]).toLowerCase();
}
const k_ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Fh = {
  randomUUID: k_
};
function ln(e, n, i) {
  if (Fh.randomUUID && !n && !e)
    return Fh.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || x_)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, n) {
    i = i || 0;
    for (let a = 0; a < 16; ++a)
      n[i + a] = o[a];
    return n;
  }
  return w_(o);
}
function Sl(e) {
  return Wt(() => {
    let i;
    return typeof e[0] == "string" ? i = e.map((o) => ({ value: o, hookInsertedUuid: ln() })) : i = e.map((a) => ({
      ...a,
      hookInsertedUuid: ln()
    })), i;
  }, [e]);
}
const $C = Tr(
  ({
    data: e,
    show: n,
    label: i,
    clearAfterSelect: o = !1,
    showArrowButton: a = !0,
    error: c,
    keyName: u,
    isMultiple: h = !1,
    variant: f = "default",
    background: m,
    color: g,
    suggestionContainerWidth: x,
    onSelectedOptionsChange: T,
    height: E,
    defaultValue: I
  }, D) => {
    const [W, F] = nt([]), [z, L] = nt(!1), [G, Q] = nt(""), { convertKeys: fe } = Ni(), ge = Wt(() => ln(), []), he = un(null), [$e, Qe] = nt(!1), Ge = Sl(e);
    xs({
      ref: he,
      onClickOutside: () => L(!1),
      avoidElementHaveClasses: ["arrow-icon"]
    }), mt(() => {
      (I == null ? void 0 : I.length) !== 0 && !$e && (Qe(!0), I == null || I.forEach((Se) => {
        Ge.forEach((y) => {
          const { hookInsertedUuid: k, ...$ } = y, S = n && Object.keys(n)[0];
          Se[S] === $[S] && (console.log(1, $e), F((p) => Array.from(/* @__PURE__ */ new Set([...p, y]))));
        });
      }));
    }, [I]), mt(() => {
      if (D) {
        if (u) {
          D.current[u] = [], W.map((Se) => {
            const y = Ge.find(
              ({ hookInsertedUuid: $ }) => $ === Se.hookInsertedUuid
            ), k = Object.assign({}, y);
            delete k.hookInsertedUuid, D.current[u].push(k);
          });
          return;
        }
        D.current = [], W.map((Se) => {
          const y = Ge.find(
            ({ hookInsertedUuid: $ }) => $ === Se.hookInsertedUuid
          ), k = Object.assign({}, y);
          delete k.hookInsertedUuid, D.current.push(k);
        });
      }
      if (T && W.length > 0) {
        const Se = W.map(
          ({ hookInsertedUuid: $ }) => $
        ), k = Ge.map(
          ($) => Se.includes($.hookInsertedUuid) ? $ : null
        ).filter(Boolean).map(
          ($) => {
            const S = Object.assign({}, $);
            return delete S.hookInsertedUuid, S;
          }
        );
        T(k);
      }
    }, [W]);
    function _e(Se) {
      F(h ? (y) => [...y, Se] : [Se]), o && Q("");
    }
    function re(Se) {
      F(
        (y) => y.filter((k) => k.hookInsertedUuid !== Se)
      );
    }
    const ve = Wt(() => {
      const Se = fe(n);
      return Ge.map((y) => {
        let k = { ...y };
        return Se.forEach(($) => {
          $.includes(".") ? $.split(".").forEach((p) => {
            k = k[p];
          }) : k = k[$];
        }), { value: k, id: y.hookInsertedUuid };
      });
    }, [e, n]), le = Wt(() => ve.filter((Se) => String(Se.value).toLowerCase().includes(G.toLowerCase())), [G]);
    function We(Se) {
      return /* @__PURE__ */ R(_n, { children: z && /* @__PURE__ */ R(
        u_,
        {
          background: m,
          color: g,
          variant: f,
          variants: d_,
          initial: "hidden",
          animate: "show",
          exit: "exit",
          suggestionContainerWidth: x,
          ref: he,
          children: /* @__PURE__ */ R("ul", { children: Se.map(
            (y) => W.find(
              ({ hookInsertedUuid: k }) => k === y.id
            ) ? null : /* @__PURE__ */ R(
              "li",
              {
                onClick: () => {
                  const k = Ge.find(
                    ({ hookInsertedUuid: $ }) => $ === y.id
                  );
                  _e(k);
                },
                children: `${y.value}`
              },
              y.id
            )
          ) })
        }
      ) });
    }
    function je() {
      return G ? le.length && G ? We(le) : /* @__PURE__ */ R(_n, { children: /* @__PURE__ */ R(
        h_,
        {
          variants: p_,
          initial: "hidden",
          animate: "show",
          exit: "exit",
          variant: f,
          children: "Nenhum resultado encontrado"
        }
      ) }) : We(ve);
    }
    return /* @__PURE__ */ me(t_, { children: [
      /* @__PURE__ */ me(n_, { background: m, color: g, variant: f, children: [
        /* @__PURE__ */ R("label", { children: i }),
        /* @__PURE__ */ me(r_, { children: [
          /* @__PURE__ */ me(i_, { children: [
            /* @__PURE__ */ R(
              a_,
              {
                onChange: (Se) => {
                  Q(Se.target.value);
                },
                role: "input",
                onFocus: () => L(!0),
                value: G,
                type: "text",
                height: E
              },
              ge
            ),
            a && /* @__PURE__ */ R(
              s_,
              {
                isSuggestionsShown: z,
                onClick: () => L((Se) => !Se),
                variant: f,
                title: "options arrow",
                className: "arrow-icon",
                size: 20
              }
            )
          ] }),
          W.length > 0 && /* @__PURE__ */ R(l_, { children: W.map((Se) => {
            const y = fe(n);
            let k = Object.assign({}, Se);
            return y.forEach(($) => {
              $.includes(".") ? $.split(".").forEach((p) => {
                k = k[p];
              }) : k = k[$];
            }), /* @__PURE__ */ R(
              b_,
              {
                value: k,
                onRemoveClick: () => {
                  re(Se.hookInsertedUuid);
                }
              },
              Se.id
            );
          }) })
        ] }),
        c && /* @__PURE__ */ R("small", { children: c })
      ] }),
      /* @__PURE__ */ R(c_, { children: je() })
    ] });
  }
), Qa = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: transparent;
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  success: U`
    background: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.success)};
    color: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.success)};
    border: none;
  `,
  warning: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.warning};
    color: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.warning)};
    border: none;
  `,
  danger: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.error};
    color: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.error)};
    border: none;
  `,
  small: U`
    width: 50%;
  `,
  medium: U`
    width: 75%;
  `,
  large: U`
    width: 100%;
  `
}, T_ = V.div`
  ${({ size: e }) => Qa[e]}
  ${({ variant: e }) => e && Qa[e]};
  ${({ type: e }) => e && Qa[e]};
  border-radius: 100px;
  height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 9px 12px;
  color: ${({ color: e }) => e};
  background: ${({ background: e }) => e};
  height: ${({ height: e }) => e && e};
`, __ = V.p`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`;
function EC({
  type: e,
  title: n,
  size: i = "large",
  icon: o,
  variant: a = "default",
  height: c,
  background: u,
  color: h
}) {
  return /* @__PURE__ */ me(
    T_,
    {
      type: e,
      size: i,
      variant: a,
      background: u,
      color: h,
      height: c,
      children: [
        /* @__PURE__ */ R(__, { children: n }),
        o && (typeof o == "string" ? /* @__PURE__ */ R("img", { src: o }) : o)
      ]
    }
  );
}
const S_ = V.div`
  box-sizing: border-box;
  ${(e) => U`
    padding: ${e.padding};
    padding-left: ${e.paddingLeft};
    padding-top: ${e.paddingTop};
    padding-right: ${e.paddingRight};
    padding-bottom: ${e.paddingBottom};
    border: ${e.border};
    border-top: ${e.borderTop};
    border-left: ${e.borderLeft};
    border-right: ${e.borderRight};
    border-bottom: ${e.borderBottom};
    border-color: ${e.borderColor};
    margin: ${e.margin};
    margin-top: ${e.marginTop};
    margin-left: ${e.marginLeft};
    margin-right: ${e.marginRight};
    margin-bottom: ${e.marginBottom};
    width: ${e.width};
    height: ${e.height};
    background-color: ${e.bgColor ? e.bgColor : "none"};
    box-shadow: ${e.boxShadow && e.boxShadow};
  `}
`;
function PC({
  width: e,
  height: n,
  bgColor: i,
  paddingTop: o,
  paddingLeft: a,
  paddingBottom: c,
  paddingRight: u,
  marginBottom: h,
  marginLeft: f,
  marginRight: m,
  marginTop: g,
  borderBottom: x,
  borderLeft: T,
  borderRight: E,
  borderTop: I,
  border: D,
  borderColor: W,
  margin: F,
  padding: z,
  children: L,
  boxShadow: G
}) {
  return /* @__PURE__ */ R(
    S_,
    {
      boxShadow: G,
      height: n,
      width: e,
      bgColor: i,
      paddingBottom: c,
      paddingLeft: a,
      paddingRight: u,
      paddingTop: o,
      marginBottom: h,
      marginLeft: f,
      marginRight: m,
      marginTop: g,
      borderLeft: T,
      borderBottom: x,
      borderRight: E,
      borderTop: I,
      border: D,
      margin: F,
      padding: z,
      borderColor: W,
      children: L
    }
  );
}
const mn = {
  monkUiThemes: {
    fontFamily: {
      sora: "Sora, sans-serif",
      epilogue: "Epilogue, sans-serif",
      poppins: "Poppins, sans-serif",
      roboto: "Roboto, sans-serif",
      inter: "Inter, sans-serif"
    },
    colors: {
      main: "#3377ff",
      error: "#ff3b3b",
      warning: "#ffcc00",
      success: "#06c270",
      white: "#fafafc",
      black: "#3a3a3c"
    }
  }
}, Vh = Ul`
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
`, Bh = Ul`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`, C_ = V.div`
  color: ${({ color: e }) => e};
  font-size: ${({ size: e }) => `${e}px`};
  width: 1em;
  height: 1em;
  border-radius: 50%;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: ${Vh} 1.5s infinite ease, ${Bh} 1.5s infinite ease;
  animation: ${Vh} 1.5s infinite ease, ${Bh} 1.5s infinite ease;
`;
function $_({
  size: e = 32,
  color: n = mn.monkUiThemes.colors.white
}) {
  return /* @__PURE__ */ R(C_, { size: e, color: n, role: "loader" });
}
function wr(e) {
  let n = 0, i = 0, o = 0;
  return e.startsWith("rgb") && ([, , n, i, o] = /^(rgb|rgba)\((\d+),\s*(\d+),\s*(\d+)/i.exec(e).map(Number)), e.startsWith("#") && (e.length === 4 && (n = parseInt(e[1] + e[1], 16), i = parseInt(e[2] + e[2], 16), o = parseInt(e[3] + e[3], 16)), e.length === 7 && (n = parseInt(e.substring(1, 3), 16), i = parseInt(e.substring(3, 5), 16), o = parseInt(e.substring(5, 7), 16))), (n * 299 + i * 587 + o * 114) / 1e3 > 125 ? "dark" : "light";
}
var Yr = /* @__PURE__ */ ((e) => (e.light = "#fafafc", e.dark = "#000", e))(Yr || {});
const Nh = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    cursor: pointer;
    border: none;
    color: ${({ theme: e }) => Yr[wr(e.monkUiThemes.colors.main)]};

    &:hover {
      background: ${({ theme: e }) => Pe(0.25, e.monkUiThemes.colors.main)};
    }
  `,
  outlined: U`
    background: transparent;
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.main};
    cursor: pointer;

    &:hover {
      background: ${({ theme: e }) => e.monkUiThemes.colors.main};
      color: ${({ theme: e }) => Yr[wr(e.monkUiThemes.colors.main)]};
    }
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => Yr[wr(e.monkUiThemes.colors.main)]};
    border: none;
    cursor: pointer;

    &:hover {
      background: ${({ theme: e }) => Pe(0.25, e.monkUiThemes.colors.main)};
    }
  `,
  small: U`
    width: 50%;
    font-size: 14px;
    padding: 12px 24px;
  `,
  medium: U`
    width: 75%;
    font-size: 16px;
    padding: 14px 2rem;
  `,
  large: U`
    width: 100%;
    font-size: 18px;
    padding: 1rem 3rem;
  `
}, E_ = V.button`
  ${({ size: e }) => Nh[e]};
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.sora};
  font-weight: ${({ fontWeight: e }) => e || "bold"};
  transition: all 0.3s ease-in-out;
  border-radius: 6px;
  ${({ variant: e }) => Nh[e]};
  background: ${({ background: e }) => e};
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  flex-direction: ${({ iconSide: e }) => e === "left" ? "row-reverse" : "row"};
  height: 50px;

  color: ${({ fontColor: e, background: n }) => !e && n && Yr[wr(n)]};

  color: ${({ fontColor: e }) => e && e};

  &:hover {
    background: ${({ background: e }) => e && wr(e) === "light" && Pe(0.1, e)};

    background: ${({ background: e }) => e && wr(e) === "dark" && Je(0.1, e)};
  }

  ${({ borderColor: e }) => e && U`
      border-color: ${e};
      color: ${e};

      &:hover {
        background: ${e};
        color: ${Yr[wr(e)]};
      }
    `}

  img {
    height: 15px;
    width: 15px;
  }
`;
function Wh({
  size: e = "small",
  type: n = "button",
  disabled: i = !1,
  isLoading: o = !1,
  fontWeight: a,
  title: c,
  fontColor: u,
  variant: h = "default",
  onClick: f,
  background: m,
  icon: g,
  iconSide: x,
  loaderStyles: T = { size: 15 },
  borderColor: E
}) {
  return /* @__PURE__ */ me(
    E_,
    {
      background: m,
      type: n,
      size: e,
      disabled: i,
      fontWeight: a,
      fontColor: u,
      variant: h,
      onClick: f,
      iconSide: x,
      borderColor: E,
      children: [
        !o && /* @__PURE__ */ me(id, { children: [
          c && /* @__PURE__ */ R("p", { children: c }),
          g && typeof g == "string" ? /* @__PURE__ */ R("img", { src: g }) : g
        ] }),
        o && /* @__PURE__ */ R($_, { ...T })
      ]
    }
  );
}
const P_ = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: transparent;
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, A_ = V.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${({ display: e }) => e};
  ${({ variant: e }) => e && P_[e]};
  background: ${({ background: e }) => e};
  color: ${({ color: e }) => e};
  border-radius: 10px;
  padding: 8px;
`, R_ = V.label`
  margin-bottom: ${({ display: e }) => e === "row" ? 0 : "8px"};
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
`, I_ = V.input`
  border: none;
  width: 35px;
  height: 35px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  cursor: pointer;
  ::-webkit-color-swatch {
    border-radius: 50%;
  }
`;
function AC({
  label: e,
  display: n = "column",
  defaultValue: i,
  variant: o = "default",
  background: a,
  color: c,
  onChange: u
}) {
  const h = Wt(() => ln(), []);
  function f(m) {
    u && u(m.target.value);
  }
  return /* @__PURE__ */ me(
    A_,
    {
      display: n,
      variant: o,
      background: a,
      color: c,
      children: [
        /* @__PURE__ */ R(R_, { display: n, htmlFor: h, children: e }),
        /* @__PURE__ */ R(
          I_,
          {
            id: h,
            onChange: f,
            type: "color",
            defaultValue: i,
            role: "input",
            "aria-label": "cost-input"
          }
        )
      ]
    }
  );
}
const U_ = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, D_ = V.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 5px;
  padding: 0.5rem;
`, zh = V.div``, M_ = V.div`
  display: flex;
  margin-top: 1rem;

  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};

  div {
    margin-right: 1rem;

    label {
      margin-right: 0.5rem;
    }
  }
`, O_ = V.label`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  width: 100%;
  font-size: ${({ fontSize: e }) => e + "px"};
  color: ${({ labelFontColor: e }) => e};
`, jh = V.input`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.roboto};
  border: none;
  ${({ variants: e }) => e && U_[e]}
  border-radius: 5px;
  outline: none;
  padding: 10px;
  background: ${({ background: e }) => e};
  height: 1rem;
  width: 130px;

  ::placeholder {
    color: ${({ variants: e }) => e === "outlined" ? "#000" : "#fff"};
    color: ${({ inputFontColor: e }) => e};
  }

  ::-webkit-calendar-picker-indicator {
    background-color: white;
    padding: 5px;
    cursor: pointer;
    border-radius: 3px;
  }
`, RC = Tr(
  ({
    label: e,
    max: n,
    min: i,
    variant: o,
    background: a,
    labelFontColor: c,
    inputFontColor: u,
    fontSize: h
  }, f) => {
    const [m, g] = nt(""), [x, T] = nt("");
    return ex(
      f,
      () => ({
        getData: () => [m, x]
      }),
      [m, x]
    ), /* @__PURE__ */ me(D_, { children: [
      /* @__PURE__ */ R(O_, { fontSize: h, labelFontColor: c, children: e }),
      /* @__PURE__ */ me(M_, { children: [
        /* @__PURE__ */ R(zh, { children: /* @__PURE__ */ R(
          jh,
          {
            max: n,
            min: i,
            inputFontColor: u,
            background: a,
            id: "date-range-start",
            type: "date",
            placeholder: "From",
            onChange: (E) => g(E.currentTarget.value),
            variants: o
          }
        ) }),
        /* @__PURE__ */ R(zh, { children: /* @__PURE__ */ R(
          jh,
          {
            max: n,
            min: i,
            inputFontColor: u,
            background: a,
            id: "date-range-end",
            type: "date",
            placeholder: "To",
            onChange: (E) => T(E.currentTarget.value),
            variants: o
          }
        ) })
      ] })
    ] });
  }
), Gh = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: transparent;
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, L_ = V.div`
  width: 100%;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ variant: e }) => e && Gh[e] || Gh.default}
  border-bottom: 2px solid ${({ borderColor: e }) => e ?? "none"};
  padding: ${({ padding: e }) => e};
  background: ${({ background: e }) => e};
`, F_ = V.p`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.roboto};
  font-size: 2.5rem;
  color: ${({ color: e }) => e};
`, V_ = V.p`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.roboto};
  flex-grow: 1;
  text-align: center;
  font-size: 14px;
  height: 2rem;
  margin: 0;
  cursor: pointer;
  color: ${({ isSelected: e, selectedItemColor: n, color: i }) => n && e ? n : i};
`, B_ = V.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
`;
function IC({
  title: e,
  options: n,
  color: i,
  selectedItemColor: o = "#000000",
  borderColor: a,
  background: c,
  padding: u = "0",
  getValue: h,
  variant: f
}) {
  const [m, g] = nt("");
  function x(T) {
    g(T), h && h(T);
  }
  return /* @__PURE__ */ me(
    L_,
    {
      variant: f,
      background: c,
      padding: u,
      borderColor: a,
      children: [
        /* @__PURE__ */ R(F_, { color: i, children: e }),
        /* @__PURE__ */ R(B_, { children: n && n.map((T) => /* @__PURE__ */ R(
          V_,
          {
            color: i,
            selectedItemColor: o,
            isSelected: m === T.value,
            onClick: () => x(T.value),
            children: T.text
          },
          T.text + T.value
        )) })
      ]
    }
  );
}
const N_ = V.div`
  display: flex;
  ${(e) => U`
    gap: ${e.gap ? e.gap : "1rem"};

    flex-direction: ${e.direction ? e.direction : "row"};
    align-items: ${e.alignItems ? e.alignItems : "flex-start"};
    justify-content: ${e.justifyContent ? e.justifyContent : "flex-start"};

    width: ${e.width ? e.width : "100%"};
    height: ${e.height ? e.height : "100%"};

    margin: ${e.margin ? e.margin : "0"};
    margin-top: ${e.marginTop && e.marginTop};
    margin-bottom: ${e.marginBottom && e.marginBottom};
    margin-right: ${e.marginRight && e.marginRight};
    margin-left: ${e.marginLeft && e.marginLeft};

    padding: ${e.padding ? e.padding : "0"};
    padding-top: ${e.paddingTop && e.paddingTop};
    padding-bottom: ${e.paddingBottom && e.paddingBottom};
    padding-right: ${e.paddingRight && e.paddingRight};
    padding-left: ${e.paddingLeft && e.paddingLeft};

    background: ${e.background};
    border: ${e.border ? e.border : "none"};
    border-radius: ${e.borderRadius ? e.borderRadius : "0"};
    box-shadow: ${e.boxShadow && e.boxShadow};
  `}
`;
function UC(e) {
  return /* @__PURE__ */ R(N_, { ...e, children: e.children });
}
function W_(e, n) {
  let i = !1;
  if (!n)
    return i;
  try {
    for (let o of n)
      if (o.name === e.name) {
        i = !0;
        break;
      }
    return i;
  } catch {
    return !1;
  }
}
const z_ = V.div`
  max-height: min(40rem, 90vh);
`, j_ = V.form`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-weight: 500;
  max-height: 70vh;
  color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  background: ${({ theme: e }) => e.monkUiThemes.colors.white};
  background: ${({ background: e }) => e && e};
`, G_ = V.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`, el = {
  default: (e) => U`
    background: ${({ theme: n }) => n.monkUiThemes.colors.white};
    color: ${({ theme: n }) => n.monkUiThemes.colors.main};

    ${e && U`
      background: ${({ theme: n }) => Je(0.1, n.monkUiThemes.colors.white)};
    `}
  `,
  filled: (e) => U`
    background: ${({ theme: n }) => Pe(0.1, n.monkUiThemes.colors.main)};
    color: ${({ theme: n }) => n.monkUiThemes.colors.white};

    ${e && U`
      background: ${({ theme: n }) => n.monkUiThemes.colors.main};
    `}
  `,
  outlined: (e) => U`
    background: ${({ theme: n }) => n.monkUiThemes.colors.white};
    border: 1px solid ${({ theme: n }) => n.monkUiThemes.colors.main};

    ${e && U`
      background: ${({ theme: n }) => Pe(0.1, n.monkUiThemes.colors.main)};
      color: ${({ theme: n }) => n.monkUiThemes.colors.white};
    `}
  `,
  unique: U`
    border-radius: 5px 5px 0 0;
  `,
  multiple: U`
    &:first-of-type {
      border-radius: 5px 0 0 0;
    }

    &:last-of-type {
      border-radius: 0 5px 0 0;
    }
  `
}, H_ = V.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-grow: 1;
  transition: all 0.3s ease-in-out;
  border-bottom: ${({ isInvalid: e, theme: n }) => e && `2px solid ${n.monkUiThemes.colors.error}`};

  ${({ isUnique: e }) => e ? el.unique : el.multiple}

  ${({ variant: e, selected: n }) => el[e](n)}
    ${({ background: e, selected: n }) => U`
    background: ${n && e ? Je(0.1, e) : e};
  `};

  color: ${({ isInvalid: e, theme: n }) => e && n.monkUiThemes.colors.error};
`, q_ = V.div`
  padding: 0.5rem 0;
  display: flex;
  max-width: 100%;
  ${({ have2Buttons: e }) => U`
    align-items: center;
    justify-content: ${e ? "space-between" : "flex-end"};

    button {
      width: 48% !important;
    }
  `}
`, Y_ = V.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  overflow: scroll;

  &::-webkit-scrollbar {
    background: transparent;
    height: 6px;
    width: 4px;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: #888;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
function DC({
  onSubmit: e,
  tabs: n,
  variant: i = "default",
  formBackground: o,
  tabsBackground: a,
  buttonsBackground: c,
  textColor: u,
  buttonsFontColor: h,
  invalidTabs: f
}) {
  var I;
  const [m, g] = nt(0);
  let x = m;
  function T() {
    x <= 1 && g(x + 1);
  }
  function E() {
    x <= n.length && g(x - 1);
  }
  return /* @__PURE__ */ me(z_, { children: [
    /* @__PURE__ */ me(
      j_,
      {
        "aria-label": "form",
        variant: i,
        onSubmit: e,
        background: o,
        children: [
          n.length > 0 && /* @__PURE__ */ R(G_, { variant: i, children: n.map((D, W) => /* @__PURE__ */ R(
            H_,
            {
              isInvalid: f ? W_(D, f) : !1,
              isUnique: n.length === 1,
              variant: i,
              selected: m === W,
              onClick: () => g(W),
              background: a,
              textColor: u,
              children: D.name
            },
            D.name
          )) }),
          /* @__PURE__ */ R(Y_, { children: (I = n.find((D, W) => W === m)) == null ? void 0 : I.component })
        ]
      }
    ),
    /* @__PURE__ */ me(q_, { have2Buttons: m !== 0, children: [
      m !== 0 && /* @__PURE__ */ R(
        Wh,
        {
          onClick: () => E(),
          disabled: m === 0,
          title: "Página anterior",
          variant: i,
          background: c,
          fontColor: h,
          fontWeight: "bold",
          size: "small"
        }
      ),
      /* @__PURE__ */ R(
        Wh,
        {
          title: m + 1 === n.length ? "Enviar" : "Próxima página",
          variant: i,
          onClick: () => {
            m + 1 === n.length ? e() : T();
          },
          background: c,
          fontColor: h,
          fontWeight: "bold",
          size: "small"
        }
      )
    ] })
  ] });
}
const MC = V.div`
  display: grid;
  box-sizing: border-box;
  ${(e) => U`
    flex-direction: ${e.direction ?? "row"};
    width: ${e.width ?? "100%"};
    height: ${e.height ?? "100%"};
    gap: ${e.gap ?? "1rem"};
    align-items: ${e.alignItems ?? "center"};
    justify-content: ${e.justifyContent ?? "center"};
    grid-template-rows: ${e.rows};
    grid-template-columns: ${e.columns};
    padding: ${e.padding};
    margin: ${e.margin};
    box-shadow: ${e.boxShadow && e.boxShadow};
  `}
`, K_ = V.div`
  width: 25rem;
  border-radius: 0.4rem;
  max-height: 20rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`, Z_ = V.div`
  width: 100%;
`;
function X_(e) {
  return or({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z" } }] })(e);
}
const J_ = V(vn.ul)`
  width: 100%;
  background: ${({ theme: e }) => e.monkUiThemes.colors.white};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;

  * {
    font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.sora};
    font-size: 1rem;
  }

  list-style: none;
  padding: 0;
  margin: 0;
`, Q_ = V.li`
  padding: 0.3rem;
`, eS = V.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.sora};
  font-size: 1.1rem;
  background: ${({ theme: e }) => e.monkUiThemes.colors.black};
  color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  cursor: pointer;

  transition: all 0.3s ease-in-out;

  svg {
    transition: all 0.3s ease-in-out;
    margin-right: 1rem;
    transform: ${({ isCollapsed: e }) => !e && "rotate(-180deg)"};
  }

  &:hover {
    opacity: 0.8;
  }
`, tS = V.p`
  margin-left: 1rem;
`, nS = {
  hidden: {
    opacity: 0,
    height: 0
  },
  show: {
    opacity: 1,
    height: "fit-content",
    transition: {
      height: {
        duration: 0.4
      },
      opacity: {
        duration: 0.4
      }
    }
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      height: {
        duration: 0.4
      },
      opacity: {
        duration: 0.4
      }
    }
  }
};
function rS({
  data: e,
  show: n,
  /* c8 ignore next */
  onListItemClick: i = (c) => {
  },
  header: o,
  startCollapsed: a = !0
}) {
  const { convertKeys: c } = Ni(), [u, h] = nt(a);
  function f(g) {
    i(g);
  }
  function m() {
    if (typeof e[0] == "object" && n) {
      const g = c(n);
      return e.map((T, E) => g.map((I) => {
        let D = { ...T };
        return I.split(".").forEach((F) => {
          D = D[F];
        }), /* @__PURE__ */ R(Q_, { onClick: () => f(T), children: D }, E);
      }));
    }
  }
  return /* @__PURE__ */ me(id, { children: [
    /* @__PURE__ */ me(
      eS,
      {
        onClick: () => h((g) => !g),
        isCollapsed: u,
        children: [
          /* @__PURE__ */ R(tS, { children: o }),
          /* @__PURE__ */ R(X_, { size: 30 })
        ]
      }
    ),
    /* @__PURE__ */ R(_n, { children: !u && /* @__PURE__ */ R(
      J_,
      {
        variants: nS,
        initial: "hidden",
        animate: "show",
        exit: "exit",
        children: m()
      }
    ) })
  ] });
}
function OC({ data: e, objectKey: n, show: i }) {
  const { convertKeys: o } = Ni();
  function a() {
    if (typeof e[0] == "object" && n) {
      const u = o(n);
      return e.reduce((f, m) => {
        let g = { ...m };
        return u.forEach((x) => {
          x.split(".").forEach((E) => {
            g = g[E];
          });
        }), {
          ...f,
          [g]: [...f[g] || [], m]
        };
      }, {});
    }
  }
  const c = a();
  return /* @__PURE__ */ R(K_, { children: Object.entries(c).map(([u, h], f) => /* @__PURE__ */ R(Z_, { children: /* @__PURE__ */ R(rS, { data: h, header: u, show: i }) }, f + Math.random())) });
}
const iS = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { opacity: { duration: 0.8 } } },
  exit: { opacity: 0 }
}, oS = {
  hidden: { y: -2e3, opacity: 0 },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      opacity: { duration: 0.8 },
      y: { duration: 0.8 }
    }
  },
  exit: {
    y: -2e3,
    opacity: 0,
    transition: {
      y: { duration: 0.6 },
      opacity: { duration: 0.6 }
    }
  }
}, sS = V(vn.div)`
  position: fixed;
  inset: 0;
  backdrop-filter: blur(5px);
  background: rgba(1, 10, 12, 0.5);
  width: 100%;
  display: grid;
  place-content: center;
  z-index: 1000;
  border-radius: 5px;
`, aS = V(vn.div)`
  width: fit-content;
  height: fit-content;
  margin: 0 auto;
  background: ${({ backgroundColor: e, theme: n }) => e || n.monkUiThemes.colors.white};
  border-radius: ${({ borderRadius: e }) => e && e};
`, lS = V.div`
  width: 100%;
  display: flex;
  justify-content: ${({ haveTitle: e }) => e ? "space-between" : "flex-end"};
  height: fit-content;
  align-items: center;

  svg {
    cursor: pointer;
    padding: 0.2rem;
    transition: all 0.3s ease-in-out;
    margin-right: 0.2rem;

    &:hover {
      fill: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
    }
  }
`, uS = V.h3`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  font-size: 1.3rem;
  font-weight: 500;
  margin-left: 1rem;
`;
function LC({
  children: e,
  close: n,
  isRendered: i,
  backgroundColor: o,
  dontCloseIfClassnamesExists: a = [],
  dontCloseIfElementsHaveClassnames: c = [],
  title: u,
  borderRadius: h
}) {
  const f = un(null);
  return xs({
    ref: f,
    onClickOutside: n,
    avoidElementHaveClasses: c,
    avoidRenderedClasses: a
  }), rx(
    /* @__PURE__ */ R(_n, { children: i && /* @__PURE__ */ R(
      sS,
      {
        variants: iS,
        initial: "hidden",
        animate: "show",
        exit: "exit",
        children: /* @__PURE__ */ me(
          aS,
          {
            ref: f,
            backgroundColor: o,
            variants: oS,
            role: "modal",
            initial: "hidden",
            animate: "show",
            exit: "exit",
            borderRadius: h,
            children: [
              /* @__PURE__ */ me(lS, { haveTitle: !!u, children: [
                u && /* @__PURE__ */ R(uS, { children: u }),
                /* @__PURE__ */ R(
                  Ip,
                  {
                    onClick: n,
                    role: "button",
                    size: 26,
                    color: mn.monkUiThemes.colors.black[400]
                  }
                )
              ] }),
              e
            ]
          }
        )
      }
    ) }),
    document.getElementById("modal-root")
  );
}
const cS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: transparent;
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, fS = V.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  max-height: 20rem;
  overflow-y: scroll;
  border: 1px solid grey;
  background: ${({ background: e }) => e};
  color: ${({ color: e }) => e};
  border-radius: 10px;
  ${({ variant: e }) => cS[e]}

  &::-webkit-scrollbar {
    display: none;
  }
`, hS = V.a`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid
    ${({ theme: e }) => Pe(0.3, e.monkUiThemes.colors.black)};
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  &:last-of-type {
    border: none;
  }

  &:visited {
    text-decoration: none;
  }
`, dS = V.p`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  color: ${({ color: e }) => e};
`;
function FC({
  notifications: e,
  background: n,
  color: i,
  variant: o = "default"
}) {
  return /* @__PURE__ */ R(fS, { background: n, color: i, variant: o, children: e.map((a, c) => /* @__PURE__ */ me(hS, { href: a.url, children: [
    /* @__PURE__ */ R(dS, { color: i, children: a.message }),
    a.icon && (typeof a.icon == "string" ? /* @__PURE__ */ R("img", { src: a.icon }) : a.icon)
  ] }, a.message + c)) });
}
const pS = {
  default: U`
    outline: none;
    width: 16px;
    height: 16px;
    outline: none;
    border: 2px solid
      ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};

    :before {
      content: '';
      transition: all 0.3s ease-in-out;
      position: absolute;
      width: 16px;
      height: 16px;
      border: 5px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
      border-radius: 50%;
      opacity: 0;
      box-sizing: border-box;
    }

    :checked:before {
      opacity: 1;
    }

    &:hover{
      box-shadow: 0 0 6px 6px
        ${({ theme: e }) => Pe(0.7, e.monkUiThemes.colors.black)};
    }
  `,
  outlined: U`
    width: 16px;
    height: 16px;
    outline: none;
    border: 2px solid
      ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};

    :before {
      content: '';
      transition: all 0.6s ease-in-out;
      position: absolute;
      width: 8px;
      height: 8px;
      background-color: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
      border-radius: 50%;
      opacity: 0;
    }

    :checked:before {
      opacity: 1;
    }
        
    &:hover{
      box-shadow: 0 0 6px 6px
        ${({ theme: e }) => Pe(0.7, e.monkUiThemes.colors.black)};
    }
  `,
  filled: U`
    outline: none;
    width: 16px;
    height: 16px;
    outline: none;
    border: 2px solid
      ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};

    :before {
      content: '';
      transition: all 0.3s ease-in-out;
      position: absolute;
      width: 16px;
      height: 16px;
      border: .3rem solid
        ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
      border-radius: 50%;
      opacity: 0;
      box-sizing: border-box;
    }
    :checked:before {
      opacity: 1;
    }

    &:hover{
      box-shadow: 0 0 6px 6px
        ${({ theme: e }) => Pe(0.675, e.monkUiThemes.colors.black)};
    }
  `
}, mS = V.input`
  display: flex;
  justify-content: center;
  align-items: center;
  appearance: none;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  gap: 3px;
  ${({ variant: e }) => pS[e]};
`, gS = V.div`
  display: flex;
  flex-direction: ${(e) => e.directionContainer};
  gap: 0.4rem;
`, vS = V.p`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  font-size: 1rem;
  color: ${({ theme: e }) => e.monkUiThemes.colors.black};
`, bS = V.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  gap: 1rem;
  margin-left: 0;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.inter};
  flex-direction: ${(e) => e.directionOptions};
`, yS = V.label`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 14px;
  gap: 0.4rem;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  color: ${({ color: e, theme: n }) => e || Pe(0.1, n.monkUiThemes.colors.black)};
`;
function VC({
  options: e,
  disabled: n = !1,
  title: i,
  variant: o = "default",
  onChange: a,
  form: c,
  directionOptions: u = "flex-start",
  directionContainer: h = "flex-start"
}) {
  function f(g) {
    a && a(g);
  }
  const m = Wt(() => ln(), []);
  return /* @__PURE__ */ me(gS, { directionContainer: h, children: [
    /* @__PURE__ */ R(vS, { children: i }),
    /* @__PURE__ */ R(bS, { directionOptions: u, children: e.map((g) => /* @__PURE__ */ me(yS, { color: g.color, htmlFor: g.id, children: [
      /* @__PURE__ */ R(
        mS,
        {
          type: "radio",
          variant: o,
          id: g.id,
          value: g.value,
          name: g.name,
          onChange: () => f(g.value),
          disabled: n,
          form: c && c
        }
      ),
      g.label
    ] }, m)) })
  ] });
}
const xS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid
      ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
  `
}, wS = V.div`
  ${({ variant: e }) => xS[e]};
  background: ${({ background: e }) => e};
  width: 100%;
  color: ${({ color: e }) => e};
  cursor: pointer;
  border-radius: 5px;
  position: relative;
  height: 2.2rem;
  margin-top: ${({ marginTop: e }) => e};
`, kS = V(vn.div)`
  position: absolute;
  width: 100%;
  background: inherit;
  border-radius: 5px;
  max-height: 8rem;
  margin-top: 5px;
  overflow-y: scroll;
  z-index: 30;

  &::-webkit-scrollbar {
    display: none;
  }
`, TS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};

    &:hover {
      color: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.white)};
    }
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};

    &:hover {
      color: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.white)};
    }
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};

    &:hover {
      color: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
    }
  `
}, Cl = V.div`
  padding: 0.5rem 0.4rem;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  transition: all 0.2s ease-in-out;

  &:first-of-type {
    border-radius: 5px 5px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 5px 5px;
  }

  ${({ variant: e }) => TS[e]}
`, _S = V(Cl)`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  padding-left: 0.4rem;
  height: 100%;
  border-radius: 5px;
`, SS = {
  default: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, CS = V(Rp)`
  cursor: pointer;
  position: absolute;
  top: 0.6rem;
  right: 0.3rem;
  transition: all 0.3s ease-in-out;
  transform: ${({ isSuggestionsShown: e }) => e && "rotate(-180deg)"};
  ${({ variant: e }) => SS[e]}
`, $S = V.div`
  max-width: 90%;
  margin-top: 0.4rem;
  gap: 0.2rem;
  height: 100%;
  display: flex;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    background: transparent;
    height: 10px;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: #888;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`, ES = {
  hidden: {
    height: 0
  },
  show: {
    height: "fit-content",
    transition: {
      height: { duration: 0.4 }
    }
  },
  exit: {
    height: 0,
    transition: {
      height: { duration: 0.4 }
    }
  }
}, PS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, AS = V(
  vn.div
)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.6rem;
  gap: 0.6rem;
  ${({ variant: e }) => PS[e]}

  svg {
    transition: all 0.2s ease-in-out;

    &:hover {
      color: ${({ theme: e }) => e.monkUiThemes.colors.error};
      transform: scale(1.1);
    }
  }
`, RS = V.div`
  font-size: 0.9rem;
`, IS = {
  hidden: {
    y: 20,
    opacity: 0
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      opacity: {
        duration: 0.6
      }
    }
  },
  exit: {
    y: 20,
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.6
      }
    }
  }
};
function US(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" } }] })(e);
}
function Hh({
  label: e,
  onRemove: n,
  variant: i
}) {
  return /* @__PURE__ */ R(_n, { children: /* @__PURE__ */ me(
    AS,
    {
      variant: i,
      role: `selected-item-${e}`,
      variants: IS,
      initial: "hidden",
      animate: "show",
      exit: "exit",
      children: [
        /* @__PURE__ */ R(RS, { children: e }),
        /* @__PURE__ */ R(US, { size: 20, onClick: n, title: `remove-item-${e}` })
      ]
    }
  ) });
}
var ls = {}, DS = {
  get exports() {
    return ls;
  },
  set exports(e) {
    ls = e;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, n) {
  (function() {
    var i, o = "4.17.21", a = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", h = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", m = 500, g = "__lodash_placeholder__", x = 1, T = 2, E = 4, I = 1, D = 2, W = 1, F = 2, z = 4, L = 8, G = 16, Q = 32, fe = 64, ge = 128, he = 256, $e = 512, Qe = 30, Ge = "...", _e = 800, re = 16, ve = 1, le = 2, We = 3, je = 1 / 0, Se = 9007199254740991, y = 17976931348623157e292, k = 0 / 0, $ = 4294967295, S = $ - 1, p = $ >>> 1, H = [
      ["ary", ge],
      ["bind", W],
      ["bindKey", F],
      ["curry", L],
      ["curryRight", G],
      ["flip", $e],
      ["partial", Q],
      ["partialRight", fe],
      ["rearg", he]
    ], ae = "[object Arguments]", be = "[object Array]", K = "[object AsyncFunction]", ee = "[object Boolean]", ie = "[object Date]", oe = "[object DOMException]", Z = "[object Error]", Ce = "[object Function]", X = "[object GeneratorFunction]", j = "[object Map]", J = "[object Number]", pe = "[object Null]", ce = "[object Object]", Ee = "[object Promise]", Ue = "[object Proxy]", Le = "[object RegExp]", He = "[object Set]", Xe = "[object String]", ut = "[object Symbol]", Dt = "[object Undefined]", yt = "[object WeakMap]", Bn = "[object WeakSet]", Mt = "[object ArrayBuffer]", Nn = "[object DataView]", Cr = "[object Float32Array]", $r = "[object Float64Array]", sr = "[object Int8Array]", Xr = "[object Int16Array]", Jr = "[object Int32Array]", Qr = "[object Uint8Array]", ei = "[object Uint8ClampedArray]", ti = "[object Uint16Array]", ni = "[object Uint32Array]", ws = /\b__p \+= '';/g, ri = /\b(__p \+=) '' \+/g, qi = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Sn = /&(?:amp|lt|gt|quot|#39);/g, Er = /[&<>"']/g, ii = RegExp(Sn.source), Yi = RegExp(Er.source), ks = /<%-([\s\S]+?)%>/g, Ki = /<%([\s\S]+?)%>/g, Zi = /<%=([\s\S]+?)%>/g, Xi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ji = /^\w*$/, Ts = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, oi = /[\\^$.*+?()[\]{}|]/g, Qi = RegExp(oi.source), si = /^\s+/, _s = /\s/, Ss = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Cs = /\{\n\/\* \[wrapped with (.+)\] \*/, _ = /,? & /, Y = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, te = /[()=,{}\[\]\/\s]/, Te = /\\(\\)?/g, ze = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ye = /\w*$/, Ve = /^[-+]0x[0-9a-f]+$/i, Oe = /^0b[01]+$/i, kt = /^\[object .+?Constructor\]$/, st = /^0o[0-7]+$/i, ct = /^(?:0|[1-9]\d*)$/, Ot = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, cn = /($^)/, eo = /['\n\r\u2028\u2029\\]/g, Lt = "\\ud800-\\udfff", Wp = "\\u0300-\\u036f", zp = "\\ufe20-\\ufe2f", jp = "\\u20d0-\\u20ff", nu = Wp + zp + jp, ru = "\\u2700-\\u27bf", iu = "a-z\\xdf-\\xf6\\xf8-\\xff", Gp = "\\xac\\xb1\\xd7\\xf7", Hp = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", qp = "\\u2000-\\u206f", Yp = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ou = "A-Z\\xc0-\\xd6\\xd8-\\xde", su = "\\ufe0e\\ufe0f", au = Gp + Hp + qp + Yp, $s = "['’]", Kp = "[" + Lt + "]", lu = "[" + au + "]", to = "[" + nu + "]", uu = "\\d+", Zp = "[" + ru + "]", cu = "[" + iu + "]", fu = "[^" + Lt + au + uu + ru + iu + ou + "]", Es = "\\ud83c[\\udffb-\\udfff]", Xp = "(?:" + to + "|" + Es + ")", hu = "[^" + Lt + "]", Ps = "(?:\\ud83c[\\udde6-\\uddff]){2}", As = "[\\ud800-\\udbff][\\udc00-\\udfff]", Pr = "[" + ou + "]", du = "\\u200d", pu = "(?:" + cu + "|" + fu + ")", Jp = "(?:" + Pr + "|" + fu + ")", mu = "(?:" + $s + "(?:d|ll|m|re|s|t|ve))?", gu = "(?:" + $s + "(?:D|LL|M|RE|S|T|VE))?", vu = Xp + "?", bu = "[" + su + "]?", Qp = "(?:" + du + "(?:" + [hu, Ps, As].join("|") + ")" + bu + vu + ")*", em = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", tm = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", yu = bu + vu + Qp, nm = "(?:" + [Zp, Ps, As].join("|") + ")" + yu, rm = "(?:" + [hu + to + "?", to, Ps, As, Kp].join("|") + ")", im = RegExp($s, "g"), om = RegExp(to, "g"), Rs = RegExp(Es + "(?=" + Es + ")|" + rm + yu, "g"), sm = RegExp([
      Pr + "?" + cu + "+" + mu + "(?=" + [lu, Pr, "$"].join("|") + ")",
      Jp + "+" + gu + "(?=" + [lu, Pr + pu, "$"].join("|") + ")",
      Pr + "?" + pu + "+" + mu,
      Pr + "+" + gu,
      tm,
      em,
      uu,
      nm
    ].join("|"), "g"), am = RegExp("[" + du + Lt + nu + su + "]"), lm = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, um = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], cm = -1, rt = {};
    rt[Cr] = rt[$r] = rt[sr] = rt[Xr] = rt[Jr] = rt[Qr] = rt[ei] = rt[ti] = rt[ni] = !0, rt[ae] = rt[be] = rt[Mt] = rt[ee] = rt[Nn] = rt[ie] = rt[Z] = rt[Ce] = rt[j] = rt[J] = rt[ce] = rt[Le] = rt[He] = rt[Xe] = rt[yt] = !1;
    var tt = {};
    tt[ae] = tt[be] = tt[Mt] = tt[Nn] = tt[ee] = tt[ie] = tt[Cr] = tt[$r] = tt[sr] = tt[Xr] = tt[Jr] = tt[j] = tt[J] = tt[ce] = tt[Le] = tt[He] = tt[Xe] = tt[ut] = tt[Qr] = tt[ei] = tt[ti] = tt[ni] = !0, tt[Z] = tt[Ce] = tt[yt] = !1;
    var fm = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, hm = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, dm = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, pm = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, mm = parseFloat, gm = parseInt, xu = typeof ki == "object" && ki && ki.Object === Object && ki, vm = typeof self == "object" && self && self.Object === Object && self, Tt = xu || vm || Function("return this")(), Is = n && !n.nodeType && n, ar = Is && !0 && e && !e.nodeType && e, wu = ar && ar.exports === Is, Us = wu && xu.process, Xt = function() {
      try {
        var P = ar && ar.require && ar.require("util").types;
        return P || Us && Us.binding && Us.binding("util");
      } catch {
      }
    }(), ku = Xt && Xt.isArrayBuffer, Tu = Xt && Xt.isDate, _u = Xt && Xt.isMap, Su = Xt && Xt.isRegExp, Cu = Xt && Xt.isSet, $u = Xt && Xt.isTypedArray;
    function jt(P, O, M) {
      switch (M.length) {
        case 0:
          return P.call(O);
        case 1:
          return P.call(O, M[0]);
        case 2:
          return P.call(O, M[0], M[1]);
        case 3:
          return P.call(O, M[0], M[1], M[2]);
      }
      return P.apply(O, M);
    }
    function bm(P, O, M, ue) {
      for (var Ae = -1, qe = P == null ? 0 : P.length; ++Ae < qe; ) {
        var gt = P[Ae];
        O(ue, gt, M(gt), P);
      }
      return ue;
    }
    function Jt(P, O) {
      for (var M = -1, ue = P == null ? 0 : P.length; ++M < ue && O(P[M], M, P) !== !1; )
        ;
      return P;
    }
    function ym(P, O) {
      for (var M = P == null ? 0 : P.length; M-- && O(P[M], M, P) !== !1; )
        ;
      return P;
    }
    function Eu(P, O) {
      for (var M = -1, ue = P == null ? 0 : P.length; ++M < ue; )
        if (!O(P[M], M, P))
          return !1;
      return !0;
    }
    function Wn(P, O) {
      for (var M = -1, ue = P == null ? 0 : P.length, Ae = 0, qe = []; ++M < ue; ) {
        var gt = P[M];
        O(gt, M, P) && (qe[Ae++] = gt);
      }
      return qe;
    }
    function no(P, O) {
      var M = P == null ? 0 : P.length;
      return !!M && Ar(P, O, 0) > -1;
    }
    function Ds(P, O, M) {
      for (var ue = -1, Ae = P == null ? 0 : P.length; ++ue < Ae; )
        if (M(O, P[ue]))
          return !0;
      return !1;
    }
    function it(P, O) {
      for (var M = -1, ue = P == null ? 0 : P.length, Ae = Array(ue); ++M < ue; )
        Ae[M] = O(P[M], M, P);
      return Ae;
    }
    function zn(P, O) {
      for (var M = -1, ue = O.length, Ae = P.length; ++M < ue; )
        P[Ae + M] = O[M];
      return P;
    }
    function Ms(P, O, M, ue) {
      var Ae = -1, qe = P == null ? 0 : P.length;
      for (ue && qe && (M = P[++Ae]); ++Ae < qe; )
        M = O(M, P[Ae], Ae, P);
      return M;
    }
    function xm(P, O, M, ue) {
      var Ae = P == null ? 0 : P.length;
      for (ue && Ae && (M = P[--Ae]); Ae--; )
        M = O(M, P[Ae], Ae, P);
      return M;
    }
    function Os(P, O) {
      for (var M = -1, ue = P == null ? 0 : P.length; ++M < ue; )
        if (O(P[M], M, P))
          return !0;
      return !1;
    }
    var wm = Ls("length");
    function km(P) {
      return P.split("");
    }
    function Tm(P) {
      return P.match(Y) || [];
    }
    function Pu(P, O, M) {
      var ue;
      return M(P, function(Ae, qe, gt) {
        if (O(Ae, qe, gt))
          return ue = qe, !1;
      }), ue;
    }
    function ro(P, O, M, ue) {
      for (var Ae = P.length, qe = M + (ue ? 1 : -1); ue ? qe-- : ++qe < Ae; )
        if (O(P[qe], qe, P))
          return qe;
      return -1;
    }
    function Ar(P, O, M) {
      return O === O ? Mm(P, O, M) : ro(P, Au, M);
    }
    function _m(P, O, M, ue) {
      for (var Ae = M - 1, qe = P.length; ++Ae < qe; )
        if (ue(P[Ae], O))
          return Ae;
      return -1;
    }
    function Au(P) {
      return P !== P;
    }
    function Ru(P, O) {
      var M = P == null ? 0 : P.length;
      return M ? Vs(P, O) / M : k;
    }
    function Ls(P) {
      return function(O) {
        return O == null ? i : O[P];
      };
    }
    function Fs(P) {
      return function(O) {
        return P == null ? i : P[O];
      };
    }
    function Iu(P, O, M, ue, Ae) {
      return Ae(P, function(qe, gt, et) {
        M = ue ? (ue = !1, qe) : O(M, qe, gt, et);
      }), M;
    }
    function Sm(P, O) {
      var M = P.length;
      for (P.sort(O); M--; )
        P[M] = P[M].value;
      return P;
    }
    function Vs(P, O) {
      for (var M, ue = -1, Ae = P.length; ++ue < Ae; ) {
        var qe = O(P[ue]);
        qe !== i && (M = M === i ? qe : M + qe);
      }
      return M;
    }
    function Bs(P, O) {
      for (var M = -1, ue = Array(P); ++M < P; )
        ue[M] = O(M);
      return ue;
    }
    function Cm(P, O) {
      return it(O, function(M) {
        return [M, P[M]];
      });
    }
    function Uu(P) {
      return P && P.slice(0, Lu(P) + 1).replace(si, "");
    }
    function Gt(P) {
      return function(O) {
        return P(O);
      };
    }
    function Ns(P, O) {
      return it(O, function(M) {
        return P[M];
      });
    }
    function ai(P, O) {
      return P.has(O);
    }
    function Du(P, O) {
      for (var M = -1, ue = P.length; ++M < ue && Ar(O, P[M], 0) > -1; )
        ;
      return M;
    }
    function Mu(P, O) {
      for (var M = P.length; M-- && Ar(O, P[M], 0) > -1; )
        ;
      return M;
    }
    function $m(P, O) {
      for (var M = P.length, ue = 0; M--; )
        P[M] === O && ++ue;
      return ue;
    }
    var Em = Fs(fm), Pm = Fs(hm);
    function Am(P) {
      return "\\" + pm[P];
    }
    function Rm(P, O) {
      return P == null ? i : P[O];
    }
    function Rr(P) {
      return am.test(P);
    }
    function Im(P) {
      return lm.test(P);
    }
    function Um(P) {
      for (var O, M = []; !(O = P.next()).done; )
        M.push(O.value);
      return M;
    }
    function Ws(P) {
      var O = -1, M = Array(P.size);
      return P.forEach(function(ue, Ae) {
        M[++O] = [Ae, ue];
      }), M;
    }
    function Ou(P, O) {
      return function(M) {
        return P(O(M));
      };
    }
    function jn(P, O) {
      for (var M = -1, ue = P.length, Ae = 0, qe = []; ++M < ue; ) {
        var gt = P[M];
        (gt === O || gt === g) && (P[M] = g, qe[Ae++] = M);
      }
      return qe;
    }
    function io(P) {
      var O = -1, M = Array(P.size);
      return P.forEach(function(ue) {
        M[++O] = ue;
      }), M;
    }
    function Dm(P) {
      var O = -1, M = Array(P.size);
      return P.forEach(function(ue) {
        M[++O] = [ue, ue];
      }), M;
    }
    function Mm(P, O, M) {
      for (var ue = M - 1, Ae = P.length; ++ue < Ae; )
        if (P[ue] === O)
          return ue;
      return -1;
    }
    function Om(P, O, M) {
      for (var ue = M + 1; ue--; )
        if (P[ue] === O)
          return ue;
      return ue;
    }
    function Ir(P) {
      return Rr(P) ? Fm(P) : wm(P);
    }
    function fn(P) {
      return Rr(P) ? Vm(P) : km(P);
    }
    function Lu(P) {
      for (var O = P.length; O-- && _s.test(P.charAt(O)); )
        ;
      return O;
    }
    var Lm = Fs(dm);
    function Fm(P) {
      for (var O = Rs.lastIndex = 0; Rs.test(P); )
        ++O;
      return O;
    }
    function Vm(P) {
      return P.match(Rs) || [];
    }
    function Bm(P) {
      return P.match(sm) || [];
    }
    var Nm = function P(O) {
      O = O == null ? Tt : Ur.defaults(Tt.Object(), O, Ur.pick(Tt, um));
      var M = O.Array, ue = O.Date, Ae = O.Error, qe = O.Function, gt = O.Math, et = O.Object, zs = O.RegExp, Wm = O.String, Qt = O.TypeError, oo = M.prototype, zm = qe.prototype, Dr = et.prototype, so = O["__core-js_shared__"], ao = zm.toString, Ze = Dr.hasOwnProperty, jm = 0, Fu = function() {
        var t = /[^.]+$/.exec(so && so.keys && so.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), lo = Dr.toString, Gm = ao.call(et), Hm = Tt._, qm = zs(
        "^" + ao.call(Ze).replace(oi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), uo = wu ? O.Buffer : i, Gn = O.Symbol, co = O.Uint8Array, Vu = uo ? uo.allocUnsafe : i, fo = Ou(et.getPrototypeOf, et), Bu = et.create, Nu = Dr.propertyIsEnumerable, ho = oo.splice, Wu = Gn ? Gn.isConcatSpreadable : i, li = Gn ? Gn.iterator : i, lr = Gn ? Gn.toStringTag : i, po = function() {
        try {
          var t = dr(et, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), Ym = O.clearTimeout !== Tt.clearTimeout && O.clearTimeout, Km = ue && ue.now !== Tt.Date.now && ue.now, Zm = O.setTimeout !== Tt.setTimeout && O.setTimeout, mo = gt.ceil, go = gt.floor, js = et.getOwnPropertySymbols, Xm = uo ? uo.isBuffer : i, zu = O.isFinite, Jm = oo.join, Qm = Ou(et.keys, et), vt = gt.max, Ct = gt.min, eg = ue.now, tg = O.parseInt, ju = gt.random, ng = oo.reverse, Gs = dr(O, "DataView"), ui = dr(O, "Map"), Hs = dr(O, "Promise"), Mr = dr(O, "Set"), ci = dr(O, "WeakMap"), fi = dr(et, "create"), vo = ci && new ci(), Or = {}, rg = pr(Gs), ig = pr(ui), og = pr(Hs), sg = pr(Mr), ag = pr(ci), bo = Gn ? Gn.prototype : i, hi = bo ? bo.valueOf : i, Gu = bo ? bo.toString : i;
      function v(t) {
        if (ft(t) && !Re(t) && !(t instanceof Be)) {
          if (t instanceof en)
            return t;
          if (Ze.call(t, "__wrapped__"))
            return Hc(t);
        }
        return new en(t);
      }
      var Lr = function() {
        function t() {
        }
        return function(r) {
          if (!at(r))
            return {};
          if (Bu)
            return Bu(r);
          t.prototype = r;
          var s = new t();
          return t.prototype = i, s;
        };
      }();
      function yo() {
      }
      function en(t, r) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = i;
      }
      v.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: ks,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ki,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Zi,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: v
        }
      }, v.prototype = yo.prototype, v.prototype.constructor = v, en.prototype = Lr(yo.prototype), en.prototype.constructor = en;
      function Be(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = $, this.__views__ = [];
      }
      function lg() {
        var t = new Be(this.__wrapped__);
        return t.__actions__ = Ft(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = Ft(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = Ft(this.__views__), t;
      }
      function ug() {
        if (this.__filtered__) {
          var t = new Be(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function cg() {
        var t = this.__wrapped__.value(), r = this.__dir__, s = Re(t), l = r < 0, d = s ? t.length : 0, b = k0(0, d, this.__views__), w = b.start, C = b.end, A = C - w, B = l ? C : w - 1, N = this.__iteratees__, q = N.length, ne = 0, de = Ct(A, this.__takeCount__);
        if (!s || !l && d == A && de == A)
          return mc(t, this.__actions__);
        var xe = [];
        e:
          for (; A-- && ne < de; ) {
            B += r;
            for (var De = -1, we = t[B]; ++De < q; ) {
              var Fe = N[De], Ne = Fe.iteratee, Yt = Fe.type, At = Ne(we);
              if (Yt == le)
                we = At;
              else if (!At) {
                if (Yt == ve)
                  continue e;
                break e;
              }
            }
            xe[ne++] = we;
          }
        return xe;
      }
      Be.prototype = Lr(yo.prototype), Be.prototype.constructor = Be;
      function ur(t) {
        var r = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++r < s; ) {
          var l = t[r];
          this.set(l[0], l[1]);
        }
      }
      function fg() {
        this.__data__ = fi ? fi(null) : {}, this.size = 0;
      }
      function hg(t) {
        var r = this.has(t) && delete this.__data__[t];
        return this.size -= r ? 1 : 0, r;
      }
      function dg(t) {
        var r = this.__data__;
        if (fi) {
          var s = r[t];
          return s === f ? i : s;
        }
        return Ze.call(r, t) ? r[t] : i;
      }
      function pg(t) {
        var r = this.__data__;
        return fi ? r[t] !== i : Ze.call(r, t);
      }
      function mg(t, r) {
        var s = this.__data__;
        return this.size += this.has(t) ? 0 : 1, s[t] = fi && r === i ? f : r, this;
      }
      ur.prototype.clear = fg, ur.prototype.delete = hg, ur.prototype.get = dg, ur.prototype.has = pg, ur.prototype.set = mg;
      function Cn(t) {
        var r = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++r < s; ) {
          var l = t[r];
          this.set(l[0], l[1]);
        }
      }
      function gg() {
        this.__data__ = [], this.size = 0;
      }
      function vg(t) {
        var r = this.__data__, s = xo(r, t);
        if (s < 0)
          return !1;
        var l = r.length - 1;
        return s == l ? r.pop() : ho.call(r, s, 1), --this.size, !0;
      }
      function bg(t) {
        var r = this.__data__, s = xo(r, t);
        return s < 0 ? i : r[s][1];
      }
      function yg(t) {
        return xo(this.__data__, t) > -1;
      }
      function xg(t, r) {
        var s = this.__data__, l = xo(s, t);
        return l < 0 ? (++this.size, s.push([t, r])) : s[l][1] = r, this;
      }
      Cn.prototype.clear = gg, Cn.prototype.delete = vg, Cn.prototype.get = bg, Cn.prototype.has = yg, Cn.prototype.set = xg;
      function $n(t) {
        var r = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++r < s; ) {
          var l = t[r];
          this.set(l[0], l[1]);
        }
      }
      function wg() {
        this.size = 0, this.__data__ = {
          hash: new ur(),
          map: new (ui || Cn)(),
          string: new ur()
        };
      }
      function kg(t) {
        var r = Io(this, t).delete(t);
        return this.size -= r ? 1 : 0, r;
      }
      function Tg(t) {
        return Io(this, t).get(t);
      }
      function _g(t) {
        return Io(this, t).has(t);
      }
      function Sg(t, r) {
        var s = Io(this, t), l = s.size;
        return s.set(t, r), this.size += s.size == l ? 0 : 1, this;
      }
      $n.prototype.clear = wg, $n.prototype.delete = kg, $n.prototype.get = Tg, $n.prototype.has = _g, $n.prototype.set = Sg;
      function cr(t) {
        var r = -1, s = t == null ? 0 : t.length;
        for (this.__data__ = new $n(); ++r < s; )
          this.add(t[r]);
      }
      function Cg(t) {
        return this.__data__.set(t, f), this;
      }
      function $g(t) {
        return this.__data__.has(t);
      }
      cr.prototype.add = cr.prototype.push = Cg, cr.prototype.has = $g;
      function hn(t) {
        var r = this.__data__ = new Cn(t);
        this.size = r.size;
      }
      function Eg() {
        this.__data__ = new Cn(), this.size = 0;
      }
      function Pg(t) {
        var r = this.__data__, s = r.delete(t);
        return this.size = r.size, s;
      }
      function Ag(t) {
        return this.__data__.get(t);
      }
      function Rg(t) {
        return this.__data__.has(t);
      }
      function Ig(t, r) {
        var s = this.__data__;
        if (s instanceof Cn) {
          var l = s.__data__;
          if (!ui || l.length < a - 1)
            return l.push([t, r]), this.size = ++s.size, this;
          s = this.__data__ = new $n(l);
        }
        return s.set(t, r), this.size = s.size, this;
      }
      hn.prototype.clear = Eg, hn.prototype.delete = Pg, hn.prototype.get = Ag, hn.prototype.has = Rg, hn.prototype.set = Ig;
      function Hu(t, r) {
        var s = Re(t), l = !s && mr(t), d = !s && !l && Zn(t), b = !s && !l && !d && Nr(t), w = s || l || d || b, C = w ? Bs(t.length, Wm) : [], A = C.length;
        for (var B in t)
          (r || Ze.call(t, B)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
          (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          d && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          b && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
          Rn(B, A))) && C.push(B);
        return C;
      }
      function qu(t) {
        var r = t.length;
        return r ? t[ra(0, r - 1)] : i;
      }
      function Ug(t, r) {
        return Uo(Ft(t), fr(r, 0, t.length));
      }
      function Dg(t) {
        return Uo(Ft(t));
      }
      function qs(t, r, s) {
        (s !== i && !dn(t[r], s) || s === i && !(r in t)) && En(t, r, s);
      }
      function di(t, r, s) {
        var l = t[r];
        (!(Ze.call(t, r) && dn(l, s)) || s === i && !(r in t)) && En(t, r, s);
      }
      function xo(t, r) {
        for (var s = t.length; s--; )
          if (dn(t[s][0], r))
            return s;
        return -1;
      }
      function Mg(t, r, s, l) {
        return Hn(t, function(d, b, w) {
          r(l, d, s(d), w);
        }), l;
      }
      function Yu(t, r) {
        return t && yn(r, xt(r), t);
      }
      function Og(t, r) {
        return t && yn(r, Bt(r), t);
      }
      function En(t, r, s) {
        r == "__proto__" && po ? po(t, r, {
          configurable: !0,
          enumerable: !0,
          value: s,
          writable: !0
        }) : t[r] = s;
      }
      function Ys(t, r) {
        for (var s = -1, l = r.length, d = M(l), b = t == null; ++s < l; )
          d[s] = b ? i : Ea(t, r[s]);
        return d;
      }
      function fr(t, r, s) {
        return t === t && (s !== i && (t = t <= s ? t : s), r !== i && (t = t >= r ? t : r)), t;
      }
      function tn(t, r, s, l, d, b) {
        var w, C = r & x, A = r & T, B = r & E;
        if (s && (w = d ? s(t, l, d, b) : s(t)), w !== i)
          return w;
        if (!at(t))
          return t;
        var N = Re(t);
        if (N) {
          if (w = _0(t), !C)
            return Ft(t, w);
        } else {
          var q = $t(t), ne = q == Ce || q == X;
          if (Zn(t))
            return bc(t, C);
          if (q == ce || q == ae || ne && !d) {
            if (w = A || ne ? {} : Lc(t), !C)
              return A ? d0(t, Og(w, t)) : h0(t, Yu(w, t));
          } else {
            if (!tt[q])
              return d ? t : {};
            w = S0(t, q, C);
          }
        }
        b || (b = new hn());
        var de = b.get(t);
        if (de)
          return de;
        b.set(t, w), df(t) ? t.forEach(function(we) {
          w.add(tn(we, r, s, we, t, b));
        }) : ff(t) && t.forEach(function(we, Fe) {
          w.set(Fe, tn(we, r, s, Fe, t, b));
        });
        var xe = B ? A ? pa : da : A ? Bt : xt, De = N ? i : xe(t);
        return Jt(De || t, function(we, Fe) {
          De && (Fe = we, we = t[Fe]), di(w, Fe, tn(we, r, s, Fe, t, b));
        }), w;
      }
      function Lg(t) {
        var r = xt(t);
        return function(s) {
          return Ku(s, t, r);
        };
      }
      function Ku(t, r, s) {
        var l = s.length;
        if (t == null)
          return !l;
        for (t = et(t); l--; ) {
          var d = s[l], b = r[d], w = t[d];
          if (w === i && !(d in t) || !b(w))
            return !1;
        }
        return !0;
      }
      function Zu(t, r, s) {
        if (typeof t != "function")
          throw new Qt(u);
        return xi(function() {
          t.apply(i, s);
        }, r);
      }
      function pi(t, r, s, l) {
        var d = -1, b = no, w = !0, C = t.length, A = [], B = r.length;
        if (!C)
          return A;
        s && (r = it(r, Gt(s))), l ? (b = Ds, w = !1) : r.length >= a && (b = ai, w = !1, r = new cr(r));
        e:
          for (; ++d < C; ) {
            var N = t[d], q = s == null ? N : s(N);
            if (N = l || N !== 0 ? N : 0, w && q === q) {
              for (var ne = B; ne--; )
                if (r[ne] === q)
                  continue e;
              A.push(N);
            } else
              b(r, q, l) || A.push(N);
          }
        return A;
      }
      var Hn = Tc(bn), Xu = Tc(Zs, !0);
      function Fg(t, r) {
        var s = !0;
        return Hn(t, function(l, d, b) {
          return s = !!r(l, d, b), s;
        }), s;
      }
      function wo(t, r, s) {
        for (var l = -1, d = t.length; ++l < d; ) {
          var b = t[l], w = r(b);
          if (w != null && (C === i ? w === w && !qt(w) : s(w, C)))
            var C = w, A = b;
        }
        return A;
      }
      function Vg(t, r, s, l) {
        var d = t.length;
        for (s = Ie(s), s < 0 && (s = -s > d ? 0 : d + s), l = l === i || l > d ? d : Ie(l), l < 0 && (l += d), l = s > l ? 0 : mf(l); s < l; )
          t[s++] = r;
        return t;
      }
      function Ju(t, r) {
        var s = [];
        return Hn(t, function(l, d, b) {
          r(l, d, b) && s.push(l);
        }), s;
      }
      function _t(t, r, s, l, d) {
        var b = -1, w = t.length;
        for (s || (s = $0), d || (d = []); ++b < w; ) {
          var C = t[b];
          r > 0 && s(C) ? r > 1 ? _t(C, r - 1, s, l, d) : zn(d, C) : l || (d[d.length] = C);
        }
        return d;
      }
      var Ks = _c(), Qu = _c(!0);
      function bn(t, r) {
        return t && Ks(t, r, xt);
      }
      function Zs(t, r) {
        return t && Qu(t, r, xt);
      }
      function ko(t, r) {
        return Wn(r, function(s) {
          return In(t[s]);
        });
      }
      function hr(t, r) {
        r = Yn(r, t);
        for (var s = 0, l = r.length; t != null && s < l; )
          t = t[xn(r[s++])];
        return s && s == l ? t : i;
      }
      function ec(t, r, s) {
        var l = r(t);
        return Re(t) ? l : zn(l, s(t));
      }
      function Et(t) {
        return t == null ? t === i ? Dt : pe : lr && lr in et(t) ? w0(t) : D0(t);
      }
      function Xs(t, r) {
        return t > r;
      }
      function Bg(t, r) {
        return t != null && Ze.call(t, r);
      }
      function Ng(t, r) {
        return t != null && r in et(t);
      }
      function Wg(t, r, s) {
        return t >= Ct(r, s) && t < vt(r, s);
      }
      function Js(t, r, s) {
        for (var l = s ? Ds : no, d = t[0].length, b = t.length, w = b, C = M(b), A = 1 / 0, B = []; w--; ) {
          var N = t[w];
          w && r && (N = it(N, Gt(r))), A = Ct(N.length, A), C[w] = !s && (r || d >= 120 && N.length >= 120) ? new cr(w && N) : i;
        }
        N = t[0];
        var q = -1, ne = C[0];
        e:
          for (; ++q < d && B.length < A; ) {
            var de = N[q], xe = r ? r(de) : de;
            if (de = s || de !== 0 ? de : 0, !(ne ? ai(ne, xe) : l(B, xe, s))) {
              for (w = b; --w; ) {
                var De = C[w];
                if (!(De ? ai(De, xe) : l(t[w], xe, s)))
                  continue e;
              }
              ne && ne.push(xe), B.push(de);
            }
          }
        return B;
      }
      function zg(t, r, s, l) {
        return bn(t, function(d, b, w) {
          r(l, s(d), b, w);
        }), l;
      }
      function mi(t, r, s) {
        r = Yn(r, t), t = Nc(t, r);
        var l = t == null ? t : t[xn(rn(r))];
        return l == null ? i : jt(l, t, s);
      }
      function tc(t) {
        return ft(t) && Et(t) == ae;
      }
      function jg(t) {
        return ft(t) && Et(t) == Mt;
      }
      function Gg(t) {
        return ft(t) && Et(t) == ie;
      }
      function gi(t, r, s, l, d) {
        return t === r ? !0 : t == null || r == null || !ft(t) && !ft(r) ? t !== t && r !== r : Hg(t, r, s, l, gi, d);
      }
      function Hg(t, r, s, l, d, b) {
        var w = Re(t), C = Re(r), A = w ? be : $t(t), B = C ? be : $t(r);
        A = A == ae ? ce : A, B = B == ae ? ce : B;
        var N = A == ce, q = B == ce, ne = A == B;
        if (ne && Zn(t)) {
          if (!Zn(r))
            return !1;
          w = !0, N = !1;
        }
        if (ne && !N)
          return b || (b = new hn()), w || Nr(t) ? Dc(t, r, s, l, d, b) : y0(t, r, A, s, l, d, b);
        if (!(s & I)) {
          var de = N && Ze.call(t, "__wrapped__"), xe = q && Ze.call(r, "__wrapped__");
          if (de || xe) {
            var De = de ? t.value() : t, we = xe ? r.value() : r;
            return b || (b = new hn()), d(De, we, s, l, b);
          }
        }
        return ne ? (b || (b = new hn()), x0(t, r, s, l, d, b)) : !1;
      }
      function qg(t) {
        return ft(t) && $t(t) == j;
      }
      function Qs(t, r, s, l) {
        var d = s.length, b = d, w = !l;
        if (t == null)
          return !b;
        for (t = et(t); d--; ) {
          var C = s[d];
          if (w && C[2] ? C[1] !== t[C[0]] : !(C[0] in t))
            return !1;
        }
        for (; ++d < b; ) {
          C = s[d];
          var A = C[0], B = t[A], N = C[1];
          if (w && C[2]) {
            if (B === i && !(A in t))
              return !1;
          } else {
            var q = new hn();
            if (l)
              var ne = l(B, N, A, t, r, q);
            if (!(ne === i ? gi(N, B, I | D, l, q) : ne))
              return !1;
          }
        }
        return !0;
      }
      function nc(t) {
        if (!at(t) || P0(t))
          return !1;
        var r = In(t) ? qm : kt;
        return r.test(pr(t));
      }
      function Yg(t) {
        return ft(t) && Et(t) == Le;
      }
      function Kg(t) {
        return ft(t) && $t(t) == He;
      }
      function Zg(t) {
        return ft(t) && Vo(t.length) && !!rt[Et(t)];
      }
      function rc(t) {
        return typeof t == "function" ? t : t == null ? Nt : typeof t == "object" ? Re(t) ? sc(t[0], t[1]) : oc(t) : Cf(t);
      }
      function ea(t) {
        if (!yi(t))
          return Qm(t);
        var r = [];
        for (var s in et(t))
          Ze.call(t, s) && s != "constructor" && r.push(s);
        return r;
      }
      function Xg(t) {
        if (!at(t))
          return U0(t);
        var r = yi(t), s = [];
        for (var l in t)
          l == "constructor" && (r || !Ze.call(t, l)) || s.push(l);
        return s;
      }
      function ta(t, r) {
        return t < r;
      }
      function ic(t, r) {
        var s = -1, l = Vt(t) ? M(t.length) : [];
        return Hn(t, function(d, b, w) {
          l[++s] = r(d, b, w);
        }), l;
      }
      function oc(t) {
        var r = ga(t);
        return r.length == 1 && r[0][2] ? Vc(r[0][0], r[0][1]) : function(s) {
          return s === t || Qs(s, t, r);
        };
      }
      function sc(t, r) {
        return ba(t) && Fc(r) ? Vc(xn(t), r) : function(s) {
          var l = Ea(s, t);
          return l === i && l === r ? Pa(s, t) : gi(r, l, I | D);
        };
      }
      function To(t, r, s, l, d) {
        t !== r && Ks(r, function(b, w) {
          if (d || (d = new hn()), at(b))
            Jg(t, r, w, s, To, l, d);
          else {
            var C = l ? l(xa(t, w), b, w + "", t, r, d) : i;
            C === i && (C = b), qs(t, w, C);
          }
        }, Bt);
      }
      function Jg(t, r, s, l, d, b, w) {
        var C = xa(t, s), A = xa(r, s), B = w.get(A);
        if (B) {
          qs(t, s, B);
          return;
        }
        var N = b ? b(C, A, s + "", t, r, w) : i, q = N === i;
        if (q) {
          var ne = Re(A), de = !ne && Zn(A), xe = !ne && !de && Nr(A);
          N = A, ne || de || xe ? Re(C) ? N = C : ht(C) ? N = Ft(C) : de ? (q = !1, N = bc(A, !0)) : xe ? (q = !1, N = yc(A, !0)) : N = [] : wi(A) || mr(A) ? (N = C, mr(C) ? N = gf(C) : (!at(C) || In(C)) && (N = Lc(A))) : q = !1;
        }
        q && (w.set(A, N), d(N, A, l, b, w), w.delete(A)), qs(t, s, N);
      }
      function ac(t, r) {
        var s = t.length;
        if (s)
          return r += r < 0 ? s : 0, Rn(r, s) ? t[r] : i;
      }
      function lc(t, r, s) {
        r.length ? r = it(r, function(b) {
          return Re(b) ? function(w) {
            return hr(w, b.length === 1 ? b[0] : b);
          } : b;
        }) : r = [Nt];
        var l = -1;
        r = it(r, Gt(ye()));
        var d = ic(t, function(b, w, C) {
          var A = it(r, function(B) {
            return B(b);
          });
          return { criteria: A, index: ++l, value: b };
        });
        return Sm(d, function(b, w) {
          return f0(b, w, s);
        });
      }
      function Qg(t, r) {
        return uc(t, r, function(s, l) {
          return Pa(t, l);
        });
      }
      function uc(t, r, s) {
        for (var l = -1, d = r.length, b = {}; ++l < d; ) {
          var w = r[l], C = hr(t, w);
          s(C, w) && vi(b, Yn(w, t), C);
        }
        return b;
      }
      function e0(t) {
        return function(r) {
          return hr(r, t);
        };
      }
      function na(t, r, s, l) {
        var d = l ? _m : Ar, b = -1, w = r.length, C = t;
        for (t === r && (r = Ft(r)), s && (C = it(t, Gt(s))); ++b < w; )
          for (var A = 0, B = r[b], N = s ? s(B) : B; (A = d(C, N, A, l)) > -1; )
            C !== t && ho.call(C, A, 1), ho.call(t, A, 1);
        return t;
      }
      function cc(t, r) {
        for (var s = t ? r.length : 0, l = s - 1; s--; ) {
          var d = r[s];
          if (s == l || d !== b) {
            var b = d;
            Rn(d) ? ho.call(t, d, 1) : sa(t, d);
          }
        }
        return t;
      }
      function ra(t, r) {
        return t + go(ju() * (r - t + 1));
      }
      function t0(t, r, s, l) {
        for (var d = -1, b = vt(mo((r - t) / (s || 1)), 0), w = M(b); b--; )
          w[l ? b : ++d] = t, t += s;
        return w;
      }
      function ia(t, r) {
        var s = "";
        if (!t || r < 1 || r > Se)
          return s;
        do
          r % 2 && (s += t), r = go(r / 2), r && (t += t);
        while (r);
        return s;
      }
      function Me(t, r) {
        return wa(Bc(t, r, Nt), t + "");
      }
      function n0(t) {
        return qu(Wr(t));
      }
      function r0(t, r) {
        var s = Wr(t);
        return Uo(s, fr(r, 0, s.length));
      }
      function vi(t, r, s, l) {
        if (!at(t))
          return t;
        r = Yn(r, t);
        for (var d = -1, b = r.length, w = b - 1, C = t; C != null && ++d < b; ) {
          var A = xn(r[d]), B = s;
          if (A === "__proto__" || A === "constructor" || A === "prototype")
            return t;
          if (d != w) {
            var N = C[A];
            B = l ? l(N, A, C) : i, B === i && (B = at(N) ? N : Rn(r[d + 1]) ? [] : {});
          }
          di(C, A, B), C = C[A];
        }
        return t;
      }
      var fc = vo ? function(t, r) {
        return vo.set(t, r), t;
      } : Nt, i0 = po ? function(t, r) {
        return po(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ra(r),
          writable: !0
        });
      } : Nt;
      function o0(t) {
        return Uo(Wr(t));
      }
      function nn(t, r, s) {
        var l = -1, d = t.length;
        r < 0 && (r = -r > d ? 0 : d + r), s = s > d ? d : s, s < 0 && (s += d), d = r > s ? 0 : s - r >>> 0, r >>>= 0;
        for (var b = M(d); ++l < d; )
          b[l] = t[l + r];
        return b;
      }
      function s0(t, r) {
        var s;
        return Hn(t, function(l, d, b) {
          return s = r(l, d, b), !s;
        }), !!s;
      }
      function _o(t, r, s) {
        var l = 0, d = t == null ? l : t.length;
        if (typeof r == "number" && r === r && d <= p) {
          for (; l < d; ) {
            var b = l + d >>> 1, w = t[b];
            w !== null && !qt(w) && (s ? w <= r : w < r) ? l = b + 1 : d = b;
          }
          return d;
        }
        return oa(t, r, Nt, s);
      }
      function oa(t, r, s, l) {
        var d = 0, b = t == null ? 0 : t.length;
        if (b === 0)
          return 0;
        r = s(r);
        for (var w = r !== r, C = r === null, A = qt(r), B = r === i; d < b; ) {
          var N = go((d + b) / 2), q = s(t[N]), ne = q !== i, de = q === null, xe = q === q, De = qt(q);
          if (w)
            var we = l || xe;
          else
            B ? we = xe && (l || ne) : C ? we = xe && ne && (l || !de) : A ? we = xe && ne && !de && (l || !De) : de || De ? we = !1 : we = l ? q <= r : q < r;
          we ? d = N + 1 : b = N;
        }
        return Ct(b, S);
      }
      function hc(t, r) {
        for (var s = -1, l = t.length, d = 0, b = []; ++s < l; ) {
          var w = t[s], C = r ? r(w) : w;
          if (!s || !dn(C, A)) {
            var A = C;
            b[d++] = w === 0 ? 0 : w;
          }
        }
        return b;
      }
      function dc(t) {
        return typeof t == "number" ? t : qt(t) ? k : +t;
      }
      function Ht(t) {
        if (typeof t == "string")
          return t;
        if (Re(t))
          return it(t, Ht) + "";
        if (qt(t))
          return Gu ? Gu.call(t) : "";
        var r = t + "";
        return r == "0" && 1 / t == -je ? "-0" : r;
      }
      function qn(t, r, s) {
        var l = -1, d = no, b = t.length, w = !0, C = [], A = C;
        if (s)
          w = !1, d = Ds;
        else if (b >= a) {
          var B = r ? null : v0(t);
          if (B)
            return io(B);
          w = !1, d = ai, A = new cr();
        } else
          A = r ? [] : C;
        e:
          for (; ++l < b; ) {
            var N = t[l], q = r ? r(N) : N;
            if (N = s || N !== 0 ? N : 0, w && q === q) {
              for (var ne = A.length; ne--; )
                if (A[ne] === q)
                  continue e;
              r && A.push(q), C.push(N);
            } else
              d(A, q, s) || (A !== C && A.push(q), C.push(N));
          }
        return C;
      }
      function sa(t, r) {
        return r = Yn(r, t), t = Nc(t, r), t == null || delete t[xn(rn(r))];
      }
      function pc(t, r, s, l) {
        return vi(t, r, s(hr(t, r)), l);
      }
      function So(t, r, s, l) {
        for (var d = t.length, b = l ? d : -1; (l ? b-- : ++b < d) && r(t[b], b, t); )
          ;
        return s ? nn(t, l ? 0 : b, l ? b + 1 : d) : nn(t, l ? b + 1 : 0, l ? d : b);
      }
      function mc(t, r) {
        var s = t;
        return s instanceof Be && (s = s.value()), Ms(r, function(l, d) {
          return d.func.apply(d.thisArg, zn([l], d.args));
        }, s);
      }
      function aa(t, r, s) {
        var l = t.length;
        if (l < 2)
          return l ? qn(t[0]) : [];
        for (var d = -1, b = M(l); ++d < l; )
          for (var w = t[d], C = -1; ++C < l; )
            C != d && (b[d] = pi(b[d] || w, t[C], r, s));
        return qn(_t(b, 1), r, s);
      }
      function gc(t, r, s) {
        for (var l = -1, d = t.length, b = r.length, w = {}; ++l < d; ) {
          var C = l < b ? r[l] : i;
          s(w, t[l], C);
        }
        return w;
      }
      function la(t) {
        return ht(t) ? t : [];
      }
      function ua(t) {
        return typeof t == "function" ? t : Nt;
      }
      function Yn(t, r) {
        return Re(t) ? t : ba(t, r) ? [t] : Gc(Ke(t));
      }
      var a0 = Me;
      function Kn(t, r, s) {
        var l = t.length;
        return s = s === i ? l : s, !r && s >= l ? t : nn(t, r, s);
      }
      var vc = Ym || function(t) {
        return Tt.clearTimeout(t);
      };
      function bc(t, r) {
        if (r)
          return t.slice();
        var s = t.length, l = Vu ? Vu(s) : new t.constructor(s);
        return t.copy(l), l;
      }
      function ca(t) {
        var r = new t.constructor(t.byteLength);
        return new co(r).set(new co(t)), r;
      }
      function l0(t, r) {
        var s = r ? ca(t.buffer) : t.buffer;
        return new t.constructor(s, t.byteOffset, t.byteLength);
      }
      function u0(t) {
        var r = new t.constructor(t.source, Ye.exec(t));
        return r.lastIndex = t.lastIndex, r;
      }
      function c0(t) {
        return hi ? et(hi.call(t)) : {};
      }
      function yc(t, r) {
        var s = r ? ca(t.buffer) : t.buffer;
        return new t.constructor(s, t.byteOffset, t.length);
      }
      function xc(t, r) {
        if (t !== r) {
          var s = t !== i, l = t === null, d = t === t, b = qt(t), w = r !== i, C = r === null, A = r === r, B = qt(r);
          if (!C && !B && !b && t > r || b && w && A && !C && !B || l && w && A || !s && A || !d)
            return 1;
          if (!l && !b && !B && t < r || B && s && d && !l && !b || C && s && d || !w && d || !A)
            return -1;
        }
        return 0;
      }
      function f0(t, r, s) {
        for (var l = -1, d = t.criteria, b = r.criteria, w = d.length, C = s.length; ++l < w; ) {
          var A = xc(d[l], b[l]);
          if (A) {
            if (l >= C)
              return A;
            var B = s[l];
            return A * (B == "desc" ? -1 : 1);
          }
        }
        return t.index - r.index;
      }
      function wc(t, r, s, l) {
        for (var d = -1, b = t.length, w = s.length, C = -1, A = r.length, B = vt(b - w, 0), N = M(A + B), q = !l; ++C < A; )
          N[C] = r[C];
        for (; ++d < w; )
          (q || d < b) && (N[s[d]] = t[d]);
        for (; B--; )
          N[C++] = t[d++];
        return N;
      }
      function kc(t, r, s, l) {
        for (var d = -1, b = t.length, w = -1, C = s.length, A = -1, B = r.length, N = vt(b - C, 0), q = M(N + B), ne = !l; ++d < N; )
          q[d] = t[d];
        for (var de = d; ++A < B; )
          q[de + A] = r[A];
        for (; ++w < C; )
          (ne || d < b) && (q[de + s[w]] = t[d++]);
        return q;
      }
      function Ft(t, r) {
        var s = -1, l = t.length;
        for (r || (r = M(l)); ++s < l; )
          r[s] = t[s];
        return r;
      }
      function yn(t, r, s, l) {
        var d = !s;
        s || (s = {});
        for (var b = -1, w = r.length; ++b < w; ) {
          var C = r[b], A = l ? l(s[C], t[C], C, s, t) : i;
          A === i && (A = t[C]), d ? En(s, C, A) : di(s, C, A);
        }
        return s;
      }
      function h0(t, r) {
        return yn(t, va(t), r);
      }
      function d0(t, r) {
        return yn(t, Mc(t), r);
      }
      function Co(t, r) {
        return function(s, l) {
          var d = Re(s) ? bm : Mg, b = r ? r() : {};
          return d(s, t, ye(l, 2), b);
        };
      }
      function Fr(t) {
        return Me(function(r, s) {
          var l = -1, d = s.length, b = d > 1 ? s[d - 1] : i, w = d > 2 ? s[2] : i;
          for (b = t.length > 3 && typeof b == "function" ? (d--, b) : i, w && Pt(s[0], s[1], w) && (b = d < 3 ? i : b, d = 1), r = et(r); ++l < d; ) {
            var C = s[l];
            C && t(r, C, l, b);
          }
          return r;
        });
      }
      function Tc(t, r) {
        return function(s, l) {
          if (s == null)
            return s;
          if (!Vt(s))
            return t(s, l);
          for (var d = s.length, b = r ? d : -1, w = et(s); (r ? b-- : ++b < d) && l(w[b], b, w) !== !1; )
            ;
          return s;
        };
      }
      function _c(t) {
        return function(r, s, l) {
          for (var d = -1, b = et(r), w = l(r), C = w.length; C--; ) {
            var A = w[t ? C : ++d];
            if (s(b[A], A, b) === !1)
              break;
          }
          return r;
        };
      }
      function p0(t, r, s) {
        var l = r & W, d = bi(t);
        function b() {
          var w = this && this !== Tt && this instanceof b ? d : t;
          return w.apply(l ? s : this, arguments);
        }
        return b;
      }
      function Sc(t) {
        return function(r) {
          r = Ke(r);
          var s = Rr(r) ? fn(r) : i, l = s ? s[0] : r.charAt(0), d = s ? Kn(s, 1).join("") : r.slice(1);
          return l[t]() + d;
        };
      }
      function Vr(t) {
        return function(r) {
          return Ms(_f(Tf(r).replace(im, "")), t, "");
        };
      }
      function bi(t) {
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return new t();
            case 1:
              return new t(r[0]);
            case 2:
              return new t(r[0], r[1]);
            case 3:
              return new t(r[0], r[1], r[2]);
            case 4:
              return new t(r[0], r[1], r[2], r[3]);
            case 5:
              return new t(r[0], r[1], r[2], r[3], r[4]);
            case 6:
              return new t(r[0], r[1], r[2], r[3], r[4], r[5]);
            case 7:
              return new t(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
          }
          var s = Lr(t.prototype), l = t.apply(s, r);
          return at(l) ? l : s;
        };
      }
      function m0(t, r, s) {
        var l = bi(t);
        function d() {
          for (var b = arguments.length, w = M(b), C = b, A = Br(d); C--; )
            w[C] = arguments[C];
          var B = b < 3 && w[0] !== A && w[b - 1] !== A ? [] : jn(w, A);
          if (b -= B.length, b < s)
            return Ac(
              t,
              r,
              $o,
              d.placeholder,
              i,
              w,
              B,
              i,
              i,
              s - b
            );
          var N = this && this !== Tt && this instanceof d ? l : t;
          return jt(N, this, w);
        }
        return d;
      }
      function Cc(t) {
        return function(r, s, l) {
          var d = et(r);
          if (!Vt(r)) {
            var b = ye(s, 3);
            r = xt(r), s = function(C) {
              return b(d[C], C, d);
            };
          }
          var w = t(r, s, l);
          return w > -1 ? d[b ? r[w] : w] : i;
        };
      }
      function $c(t) {
        return An(function(r) {
          var s = r.length, l = s, d = en.prototype.thru;
          for (t && r.reverse(); l--; ) {
            var b = r[l];
            if (typeof b != "function")
              throw new Qt(u);
            if (d && !w && Ro(b) == "wrapper")
              var w = new en([], !0);
          }
          for (l = w ? l : s; ++l < s; ) {
            b = r[l];
            var C = Ro(b), A = C == "wrapper" ? ma(b) : i;
            A && ya(A[0]) && A[1] == (ge | L | Q | he) && !A[4].length && A[9] == 1 ? w = w[Ro(A[0])].apply(w, A[3]) : w = b.length == 1 && ya(b) ? w[C]() : w.thru(b);
          }
          return function() {
            var B = arguments, N = B[0];
            if (w && B.length == 1 && Re(N))
              return w.plant(N).value();
            for (var q = 0, ne = s ? r[q].apply(this, B) : N; ++q < s; )
              ne = r[q].call(this, ne);
            return ne;
          };
        });
      }
      function $o(t, r, s, l, d, b, w, C, A, B) {
        var N = r & ge, q = r & W, ne = r & F, de = r & (L | G), xe = r & $e, De = ne ? i : bi(t);
        function we() {
          for (var Fe = arguments.length, Ne = M(Fe), Yt = Fe; Yt--; )
            Ne[Yt] = arguments[Yt];
          if (de)
            var At = Br(we), Kt = $m(Ne, At);
          if (l && (Ne = wc(Ne, l, d, de)), b && (Ne = kc(Ne, b, w, de)), Fe -= Kt, de && Fe < B) {
            var dt = jn(Ne, At);
            return Ac(
              t,
              r,
              $o,
              we.placeholder,
              s,
              Ne,
              dt,
              C,
              A,
              B - Fe
            );
          }
          var pn = q ? s : this, Dn = ne ? pn[t] : t;
          return Fe = Ne.length, C ? Ne = M0(Ne, C) : xe && Fe > 1 && Ne.reverse(), N && A < Fe && (Ne.length = A), this && this !== Tt && this instanceof we && (Dn = De || bi(Dn)), Dn.apply(pn, Ne);
        }
        return we;
      }
      function Ec(t, r) {
        return function(s, l) {
          return zg(s, t, r(l), {});
        };
      }
      function Eo(t, r) {
        return function(s, l) {
          var d;
          if (s === i && l === i)
            return r;
          if (s !== i && (d = s), l !== i) {
            if (d === i)
              return l;
            typeof s == "string" || typeof l == "string" ? (s = Ht(s), l = Ht(l)) : (s = dc(s), l = dc(l)), d = t(s, l);
          }
          return d;
        };
      }
      function fa(t) {
        return An(function(r) {
          return r = it(r, Gt(ye())), Me(function(s) {
            var l = this;
            return t(r, function(d) {
              return jt(d, l, s);
            });
          });
        });
      }
      function Po(t, r) {
        r = r === i ? " " : Ht(r);
        var s = r.length;
        if (s < 2)
          return s ? ia(r, t) : r;
        var l = ia(r, mo(t / Ir(r)));
        return Rr(r) ? Kn(fn(l), 0, t).join("") : l.slice(0, t);
      }
      function g0(t, r, s, l) {
        var d = r & W, b = bi(t);
        function w() {
          for (var C = -1, A = arguments.length, B = -1, N = l.length, q = M(N + A), ne = this && this !== Tt && this instanceof w ? b : t; ++B < N; )
            q[B] = l[B];
          for (; A--; )
            q[B++] = arguments[++C];
          return jt(ne, d ? s : this, q);
        }
        return w;
      }
      function Pc(t) {
        return function(r, s, l) {
          return l && typeof l != "number" && Pt(r, s, l) && (s = l = i), r = Un(r), s === i ? (s = r, r = 0) : s = Un(s), l = l === i ? r < s ? 1 : -1 : Un(l), t0(r, s, l, t);
        };
      }
      function Ao(t) {
        return function(r, s) {
          return typeof r == "string" && typeof s == "string" || (r = on(r), s = on(s)), t(r, s);
        };
      }
      function Ac(t, r, s, l, d, b, w, C, A, B) {
        var N = r & L, q = N ? w : i, ne = N ? i : w, de = N ? b : i, xe = N ? i : b;
        r |= N ? Q : fe, r &= ~(N ? fe : Q), r & z || (r &= ~(W | F));
        var De = [
          t,
          r,
          d,
          de,
          q,
          xe,
          ne,
          C,
          A,
          B
        ], we = s.apply(i, De);
        return ya(t) && Wc(we, De), we.placeholder = l, zc(we, t, r);
      }
      function ha(t) {
        var r = gt[t];
        return function(s, l) {
          if (s = on(s), l = l == null ? 0 : Ct(Ie(l), 292), l && zu(s)) {
            var d = (Ke(s) + "e").split("e"), b = r(d[0] + "e" + (+d[1] + l));
            return d = (Ke(b) + "e").split("e"), +(d[0] + "e" + (+d[1] - l));
          }
          return r(s);
        };
      }
      var v0 = Mr && 1 / io(new Mr([, -0]))[1] == je ? function(t) {
        return new Mr(t);
      } : Da;
      function Rc(t) {
        return function(r) {
          var s = $t(r);
          return s == j ? Ws(r) : s == He ? Dm(r) : Cm(r, t(r));
        };
      }
      function Pn(t, r, s, l, d, b, w, C) {
        var A = r & F;
        if (!A && typeof t != "function")
          throw new Qt(u);
        var B = l ? l.length : 0;
        if (B || (r &= ~(Q | fe), l = d = i), w = w === i ? w : vt(Ie(w), 0), C = C === i ? C : Ie(C), B -= d ? d.length : 0, r & fe) {
          var N = l, q = d;
          l = d = i;
        }
        var ne = A ? i : ma(t), de = [
          t,
          r,
          s,
          l,
          d,
          N,
          q,
          b,
          w,
          C
        ];
        if (ne && I0(de, ne), t = de[0], r = de[1], s = de[2], l = de[3], d = de[4], C = de[9] = de[9] === i ? A ? 0 : t.length : vt(de[9] - B, 0), !C && r & (L | G) && (r &= ~(L | G)), !r || r == W)
          var xe = p0(t, r, s);
        else
          r == L || r == G ? xe = m0(t, r, C) : (r == Q || r == (W | Q)) && !d.length ? xe = g0(t, r, s, l) : xe = $o.apply(i, de);
        var De = ne ? fc : Wc;
        return zc(De(xe, de), t, r);
      }
      function Ic(t, r, s, l) {
        return t === i || dn(t, Dr[s]) && !Ze.call(l, s) ? r : t;
      }
      function Uc(t, r, s, l, d, b) {
        return at(t) && at(r) && (b.set(r, t), To(t, r, i, Uc, b), b.delete(r)), t;
      }
      function b0(t) {
        return wi(t) ? i : t;
      }
      function Dc(t, r, s, l, d, b) {
        var w = s & I, C = t.length, A = r.length;
        if (C != A && !(w && A > C))
          return !1;
        var B = b.get(t), N = b.get(r);
        if (B && N)
          return B == r && N == t;
        var q = -1, ne = !0, de = s & D ? new cr() : i;
        for (b.set(t, r), b.set(r, t); ++q < C; ) {
          var xe = t[q], De = r[q];
          if (l)
            var we = w ? l(De, xe, q, r, t, b) : l(xe, De, q, t, r, b);
          if (we !== i) {
            if (we)
              continue;
            ne = !1;
            break;
          }
          if (de) {
            if (!Os(r, function(Fe, Ne) {
              if (!ai(de, Ne) && (xe === Fe || d(xe, Fe, s, l, b)))
                return de.push(Ne);
            })) {
              ne = !1;
              break;
            }
          } else if (!(xe === De || d(xe, De, s, l, b))) {
            ne = !1;
            break;
          }
        }
        return b.delete(t), b.delete(r), ne;
      }
      function y0(t, r, s, l, d, b, w) {
        switch (s) {
          case Nn:
            if (t.byteLength != r.byteLength || t.byteOffset != r.byteOffset)
              return !1;
            t = t.buffer, r = r.buffer;
          case Mt:
            return !(t.byteLength != r.byteLength || !b(new co(t), new co(r)));
          case ee:
          case ie:
          case J:
            return dn(+t, +r);
          case Z:
            return t.name == r.name && t.message == r.message;
          case Le:
          case Xe:
            return t == r + "";
          case j:
            var C = Ws;
          case He:
            var A = l & I;
            if (C || (C = io), t.size != r.size && !A)
              return !1;
            var B = w.get(t);
            if (B)
              return B == r;
            l |= D, w.set(t, r);
            var N = Dc(C(t), C(r), l, d, b, w);
            return w.delete(t), N;
          case ut:
            if (hi)
              return hi.call(t) == hi.call(r);
        }
        return !1;
      }
      function x0(t, r, s, l, d, b) {
        var w = s & I, C = da(t), A = C.length, B = da(r), N = B.length;
        if (A != N && !w)
          return !1;
        for (var q = A; q--; ) {
          var ne = C[q];
          if (!(w ? ne in r : Ze.call(r, ne)))
            return !1;
        }
        var de = b.get(t), xe = b.get(r);
        if (de && xe)
          return de == r && xe == t;
        var De = !0;
        b.set(t, r), b.set(r, t);
        for (var we = w; ++q < A; ) {
          ne = C[q];
          var Fe = t[ne], Ne = r[ne];
          if (l)
            var Yt = w ? l(Ne, Fe, ne, r, t, b) : l(Fe, Ne, ne, t, r, b);
          if (!(Yt === i ? Fe === Ne || d(Fe, Ne, s, l, b) : Yt)) {
            De = !1;
            break;
          }
          we || (we = ne == "constructor");
        }
        if (De && !we) {
          var At = t.constructor, Kt = r.constructor;
          At != Kt && "constructor" in t && "constructor" in r && !(typeof At == "function" && At instanceof At && typeof Kt == "function" && Kt instanceof Kt) && (De = !1);
        }
        return b.delete(t), b.delete(r), De;
      }
      function An(t) {
        return wa(Bc(t, i, Kc), t + "");
      }
      function da(t) {
        return ec(t, xt, va);
      }
      function pa(t) {
        return ec(t, Bt, Mc);
      }
      var ma = vo ? function(t) {
        return vo.get(t);
      } : Da;
      function Ro(t) {
        for (var r = t.name + "", s = Or[r], l = Ze.call(Or, r) ? s.length : 0; l--; ) {
          var d = s[l], b = d.func;
          if (b == null || b == t)
            return d.name;
        }
        return r;
      }
      function Br(t) {
        var r = Ze.call(v, "placeholder") ? v : t;
        return r.placeholder;
      }
      function ye() {
        var t = v.iteratee || Ia;
        return t = t === Ia ? rc : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function Io(t, r) {
        var s = t.__data__;
        return E0(r) ? s[typeof r == "string" ? "string" : "hash"] : s.map;
      }
      function ga(t) {
        for (var r = xt(t), s = r.length; s--; ) {
          var l = r[s], d = t[l];
          r[s] = [l, d, Fc(d)];
        }
        return r;
      }
      function dr(t, r) {
        var s = Rm(t, r);
        return nc(s) ? s : i;
      }
      function w0(t) {
        var r = Ze.call(t, lr), s = t[lr];
        try {
          t[lr] = i;
          var l = !0;
        } catch {
        }
        var d = lo.call(t);
        return l && (r ? t[lr] = s : delete t[lr]), d;
      }
      var va = js ? function(t) {
        return t == null ? [] : (t = et(t), Wn(js(t), function(r) {
          return Nu.call(t, r);
        }));
      } : Ma, Mc = js ? function(t) {
        for (var r = []; t; )
          zn(r, va(t)), t = fo(t);
        return r;
      } : Ma, $t = Et;
      (Gs && $t(new Gs(new ArrayBuffer(1))) != Nn || ui && $t(new ui()) != j || Hs && $t(Hs.resolve()) != Ee || Mr && $t(new Mr()) != He || ci && $t(new ci()) != yt) && ($t = function(t) {
        var r = Et(t), s = r == ce ? t.constructor : i, l = s ? pr(s) : "";
        if (l)
          switch (l) {
            case rg:
              return Nn;
            case ig:
              return j;
            case og:
              return Ee;
            case sg:
              return He;
            case ag:
              return yt;
          }
        return r;
      });
      function k0(t, r, s) {
        for (var l = -1, d = s.length; ++l < d; ) {
          var b = s[l], w = b.size;
          switch (b.type) {
            case "drop":
              t += w;
              break;
            case "dropRight":
              r -= w;
              break;
            case "take":
              r = Ct(r, t + w);
              break;
            case "takeRight":
              t = vt(t, r - w);
              break;
          }
        }
        return { start: t, end: r };
      }
      function T0(t) {
        var r = t.match(Cs);
        return r ? r[1].split(_) : [];
      }
      function Oc(t, r, s) {
        r = Yn(r, t);
        for (var l = -1, d = r.length, b = !1; ++l < d; ) {
          var w = xn(r[l]);
          if (!(b = t != null && s(t, w)))
            break;
          t = t[w];
        }
        return b || ++l != d ? b : (d = t == null ? 0 : t.length, !!d && Vo(d) && Rn(w, d) && (Re(t) || mr(t)));
      }
      function _0(t) {
        var r = t.length, s = new t.constructor(r);
        return r && typeof t[0] == "string" && Ze.call(t, "index") && (s.index = t.index, s.input = t.input), s;
      }
      function Lc(t) {
        return typeof t.constructor == "function" && !yi(t) ? Lr(fo(t)) : {};
      }
      function S0(t, r, s) {
        var l = t.constructor;
        switch (r) {
          case Mt:
            return ca(t);
          case ee:
          case ie:
            return new l(+t);
          case Nn:
            return l0(t, s);
          case Cr:
          case $r:
          case sr:
          case Xr:
          case Jr:
          case Qr:
          case ei:
          case ti:
          case ni:
            return yc(t, s);
          case j:
            return new l();
          case J:
          case Xe:
            return new l(t);
          case Le:
            return u0(t);
          case He:
            return new l();
          case ut:
            return c0(t);
        }
      }
      function C0(t, r) {
        var s = r.length;
        if (!s)
          return t;
        var l = s - 1;
        return r[l] = (s > 1 ? "& " : "") + r[l], r = r.join(s > 2 ? ", " : " "), t.replace(Ss, `{
/* [wrapped with ` + r + `] */
`);
      }
      function $0(t) {
        return Re(t) || mr(t) || !!(Wu && t && t[Wu]);
      }
      function Rn(t, r) {
        var s = typeof t;
        return r = r ?? Se, !!r && (s == "number" || s != "symbol" && ct.test(t)) && t > -1 && t % 1 == 0 && t < r;
      }
      function Pt(t, r, s) {
        if (!at(s))
          return !1;
        var l = typeof r;
        return (l == "number" ? Vt(s) && Rn(r, s.length) : l == "string" && r in s) ? dn(s[r], t) : !1;
      }
      function ba(t, r) {
        if (Re(t))
          return !1;
        var s = typeof t;
        return s == "number" || s == "symbol" || s == "boolean" || t == null || qt(t) ? !0 : Ji.test(t) || !Xi.test(t) || r != null && t in et(r);
      }
      function E0(t) {
        var r = typeof t;
        return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
      }
      function ya(t) {
        var r = Ro(t), s = v[r];
        if (typeof s != "function" || !(r in Be.prototype))
          return !1;
        if (t === s)
          return !0;
        var l = ma(s);
        return !!l && t === l[0];
      }
      function P0(t) {
        return !!Fu && Fu in t;
      }
      var A0 = so ? In : Oa;
      function yi(t) {
        var r = t && t.constructor, s = typeof r == "function" && r.prototype || Dr;
        return t === s;
      }
      function Fc(t) {
        return t === t && !at(t);
      }
      function Vc(t, r) {
        return function(s) {
          return s == null ? !1 : s[t] === r && (r !== i || t in et(s));
        };
      }
      function R0(t) {
        var r = Lo(t, function(l) {
          return s.size === m && s.clear(), l;
        }), s = r.cache;
        return r;
      }
      function I0(t, r) {
        var s = t[1], l = r[1], d = s | l, b = d < (W | F | ge), w = l == ge && s == L || l == ge && s == he && t[7].length <= r[8] || l == (ge | he) && r[7].length <= r[8] && s == L;
        if (!(b || w))
          return t;
        l & W && (t[2] = r[2], d |= s & W ? 0 : z);
        var C = r[3];
        if (C) {
          var A = t[3];
          t[3] = A ? wc(A, C, r[4]) : C, t[4] = A ? jn(t[3], g) : r[4];
        }
        return C = r[5], C && (A = t[5], t[5] = A ? kc(A, C, r[6]) : C, t[6] = A ? jn(t[5], g) : r[6]), C = r[7], C && (t[7] = C), l & ge && (t[8] = t[8] == null ? r[8] : Ct(t[8], r[8])), t[9] == null && (t[9] = r[9]), t[0] = r[0], t[1] = d, t;
      }
      function U0(t) {
        var r = [];
        if (t != null)
          for (var s in et(t))
            r.push(s);
        return r;
      }
      function D0(t) {
        return lo.call(t);
      }
      function Bc(t, r, s) {
        return r = vt(r === i ? t.length - 1 : r, 0), function() {
          for (var l = arguments, d = -1, b = vt(l.length - r, 0), w = M(b); ++d < b; )
            w[d] = l[r + d];
          d = -1;
          for (var C = M(r + 1); ++d < r; )
            C[d] = l[d];
          return C[r] = s(w), jt(t, this, C);
        };
      }
      function Nc(t, r) {
        return r.length < 2 ? t : hr(t, nn(r, 0, -1));
      }
      function M0(t, r) {
        for (var s = t.length, l = Ct(r.length, s), d = Ft(t); l--; ) {
          var b = r[l];
          t[l] = Rn(b, s) ? d[b] : i;
        }
        return t;
      }
      function xa(t, r) {
        if (!(r === "constructor" && typeof t[r] == "function") && r != "__proto__")
          return t[r];
      }
      var Wc = jc(fc), xi = Zm || function(t, r) {
        return Tt.setTimeout(t, r);
      }, wa = jc(i0);
      function zc(t, r, s) {
        var l = r + "";
        return wa(t, C0(l, O0(T0(l), s)));
      }
      function jc(t) {
        var r = 0, s = 0;
        return function() {
          var l = eg(), d = re - (l - s);
          if (s = l, d > 0) {
            if (++r >= _e)
              return arguments[0];
          } else
            r = 0;
          return t.apply(i, arguments);
        };
      }
      function Uo(t, r) {
        var s = -1, l = t.length, d = l - 1;
        for (r = r === i ? l : r; ++s < r; ) {
          var b = ra(s, d), w = t[b];
          t[b] = t[s], t[s] = w;
        }
        return t.length = r, t;
      }
      var Gc = R0(function(t) {
        var r = [];
        return t.charCodeAt(0) === 46 && r.push(""), t.replace(Ts, function(s, l, d, b) {
          r.push(d ? b.replace(Te, "$1") : l || s);
        }), r;
      });
      function xn(t) {
        if (typeof t == "string" || qt(t))
          return t;
        var r = t + "";
        return r == "0" && 1 / t == -je ? "-0" : r;
      }
      function pr(t) {
        if (t != null) {
          try {
            return ao.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function O0(t, r) {
        return Jt(H, function(s) {
          var l = "_." + s[0];
          r & s[1] && !no(t, l) && t.push(l);
        }), t.sort();
      }
      function Hc(t) {
        if (t instanceof Be)
          return t.clone();
        var r = new en(t.__wrapped__, t.__chain__);
        return r.__actions__ = Ft(t.__actions__), r.__index__ = t.__index__, r.__values__ = t.__values__, r;
      }
      function L0(t, r, s) {
        (s ? Pt(t, r, s) : r === i) ? r = 1 : r = vt(Ie(r), 0);
        var l = t == null ? 0 : t.length;
        if (!l || r < 1)
          return [];
        for (var d = 0, b = 0, w = M(mo(l / r)); d < l; )
          w[b++] = nn(t, d, d += r);
        return w;
      }
      function F0(t) {
        for (var r = -1, s = t == null ? 0 : t.length, l = 0, d = []; ++r < s; ) {
          var b = t[r];
          b && (d[l++] = b);
        }
        return d;
      }
      function V0() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var r = M(t - 1), s = arguments[0], l = t; l--; )
          r[l - 1] = arguments[l];
        return zn(Re(s) ? Ft(s) : [s], _t(r, 1));
      }
      var B0 = Me(function(t, r) {
        return ht(t) ? pi(t, _t(r, 1, ht, !0)) : [];
      }), N0 = Me(function(t, r) {
        var s = rn(r);
        return ht(s) && (s = i), ht(t) ? pi(t, _t(r, 1, ht, !0), ye(s, 2)) : [];
      }), W0 = Me(function(t, r) {
        var s = rn(r);
        return ht(s) && (s = i), ht(t) ? pi(t, _t(r, 1, ht, !0), i, s) : [];
      });
      function z0(t, r, s) {
        var l = t == null ? 0 : t.length;
        return l ? (r = s || r === i ? 1 : Ie(r), nn(t, r < 0 ? 0 : r, l)) : [];
      }
      function j0(t, r, s) {
        var l = t == null ? 0 : t.length;
        return l ? (r = s || r === i ? 1 : Ie(r), r = l - r, nn(t, 0, r < 0 ? 0 : r)) : [];
      }
      function G0(t, r) {
        return t && t.length ? So(t, ye(r, 3), !0, !0) : [];
      }
      function H0(t, r) {
        return t && t.length ? So(t, ye(r, 3), !0) : [];
      }
      function q0(t, r, s, l) {
        var d = t == null ? 0 : t.length;
        return d ? (s && typeof s != "number" && Pt(t, r, s) && (s = 0, l = d), Vg(t, r, s, l)) : [];
      }
      function qc(t, r, s) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var d = s == null ? 0 : Ie(s);
        return d < 0 && (d = vt(l + d, 0)), ro(t, ye(r, 3), d);
      }
      function Yc(t, r, s) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var d = l - 1;
        return s !== i && (d = Ie(s), d = s < 0 ? vt(l + d, 0) : Ct(d, l - 1)), ro(t, ye(r, 3), d, !0);
      }
      function Kc(t) {
        var r = t == null ? 0 : t.length;
        return r ? _t(t, 1) : [];
      }
      function Y0(t) {
        var r = t == null ? 0 : t.length;
        return r ? _t(t, je) : [];
      }
      function K0(t, r) {
        var s = t == null ? 0 : t.length;
        return s ? (r = r === i ? 1 : Ie(r), _t(t, r)) : [];
      }
      function Z0(t) {
        for (var r = -1, s = t == null ? 0 : t.length, l = {}; ++r < s; ) {
          var d = t[r];
          l[d[0]] = d[1];
        }
        return l;
      }
      function Zc(t) {
        return t && t.length ? t[0] : i;
      }
      function X0(t, r, s) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var d = s == null ? 0 : Ie(s);
        return d < 0 && (d = vt(l + d, 0)), Ar(t, r, d);
      }
      function J0(t) {
        var r = t == null ? 0 : t.length;
        return r ? nn(t, 0, -1) : [];
      }
      var Q0 = Me(function(t) {
        var r = it(t, la);
        return r.length && r[0] === t[0] ? Js(r) : [];
      }), ev = Me(function(t) {
        var r = rn(t), s = it(t, la);
        return r === rn(s) ? r = i : s.pop(), s.length && s[0] === t[0] ? Js(s, ye(r, 2)) : [];
      }), tv = Me(function(t) {
        var r = rn(t), s = it(t, la);
        return r = typeof r == "function" ? r : i, r && s.pop(), s.length && s[0] === t[0] ? Js(s, i, r) : [];
      });
      function nv(t, r) {
        return t == null ? "" : Jm.call(t, r);
      }
      function rn(t) {
        var r = t == null ? 0 : t.length;
        return r ? t[r - 1] : i;
      }
      function rv(t, r, s) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var d = l;
        return s !== i && (d = Ie(s), d = d < 0 ? vt(l + d, 0) : Ct(d, l - 1)), r === r ? Om(t, r, d) : ro(t, Au, d, !0);
      }
      function iv(t, r) {
        return t && t.length ? ac(t, Ie(r)) : i;
      }
      var ov = Me(Xc);
      function Xc(t, r) {
        return t && t.length && r && r.length ? na(t, r) : t;
      }
      function sv(t, r, s) {
        return t && t.length && r && r.length ? na(t, r, ye(s, 2)) : t;
      }
      function av(t, r, s) {
        return t && t.length && r && r.length ? na(t, r, i, s) : t;
      }
      var lv = An(function(t, r) {
        var s = t == null ? 0 : t.length, l = Ys(t, r);
        return cc(t, it(r, function(d) {
          return Rn(d, s) ? +d : d;
        }).sort(xc)), l;
      });
      function uv(t, r) {
        var s = [];
        if (!(t && t.length))
          return s;
        var l = -1, d = [], b = t.length;
        for (r = ye(r, 3); ++l < b; ) {
          var w = t[l];
          r(w, l, t) && (s.push(w), d.push(l));
        }
        return cc(t, d), s;
      }
      function ka(t) {
        return t == null ? t : ng.call(t);
      }
      function cv(t, r, s) {
        var l = t == null ? 0 : t.length;
        return l ? (s && typeof s != "number" && Pt(t, r, s) ? (r = 0, s = l) : (r = r == null ? 0 : Ie(r), s = s === i ? l : Ie(s)), nn(t, r, s)) : [];
      }
      function fv(t, r) {
        return _o(t, r);
      }
      function hv(t, r, s) {
        return oa(t, r, ye(s, 2));
      }
      function dv(t, r) {
        var s = t == null ? 0 : t.length;
        if (s) {
          var l = _o(t, r);
          if (l < s && dn(t[l], r))
            return l;
        }
        return -1;
      }
      function pv(t, r) {
        return _o(t, r, !0);
      }
      function mv(t, r, s) {
        return oa(t, r, ye(s, 2), !0);
      }
      function gv(t, r) {
        var s = t == null ? 0 : t.length;
        if (s) {
          var l = _o(t, r, !0) - 1;
          if (dn(t[l], r))
            return l;
        }
        return -1;
      }
      function vv(t) {
        return t && t.length ? hc(t) : [];
      }
      function bv(t, r) {
        return t && t.length ? hc(t, ye(r, 2)) : [];
      }
      function yv(t) {
        var r = t == null ? 0 : t.length;
        return r ? nn(t, 1, r) : [];
      }
      function xv(t, r, s) {
        return t && t.length ? (r = s || r === i ? 1 : Ie(r), nn(t, 0, r < 0 ? 0 : r)) : [];
      }
      function wv(t, r, s) {
        var l = t == null ? 0 : t.length;
        return l ? (r = s || r === i ? 1 : Ie(r), r = l - r, nn(t, r < 0 ? 0 : r, l)) : [];
      }
      function kv(t, r) {
        return t && t.length ? So(t, ye(r, 3), !1, !0) : [];
      }
      function Tv(t, r) {
        return t && t.length ? So(t, ye(r, 3)) : [];
      }
      var _v = Me(function(t) {
        return qn(_t(t, 1, ht, !0));
      }), Sv = Me(function(t) {
        var r = rn(t);
        return ht(r) && (r = i), qn(_t(t, 1, ht, !0), ye(r, 2));
      }), Cv = Me(function(t) {
        var r = rn(t);
        return r = typeof r == "function" ? r : i, qn(_t(t, 1, ht, !0), i, r);
      });
      function $v(t) {
        return t && t.length ? qn(t) : [];
      }
      function Ev(t, r) {
        return t && t.length ? qn(t, ye(r, 2)) : [];
      }
      function Pv(t, r) {
        return r = typeof r == "function" ? r : i, t && t.length ? qn(t, i, r) : [];
      }
      function Ta(t) {
        if (!(t && t.length))
          return [];
        var r = 0;
        return t = Wn(t, function(s) {
          if (ht(s))
            return r = vt(s.length, r), !0;
        }), Bs(r, function(s) {
          return it(t, Ls(s));
        });
      }
      function Jc(t, r) {
        if (!(t && t.length))
          return [];
        var s = Ta(t);
        return r == null ? s : it(s, function(l) {
          return jt(r, i, l);
        });
      }
      var Av = Me(function(t, r) {
        return ht(t) ? pi(t, r) : [];
      }), Rv = Me(function(t) {
        return aa(Wn(t, ht));
      }), Iv = Me(function(t) {
        var r = rn(t);
        return ht(r) && (r = i), aa(Wn(t, ht), ye(r, 2));
      }), Uv = Me(function(t) {
        var r = rn(t);
        return r = typeof r == "function" ? r : i, aa(Wn(t, ht), i, r);
      }), Dv = Me(Ta);
      function Mv(t, r) {
        return gc(t || [], r || [], di);
      }
      function Ov(t, r) {
        return gc(t || [], r || [], vi);
      }
      var Lv = Me(function(t) {
        var r = t.length, s = r > 1 ? t[r - 1] : i;
        return s = typeof s == "function" ? (t.pop(), s) : i, Jc(t, s);
      });
      function Qc(t) {
        var r = v(t);
        return r.__chain__ = !0, r;
      }
      function Fv(t, r) {
        return r(t), t;
      }
      function Do(t, r) {
        return r(t);
      }
      var Vv = An(function(t) {
        var r = t.length, s = r ? t[0] : 0, l = this.__wrapped__, d = function(b) {
          return Ys(b, t);
        };
        return r > 1 || this.__actions__.length || !(l instanceof Be) || !Rn(s) ? this.thru(d) : (l = l.slice(s, +s + (r ? 1 : 0)), l.__actions__.push({
          func: Do,
          args: [d],
          thisArg: i
        }), new en(l, this.__chain__).thru(function(b) {
          return r && !b.length && b.push(i), b;
        }));
      });
      function Bv() {
        return Qc(this);
      }
      function Nv() {
        return new en(this.value(), this.__chain__);
      }
      function Wv() {
        this.__values__ === i && (this.__values__ = pf(this.value()));
        var t = this.__index__ >= this.__values__.length, r = t ? i : this.__values__[this.__index__++];
        return { done: t, value: r };
      }
      function zv() {
        return this;
      }
      function jv(t) {
        for (var r, s = this; s instanceof yo; ) {
          var l = Hc(s);
          l.__index__ = 0, l.__values__ = i, r ? d.__wrapped__ = l : r = l;
          var d = l;
          s = s.__wrapped__;
        }
        return d.__wrapped__ = t, r;
      }
      function Gv() {
        var t = this.__wrapped__;
        if (t instanceof Be) {
          var r = t;
          return this.__actions__.length && (r = new Be(this)), r = r.reverse(), r.__actions__.push({
            func: Do,
            args: [ka],
            thisArg: i
          }), new en(r, this.__chain__);
        }
        return this.thru(ka);
      }
      function Hv() {
        return mc(this.__wrapped__, this.__actions__);
      }
      var qv = Co(function(t, r, s) {
        Ze.call(t, s) ? ++t[s] : En(t, s, 1);
      });
      function Yv(t, r, s) {
        var l = Re(t) ? Eu : Fg;
        return s && Pt(t, r, s) && (r = i), l(t, ye(r, 3));
      }
      function Kv(t, r) {
        var s = Re(t) ? Wn : Ju;
        return s(t, ye(r, 3));
      }
      var Zv = Cc(qc), Xv = Cc(Yc);
      function Jv(t, r) {
        return _t(Mo(t, r), 1);
      }
      function Qv(t, r) {
        return _t(Mo(t, r), je);
      }
      function e1(t, r, s) {
        return s = s === i ? 1 : Ie(s), _t(Mo(t, r), s);
      }
      function ef(t, r) {
        var s = Re(t) ? Jt : Hn;
        return s(t, ye(r, 3));
      }
      function tf(t, r) {
        var s = Re(t) ? ym : Xu;
        return s(t, ye(r, 3));
      }
      var t1 = Co(function(t, r, s) {
        Ze.call(t, s) ? t[s].push(r) : En(t, s, [r]);
      });
      function n1(t, r, s, l) {
        t = Vt(t) ? t : Wr(t), s = s && !l ? Ie(s) : 0;
        var d = t.length;
        return s < 0 && (s = vt(d + s, 0)), Bo(t) ? s <= d && t.indexOf(r, s) > -1 : !!d && Ar(t, r, s) > -1;
      }
      var r1 = Me(function(t, r, s) {
        var l = -1, d = typeof r == "function", b = Vt(t) ? M(t.length) : [];
        return Hn(t, function(w) {
          b[++l] = d ? jt(r, w, s) : mi(w, r, s);
        }), b;
      }), i1 = Co(function(t, r, s) {
        En(t, s, r);
      });
      function Mo(t, r) {
        var s = Re(t) ? it : ic;
        return s(t, ye(r, 3));
      }
      function o1(t, r, s, l) {
        return t == null ? [] : (Re(r) || (r = r == null ? [] : [r]), s = l ? i : s, Re(s) || (s = s == null ? [] : [s]), lc(t, r, s));
      }
      var s1 = Co(function(t, r, s) {
        t[s ? 0 : 1].push(r);
      }, function() {
        return [[], []];
      });
      function a1(t, r, s) {
        var l = Re(t) ? Ms : Iu, d = arguments.length < 3;
        return l(t, ye(r, 4), s, d, Hn);
      }
      function l1(t, r, s) {
        var l = Re(t) ? xm : Iu, d = arguments.length < 3;
        return l(t, ye(r, 4), s, d, Xu);
      }
      function u1(t, r) {
        var s = Re(t) ? Wn : Ju;
        return s(t, Fo(ye(r, 3)));
      }
      function c1(t) {
        var r = Re(t) ? qu : n0;
        return r(t);
      }
      function f1(t, r, s) {
        (s ? Pt(t, r, s) : r === i) ? r = 1 : r = Ie(r);
        var l = Re(t) ? Ug : r0;
        return l(t, r);
      }
      function h1(t) {
        var r = Re(t) ? Dg : o0;
        return r(t);
      }
      function d1(t) {
        if (t == null)
          return 0;
        if (Vt(t))
          return Bo(t) ? Ir(t) : t.length;
        var r = $t(t);
        return r == j || r == He ? t.size : ea(t).length;
      }
      function p1(t, r, s) {
        var l = Re(t) ? Os : s0;
        return s && Pt(t, r, s) && (r = i), l(t, ye(r, 3));
      }
      var m1 = Me(function(t, r) {
        if (t == null)
          return [];
        var s = r.length;
        return s > 1 && Pt(t, r[0], r[1]) ? r = [] : s > 2 && Pt(r[0], r[1], r[2]) && (r = [r[0]]), lc(t, _t(r, 1), []);
      }), Oo = Km || function() {
        return Tt.Date.now();
      };
      function g1(t, r) {
        if (typeof r != "function")
          throw new Qt(u);
        return t = Ie(t), function() {
          if (--t < 1)
            return r.apply(this, arguments);
        };
      }
      function nf(t, r, s) {
        return r = s ? i : r, r = t && r == null ? t.length : r, Pn(t, ge, i, i, i, i, r);
      }
      function rf(t, r) {
        var s;
        if (typeof r != "function")
          throw new Qt(u);
        return t = Ie(t), function() {
          return --t > 0 && (s = r.apply(this, arguments)), t <= 1 && (r = i), s;
        };
      }
      var _a = Me(function(t, r, s) {
        var l = W;
        if (s.length) {
          var d = jn(s, Br(_a));
          l |= Q;
        }
        return Pn(t, l, r, s, d);
      }), of = Me(function(t, r, s) {
        var l = W | F;
        if (s.length) {
          var d = jn(s, Br(of));
          l |= Q;
        }
        return Pn(r, l, t, s, d);
      });
      function sf(t, r, s) {
        r = s ? i : r;
        var l = Pn(t, L, i, i, i, i, i, r);
        return l.placeholder = sf.placeholder, l;
      }
      function af(t, r, s) {
        r = s ? i : r;
        var l = Pn(t, G, i, i, i, i, i, r);
        return l.placeholder = af.placeholder, l;
      }
      function lf(t, r, s) {
        var l, d, b, w, C, A, B = 0, N = !1, q = !1, ne = !0;
        if (typeof t != "function")
          throw new Qt(u);
        r = on(r) || 0, at(s) && (N = !!s.leading, q = "maxWait" in s, b = q ? vt(on(s.maxWait) || 0, r) : b, ne = "trailing" in s ? !!s.trailing : ne);
        function de(dt) {
          var pn = l, Dn = d;
          return l = d = i, B = dt, w = t.apply(Dn, pn), w;
        }
        function xe(dt) {
          return B = dt, C = xi(Fe, r), N ? de(dt) : w;
        }
        function De(dt) {
          var pn = dt - A, Dn = dt - B, $f = r - pn;
          return q ? Ct($f, b - Dn) : $f;
        }
        function we(dt) {
          var pn = dt - A, Dn = dt - B;
          return A === i || pn >= r || pn < 0 || q && Dn >= b;
        }
        function Fe() {
          var dt = Oo();
          if (we(dt))
            return Ne(dt);
          C = xi(Fe, De(dt));
        }
        function Ne(dt) {
          return C = i, ne && l ? de(dt) : (l = d = i, w);
        }
        function Yt() {
          C !== i && vc(C), B = 0, l = A = d = C = i;
        }
        function At() {
          return C === i ? w : Ne(Oo());
        }
        function Kt() {
          var dt = Oo(), pn = we(dt);
          if (l = arguments, d = this, A = dt, pn) {
            if (C === i)
              return xe(A);
            if (q)
              return vc(C), C = xi(Fe, r), de(A);
          }
          return C === i && (C = xi(Fe, r)), w;
        }
        return Kt.cancel = Yt, Kt.flush = At, Kt;
      }
      var v1 = Me(function(t, r) {
        return Zu(t, 1, r);
      }), b1 = Me(function(t, r, s) {
        return Zu(t, on(r) || 0, s);
      });
      function y1(t) {
        return Pn(t, $e);
      }
      function Lo(t, r) {
        if (typeof t != "function" || r != null && typeof r != "function")
          throw new Qt(u);
        var s = function() {
          var l = arguments, d = r ? r.apply(this, l) : l[0], b = s.cache;
          if (b.has(d))
            return b.get(d);
          var w = t.apply(this, l);
          return s.cache = b.set(d, w) || b, w;
        };
        return s.cache = new (Lo.Cache || $n)(), s;
      }
      Lo.Cache = $n;
      function Fo(t) {
        if (typeof t != "function")
          throw new Qt(u);
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, r[0]);
            case 2:
              return !t.call(this, r[0], r[1]);
            case 3:
              return !t.call(this, r[0], r[1], r[2]);
          }
          return !t.apply(this, r);
        };
      }
      function x1(t) {
        return rf(2, t);
      }
      var w1 = a0(function(t, r) {
        r = r.length == 1 && Re(r[0]) ? it(r[0], Gt(ye())) : it(_t(r, 1), Gt(ye()));
        var s = r.length;
        return Me(function(l) {
          for (var d = -1, b = Ct(l.length, s); ++d < b; )
            l[d] = r[d].call(this, l[d]);
          return jt(t, this, l);
        });
      }), Sa = Me(function(t, r) {
        var s = jn(r, Br(Sa));
        return Pn(t, Q, i, r, s);
      }), uf = Me(function(t, r) {
        var s = jn(r, Br(uf));
        return Pn(t, fe, i, r, s);
      }), k1 = An(function(t, r) {
        return Pn(t, he, i, i, i, r);
      });
      function T1(t, r) {
        if (typeof t != "function")
          throw new Qt(u);
        return r = r === i ? r : Ie(r), Me(t, r);
      }
      function _1(t, r) {
        if (typeof t != "function")
          throw new Qt(u);
        return r = r == null ? 0 : vt(Ie(r), 0), Me(function(s) {
          var l = s[r], d = Kn(s, 0, r);
          return l && zn(d, l), jt(t, this, d);
        });
      }
      function S1(t, r, s) {
        var l = !0, d = !0;
        if (typeof t != "function")
          throw new Qt(u);
        return at(s) && (l = "leading" in s ? !!s.leading : l, d = "trailing" in s ? !!s.trailing : d), lf(t, r, {
          leading: l,
          maxWait: r,
          trailing: d
        });
      }
      function C1(t) {
        return nf(t, 1);
      }
      function $1(t, r) {
        return Sa(ua(r), t);
      }
      function E1() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return Re(t) ? t : [t];
      }
      function P1(t) {
        return tn(t, E);
      }
      function A1(t, r) {
        return r = typeof r == "function" ? r : i, tn(t, E, r);
      }
      function R1(t) {
        return tn(t, x | E);
      }
      function I1(t, r) {
        return r = typeof r == "function" ? r : i, tn(t, x | E, r);
      }
      function U1(t, r) {
        return r == null || Ku(t, r, xt(r));
      }
      function dn(t, r) {
        return t === r || t !== t && r !== r;
      }
      var D1 = Ao(Xs), M1 = Ao(function(t, r) {
        return t >= r;
      }), mr = tc(function() {
        return arguments;
      }()) ? tc : function(t) {
        return ft(t) && Ze.call(t, "callee") && !Nu.call(t, "callee");
      }, Re = M.isArray, O1 = ku ? Gt(ku) : jg;
      function Vt(t) {
        return t != null && Vo(t.length) && !In(t);
      }
      function ht(t) {
        return ft(t) && Vt(t);
      }
      function L1(t) {
        return t === !0 || t === !1 || ft(t) && Et(t) == ee;
      }
      var Zn = Xm || Oa, F1 = Tu ? Gt(Tu) : Gg;
      function V1(t) {
        return ft(t) && t.nodeType === 1 && !wi(t);
      }
      function B1(t) {
        if (t == null)
          return !0;
        if (Vt(t) && (Re(t) || typeof t == "string" || typeof t.splice == "function" || Zn(t) || Nr(t) || mr(t)))
          return !t.length;
        var r = $t(t);
        if (r == j || r == He)
          return !t.size;
        if (yi(t))
          return !ea(t).length;
        for (var s in t)
          if (Ze.call(t, s))
            return !1;
        return !0;
      }
      function N1(t, r) {
        return gi(t, r);
      }
      function W1(t, r, s) {
        s = typeof s == "function" ? s : i;
        var l = s ? s(t, r) : i;
        return l === i ? gi(t, r, i, s) : !!l;
      }
      function Ca(t) {
        if (!ft(t))
          return !1;
        var r = Et(t);
        return r == Z || r == oe || typeof t.message == "string" && typeof t.name == "string" && !wi(t);
      }
      function z1(t) {
        return typeof t == "number" && zu(t);
      }
      function In(t) {
        if (!at(t))
          return !1;
        var r = Et(t);
        return r == Ce || r == X || r == K || r == Ue;
      }
      function cf(t) {
        return typeof t == "number" && t == Ie(t);
      }
      function Vo(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Se;
      }
      function at(t) {
        var r = typeof t;
        return t != null && (r == "object" || r == "function");
      }
      function ft(t) {
        return t != null && typeof t == "object";
      }
      var ff = _u ? Gt(_u) : qg;
      function j1(t, r) {
        return t === r || Qs(t, r, ga(r));
      }
      function G1(t, r, s) {
        return s = typeof s == "function" ? s : i, Qs(t, r, ga(r), s);
      }
      function H1(t) {
        return hf(t) && t != +t;
      }
      function q1(t) {
        if (A0(t))
          throw new Ae(c);
        return nc(t);
      }
      function Y1(t) {
        return t === null;
      }
      function K1(t) {
        return t == null;
      }
      function hf(t) {
        return typeof t == "number" || ft(t) && Et(t) == J;
      }
      function wi(t) {
        if (!ft(t) || Et(t) != ce)
          return !1;
        var r = fo(t);
        if (r === null)
          return !0;
        var s = Ze.call(r, "constructor") && r.constructor;
        return typeof s == "function" && s instanceof s && ao.call(s) == Gm;
      }
      var $a = Su ? Gt(Su) : Yg;
      function Z1(t) {
        return cf(t) && t >= -Se && t <= Se;
      }
      var df = Cu ? Gt(Cu) : Kg;
      function Bo(t) {
        return typeof t == "string" || !Re(t) && ft(t) && Et(t) == Xe;
      }
      function qt(t) {
        return typeof t == "symbol" || ft(t) && Et(t) == ut;
      }
      var Nr = $u ? Gt($u) : Zg;
      function X1(t) {
        return t === i;
      }
      function J1(t) {
        return ft(t) && $t(t) == yt;
      }
      function Q1(t) {
        return ft(t) && Et(t) == Bn;
      }
      var eb = Ao(ta), tb = Ao(function(t, r) {
        return t <= r;
      });
      function pf(t) {
        if (!t)
          return [];
        if (Vt(t))
          return Bo(t) ? fn(t) : Ft(t);
        if (li && t[li])
          return Um(t[li]());
        var r = $t(t), s = r == j ? Ws : r == He ? io : Wr;
        return s(t);
      }
      function Un(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = on(t), t === je || t === -je) {
          var r = t < 0 ? -1 : 1;
          return r * y;
        }
        return t === t ? t : 0;
      }
      function Ie(t) {
        var r = Un(t), s = r % 1;
        return r === r ? s ? r - s : r : 0;
      }
      function mf(t) {
        return t ? fr(Ie(t), 0, $) : 0;
      }
      function on(t) {
        if (typeof t == "number")
          return t;
        if (qt(t))
          return k;
        if (at(t)) {
          var r = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = at(r) ? r + "" : r;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = Uu(t);
        var s = Oe.test(t);
        return s || st.test(t) ? gm(t.slice(2), s ? 2 : 8) : Ve.test(t) ? k : +t;
      }
      function gf(t) {
        return yn(t, Bt(t));
      }
      function nb(t) {
        return t ? fr(Ie(t), -Se, Se) : t === 0 ? t : 0;
      }
      function Ke(t) {
        return t == null ? "" : Ht(t);
      }
      var rb = Fr(function(t, r) {
        if (yi(r) || Vt(r)) {
          yn(r, xt(r), t);
          return;
        }
        for (var s in r)
          Ze.call(r, s) && di(t, s, r[s]);
      }), vf = Fr(function(t, r) {
        yn(r, Bt(r), t);
      }), No = Fr(function(t, r, s, l) {
        yn(r, Bt(r), t, l);
      }), ib = Fr(function(t, r, s, l) {
        yn(r, xt(r), t, l);
      }), ob = An(Ys);
      function sb(t, r) {
        var s = Lr(t);
        return r == null ? s : Yu(s, r);
      }
      var ab = Me(function(t, r) {
        t = et(t);
        var s = -1, l = r.length, d = l > 2 ? r[2] : i;
        for (d && Pt(r[0], r[1], d) && (l = 1); ++s < l; )
          for (var b = r[s], w = Bt(b), C = -1, A = w.length; ++C < A; ) {
            var B = w[C], N = t[B];
            (N === i || dn(N, Dr[B]) && !Ze.call(t, B)) && (t[B] = b[B]);
          }
        return t;
      }), lb = Me(function(t) {
        return t.push(i, Uc), jt(bf, i, t);
      });
      function ub(t, r) {
        return Pu(t, ye(r, 3), bn);
      }
      function cb(t, r) {
        return Pu(t, ye(r, 3), Zs);
      }
      function fb(t, r) {
        return t == null ? t : Ks(t, ye(r, 3), Bt);
      }
      function hb(t, r) {
        return t == null ? t : Qu(t, ye(r, 3), Bt);
      }
      function db(t, r) {
        return t && bn(t, ye(r, 3));
      }
      function pb(t, r) {
        return t && Zs(t, ye(r, 3));
      }
      function mb(t) {
        return t == null ? [] : ko(t, xt(t));
      }
      function gb(t) {
        return t == null ? [] : ko(t, Bt(t));
      }
      function Ea(t, r, s) {
        var l = t == null ? i : hr(t, r);
        return l === i ? s : l;
      }
      function vb(t, r) {
        return t != null && Oc(t, r, Bg);
      }
      function Pa(t, r) {
        return t != null && Oc(t, r, Ng);
      }
      var bb = Ec(function(t, r, s) {
        r != null && typeof r.toString != "function" && (r = lo.call(r)), t[r] = s;
      }, Ra(Nt)), yb = Ec(function(t, r, s) {
        r != null && typeof r.toString != "function" && (r = lo.call(r)), Ze.call(t, r) ? t[r].push(s) : t[r] = [s];
      }, ye), xb = Me(mi);
      function xt(t) {
        return Vt(t) ? Hu(t) : ea(t);
      }
      function Bt(t) {
        return Vt(t) ? Hu(t, !0) : Xg(t);
      }
      function wb(t, r) {
        var s = {};
        return r = ye(r, 3), bn(t, function(l, d, b) {
          En(s, r(l, d, b), l);
        }), s;
      }
      function kb(t, r) {
        var s = {};
        return r = ye(r, 3), bn(t, function(l, d, b) {
          En(s, d, r(l, d, b));
        }), s;
      }
      var Tb = Fr(function(t, r, s) {
        To(t, r, s);
      }), bf = Fr(function(t, r, s, l) {
        To(t, r, s, l);
      }), _b = An(function(t, r) {
        var s = {};
        if (t == null)
          return s;
        var l = !1;
        r = it(r, function(b) {
          return b = Yn(b, t), l || (l = b.length > 1), b;
        }), yn(t, pa(t), s), l && (s = tn(s, x | T | E, b0));
        for (var d = r.length; d--; )
          sa(s, r[d]);
        return s;
      });
      function Sb(t, r) {
        return yf(t, Fo(ye(r)));
      }
      var Cb = An(function(t, r) {
        return t == null ? {} : Qg(t, r);
      });
      function yf(t, r) {
        if (t == null)
          return {};
        var s = it(pa(t), function(l) {
          return [l];
        });
        return r = ye(r), uc(t, s, function(l, d) {
          return r(l, d[0]);
        });
      }
      function $b(t, r, s) {
        r = Yn(r, t);
        var l = -1, d = r.length;
        for (d || (d = 1, t = i); ++l < d; ) {
          var b = t == null ? i : t[xn(r[l])];
          b === i && (l = d, b = s), t = In(b) ? b.call(t) : b;
        }
        return t;
      }
      function Eb(t, r, s) {
        return t == null ? t : vi(t, r, s);
      }
      function Pb(t, r, s, l) {
        return l = typeof l == "function" ? l : i, t == null ? t : vi(t, r, s, l);
      }
      var xf = Rc(xt), wf = Rc(Bt);
      function Ab(t, r, s) {
        var l = Re(t), d = l || Zn(t) || Nr(t);
        if (r = ye(r, 4), s == null) {
          var b = t && t.constructor;
          d ? s = l ? new b() : [] : at(t) ? s = In(b) ? Lr(fo(t)) : {} : s = {};
        }
        return (d ? Jt : bn)(t, function(w, C, A) {
          return r(s, w, C, A);
        }), s;
      }
      function Rb(t, r) {
        return t == null ? !0 : sa(t, r);
      }
      function Ib(t, r, s) {
        return t == null ? t : pc(t, r, ua(s));
      }
      function Ub(t, r, s, l) {
        return l = typeof l == "function" ? l : i, t == null ? t : pc(t, r, ua(s), l);
      }
      function Wr(t) {
        return t == null ? [] : Ns(t, xt(t));
      }
      function Db(t) {
        return t == null ? [] : Ns(t, Bt(t));
      }
      function Mb(t, r, s) {
        return s === i && (s = r, r = i), s !== i && (s = on(s), s = s === s ? s : 0), r !== i && (r = on(r), r = r === r ? r : 0), fr(on(t), r, s);
      }
      function Ob(t, r, s) {
        return r = Un(r), s === i ? (s = r, r = 0) : s = Un(s), t = on(t), Wg(t, r, s);
      }
      function Lb(t, r, s) {
        if (s && typeof s != "boolean" && Pt(t, r, s) && (r = s = i), s === i && (typeof r == "boolean" ? (s = r, r = i) : typeof t == "boolean" && (s = t, t = i)), t === i && r === i ? (t = 0, r = 1) : (t = Un(t), r === i ? (r = t, t = 0) : r = Un(r)), t > r) {
          var l = t;
          t = r, r = l;
        }
        if (s || t % 1 || r % 1) {
          var d = ju();
          return Ct(t + d * (r - t + mm("1e-" + ((d + "").length - 1))), r);
        }
        return ra(t, r);
      }
      var Fb = Vr(function(t, r, s) {
        return r = r.toLowerCase(), t + (s ? kf(r) : r);
      });
      function kf(t) {
        return Aa(Ke(t).toLowerCase());
      }
      function Tf(t) {
        return t = Ke(t), t && t.replace(Ot, Em).replace(om, "");
      }
      function Vb(t, r, s) {
        t = Ke(t), r = Ht(r);
        var l = t.length;
        s = s === i ? l : fr(Ie(s), 0, l);
        var d = s;
        return s -= r.length, s >= 0 && t.slice(s, d) == r;
      }
      function Bb(t) {
        return t = Ke(t), t && Yi.test(t) ? t.replace(Er, Pm) : t;
      }
      function Nb(t) {
        return t = Ke(t), t && Qi.test(t) ? t.replace(oi, "\\$&") : t;
      }
      var Wb = Vr(function(t, r, s) {
        return t + (s ? "-" : "") + r.toLowerCase();
      }), zb = Vr(function(t, r, s) {
        return t + (s ? " " : "") + r.toLowerCase();
      }), jb = Sc("toLowerCase");
      function Gb(t, r, s) {
        t = Ke(t), r = Ie(r);
        var l = r ? Ir(t) : 0;
        if (!r || l >= r)
          return t;
        var d = (r - l) / 2;
        return Po(go(d), s) + t + Po(mo(d), s);
      }
      function Hb(t, r, s) {
        t = Ke(t), r = Ie(r);
        var l = r ? Ir(t) : 0;
        return r && l < r ? t + Po(r - l, s) : t;
      }
      function qb(t, r, s) {
        t = Ke(t), r = Ie(r);
        var l = r ? Ir(t) : 0;
        return r && l < r ? Po(r - l, s) + t : t;
      }
      function Yb(t, r, s) {
        return s || r == null ? r = 0 : r && (r = +r), tg(Ke(t).replace(si, ""), r || 0);
      }
      function Kb(t, r, s) {
        return (s ? Pt(t, r, s) : r === i) ? r = 1 : r = Ie(r), ia(Ke(t), r);
      }
      function Zb() {
        var t = arguments, r = Ke(t[0]);
        return t.length < 3 ? r : r.replace(t[1], t[2]);
      }
      var Xb = Vr(function(t, r, s) {
        return t + (s ? "_" : "") + r.toLowerCase();
      });
      function Jb(t, r, s) {
        return s && typeof s != "number" && Pt(t, r, s) && (r = s = i), s = s === i ? $ : s >>> 0, s ? (t = Ke(t), t && (typeof r == "string" || r != null && !$a(r)) && (r = Ht(r), !r && Rr(t)) ? Kn(fn(t), 0, s) : t.split(r, s)) : [];
      }
      var Qb = Vr(function(t, r, s) {
        return t + (s ? " " : "") + Aa(r);
      });
      function ey(t, r, s) {
        return t = Ke(t), s = s == null ? 0 : fr(Ie(s), 0, t.length), r = Ht(r), t.slice(s, s + r.length) == r;
      }
      function ty(t, r, s) {
        var l = v.templateSettings;
        s && Pt(t, r, s) && (r = i), t = Ke(t), r = No({}, r, l, Ic);
        var d = No({}, r.imports, l.imports, Ic), b = xt(d), w = Ns(d, b), C, A, B = 0, N = r.interpolate || cn, q = "__p += '", ne = zs(
          (r.escape || cn).source + "|" + N.source + "|" + (N === Zi ? ze : cn).source + "|" + (r.evaluate || cn).source + "|$",
          "g"
        ), de = "//# sourceURL=" + (Ze.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++cm + "]") + `
`;
        t.replace(ne, function(we, Fe, Ne, Yt, At, Kt) {
          return Ne || (Ne = Yt), q += t.slice(B, Kt).replace(eo, Am), Fe && (C = !0, q += `' +
__e(` + Fe + `) +
'`), At && (A = !0, q += `';
` + At + `;
__p += '`), Ne && (q += `' +
((__t = (` + Ne + `)) == null ? '' : __t) +
'`), B = Kt + we.length, we;
        }), q += `';
`;
        var xe = Ze.call(r, "variable") && r.variable;
        if (!xe)
          q = `with (obj) {
` + q + `
}
`;
        else if (te.test(xe))
          throw new Ae(h);
        q = (A ? q.replace(ws, "") : q).replace(ri, "$1").replace(qi, "$1;"), q = "function(" + (xe || "obj") + `) {
` + (xe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (A ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + q + `return __p
}`;
        var De = Sf(function() {
          return qe(b, de + "return " + q).apply(i, w);
        });
        if (De.source = q, Ca(De))
          throw De;
        return De;
      }
      function ny(t) {
        return Ke(t).toLowerCase();
      }
      function ry(t) {
        return Ke(t).toUpperCase();
      }
      function iy(t, r, s) {
        if (t = Ke(t), t && (s || r === i))
          return Uu(t);
        if (!t || !(r = Ht(r)))
          return t;
        var l = fn(t), d = fn(r), b = Du(l, d), w = Mu(l, d) + 1;
        return Kn(l, b, w).join("");
      }
      function oy(t, r, s) {
        if (t = Ke(t), t && (s || r === i))
          return t.slice(0, Lu(t) + 1);
        if (!t || !(r = Ht(r)))
          return t;
        var l = fn(t), d = Mu(l, fn(r)) + 1;
        return Kn(l, 0, d).join("");
      }
      function sy(t, r, s) {
        if (t = Ke(t), t && (s || r === i))
          return t.replace(si, "");
        if (!t || !(r = Ht(r)))
          return t;
        var l = fn(t), d = Du(l, fn(r));
        return Kn(l, d).join("");
      }
      function ay(t, r) {
        var s = Qe, l = Ge;
        if (at(r)) {
          var d = "separator" in r ? r.separator : d;
          s = "length" in r ? Ie(r.length) : s, l = "omission" in r ? Ht(r.omission) : l;
        }
        t = Ke(t);
        var b = t.length;
        if (Rr(t)) {
          var w = fn(t);
          b = w.length;
        }
        if (s >= b)
          return t;
        var C = s - Ir(l);
        if (C < 1)
          return l;
        var A = w ? Kn(w, 0, C).join("") : t.slice(0, C);
        if (d === i)
          return A + l;
        if (w && (C += A.length - C), $a(d)) {
          if (t.slice(C).search(d)) {
            var B, N = A;
            for (d.global || (d = zs(d.source, Ke(Ye.exec(d)) + "g")), d.lastIndex = 0; B = d.exec(N); )
              var q = B.index;
            A = A.slice(0, q === i ? C : q);
          }
        } else if (t.indexOf(Ht(d), C) != C) {
          var ne = A.lastIndexOf(d);
          ne > -1 && (A = A.slice(0, ne));
        }
        return A + l;
      }
      function ly(t) {
        return t = Ke(t), t && ii.test(t) ? t.replace(Sn, Lm) : t;
      }
      var uy = Vr(function(t, r, s) {
        return t + (s ? " " : "") + r.toUpperCase();
      }), Aa = Sc("toUpperCase");
      function _f(t, r, s) {
        return t = Ke(t), r = s ? i : r, r === i ? Im(t) ? Bm(t) : Tm(t) : t.match(r) || [];
      }
      var Sf = Me(function(t, r) {
        try {
          return jt(t, i, r);
        } catch (s) {
          return Ca(s) ? s : new Ae(s);
        }
      }), cy = An(function(t, r) {
        return Jt(r, function(s) {
          s = xn(s), En(t, s, _a(t[s], t));
        }), t;
      });
      function fy(t) {
        var r = t == null ? 0 : t.length, s = ye();
        return t = r ? it(t, function(l) {
          if (typeof l[1] != "function")
            throw new Qt(u);
          return [s(l[0]), l[1]];
        }) : [], Me(function(l) {
          for (var d = -1; ++d < r; ) {
            var b = t[d];
            if (jt(b[0], this, l))
              return jt(b[1], this, l);
          }
        });
      }
      function hy(t) {
        return Lg(tn(t, x));
      }
      function Ra(t) {
        return function() {
          return t;
        };
      }
      function dy(t, r) {
        return t == null || t !== t ? r : t;
      }
      var py = $c(), my = $c(!0);
      function Nt(t) {
        return t;
      }
      function Ia(t) {
        return rc(typeof t == "function" ? t : tn(t, x));
      }
      function gy(t) {
        return oc(tn(t, x));
      }
      function vy(t, r) {
        return sc(t, tn(r, x));
      }
      var by = Me(function(t, r) {
        return function(s) {
          return mi(s, t, r);
        };
      }), yy = Me(function(t, r) {
        return function(s) {
          return mi(t, s, r);
        };
      });
      function Ua(t, r, s) {
        var l = xt(r), d = ko(r, l);
        s == null && !(at(r) && (d.length || !l.length)) && (s = r, r = t, t = this, d = ko(r, xt(r)));
        var b = !(at(s) && "chain" in s) || !!s.chain, w = In(t);
        return Jt(d, function(C) {
          var A = r[C];
          t[C] = A, w && (t.prototype[C] = function() {
            var B = this.__chain__;
            if (b || B) {
              var N = t(this.__wrapped__), q = N.__actions__ = Ft(this.__actions__);
              return q.push({ func: A, args: arguments, thisArg: t }), N.__chain__ = B, N;
            }
            return A.apply(t, zn([this.value()], arguments));
          });
        }), t;
      }
      function xy() {
        return Tt._ === this && (Tt._ = Hm), this;
      }
      function Da() {
      }
      function wy(t) {
        return t = Ie(t), Me(function(r) {
          return ac(r, t);
        });
      }
      var ky = fa(it), Ty = fa(Eu), _y = fa(Os);
      function Cf(t) {
        return ba(t) ? Ls(xn(t)) : e0(t);
      }
      function Sy(t) {
        return function(r) {
          return t == null ? i : hr(t, r);
        };
      }
      var Cy = Pc(), $y = Pc(!0);
      function Ma() {
        return [];
      }
      function Oa() {
        return !1;
      }
      function Ey() {
        return {};
      }
      function Py() {
        return "";
      }
      function Ay() {
        return !0;
      }
      function Ry(t, r) {
        if (t = Ie(t), t < 1 || t > Se)
          return [];
        var s = $, l = Ct(t, $);
        r = ye(r), t -= $;
        for (var d = Bs(l, r); ++s < t; )
          r(s);
        return d;
      }
      function Iy(t) {
        return Re(t) ? it(t, xn) : qt(t) ? [t] : Ft(Gc(Ke(t)));
      }
      function Uy(t) {
        var r = ++jm;
        return Ke(t) + r;
      }
      var Dy = Eo(function(t, r) {
        return t + r;
      }, 0), My = ha("ceil"), Oy = Eo(function(t, r) {
        return t / r;
      }, 1), Ly = ha("floor");
      function Fy(t) {
        return t && t.length ? wo(t, Nt, Xs) : i;
      }
      function Vy(t, r) {
        return t && t.length ? wo(t, ye(r, 2), Xs) : i;
      }
      function By(t) {
        return Ru(t, Nt);
      }
      function Ny(t, r) {
        return Ru(t, ye(r, 2));
      }
      function Wy(t) {
        return t && t.length ? wo(t, Nt, ta) : i;
      }
      function zy(t, r) {
        return t && t.length ? wo(t, ye(r, 2), ta) : i;
      }
      var jy = Eo(function(t, r) {
        return t * r;
      }, 1), Gy = ha("round"), Hy = Eo(function(t, r) {
        return t - r;
      }, 0);
      function qy(t) {
        return t && t.length ? Vs(t, Nt) : 0;
      }
      function Yy(t, r) {
        return t && t.length ? Vs(t, ye(r, 2)) : 0;
      }
      return v.after = g1, v.ary = nf, v.assign = rb, v.assignIn = vf, v.assignInWith = No, v.assignWith = ib, v.at = ob, v.before = rf, v.bind = _a, v.bindAll = cy, v.bindKey = of, v.castArray = E1, v.chain = Qc, v.chunk = L0, v.compact = F0, v.concat = V0, v.cond = fy, v.conforms = hy, v.constant = Ra, v.countBy = qv, v.create = sb, v.curry = sf, v.curryRight = af, v.debounce = lf, v.defaults = ab, v.defaultsDeep = lb, v.defer = v1, v.delay = b1, v.difference = B0, v.differenceBy = N0, v.differenceWith = W0, v.drop = z0, v.dropRight = j0, v.dropRightWhile = G0, v.dropWhile = H0, v.fill = q0, v.filter = Kv, v.flatMap = Jv, v.flatMapDeep = Qv, v.flatMapDepth = e1, v.flatten = Kc, v.flattenDeep = Y0, v.flattenDepth = K0, v.flip = y1, v.flow = py, v.flowRight = my, v.fromPairs = Z0, v.functions = mb, v.functionsIn = gb, v.groupBy = t1, v.initial = J0, v.intersection = Q0, v.intersectionBy = ev, v.intersectionWith = tv, v.invert = bb, v.invertBy = yb, v.invokeMap = r1, v.iteratee = Ia, v.keyBy = i1, v.keys = xt, v.keysIn = Bt, v.map = Mo, v.mapKeys = wb, v.mapValues = kb, v.matches = gy, v.matchesProperty = vy, v.memoize = Lo, v.merge = Tb, v.mergeWith = bf, v.method = by, v.methodOf = yy, v.mixin = Ua, v.negate = Fo, v.nthArg = wy, v.omit = _b, v.omitBy = Sb, v.once = x1, v.orderBy = o1, v.over = ky, v.overArgs = w1, v.overEvery = Ty, v.overSome = _y, v.partial = Sa, v.partialRight = uf, v.partition = s1, v.pick = Cb, v.pickBy = yf, v.property = Cf, v.propertyOf = Sy, v.pull = ov, v.pullAll = Xc, v.pullAllBy = sv, v.pullAllWith = av, v.pullAt = lv, v.range = Cy, v.rangeRight = $y, v.rearg = k1, v.reject = u1, v.remove = uv, v.rest = T1, v.reverse = ka, v.sampleSize = f1, v.set = Eb, v.setWith = Pb, v.shuffle = h1, v.slice = cv, v.sortBy = m1, v.sortedUniq = vv, v.sortedUniqBy = bv, v.split = Jb, v.spread = _1, v.tail = yv, v.take = xv, v.takeRight = wv, v.takeRightWhile = kv, v.takeWhile = Tv, v.tap = Fv, v.throttle = S1, v.thru = Do, v.toArray = pf, v.toPairs = xf, v.toPairsIn = wf, v.toPath = Iy, v.toPlainObject = gf, v.transform = Ab, v.unary = C1, v.union = _v, v.unionBy = Sv, v.unionWith = Cv, v.uniq = $v, v.uniqBy = Ev, v.uniqWith = Pv, v.unset = Rb, v.unzip = Ta, v.unzipWith = Jc, v.update = Ib, v.updateWith = Ub, v.values = Wr, v.valuesIn = Db, v.without = Av, v.words = _f, v.wrap = $1, v.xor = Rv, v.xorBy = Iv, v.xorWith = Uv, v.zip = Dv, v.zipObject = Mv, v.zipObjectDeep = Ov, v.zipWith = Lv, v.entries = xf, v.entriesIn = wf, v.extend = vf, v.extendWith = No, Ua(v, v), v.add = Dy, v.attempt = Sf, v.camelCase = Fb, v.capitalize = kf, v.ceil = My, v.clamp = Mb, v.clone = P1, v.cloneDeep = R1, v.cloneDeepWith = I1, v.cloneWith = A1, v.conformsTo = U1, v.deburr = Tf, v.defaultTo = dy, v.divide = Oy, v.endsWith = Vb, v.eq = dn, v.escape = Bb, v.escapeRegExp = Nb, v.every = Yv, v.find = Zv, v.findIndex = qc, v.findKey = ub, v.findLast = Xv, v.findLastIndex = Yc, v.findLastKey = cb, v.floor = Ly, v.forEach = ef, v.forEachRight = tf, v.forIn = fb, v.forInRight = hb, v.forOwn = db, v.forOwnRight = pb, v.get = Ea, v.gt = D1, v.gte = M1, v.has = vb, v.hasIn = Pa, v.head = Zc, v.identity = Nt, v.includes = n1, v.indexOf = X0, v.inRange = Ob, v.invoke = xb, v.isArguments = mr, v.isArray = Re, v.isArrayBuffer = O1, v.isArrayLike = Vt, v.isArrayLikeObject = ht, v.isBoolean = L1, v.isBuffer = Zn, v.isDate = F1, v.isElement = V1, v.isEmpty = B1, v.isEqual = N1, v.isEqualWith = W1, v.isError = Ca, v.isFinite = z1, v.isFunction = In, v.isInteger = cf, v.isLength = Vo, v.isMap = ff, v.isMatch = j1, v.isMatchWith = G1, v.isNaN = H1, v.isNative = q1, v.isNil = K1, v.isNull = Y1, v.isNumber = hf, v.isObject = at, v.isObjectLike = ft, v.isPlainObject = wi, v.isRegExp = $a, v.isSafeInteger = Z1, v.isSet = df, v.isString = Bo, v.isSymbol = qt, v.isTypedArray = Nr, v.isUndefined = X1, v.isWeakMap = J1, v.isWeakSet = Q1, v.join = nv, v.kebabCase = Wb, v.last = rn, v.lastIndexOf = rv, v.lowerCase = zb, v.lowerFirst = jb, v.lt = eb, v.lte = tb, v.max = Fy, v.maxBy = Vy, v.mean = By, v.meanBy = Ny, v.min = Wy, v.minBy = zy, v.stubArray = Ma, v.stubFalse = Oa, v.stubObject = Ey, v.stubString = Py, v.stubTrue = Ay, v.multiply = jy, v.nth = iv, v.noConflict = xy, v.noop = Da, v.now = Oo, v.pad = Gb, v.padEnd = Hb, v.padStart = qb, v.parseInt = Yb, v.random = Lb, v.reduce = a1, v.reduceRight = l1, v.repeat = Kb, v.replace = Zb, v.result = $b, v.round = Gy, v.runInContext = P, v.sample = c1, v.size = d1, v.snakeCase = Xb, v.some = p1, v.sortedIndex = fv, v.sortedIndexBy = hv, v.sortedIndexOf = dv, v.sortedLastIndex = pv, v.sortedLastIndexBy = mv, v.sortedLastIndexOf = gv, v.startCase = Qb, v.startsWith = ey, v.subtract = Hy, v.sum = qy, v.sumBy = Yy, v.template = ty, v.times = Ry, v.toFinite = Un, v.toInteger = Ie, v.toLength = mf, v.toLower = ny, v.toNumber = on, v.toSafeInteger = nb, v.toString = Ke, v.toUpper = ry, v.trim = iy, v.trimEnd = oy, v.trimStart = sy, v.truncate = ay, v.unescape = ly, v.uniqueId = Uy, v.upperCase = uy, v.upperFirst = Aa, v.each = ef, v.eachRight = tf, v.first = Zc, Ua(v, function() {
        var t = {};
        return bn(v, function(r, s) {
          Ze.call(v.prototype, s) || (t[s] = r);
        }), t;
      }(), { chain: !1 }), v.VERSION = o, Jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        v[t].placeholder = v;
      }), Jt(["drop", "take"], function(t, r) {
        Be.prototype[t] = function(s) {
          s = s === i ? 1 : vt(Ie(s), 0);
          var l = this.__filtered__ && !r ? new Be(this) : this.clone();
          return l.__filtered__ ? l.__takeCount__ = Ct(s, l.__takeCount__) : l.__views__.push({
            size: Ct(s, $),
            type: t + (l.__dir__ < 0 ? "Right" : "")
          }), l;
        }, Be.prototype[t + "Right"] = function(s) {
          return this.reverse()[t](s).reverse();
        };
      }), Jt(["filter", "map", "takeWhile"], function(t, r) {
        var s = r + 1, l = s == ve || s == We;
        Be.prototype[t] = function(d) {
          var b = this.clone();
          return b.__iteratees__.push({
            iteratee: ye(d, 3),
            type: s
          }), b.__filtered__ = b.__filtered__ || l, b;
        };
      }), Jt(["head", "last"], function(t, r) {
        var s = "take" + (r ? "Right" : "");
        Be.prototype[t] = function() {
          return this[s](1).value()[0];
        };
      }), Jt(["initial", "tail"], function(t, r) {
        var s = "drop" + (r ? "" : "Right");
        Be.prototype[t] = function() {
          return this.__filtered__ ? new Be(this) : this[s](1);
        };
      }), Be.prototype.compact = function() {
        return this.filter(Nt);
      }, Be.prototype.find = function(t) {
        return this.filter(t).head();
      }, Be.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, Be.prototype.invokeMap = Me(function(t, r) {
        return typeof t == "function" ? new Be(this) : this.map(function(s) {
          return mi(s, t, r);
        });
      }), Be.prototype.reject = function(t) {
        return this.filter(Fo(ye(t)));
      }, Be.prototype.slice = function(t, r) {
        t = Ie(t);
        var s = this;
        return s.__filtered__ && (t > 0 || r < 0) ? new Be(s) : (t < 0 ? s = s.takeRight(-t) : t && (s = s.drop(t)), r !== i && (r = Ie(r), s = r < 0 ? s.dropRight(-r) : s.take(r - t)), s);
      }, Be.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, Be.prototype.toArray = function() {
        return this.take($);
      }, bn(Be.prototype, function(t, r) {
        var s = /^(?:filter|find|map|reject)|While$/.test(r), l = /^(?:head|last)$/.test(r), d = v[l ? "take" + (r == "last" ? "Right" : "") : r], b = l || /^find/.test(r);
        d && (v.prototype[r] = function() {
          var w = this.__wrapped__, C = l ? [1] : arguments, A = w instanceof Be, B = C[0], N = A || Re(w), q = function(Fe) {
            var Ne = d.apply(v, zn([Fe], C));
            return l && ne ? Ne[0] : Ne;
          };
          N && s && typeof B == "function" && B.length != 1 && (A = N = !1);
          var ne = this.__chain__, de = !!this.__actions__.length, xe = b && !ne, De = A && !de;
          if (!b && N) {
            w = De ? w : new Be(this);
            var we = t.apply(w, C);
            return we.__actions__.push({ func: Do, args: [q], thisArg: i }), new en(we, ne);
          }
          return xe && De ? t.apply(this, C) : (we = this.thru(q), xe ? l ? we.value()[0] : we.value() : we);
        });
      }), Jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var r = oo[t], s = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", l = /^(?:pop|shift)$/.test(t);
        v.prototype[t] = function() {
          var d = arguments;
          if (l && !this.__chain__) {
            var b = this.value();
            return r.apply(Re(b) ? b : [], d);
          }
          return this[s](function(w) {
            return r.apply(Re(w) ? w : [], d);
          });
        };
      }), bn(Be.prototype, function(t, r) {
        var s = v[r];
        if (s) {
          var l = s.name + "";
          Ze.call(Or, l) || (Or[l] = []), Or[l].push({ name: r, func: s });
        }
      }), Or[$o(i, F).name] = [{
        name: "wrapper",
        func: i
      }], Be.prototype.clone = lg, Be.prototype.reverse = ug, Be.prototype.value = cg, v.prototype.at = Vv, v.prototype.chain = Bv, v.prototype.commit = Nv, v.prototype.next = Wv, v.prototype.plant = jv, v.prototype.reverse = Gv, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = Hv, v.prototype.first = v.prototype.head, li && (v.prototype[li] = zv), v;
    }, Ur = Nm();
    ar ? ((ar.exports = Ur)._ = Ur, Is._ = Ur) : Tt._ = Ur;
  }).call(ki);
})(DS, ls);
const qh = ls, BC = Tr(
  ({
    data: e,
    defaultOption: n,
    show: i,
    keyName: o,
    isMultiple: a = !1,
    iconKey: c,
    variant: u = "default",
    background: h,
    color: f,
    marginTop: m,
    onChange: g,
    defaultValue: x,
    handleOnlyOneSelectOption: T
  }, E) => {
    const { convertKeys: I } = Ni(), [D, W] = nt(!1), [F, z] = nt([]), L = un(null), [G, Q] = nt(!1);
    let fe;
    e[0], fe = Sl(e), xs({
      ref: L,
      onClickOutside: () => W(!1),
      avoidElementHaveClasses: ["select-arrow"]
    }), mt(() => {
      e.length === 1 && T && T(e[0]);
    }, [T, e]), mt(() => {
      x && (typeof x[0] == "object" && !G && (Q(!0), x.forEach((_e) => {
        fe.forEach((re) => {
          const { hookInsertedUuid: ve, ...le } = re;
          qh.isEqual(_e, le) && z((We) => Array.from(/* @__PURE__ */ new Set([...We, re])));
        });
      })), typeof x[0] == "string" && x.forEach((_e) => {
        fe.forEach((re) => {
          const { value: ve } = re;
          qh.isEqual(_e, ve) && z((le) => Array.from(/* @__PURE__ */ new Set([...le, re])));
        });
      }));
    }, []), mt(() => {
      if (E) {
        if (o) {
          E.current[o] = [], F.map((_e) => {
            const re = fe.find(
              ({ hookInsertedUuid: le }) => le === _e.hookInsertedUuid
            ), ve = Object.assign({}, re);
            delete ve.hookInsertedUuid, E.current[o].push(ve);
          });
          return;
        }
        E.current = [], F.map((_e) => {
          const re = fe.find(
            ({ hookInsertedUuid: le }) => le === _e.hookInsertedUuid
          ), ve = Object.assign({}, re);
          delete ve.hookInsertedUuid, E.current.push(ve);
        });
      }
      if (g && F.length > 0) {
        const _e = F.map(
          ({ hookInsertedUuid: le }) => le
        ), ve = fe.map(
          (le) => _e.includes(le.hookInsertedUuid) ? le : null
        ).filter(Boolean).map(
          (le) => {
            const We = Object.assign({}, le);
            return delete We.hookInsertedUuid, We;
          }
        );
        g(ve);
      }
    }, [F]);
    function ge(_e) {
      z(a ? (re) => [...re, _e] : [_e]);
    }
    function he(_e) {
      z(
        (re) => re.filter((ve) => ve.hookInsertedUuid !== _e)
      );
    }
    function $e() {
      if (typeof e[0] == "object" && i) {
        const _e = I(i), re = F.map(
          ({ hookInsertedUuid: le }) => le
        );
        return fe.map((le) => re.includes(le.hookInsertedUuid) ? null : _e.map((We) => {
          let je = { ...le };
          return We.split(".").forEach((y) => {
            je = je[y];
          }), /* @__PURE__ */ me(
            Cl,
            {
              variant: u,
              role: "dropdown-option",
              onClick: () => ge(le),
              children: [
                je,
                c && c in le && typeof le[c] == "object" && le[c],
                c && typeof le[c] == "string" && /* @__PURE__ */ R("img", { src: le[c] })
              ]
            },
            le.hookInsertedUuid
          );
        }));
      }
      return fe.map((_e) => F.map(
        ({ hookInsertedUuid: ve }) => ve
      ).includes(_e.hookInsertedUuid) ? null : /* @__PURE__ */ R(
        Cl,
        {
          role: "dropdown-option",
          onClick: () => ge(_e),
          children: _e.value
        },
        ln()
      ));
    }
    function Qe(_e) {
      if (typeof e[0] == "object" && i) {
        const re = I(i);
        return F.map((ve) => {
          let le = Object.assign({}, ve);
          return re.forEach((We) => {
            We.includes(".") ? We.split(".").forEach((Se) => {
              le = le[Se];
            }) : le = le[We];
          }), /* @__PURE__ */ R(
            Hh,
            {
              variant: _e,
              label: le,
              onRemove: () => {
                he(ve.hookInsertedUuid);
              }
            },
            ve.hookInsertedUuid
          );
        });
      }
      if (typeof e[0] == "string")
        return F.map((re) => /* @__PURE__ */ R(
          Hh,
          {
            variant: _e,
            label: re.value,
            onRemove: () => {
              he(re.hookInsertedUuid);
            }
          },
          re.hookInsertedUuid
        ));
    }
    const Ge = an(() => {
      F.length === 0 && W((_e) => !_e);
    }, [F, W]);
    return /* @__PURE__ */ me(
      wS,
      {
        background: h,
        color: f,
        variant: u,
        role: "dropdown",
        marginTop: m,
        ref: L,
        children: [
          /* @__PURE__ */ R(
            _S,
            {
              role: "dropdown-option",
              onClick: Ge,
              children: F.length < 1 ? n : /* @__PURE__ */ R($S, { children: Qe(u) })
            }
          ),
          /* @__PURE__ */ R(_n, { children: D && /* @__PURE__ */ R(
            kS,
            {
              variants: ES,
              initial: "hidden",
              animate: "show",
              exit: "exit",
              children: $e()
            }
          ) }),
          /* @__PURE__ */ R(
            "div",
            {
              onClick: () => W((_e) => !_e),
              className: "select-arrow",
              title: "select arrow",
              children: /* @__PURE__ */ R(
                CS,
                {
                  isSuggestionsShown: D,
                  size: 20,
                  variant: u
                }
              )
            }
          )
        ]
      }
    );
  }
), Dp = {
  default: U`
    background: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, MS = V.div`
  height: 4rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 200px;
  ${({ variant: e }) => Dp[e]}
  background: ${({ background: e }) => e};
  padding: 1rem;

  .button-cover,
  .knobs,
  .layer {
    position: absolute;
    top: 0;
    bottom: 0;
  }

  .button {
    position: relative;
    top: 50%;
    width: 74px;
    height: 36px;
    margin-top: -20px;
    overflow: hidden;
  }

  .button.r,
  .button.r .layer {
    border-radius: 100px;
  }

  .button.b2 {
    border-radius: 2px;
  }

  .checkbox {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }

  .knobs {
    z-index: 2;
  }

  .layer {
    width: 100%;
    background-color: ${({ theme: e, switchBackgrounds: n, isOn: i }) => i && !n && Pe(0.1, e.monkUiThemes.colors.success)};
    background-color: ${({ switchBackgrounds: e, isOn: n }) => n && e && e.on};
    transition: 0.3s ease all;
    z-index: 1;
  }

  /* Button 1 */
  #button-1 .knobs:before {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 20px;
    height: 10px;
    color: black;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 9px 4px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
  }

  #button-1 .checkbox:checked + .knobs:before {
    content: '';
    left: 42px;
    background-color: white;
    color: black;
  }

  #button-1 .checkbox:checked ~ .layer {
    background-color: ${({ theme: e, switchBackgrounds: n, isOn: i }) => !i && !n && Pe(0.1, e.monkUiThemes.colors.error)};
    background-color: ${({ switchBackgrounds: e, isOn: n }) => !n && e && e.off};
  }

  #button-1 .knobs,
  #button-1 .knobs:before,
  #button-1 .layer {
    transition: 0.3s ease all;
  }
`, OS = {
  default: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, LS = V.label`
  display: flex;
  position: relative;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  font-weight: bold;
  ${({ variant: e }) => OS[e]}
  color: ${({ color: e }) => e};
`, FS = V.div`
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-top: 1rem;
`, VS = V.div`
  background-color: #fff;
  border-radius: 4px;
  width: 200px;
  display: flex;
  justify-content: center;
  ${({ variant: e }) => Dp[e]}
  background: ${({ background: e }) => e};
`, NC = Tr(
  ({
    keyName: e,
    value: n,
    background: i,
    color: o,
    enabledLabel: a = "Ativo",
    disabledLabel: c = "Inativo",
    variant: u = "default",
    switchBackgrounds: h,
    onToggle: f
  }, m) => {
    const [g, x] = nt(n ?? !1);
    return mt(() => {
      m && (e && (m.current[e] = g), e || (m.current = g)), f && f(g);
    }, [g, f]), /* @__PURE__ */ me(
      MS,
      {
        background: i,
        color: o,
        variant: u,
        isOn: g,
        switchBackgrounds: h,
        children: [
          a && c && /* @__PURE__ */ R(LS, { variant: u, color: o, children: g ? a : c }),
          /* @__PURE__ */ R(FS, { children: /* @__PURE__ */ R(
            VS,
            {
              className: "button-cover",
              background: i,
              color: o,
              variant: u,
              children: /* @__PURE__ */ me(
                "div",
                {
                  className: "button r",
                  id: "button-1",
                  onClick: () => x((T) => !T),
                  role: "switch-button",
                  children: [
                    /* @__PURE__ */ R(
                      "input",
                      {
                        type: "checkbox",
                        className: "checkbox",
                        checked: !g,
                        onChange: () => {
                        }
                      }
                    ),
                    /* @__PURE__ */ R("div", { className: "knobs" }),
                    /* @__PURE__ */ R("div", { className: "layer", role: "switch-background" })
                  ]
                }
              )
            }
          ) })
        ]
      }
    );
  }
), BS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  outlined: U`
    background: transparent;
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, NS = V.div`
  ${({ variant: e }) => BS[e]};
  padding-bottom: ${({ paddingBottom: e }) => e || "0"};
  padding-top: ${({ paddingTop: e }) => e || "0"};
  padding-left: ${({ paddingLeft: e }) => e || "0"};
  padding-right: ${({ paddingRight: e }) => e || "0"};
  margin: ${({ margin: e }) => e || "0"};
  width: ${({ width: e }) => e};
  height: ${({ height: e }) => e};
  padding: ${({ padding: e }) => e || "0"};
  margin-bottom: ${({ marginBottom: e }) => e || "0"};
  margin-top: ${({ marginTop: e }) => e || "0"};
  margin-left: ${({ marginLeft: e }) => e || "0"};
  margin-right: ${({ marginRight: e }) => e || "0"};
  border-radius: ${({ borderRadius: e }) => e || ""};
  overflow: auto;
  &::-webkit-scrollbar {
    background: transparent;
    width: 6px;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: #888;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`, WS = V.table`
  * {
    font-family: ${({ theme: e, fontFamily: n }) => n ?? e.monkUiThemes.fontFamily.sora};
    font-size: ${({ fontSize: e }) => e ?? "1rem"};
  }

  td {
    font-weight: ${({ fontWeight: e }) => e ?? "regular"};
  }

  border-collapse: collapse;
  width: 100%;
  height: 100%;
`, zS = V.thead`
  height: 2rem;
  padding: 0 1rem;
`, jS = {
  default: U`
    &:hover {
      background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    }
  `,
  outlined: U`
    &:hover {
      background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    }
  `,
  filled: U`
    &:hover {
      background: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.main)};
    }
  `
}, Mp = V.tr`
  transition: all 0.3s ease-in-out;
  &:last-of-type {
    td {
      border-bottom: none;
    }
  }

  ${({ variant: e }) => jS[e]};
`, GS = V(Mp)`
  pointer-events: none;

  * {
    pointer-events: none;
  }
`, HS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.white)};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
    border-bottom: 1px solid
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `,
  filled: U`
    background: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
    border-bottom: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, qS = V.th`
  ${({ variant: e }) => HS[e]};
  text-align: ${({ textAlign: e }) => e ?? "start"};
  padding: 1.4rem 0.5rem;
  font-weight: 500;
`, YS = V.tbody``, KS = {
  default: U`
    border-bottom: 1px solid
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `,
  outlined: U`
    border-bottom: 1px solid
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `,
  filled: U`
    border-bottom: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, ZS = V.td`
  ${({ variant: e }) => KS[e]};
  text-align: ${({ textAlign: e }) => e ?? "start"};
  padding: 1.4rem 0.5rem;
  font-weight: regular;
  max-width: 12rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`, XS = V.td`
  position: absolute;
  right: 2rem;
  transform: translateY(50%);
  z-index: 10;
  bottom: ${({ top: e }) => e};
`, JS = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    box-shadow: 2px 0 2px 0
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    box-shadow: 2px 0 2px 0
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.main};
    box-shadow: 2px 0 2px 0
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `
}, QS = V.div`
  ${({ variant: e }) => JS[e]};
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  text-align: center;
  writing-mode: vertical-rl;
  font-weight: bold;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;

  &:hover {
    transform: scale(1.1);
  }

  > span {
    display: block;
    margin-right: 1px;
  }
`, e5 = V.img`
  width: 20px;
  height: 20px;
`, t5 = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
  `,
  filled: U`
    background: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.white)};
  `
}, n5 = V(vn.div)`
  ${({ variant: e }) => t5[e]};
  border-radius: 0.3rem;
  max-height: 9rem;
  overflow: scroll;
  width: 10rem;

  &::-webkit-scrollbar {
    display: none;
  }
`, r5 = {
  default: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};

    svg {
      fill: ${({ theme: e }) => e.monkUiThemes.colors.white};
    }

    & + & {
      border-top: 2px solid ${({ theme: e }) => e.monkUiThemes.colors.white};
    }
  `,
  outlined: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};

    svg {
      fill: ${({ theme: e }) => e.monkUiThemes.colors.white};
    }

    & + & {
      border-top: 2px solid ${({ theme: e }) => e.monkUiThemes.colors.white};
    }
  `,
  filled: U`
    color: ${({ theme: e }) => e.monkUiThemes.colors.main};

    svg {
      fill: ${({ theme: e }) => e.monkUiThemes.colors.main};
    }

    & + & {
      border-top: 2px solid ${({ theme: e }) => e.monkUiThemes.colors.main};
    }
  `
}, i5 = V.div`
  ${({ variant: e }) => r5[e]};
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: all 0.3s ease-in-out;

  svg {
    width: 20px;
    height: 20px;
    margin-left: 0.6rem;
  }

  &:hover {
    opacity: 0.8;
  }
`, o5 = V.div``, s5 = V.div``, a5 = V.p`
  font-size: 0.9rem;
  margin-right: 0.6rem;
`, l5 = {
  hidden: {
    opacity: 0,
    x: -170,
    y: -30,
    height: 0,
    position: "absolute"
  },
  show: {
    opacity: 1,
    x: -170,
    y: -30,
    height: "fit-content",
    position: "absolute",
    transition: {
      height: {
        duration: 0.4
      },
      opacity: {
        duration: 0.4
      }
    }
  },
  exit: {
    opacity: 0,
    x: -170,
    y: -30,
    height: 0,
    position: "absolute",
    transition: {
      height: {
        duration: 0.4
      },
      opacity: {
        duration: 0.4
      }
    }
  }
};
function u5({
  options: e,
  rowObject: n,
  variant: i
}) {
  const [o, a] = nt(!1), [c, u] = nt(0), h = un(null);
  xs({
    ref: h,
    onClickOutside: () => a(!1)
  });
  const f = an((m) => {
    m && m.parentElement && u(m.parentElement.getBoundingClientRect().height);
  }, []);
  return /* @__PURE__ */ me(XS, { ref: f, top: c, children: [
    /* @__PURE__ */ R(
      QS,
      {
        role: "button",
        onClick: () => a((m) => !m),
        isMenuVisible: o,
        ref: h,
        variant: i,
        children: /* @__PURE__ */ R("span", { children: "..." })
      }
    ),
    /* @__PURE__ */ R(_n, { children: o && /* @__PURE__ */ R(
      n5,
      {
        variant: i,
        variants: l5,
        initial: "hidden",
        animate: "show",
        exit: "exit",
        role: "options-menu",
        children: e.map((m, g) => /* @__PURE__ */ me(
          i5,
          {
            variant: i,
            role: "option",
            onClick: () => m.action(n),
            children: [
              /* @__PURE__ */ R(o5, { children: typeof m.icon == "string" ? /* @__PURE__ */ R(e5, { src: m.icon }) : m.icon }),
              /* @__PURE__ */ R(s5, { children: /* @__PURE__ */ R(a5, { children: m.label }) })
            ]
          },
          m.label + g
        ))
      }
    ) })
  ] });
}
function WC({
  width: e = "100%",
  height: n = "100%",
  ...i
}) {
  const [o, a] = nt([]), [c, u] = nt(), { convertKeys: h, convertChildrenKeys: f } = Ni();
  return mt(() => {
    if (i.data.length < 1)
      return;
    let m = h(i.data[0]);
    i.fieldsNames && u(f(i.fieldsNames)), i.exclude && (m = m.filter((g) => !h(i.exclude).includes(g))), a(m);
  }, [
    i.data,
    i.exclude,
    i.fieldsNames,
    h,
    f
  ]), i.data.length < 1 ? /* @__PURE__ */ R("div", {}) : /* @__PURE__ */ R(
    NS,
    {
      ...i,
      width: e,
      height: n,
      variant: i.variant ?? "default",
      children: /* @__PURE__ */ me(
        WS,
        {
          variant: i.variant ?? "default",
          height: n,
          borderRadius: i.borderRadius,
          children: [
            /* @__PURE__ */ R(zS, { children: /* @__PURE__ */ R(GS, { variant: i.variant ?? "default", children: o.map((m) => {
              let g;
              return c && m in c ? g = c[m] : g = m, /* @__PURE__ */ R(
                qS,
                {
                  variant: i.variant ?? "default",
                  textAlign: i.alignText,
                  children: `${g}`
                },
                ln()
              );
            }) }) }),
            /* @__PURE__ */ R(YS, { children: i.data.map((m) => /* @__PURE__ */ me(Mp, { variant: i.variant ?? "default", children: [
              o.map((g) => {
                let x = { ...m };
                return g.split(".").forEach((E) => {
                  x = x[E];
                }), /* @__PURE__ */ R(
                  ZS,
                  {
                    variant: i.variant ?? "default",
                    textAlign: i.alignText,
                    title: x,
                    children: x ?? "---"
                  },
                  ln()
                );
              }),
              i.menuOptions && i.menuOptions.length > 0 && /* @__PURE__ */ R(
                u5,
                {
                  variant: i.variant ?? "default",
                  options: i.menuOptions,
                  rowObject: m
                },
                ln()
              )
            ] }, ln())) })
          ]
        }
      )
    }
  );
}
const c5 = V.div`
  display: flex;
  flex-direction: column;
  background: none;
  width: ${({ width: e }) => e};
  height: ${({ height: e }) => e};
`, Yh = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, f5 = V.textarea`
  padding: 0.5rem;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  border-radius: 10px;
  ${({ variant: e }) => e && Yh[e] || Yh.default};
  cursor: ${({ disabled: e }) => e && "not-allowed"};
  background: ${({ background: e }) => e};
  color: ${({ color: e }) => e};
  max-width: 100%;
  height: 100%;
  resize: ${({ resizable: e }) => !e && "none"};
`, h5 = V.label`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  margin-bottom: 0.5rem;
  color: ${({ color: e, theme: n }) => e ?? n.monkUiThemes.colors.black};
`, zC = Tr(
  ({
    disabled: e,
    placeholder: n,
    keyName: i,
    readOnly: o,
    required: a,
    size: c,
    defaultValue: u,
    label: h,
    variant: f,
    background: m,
    color: g,
    maxLength: x,
    width: T,
    height: E,
    onChange: I,
    onClick: D,
    error: W,
    resizable: F = !1,
    name: z
  }, L) => {
    const G = Wt(() => ln(), []);
    function Q(fe) {
      if (L) {
        if (i) {
          L.current[i] = fe.target.value;
          return;
        }
        L.current = fe.target.value;
      }
      I && I(fe);
    }
    return /* @__PURE__ */ me(c5, { width: T, height: E, children: [
      /* @__PURE__ */ me(h5, { color: g, htmlFor: G, children: [
        h,
        " ",
        a && "*"
      ] }),
      /* @__PURE__ */ R(
        f5,
        {
          id: G,
          disabled: e,
          name: z,
          rows: c == null ? void 0 : c.rows,
          cols: c == null ? void 0 : c.cols,
          placeholder: n,
          readOnly: o,
          required: a,
          maxLength: x,
          defaultValue: u,
          onChange: (fe) => Q(fe),
          onClick: D,
          variant: f,
          background: m,
          color: g,
          resizable: F
        }
      ),
      W && /* @__PURE__ */ R("small", { children: W })
    ] });
  }
), d5 = {
  hidden: {
    x: -20,
    opacity: 0
  },
  show: {
    x: 0,
    opacity: 1,
    transition: {
      x: { duration: 0.3 },
      opacity: { duration: 0.3 }
    }
  },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      x: { duration: 0.3 },
      opacity: { duration: 0.3 }
    }
  }
};
var $l = {}, p5 = {
  get exports() {
    return $l;
  },
  set exports(e) {
    $l = e;
  }
}, tl, Kh;
function m5() {
  if (Kh)
    return tl;
  Kh = 1;
  function e(y) {
    return y && typeof y == "object" && "default" in y ? y.default : y;
  }
  var n = e(Ut), i = rd;
  function o(y, k) {
    for (var $ = Object.getOwnPropertyNames(k), S = 0; S < $.length; S++) {
      var p = $[S], H = Object.getOwnPropertyDescriptor(k, p);
      H && H.configurable && y[p] === void 0 && Object.defineProperty(y, p, H);
    }
    return y;
  }
  function a() {
    return (a = Object.assign || function(y) {
      for (var k = 1; k < arguments.length; k++) {
        var $ = arguments[k];
        for (var S in $)
          Object.prototype.hasOwnProperty.call($, S) && (y[S] = $[S]);
      }
      return y;
    }).apply(this, arguments);
  }
  function c(y, k) {
    y.prototype = Object.create(k.prototype), o(y.prototype.constructor = y, k);
  }
  function u(y, k) {
    if (y == null)
      return {};
    var $, S, p = {}, H = Object.keys(y);
    for (S = 0; S < H.length; S++)
      $ = H[S], 0 <= k.indexOf($) || (p[$] = y[$]);
    return p;
  }
  function h(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  var f = function(y, k, $, S, p, H, ae, be) {
    if (!y) {
      var K;
      if (k === void 0)
        K = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var ee = [$, S, p, H, ae, be], ie = 0;
        (K = new Error(k.replace(/%s/g, function() {
          return ee[ie++];
        }))).name = "Invariant Violation";
      }
      throw K.framesToPop = 1, K;
    }
  }, m = f;
  function g(y, k, $) {
    if ("selectionStart" in y && "selectionEnd" in y)
      y.selectionStart = k, y.selectionEnd = $;
    else {
      var S = y.createTextRange();
      S.collapse(!0), S.moveStart("character", k), S.moveEnd("character", $ - k), S.select();
    }
  }
  function x(y) {
    var k = 0, $ = 0;
    if ("selectionStart" in y && "selectionEnd" in y)
      k = y.selectionStart, $ = y.selectionEnd;
    else {
      var S = document.selection.createRange();
      S.parentElement() === y && (k = -S.moveStart("character", -y.value.length), $ = -S.moveEnd("character", -y.value.length));
    }
    return { start: k, end: $, length: $ - k };
  }
  var T = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, E = "_";
  function I(y, k, $) {
    var S = "", p = "", H = null, ae = [];
    if (k === void 0 && (k = E), $ == null && ($ = T), !y || typeof y != "string")
      return { maskChar: k, formatChars: $, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var be = !1;
    return y.split("").forEach(function(K) {
      be = !be && K === "\\" || (be || !$[K] ? (ae.push(S.length), S.length === ae.length - 1 && (p += K)) : H = S.length + 1, S += K, !1);
    }), { maskChar: k, formatChars: $, prefix: p, mask: S, lastEditablePosition: H, permanents: ae };
  }
  function D(y, k) {
    return y.permanents.indexOf(k) !== -1;
  }
  function W(y, k, $) {
    var S = y.mask, p = y.formatChars;
    if (!$)
      return !1;
    if (D(y, k))
      return S[k] === $;
    var H = p[S[k]];
    return new RegExp(H).test($);
  }
  function F(y, k) {
    return k.split("").every(function($, S) {
      return D(y, S) || !W(y, S, $);
    });
  }
  function z(y, k) {
    var $ = y.maskChar, S = y.prefix;
    if (!$) {
      for (; k.length > S.length && D(y, k.length - 1); )
        k = k.slice(0, k.length - 1);
      return k.length;
    }
    for (var p = S.length, H = k.length; H >= S.length; H--) {
      var ae = k[H];
      if (!D(y, H) && W(y, H, ae)) {
        p = H + 1;
        break;
      }
    }
    return p;
  }
  function L(y, k) {
    return z(y, k) === y.mask.length;
  }
  function G(y, k) {
    var $ = y.maskChar, S = y.mask, p = y.prefix;
    if (!$) {
      for ((k = fe(y, "", k, 0)).length < p.length && (k = p); k.length < S.length && D(y, k.length); )
        k += S[k.length];
      return k;
    }
    if (k)
      return fe(y, G(y, ""), k, 0);
    for (var H = 0; H < S.length; H++)
      D(y, H) ? k += S[H] : k += $;
    return k;
  }
  function Q(y, k, $, S) {
    var p = $ + S, H = y.maskChar, ae = y.mask, be = y.prefix, K = k.split("");
    if (H)
      return K.map(function(ie, oe) {
        return oe < $ || p <= oe ? ie : D(y, oe) ? ae[oe] : H;
      }).join("");
    for (var ee = p; ee < K.length; ee++)
      D(y, ee) && (K[ee] = "");
    return $ = Math.max(be.length, $), K.splice($, p - $), k = K.join(""), G(y, k);
  }
  function fe(y, k, $, S) {
    var p = y.mask, H = y.maskChar, ae = y.prefix, be = $.split(""), K = L(y, k);
    return !H && S > k.length && (k += p.slice(k.length, S)), be.every(function(ee) {
      for (; Ce = ee, D(y, Z = S) && Ce !== p[Z]; ) {
        if (S >= k.length && (k += p[S]), ie = ee, oe = S, H && D(y, oe) && ie === H)
          return !0;
        if (++S >= p.length)
          return !1;
      }
      var ie, oe, Z, Ce;
      return !W(y, S, ee) && ee !== H || (S < k.length ? k = H || K || S < ae.length ? k.slice(0, S) + ee + k.slice(S + 1) : (k = k.slice(0, S) + ee + k.slice(S), G(y, k)) : H || (k += ee), ++S < p.length);
    }), k;
  }
  function ge(y, k, $, S) {
    var p = y.mask, H = y.maskChar, ae = $.split(""), be = S;
    return ae.every(function(K) {
      for (; ie = K, D(y, ee = S) && ie !== p[ee]; )
        if (++S >= p.length)
          return !1;
      var ee, ie;
      return (W(y, S, K) || K === H) && S++, S < p.length;
    }), S - be;
  }
  function he(y, k) {
    for (var $ = k; 0 <= $; --$)
      if (!D(y, $))
        return $;
    return null;
  }
  function $e(y, k) {
    for (var $ = y.mask, S = k; S < $.length; ++S)
      if (!D(y, S))
        return S;
    return null;
  }
  function Qe(y) {
    return y || y === 0 ? y + "" : "";
  }
  function Ge(y, k, $, S, p) {
    var H = y.mask, ae = y.prefix, be = y.lastEditablePosition, K = k, ee = "", ie = 0, oe = 0, Z = Math.min(p.start, $.start);
    return $.end > p.start ? oe = (ie = ge(y, S, ee = K.slice(p.start, $.end), Z)) ? p.length : 0 : K.length < S.length && (oe = S.length - K.length), K = S, oe && (oe === 1 && !p.length && (Z = p.start === $.start ? $e(y, $.start) : he(y, $.start)), K = Q(y, K, Z, oe)), K = fe(y, K, ee, Z), (Z += ie) >= H.length ? Z = H.length : Z < ae.length && !ie ? Z = ae.length : Z >= ae.length && Z < be && ie && (Z = $e(y, Z)), ee || (ee = null), { value: K = G(y, K), enteredString: ee, selection: { start: Z, end: Z } };
  }
  function _e() {
    var y = new RegExp("windows", "i"), k = new RegExp("phone", "i"), $ = navigator.userAgent;
    return y.test($) && k.test($);
  }
  function re(y) {
    return typeof y == "function";
  }
  function ve() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function le() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function We(y) {
    return (le() ? ve() : function() {
      return setTimeout(y, 1e3 / 60);
    })(y);
  }
  function je(y) {
    (le() || clearTimeout)(y);
  }
  var Se = function(y) {
    function k(S) {
      var p = y.call(this, S) || this;
      p.focused = !1, p.mounted = !1, p.previousSelection = null, p.selectionDeferId = null, p.saveSelectionLoopDeferId = null, p.saveSelectionLoop = function() {
        p.previousSelection = p.getSelection(), p.saveSelectionLoopDeferId = We(p.saveSelectionLoop);
      }, p.runSaveSelectionLoop = function() {
        p.saveSelectionLoopDeferId === null && p.saveSelectionLoop();
      }, p.stopSaveSelectionLoop = function() {
        p.saveSelectionLoopDeferId !== null && (je(p.saveSelectionLoopDeferId), p.saveSelectionLoopDeferId = null, p.previousSelection = null);
      }, p.getInputDOMNode = function() {
        if (!p.mounted)
          return null;
        var X = i.findDOMNode(h(h(p))), j = typeof window < "u" && X instanceof window.Element;
        if (X && !j)
          return null;
        if (X.nodeName !== "INPUT" && (X = X.querySelector("input")), !X)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return X;
      }, p.getInputValue = function() {
        var X = p.getInputDOMNode();
        return X ? X.value : null;
      }, p.setInputValue = function(X) {
        var j = p.getInputDOMNode();
        j && (p.value = X, j.value = X);
      }, p.setCursorToEnd = function() {
        var X = z(p.maskOptions, p.value), j = $e(p.maskOptions, X);
        j !== null && p.setCursorPosition(j);
      }, p.setSelection = function(X, j, J) {
        J === void 0 && (J = {});
        var pe = p.getInputDOMNode(), ce = p.isFocused();
        pe && ce && (J.deferred || g(pe, X, j), p.selectionDeferId !== null && je(p.selectionDeferId), p.selectionDeferId = We(function() {
          p.selectionDeferId = null, g(pe, X, j);
        }), p.previousSelection = { start: X, end: j, length: Math.abs(j - X) });
      }, p.getSelection = function() {
        return x(p.getInputDOMNode());
      }, p.getCursorPosition = function() {
        return p.getSelection().start;
      }, p.setCursorPosition = function(X) {
        p.setSelection(X, X);
      }, p.isFocused = function() {
        return p.focused;
      }, p.getBeforeMaskedValueChangeConfig = function() {
        var X = p.maskOptions, j = X.mask, J = X.maskChar, pe = X.permanents, ce = X.formatChars;
        return { mask: j, maskChar: J, permanents: pe, alwaysShowMask: !!p.props.alwaysShowMask, formatChars: ce };
      }, p.isInputAutofilled = function(X, j, J, pe) {
        var ce = p.getInputDOMNode();
        try {
          if (ce.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !p.focused || pe.end < J.length && j.end === X.length;
      }, p.onChange = function(X) {
        var j = h(h(p)).beforePasteState, J = h(h(p)).previousSelection, pe = p.props.beforeMaskedValueChange, ce = p.getInputValue(), Ee = p.value, Ue = p.getSelection();
        p.isInputAutofilled(ce, Ue, Ee, J) && (Ee = G(p.maskOptions, ""), J = { start: 0, end: 0, length: 0 }), j && (J = j.selection, Ee = j.value, Ue = { start: J.start + ce.length, end: J.start + ce.length, length: 0 }, ce = Ee.slice(0, J.start) + ce + Ee.slice(J.end), p.beforePasteState = null);
        var Le = Ge(p.maskOptions, ce, Ue, Ee, J), He = Le.enteredString, Xe = Le.selection, ut = Le.value;
        if (re(pe)) {
          var Dt = pe({ value: ut, selection: Xe }, { value: Ee, selection: J }, He, p.getBeforeMaskedValueChangeConfig());
          ut = Dt.value, Xe = Dt.selection;
        }
        p.setInputValue(ut), re(p.props.onChange) && p.props.onChange(X), p.isWindowsPhoneBrowser ? p.setSelection(Xe.start, Xe.end, { deferred: !0 }) : p.setSelection(Xe.start, Xe.end);
      }, p.onFocus = function(X) {
        var j = p.props.beforeMaskedValueChange, J = p.maskOptions, pe = J.mask, ce = J.prefix;
        if (p.focused = !0, p.mounted = !0, pe) {
          if (p.value)
            z(p.maskOptions, p.value) < p.maskOptions.mask.length && p.setCursorToEnd();
          else {
            var Ee = G(p.maskOptions, ce), Ue = G(p.maskOptions, Ee), Le = z(p.maskOptions, Ue), He = $e(p.maskOptions, Le), Xe = { start: He, end: He };
            if (re(j)) {
              var ut = j({ value: Ue, selection: Xe }, { value: p.value, selection: null }, null, p.getBeforeMaskedValueChangeConfig());
              Ue = ut.value, Xe = ut.selection;
            }
            var Dt = Ue !== p.getInputValue();
            Dt && p.setInputValue(Ue), Dt && re(p.props.onChange) && p.props.onChange(X), p.setSelection(Xe.start, Xe.end);
          }
          p.runSaveSelectionLoop();
        }
        re(p.props.onFocus) && p.props.onFocus(X);
      }, p.onBlur = function(X) {
        var j = p.props.beforeMaskedValueChange, J = p.maskOptions.mask;
        if (p.stopSaveSelectionLoop(), p.focused = !1, J && !p.props.alwaysShowMask && F(p.maskOptions, p.value)) {
          var pe = "";
          re(j) && (pe = j({ value: pe, selection: null }, { value: p.value, selection: p.previousSelection }, null, p.getBeforeMaskedValueChangeConfig()).value);
          var ce = pe !== p.getInputValue();
          ce && p.setInputValue(pe), ce && re(p.props.onChange) && p.props.onChange(X);
        }
        re(p.props.onBlur) && p.props.onBlur(X);
      }, p.onMouseDown = function(X) {
        if (!p.focused && document.addEventListener) {
          p.mouseDownX = X.clientX, p.mouseDownY = X.clientY, p.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var j = function J(pe) {
            if (document.removeEventListener("mouseup", J), p.focused) {
              var ce = Math.abs(pe.clientX - p.mouseDownX), Ee = Math.abs(pe.clientY - p.mouseDownY), Ue = Math.max(ce, Ee), Le = (/* @__PURE__ */ new Date()).getTime() - p.mouseDownTime;
              (Ue <= 10 && Le <= 200 || Ue <= 5 && Le <= 300) && p.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", j);
        }
        re(p.props.onMouseDown) && p.props.onMouseDown(X);
      }, p.onPaste = function(X) {
        re(p.props.onPaste) && p.props.onPaste(X), X.defaultPrevented || (p.beforePasteState = { value: p.getInputValue(), selection: p.getSelection() }, p.setInputValue(""));
      }, p.handleRef = function(X) {
        p.props.children == null && re(p.props.inputRef) && p.props.inputRef(X);
      };
      var H = S.mask, ae = S.maskChar, be = S.formatChars, K = S.alwaysShowMask, ee = S.beforeMaskedValueChange, ie = S.defaultValue, oe = S.value;
      p.maskOptions = I(H, ae, be), ie == null && (ie = ""), oe == null && (oe = ie);
      var Z = Qe(oe);
      if (p.maskOptions.mask && (K || Z) && (Z = G(p.maskOptions, Z), re(ee))) {
        var Ce = S.value;
        S.value == null && (Ce = ie), Z = ee({ value: Z, selection: null }, { value: Ce = Qe(Ce), selection: null }, null, p.getBeforeMaskedValueChangeConfig()).value;
      }
      return p.value = Z, p;
    }
    c(k, y);
    var $ = k.prototype;
    return $.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = _e(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, $.componentDidUpdate = function() {
      var S = this.previousSelection, p = this.props, H = p.beforeMaskedValueChange, ae = p.alwaysShowMask, be = p.mask, K = p.maskChar, ee = p.formatChars, ie = this.maskOptions, oe = ae || this.isFocused(), Z = this.props.value != null, Ce = Z ? Qe(this.props.value) : this.value, X = S ? S.start : null;
      if (this.maskOptions = I(be, K, ee), this.maskOptions.mask) {
        !ie.mask && this.isFocused() && this.runSaveSelectionLoop();
        var j = this.maskOptions.mask && this.maskOptions.mask !== ie.mask;
        if (ie.mask || Z || (Ce = this.getInputValue()), (j || this.maskOptions.mask && (Ce || oe)) && (Ce = G(this.maskOptions, Ce)), j) {
          var J = z(this.maskOptions, Ce);
          (X === null || J < X) && (X = L(this.maskOptions, Ce) ? J : $e(this.maskOptions, J));
        }
        !this.maskOptions.mask || !F(this.maskOptions, Ce) || oe || Z && this.props.value || (Ce = "");
        var pe = { start: X, end: X };
        if (re(H)) {
          var ce = H({ value: Ce, selection: pe }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          Ce = ce.value, pe = ce.selection;
        }
        this.value = Ce;
        var Ee = this.getInputValue() !== this.value;
        Ee ? (this.setInputValue(this.value), this.forceUpdate()) : j && this.forceUpdate();
        var Ue = !1;
        pe.start != null && pe.end != null && (Ue = !S || S.start !== pe.start || S.end !== pe.end), (Ue || Ee) && this.setSelection(pe.start, pe.end);
      } else
        ie.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, $.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && je(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, $.render = function() {
      var S, p = this.props, H = (p.mask, p.alwaysShowMask, p.maskChar, p.formatChars, p.inputRef, p.beforeMaskedValueChange, p.children), ae = u(p, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (H) {
        re(H) || m(!1);
        var be = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], K = a({}, ae);
        be.forEach(function(ie) {
          return delete K[ie];
        }), S = H(K), be.filter(function(ie) {
          return S.props[ie] != null && S.props[ie] !== ae[ie];
        }).length && m(!1);
      } else
        S = n.createElement("input", a({ ref: this.handleRef }, ae));
      var ee = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (ae.disabled || ae.readOnly || (ee.onChange = this.onChange, ee.onPaste = this.onPaste, ee.onMouseDown = this.onMouseDown), ae.value != null && (ee.value = this.value)), S = n.cloneElement(S, ee);
    }, k;
  }(n.Component);
  return tl = Se, tl;
}
var nl, Zh;
function g5() {
  if (Zh)
    return nl;
  Zh = 1;
  var e = function(n, i, o, a, c, u, h, f) {
    if (process.env.NODE_ENV !== "production" && i === void 0)
      throw new Error("invariant requires an error message argument");
    if (!n) {
      var m;
      if (i === void 0)
        m = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var g = [o, a, c, u, h, f], x = 0;
        m = new Error(
          i.replace(/%s/g, function() {
            return g[x++];
          })
        ), m.name = "Invariant Violation";
      }
      throw m.framesToPop = 1, m;
    }
  };
  return nl = e, nl;
}
var rl, Xh;
function v5() {
  if (Xh)
    return rl;
  Xh = 1;
  var e = process.env.NODE_ENV !== "production", n = function() {
  };
  if (e) {
    var i = function(a, c) {
      var u = arguments.length;
      c = new Array(u > 1 ? u - 1 : 0);
      for (var h = 1; h < u; h++)
        c[h - 1] = arguments[h];
      var f = 0, m = "Warning: " + a.replace(/%s/g, function() {
        return c[f++];
      });
      typeof console < "u" && console.error(m);
      try {
        throw new Error(m);
      } catch {
      }
    };
    n = function(o, a, c) {
      var u = arguments.length;
      c = new Array(u > 2 ? u - 2 : 0);
      for (var h = 2; h < u; h++)
        c[h - 2] = arguments[h];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      o || i.apply(null, [a].concat(c));
    };
  }
  return rl = n, rl;
}
var il, Jh;
function b5() {
  if (Jh)
    return il;
  Jh = 1;
  function e(y) {
    return y && typeof y == "object" && "default" in y ? y.default : y;
  }
  var n = e(Ut), i = rd, o = e(g5()), a = e(v5());
  function c(y, k) {
    for (var $ = Object.getOwnPropertyNames(k), S = 0; S < $.length; S++) {
      var p = $[S], H = Object.getOwnPropertyDescriptor(k, p);
      H && H.configurable && y[p] === void 0 && Object.defineProperty(y, p, H);
    }
    return y;
  }
  function u() {
    return u = Object.assign || function(y) {
      for (var k = 1; k < arguments.length; k++) {
        var $ = arguments[k];
        for (var S in $)
          Object.prototype.hasOwnProperty.call($, S) && (y[S] = $[S]);
      }
      return y;
    }, u.apply(this, arguments);
  }
  function h(y, k) {
    y.prototype = Object.create(k.prototype), y.prototype.constructor = y, c(y, k);
  }
  function f(y, k) {
    if (y == null)
      return {};
    var $ = {}, S = Object.keys(y), p, H;
    for (H = 0; H < S.length; H++)
      p = S[H], !(k.indexOf(p) >= 0) && ($[p] = y[p]);
    return $;
  }
  function m(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  function g(y, k, $) {
    if ("selectionStart" in y && "selectionEnd" in y)
      y.selectionStart = k, y.selectionEnd = $;
    else {
      var S = y.createTextRange();
      S.collapse(!0), S.moveStart("character", k), S.moveEnd("character", $ - k), S.select();
    }
  }
  function x(y) {
    var k = 0, $ = 0;
    if ("selectionStart" in y && "selectionEnd" in y)
      k = y.selectionStart, $ = y.selectionEnd;
    else {
      var S = document.selection.createRange();
      S.parentElement() === y && (k = -S.moveStart("character", -y.value.length), $ = -S.moveEnd("character", -y.value.length));
    }
    return {
      start: k,
      end: $,
      length: $ - k
    };
  }
  var T = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, E = "_";
  function I(y, k, $) {
    var S = "", p = "", H = null, ae = [];
    if (k === void 0 && (k = E), $ == null && ($ = T), !y || typeof y != "string")
      return {
        maskChar: k,
        formatChars: $,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var be = !1;
    return y.split("").forEach(function(K) {
      !be && K === "\\" ? be = !0 : (be || !$[K] ? (ae.push(S.length), S.length === ae.length - 1 && (p += K)) : H = S.length + 1, S += K, be = !1);
    }), {
      maskChar: k,
      formatChars: $,
      prefix: p,
      mask: S,
      lastEditablePosition: H,
      permanents: ae
    };
  }
  function D(y, k) {
    return y.permanents.indexOf(k) !== -1;
  }
  function W(y, k, $) {
    var S = y.mask, p = y.formatChars;
    if (!$)
      return !1;
    if (D(y, k))
      return S[k] === $;
    var H = S[k], ae = p[H];
    return new RegExp(ae).test($);
  }
  function F(y, k) {
    return k.split("").every(function($, S) {
      return D(y, S) || !W(y, S, $);
    });
  }
  function z(y, k) {
    var $ = y.maskChar, S = y.prefix;
    if (!$) {
      for (; k.length > S.length && D(y, k.length - 1); )
        k = k.slice(0, k.length - 1);
      return k.length;
    }
    for (var p = S.length, H = k.length; H >= S.length; H--) {
      var ae = k[H], be = !D(y, H) && W(y, H, ae);
      if (be) {
        p = H + 1;
        break;
      }
    }
    return p;
  }
  function L(y, k) {
    return z(y, k) === y.mask.length;
  }
  function G(y, k) {
    var $ = y.maskChar, S = y.mask, p = y.prefix;
    if (!$) {
      for (k = fe(y, "", k, 0), k.length < p.length && (k = p); k.length < S.length && D(y, k.length); )
        k += S[k.length];
      return k;
    }
    if (k) {
      var H = G(y, "");
      return fe(y, H, k, 0);
    }
    for (var ae = 0; ae < S.length; ae++)
      D(y, ae) ? k += S[ae] : k += $;
    return k;
  }
  function Q(y, k, $, S) {
    var p = $ + S, H = y.maskChar, ae = y.mask, be = y.prefix, K = k.split("");
    if (!H) {
      for (var ee = p; ee < K.length; ee++)
        D(y, ee) && (K[ee] = "");
      return $ = Math.max(be.length, $), K.splice($, p - $), k = K.join(""), G(y, k);
    }
    return K.map(function(ie, oe) {
      return oe < $ || oe >= p ? ie : D(y, oe) ? ae[oe] : H;
    }).join("");
  }
  function fe(y, k, $, S) {
    var p = y.mask, H = y.maskChar, ae = y.prefix, be = $.split(""), K = L(y, k), ee = function(Z, Ce) {
      return !D(y, Z) || Ce === p[Z];
    }, ie = function(Z, Ce) {
      return !H || !D(y, Ce) || Z !== H;
    };
    return !H && S > k.length && (k += p.slice(k.length, S)), be.every(function(oe) {
      for (; !ee(S, oe); ) {
        if (S >= k.length && (k += p[S]), !ie(oe, S))
          return !0;
        if (S++, S >= p.length)
          return !1;
      }
      var Z = W(y, S, oe) || oe === H;
      return Z ? (S < k.length ? H || K || S < ae.length ? k = k.slice(0, S) + oe + k.slice(S + 1) : (k = k.slice(0, S) + oe + k.slice(S), k = G(y, k)) : H || (k += oe), S++, S < p.length) : !0;
    }), k;
  }
  function ge(y, k, $, S) {
    var p = y.mask, H = y.maskChar, ae = $.split(""), be = S, K = function(ie, oe) {
      return !D(y, ie) || oe === p[ie];
    };
    return ae.every(function(ee) {
      for (; !K(S, ee); )
        if (S++, S >= p.length)
          return !1;
      var ie = W(y, S, ee) || ee === H;
      return ie && S++, S < p.length;
    }), S - be;
  }
  function he(y, k) {
    for (var $ = k; $ >= 0; --$)
      if (!D(y, $))
        return $;
    return null;
  }
  function $e(y, k) {
    for (var $ = y.mask, S = k; S < $.length; ++S)
      if (!D(y, S))
        return S;
    return null;
  }
  function Qe(y) {
    return !y && y !== 0 ? "" : y + "";
  }
  function Ge(y, k, $, S, p) {
    var H = y.mask, ae = y.prefix, be = y.lastEditablePosition, K = k, ee = "", ie = 0, oe = 0, Z = Math.min(p.start, $.start);
    if ($.end > p.start ? (ee = K.slice(p.start, $.end), ie = ge(y, S, ee, Z), ie ? oe = p.length : oe = 0) : K.length < S.length && (oe = S.length - K.length), K = S, oe) {
      if (oe === 1 && !p.length) {
        var Ce = p.start === $.start;
        Z = Ce ? $e(y, $.start) : he(y, $.start);
      }
      K = Q(y, K, Z, oe);
    }
    return K = fe(y, K, ee, Z), Z = Z + ie, Z >= H.length ? Z = H.length : Z < ae.length && !ie ? Z = ae.length : Z >= ae.length && Z < be && ie && (Z = $e(y, Z)), K = G(y, K), ee || (ee = null), {
      value: K,
      enteredString: ee,
      selection: {
        start: Z,
        end: Z
      }
    };
  }
  function _e() {
    var y = new RegExp("windows", "i"), k = new RegExp("phone", "i"), $ = navigator.userAgent;
    return y.test($) && k.test($);
  }
  function re(y) {
    return typeof y == "function";
  }
  function ve() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function le() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function We(y) {
    var k = !!le(), $;
    return k ? $ = ve() : $ = function() {
      return setTimeout(y, 1e3 / 60);
    }, $(y);
  }
  function je(y) {
    var k = le() || clearTimeout;
    k(y);
  }
  var Se = /* @__PURE__ */ function(y) {
    h(k, y);
    function k(S) {
      var p;
      p = y.call(this, S) || this, p.focused = !1, p.mounted = !1, p.previousSelection = null, p.selectionDeferId = null, p.saveSelectionLoopDeferId = null, p.saveSelectionLoop = function() {
        p.previousSelection = p.getSelection(), p.saveSelectionLoopDeferId = We(p.saveSelectionLoop);
      }, p.runSaveSelectionLoop = function() {
        p.saveSelectionLoopDeferId === null && p.saveSelectionLoop();
      }, p.stopSaveSelectionLoop = function() {
        p.saveSelectionLoopDeferId !== null && (je(p.saveSelectionLoopDeferId), p.saveSelectionLoopDeferId = null, p.previousSelection = null);
      }, p.getInputDOMNode = function() {
        if (!p.mounted)
          return null;
        var j = i.findDOMNode(m(m(p))), J = typeof window < "u" && j instanceof window.Element;
        if (j && !J)
          return null;
        if (j.nodeName !== "INPUT" && (j = j.querySelector("input")), !j)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return j;
      }, p.getInputValue = function() {
        var j = p.getInputDOMNode();
        return j ? j.value : null;
      }, p.setInputValue = function(j) {
        var J = p.getInputDOMNode();
        J && (p.value = j, J.value = j);
      }, p.setCursorToEnd = function() {
        var j = z(p.maskOptions, p.value), J = $e(p.maskOptions, j);
        J !== null && p.setCursorPosition(J);
      }, p.setSelection = function(j, J, pe) {
        pe === void 0 && (pe = {});
        var ce = p.getInputDOMNode(), Ee = p.isFocused();
        if (!(!ce || !Ee)) {
          var Ue = pe, Le = Ue.deferred;
          Le || g(ce, j, J), p.selectionDeferId !== null && je(p.selectionDeferId), p.selectionDeferId = We(function() {
            p.selectionDeferId = null, g(ce, j, J);
          }), p.previousSelection = {
            start: j,
            end: J,
            length: Math.abs(J - j)
          };
        }
      }, p.getSelection = function() {
        var j = p.getInputDOMNode();
        return x(j);
      }, p.getCursorPosition = function() {
        return p.getSelection().start;
      }, p.setCursorPosition = function(j) {
        p.setSelection(j, j);
      }, p.isFocused = function() {
        return p.focused;
      }, p.getBeforeMaskedValueChangeConfig = function() {
        var j = p.maskOptions, J = j.mask, pe = j.maskChar, ce = j.permanents, Ee = j.formatChars, Ue = p.props.alwaysShowMask;
        return {
          mask: J,
          maskChar: pe,
          permanents: ce,
          alwaysShowMask: !!Ue,
          formatChars: Ee
        };
      }, p.isInputAutofilled = function(j, J, pe, ce) {
        var Ee = p.getInputDOMNode();
        try {
          if (Ee.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return p.focused ? ce.end < pe.length && J.end === j.length : !0;
      }, p.onChange = function(j) {
        var J = m(m(p)), pe = J.beforePasteState, ce = m(m(p)), Ee = ce.previousSelection, Ue = p.props.beforeMaskedValueChange, Le = p.getInputValue(), He = p.value, Xe = p.getSelection();
        p.isInputAutofilled(Le, Xe, He, Ee) && (He = G(p.maskOptions, ""), Ee = {
          start: 0,
          end: 0,
          length: 0
        }), pe && (Ee = pe.selection, He = pe.value, Xe = {
          start: Ee.start + Le.length,
          end: Ee.start + Le.length,
          length: 0
        }, Le = He.slice(0, Ee.start) + Le + He.slice(Ee.end), p.beforePasteState = null);
        var ut = Ge(p.maskOptions, Le, Xe, He, Ee), Dt = ut.enteredString, yt = ut.selection, Bn = ut.value;
        if (re(Ue)) {
          var Mt = Ue({
            value: Bn,
            selection: yt
          }, {
            value: He,
            selection: Ee
          }, Dt, p.getBeforeMaskedValueChangeConfig());
          Bn = Mt.value, yt = Mt.selection;
        }
        p.setInputValue(Bn), re(p.props.onChange) && p.props.onChange(j), p.isWindowsPhoneBrowser ? p.setSelection(yt.start, yt.end, {
          deferred: !0
        }) : p.setSelection(yt.start, yt.end);
      }, p.onFocus = function(j) {
        var J = p.props.beforeMaskedValueChange, pe = p.maskOptions, ce = pe.mask, Ee = pe.prefix;
        if (p.focused = !0, p.mounted = !0, ce) {
          if (p.value)
            z(p.maskOptions, p.value) < p.maskOptions.mask.length && p.setCursorToEnd();
          else {
            var Ue = G(p.maskOptions, Ee), Le = G(p.maskOptions, Ue), He = z(p.maskOptions, Le), Xe = $e(p.maskOptions, He), ut = {
              start: Xe,
              end: Xe
            };
            if (re(J)) {
              var Dt = J({
                value: Le,
                selection: ut
              }, {
                value: p.value,
                selection: null
              }, null, p.getBeforeMaskedValueChangeConfig());
              Le = Dt.value, ut = Dt.selection;
            }
            var yt = Le !== p.getInputValue();
            yt && p.setInputValue(Le), yt && re(p.props.onChange) && p.props.onChange(j), p.setSelection(ut.start, ut.end);
          }
          p.runSaveSelectionLoop();
        }
        re(p.props.onFocus) && p.props.onFocus(j);
      }, p.onBlur = function(j) {
        var J = p.props.beforeMaskedValueChange, pe = p.maskOptions.mask;
        if (p.stopSaveSelectionLoop(), p.focused = !1, pe && !p.props.alwaysShowMask && F(p.maskOptions, p.value)) {
          var ce = "";
          if (re(J)) {
            var Ee = J({
              value: ce,
              selection: null
            }, {
              value: p.value,
              selection: p.previousSelection
            }, null, p.getBeforeMaskedValueChangeConfig());
            ce = Ee.value;
          }
          var Ue = ce !== p.getInputValue();
          Ue && p.setInputValue(ce), Ue && re(p.props.onChange) && p.props.onChange(j);
        }
        re(p.props.onBlur) && p.props.onBlur(j);
      }, p.onMouseDown = function(j) {
        if (!p.focused && document.addEventListener) {
          p.mouseDownX = j.clientX, p.mouseDownY = j.clientY, p.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var J = function pe(ce) {
            if (document.removeEventListener("mouseup", pe), !!p.focused) {
              var Ee = Math.abs(ce.clientX - p.mouseDownX), Ue = Math.abs(ce.clientY - p.mouseDownY), Le = Math.max(Ee, Ue), He = (/* @__PURE__ */ new Date()).getTime() - p.mouseDownTime;
              (Le <= 10 && He <= 200 || Le <= 5 && He <= 300) && p.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", J);
        }
        re(p.props.onMouseDown) && p.props.onMouseDown(j);
      }, p.onPaste = function(j) {
        re(p.props.onPaste) && p.props.onPaste(j), j.defaultPrevented || (p.beforePasteState = {
          value: p.getInputValue(),
          selection: p.getSelection()
        }, p.setInputValue(""));
      }, p.handleRef = function(j) {
        p.props.children == null && re(p.props.inputRef) && p.props.inputRef(j);
      };
      var H = S.mask, ae = S.maskChar, be = S.formatChars, K = S.alwaysShowMask, ee = S.beforeMaskedValueChange, ie = S.defaultValue, oe = S.value;
      p.maskOptions = I(H, ae, be), ie == null && (ie = ""), oe == null && (oe = ie);
      var Z = Qe(oe);
      if (p.maskOptions.mask && (K || Z) && (Z = G(p.maskOptions, Z), re(ee))) {
        var Ce = S.value;
        S.value == null && (Ce = ie), Ce = Qe(Ce);
        var X = ee({
          value: Z,
          selection: null
        }, {
          value: Ce,
          selection: null
        }, null, p.getBeforeMaskedValueChangeConfig());
        Z = X.value;
      }
      return p.value = Z, p;
    }
    var $ = k.prototype;
    return $.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = _e(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, $.componentDidUpdate = function() {
      var p = this.previousSelection, H = this.props, ae = H.beforeMaskedValueChange, be = H.alwaysShowMask, K = H.mask, ee = H.maskChar, ie = H.formatChars, oe = this.maskOptions, Z = be || this.isFocused(), Ce = this.props.value != null, X = Ce ? Qe(this.props.value) : this.value, j = p ? p.start : null;
      if (this.maskOptions = I(K, ee, ie), this.maskOptions.mask)
        !oe.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        oe.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var J = this.maskOptions.mask && this.maskOptions.mask !== oe.mask;
      if (!oe.mask && !Ce && (X = this.getInputValue()), (J || this.maskOptions.mask && (X || Z)) && (X = G(this.maskOptions, X)), J) {
        var pe = z(this.maskOptions, X);
        (j === null || pe < j) && (L(this.maskOptions, X) ? j = pe : j = $e(this.maskOptions, pe));
      }
      this.maskOptions.mask && F(this.maskOptions, X) && !Z && (!Ce || !this.props.value) && (X = "");
      var ce = {
        start: j,
        end: j
      };
      if (re(ae)) {
        var Ee = ae({
          value: X,
          selection: ce
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        X = Ee.value, ce = Ee.selection;
      }
      this.value = X;
      var Ue = this.getInputValue() !== this.value;
      Ue ? (this.setInputValue(this.value), this.forceUpdate()) : J && this.forceUpdate();
      var Le = !1;
      ce.start != null && ce.end != null && (Le = !p || p.start !== ce.start || p.end !== ce.end), (Le || Ue) && this.setSelection(ce.start, ce.end);
    }, $.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && je(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, $.render = function() {
      var p = this.props, H = p.mask;
      p.alwaysShowMask;
      var ae = p.maskChar, be = p.formatChars, K = p.inputRef;
      p.beforeMaskedValueChange;
      var ee = p.children, ie = f(p, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), oe;
      if (process.env.NODE_ENV !== "production" && a(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !ie.maxLength || !I(H, ae, be).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), ee) {
        re(ee) || (process.env.NODE_ENV !== "production" ? o(!1, "react-input-mask: children must be a function") : o(!1));
        var Z = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], Ce = u({}, ie);
        Z.forEach(function(J) {
          return delete Ce[J];
        }), oe = ee(Ce);
        var X = Z.filter(function(J) {
          return oe.props[J] != null && oe.props[J] !== ie[J];
        });
        X.length && (process.env.NODE_ENV !== "production" ? o(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + X.join(", ")) : o(!1)), process.env.NODE_ENV !== "production" && a(!K, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        oe = n.createElement("input", u({
          ref: this.handleRef
        }, ie));
      var j = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!ie.disabled && !ie.readOnly && (j.onChange = this.onChange, j.onPaste = this.onPaste, j.onMouseDown = this.onMouseDown), ie.value != null && (j.value = this.value)), oe = n.cloneElement(oe, j), oe;
    }, k;
  }(n.Component);
  return il = Se, il;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = m5() : e.exports = b5();
})(p5);
const y5 = /* @__PURE__ */ ix($l), x5 = {
  default: U`
    border: none;
    padding: 10px 15px;
    border-bottom: 2px solid
      ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
    outline: none;
    font-size: 16px;
    outline: 0;
    box-sizing: border-box;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    transition: 0.2s;

    &:hover {
      opacity: 0.96;
      transition: 0.2s;
    }

    &:focus {
      border-bottom: 2px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    }

    &:focus ~label {
      color: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    }
  `,
  outlined: U`
    border: 1px solid
      ${({ theme: e }) => Pe(0.6, e.monkUiThemes.colors.black)};
    outline: none;
    font-size: 15px;
    outline: 0;
    box-sizing: border-box;
    border-radius: 5px;

    &:hover {
      border: 1px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    }

    &:focus {
      border: 1px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
      box-shadow: 0 0 2.5px 2.5px
        ${({ theme: e }) => Pe(0.3, e.monkUiThemes.colors.main)};
      transition: all 0.3s ease-in-out;
    }
    &::placeholder {
      color: #c7c9d9;
      font-size: 14px;
      font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
      font-weight: 500;
    }
  `,
  filled: U`
    outline: none;
    font-size: 15px;
    outline: 0;
    box-sizing: border-box;
    border: 1px solid
      ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
    border-radius: 5px;

    &:hover {
      opacity: 1;
      border: 1px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    }


    &:focus {
      border-radius: 5px;
      border: 2px solid
        ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    }
    ${({ haveValue: e }) => e && U`
        &:focus ~ label,
        &:valid ~ label {
          transform: translateY(-20px);
          margin-left: 2px;
          padding: 0 5px;
          font-size: 12px !important;
          left: 10px;
        }
      `}

    ${({ haveValue: e }) => !e && U`
        &:focus ~ label,
        &:invalid ~ label {
          transform: translateY(-20px);
          border-radius: 7px;
          margin-left: 2px;
          padding: 0 5px;
          font-size: 12px !important;
          left: 10px;
        }
      `}
  `
}, us = V(y5)`
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  ${({ variant: e }) => x5[e]}
  /* c8 ignore next 2 */
  color: ${({ theme: e, textColor: n }) => n || Pe(0.2, e.monkUiThemes.colors.black)};
  font-size: 0.9em;
  background: ${({ background: e }) => e};
`, w5 = V.button`
  position: absolute;
  top: 45%;
  right: 15px;
  border: none;
  background: none;
  cursor: pointer;
`, k5 = {
  default: U`
    font-size: .9rem;
    color: ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
  `,
  outlined: U`
    font-size: 0.9em;
    color: ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
  `,
  filled: U`
    color: ${({ theme: e }) => Pe(0.2, e.monkUiThemes.colors.black)};
    position: relative;
    top: 37px;
    left: 15px;
  `
}, El = V.label`
  transition: all 0.3s ease-in-out;
  cursor: text;
  box-sizing: border-box;
  background: ${({ background: e, variant: n }) => n === "filled" ? e : "none"};
  color: ${({ textColor: e }) => e + " !important"};
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  width: fit-content;
  ${({ variant: e }) => k5[e]}
`, T5 = V(vn.small)`
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
  color: ${({ theme: e }) => e.monkUiThemes.colors.error};
  position: absolute;
  left: 0.2rem;
  bottom: -1.1rem;
`, qo = {
  animated: U`
    ${us} {
      &:not(:placeholder-shown) ~ label,
      &:focus ~ label {
        transform: translateY(-20px);
        font-size: 14px;
        color: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.main)};
        font-weight: 500;
        padding: 0 10px;
      }
    }
  `,
  default: U`
  ${El} {
    position: relative;
    padding: 0;
  }
    flex-direction: column-reverse;
  `,
  outlined: U`
    flex-direction: column-reverse;
  `,
  filled: U`
    flex-direction: column;
  `,
  small: U`
    width: 50%;
  `,
  medium: U`
    width: 75%;
  `,
  large: U`
    width: 100%;
  `
}, _5 = V.div`
  height: 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 2rem 0;
  gap: 0.3em;
  ${({ variant: e }) => qo[e]};
  ${({ size: e }) => qo[e]};
  ${({ background: e }) => e && U`
      ${us} {
        background: ${e};
      },
    `};
  ${({ textColor: e }) => e && U`
      ${us} {
        color: ${e};
      }
    `};

  ${({ animation: e }) => e && qo.animated};
  ${({ animation: e }) => !e && qo.default};
`;
function S5(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] })(e);
}
function C5(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] })(e);
}
function $5(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] })(e);
}
function E5(e) {
  return or({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z" } }] })(e);
}
const jC = Tr(
  ({
    readOnly: e = !1,
    label: n,
    keyName: i,
    error: o,
    value: a,
    defaultValue: c,
    onChange: u,
    onBlur: h,
    mask: f = "",
    placeholder: m = " ",
    required: g = !1,
    size: x = "large",
    type: T = "text",
    variant: E = "default",
    background: I = "#fff",
    textColor: D,
    fontSize: W,
    transformer: F = (G) => G,
    animation: z = !1
  }, L) => {
    const [G, Q] = nt(!1), [fe, ge] = nt(""), he = Wt(() => ln(), []), $e = {
      cpf: "999.999.999-99",
      cnpj: "99.999.999.9999-99",
      telephone: "(99)99999-9999",
      cep: "99999-999"
    };
    function Qe(Ge) {
      if (L) {
        if (i) {
          L.current[i] = F(Ge.target.value);
          return;
        }
        L.current = F(Ge.target.value);
      }
      ge(F(Ge.target.value)), u && u(Ge);
    }
    return /* @__PURE__ */ me(
      _5,
      {
        size: x,
        animation: z,
        background: I,
        textColor: D,
        variant: E,
        children: [
          /* @__PURE__ */ R(
            us,
            {
              haveValue: fe.length !== 0,
              mask: $e[f] ?? f,
              type: G ? "text" : T,
              id: he,
              value: a,
              defaultValue: c,
              required: fe.length > 0 ? !0 : g,
              readOnly: e,
              placeholder: m,
              onChange: Qe,
              onBlur: h,
              variant: E
            },
            he
          ),
          !z && /* @__PURE__ */ R(
            El,
            {
              textColor: D,
              background: I,
              fontSize: W,
              variant: E,
              htmlFor: he,
              children: n
            }
          ),
          T === "password" && /* @__PURE__ */ R(w5, { type: "button", children: /* @__PURE__ */ R(
            $5,
            {
              onClick: () => Q(!G),
              title: "eye-icon"
            }
          ) }),
          z && /* @__PURE__ */ R(
            El,
            {
              textColor: D,
              background: I,
              fontSize: W,
              variant: E,
              htmlFor: he,
              children: n
            }
          ),
          /* @__PURE__ */ R(_n, { children: !!o && /* @__PURE__ */ R(
            T5,
            {
              variants: d5,
              initial: "hidden",
              animate: "show",
              exit: "exit",
              children: o
            }
          ) })
        ]
      }
    );
  }
), Qh = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
  `,
  success: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.success};
  `,
  danger: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.error};
  `,
  warning: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.warning};
  `
}, P5 = V(vn.div)`
  padding: 1rem 2rem;
  color: ${({ color: e }) => e || "#fff"};
  border-radius: 4px;
  box-shadow: 0px 20px 20px -16px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};

  ${({ type: e }) => e && Qh[e] || Qh.default}

  background: ${({ background: e }) => e};

  & + & {
    margin-top: 12px;
  }

  strong {
    margin-left: 0.5rem;
  }
`, A5 = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { opacity: { duration: 0.5 } } },
  exit: { opacity: 0 }
};
function R5({ message: e, onRemoveMessage: n }) {
  mt(() => {
    const o = setTimeout(() => {
      n(e.id);
    }, e.duration || 3e3);
    return () => {
      clearTimeout(o);
    };
  }, [e, n]);
  function i() {
    n(e.id);
  }
  return /* @__PURE__ */ R(_n, { children: /* @__PURE__ */ me(
    P5,
    {
      type: e.type,
      onClick: i,
      tabIndex: 0,
      role: "button",
      variants: A5,
      initial: "hidden",
      animate: "show",
      exit: "exit",
      background: e.background,
      children: [
        e.type === "warning" && /* @__PURE__ */ R(E5, {}),
        e.type === "danger" && /* @__PURE__ */ R(C5, {}),
        e.type === "success" && /* @__PURE__ */ R(S5, {}),
        /* @__PURE__ */ R("strong", { children: e.text })
      ]
    }
  ) });
}
const I5 = V.div`
  position: fixed;
  z-index: 9999;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
`;
function GC() {
  const [e, n] = nt([]);
  mt(() => {
    function o(a) {
      const { type: c, text: u, background: h, duration: f } = a.detail;
      n((m) => [
        ...m,
        { id: Math.random(), type: c, text: u, background: h, duration: f }
      ]);
    }
    return document.addEventListener("addToast", o), () => {
      document.removeEventListener("addToast", o);
    };
  }, []);
  const i = an((o) => {
    n((a) => a.filter((c) => c.id !== o));
  }, []);
  return /* @__PURE__ */ R(I5, { children: e.map((o) => /* @__PURE__ */ R(
    R5,
    {
      message: o,
      onRemoveMessage: i
    },
    o.id
  )) });
}
const U5 = {
  default: Pe(0.1, mn.monkUiThemes.colors.black),
  filled: Je(0.1, mn.monkUiThemes.colors.main),
  outlined: Pe(0.1, mn.monkUiThemes.colors.black)
}, D5 = {
  default: mn.monkUiThemes.colors.black,
  filled: mn.monkUiThemes.colors.white,
  outlined: mn.monkUiThemes.colors.black
}, M5 = {
  small: U`
    width: 50%;
  `,
  medium: U`
    width: 75%;
  `,
  large: U`
    width: 100%;
  `
}, O5 = V.div`
  display: flex;
  flex-direction: column;
  ${({ size: e }) => M5[e]};

  label {
    margin-bottom: 8px;
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    color: ${({ labelColor: e }) => e};
  }
`, L5 = V.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`, F5 = {
  default: U`
    background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `,
  outlined: U`
    background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    border: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.black};
  `
}, V5 = V.button`
  width: 100%;
  display: flex;
  padding: 0.3rem 0.4rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  font-weight: 500;
  ${({ variant: e }) => e && F5[e]}
  height: ${({ height: e }) => e};

  svg {
    width: 1rem;
    height: 1rem;
  }

  background: ${({ selectedBackground: e, isSelected: n }) => n && e && e};

  background: ${({ selectedBackground: e, isSelected: n, variant: i }) => n && !e && U5[i]};

  background: ${({ isSelected: e, background: n }) => !e && n};

  border: ${({ selectedBorderColor: e, isSelected: n, borderColor: i }) => `1px solid ${n && e ? e : i}`};

  cursor: pointer;
  transition: all 0.2s;

  :first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  :last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};

  color: ${({ isSelected: e, color: n }) => !e && n ? n : mn.monkUiThemes.colors.black};

  color: ${({ selectedTextColor: e, isSelected: n }) => n && e && e};
`;
function HC({
  label: e,
  options: n,
  selectedBackground: i,
  background: o,
  variant: a = "default",
  color: c,
  labelColor: u,
  size: h = "large",
  height: f,
  borderColor: m,
  selectedTextColor: g,
  selectedBorderColor: x,
  onToggle: T,
  defaultValue: E
}) {
  const [I, D] = nt(E ?? "");
  mt(() => {
    T && T(I);
  }, [I, T]);
  function W(F, z) {
    F.length === 1 && D((L) => L !== "" ? "" : z.value), F.length > 1 && D((L) => L === z.value ? "" : z.value);
  }
  return /* @__PURE__ */ me(O5, { labelColor: u, size: h, children: [
    /* @__PURE__ */ R("label", { children: e }),
    /* @__PURE__ */ R(L5, { children: n && n.map((F) => /* @__PURE__ */ me(
      V5,
      {
        type: "button",
        isSelected: F.value === I,
        onClick: () => W(n, F),
        selectedBackground: i,
        selectedBorderColor: x,
        selectedTextColor: g ?? mn.monkUiThemes.colors.white,
        borderColor: m,
        background: o,
        variant: a,
        color: c ?? D5[a],
        height: f,
        children: [
          F.label,
          typeof F.icon == "string" ? /* @__PURE__ */ R("img", { src: F.icon }) : F.icon
        ]
      },
      F.value
    )) })
  ] });
}
const B5 = (e) => typeof e == "string" ? e : `${e}px`, N5 = V.div`
  width: ${(e) => B5(e.width)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${({ theme: e, textLight: n }) => n ? e.monkUiThemes.colors.white : e.monkUiThemes.colors.black};
`, W5 = V.span`
  font-family: Epilogue;
  font-size: ${(e) => e.fontSize};
  font-weight: ${(e) => e.textWeight};

  color: ${({ theme: e, textLight: n }) => n ? e.monkUiThemes.colors.white : e.monkUiThemes.colors.black};

  letter-spacing: -0.01rem;

  ${(e) => e.lineHeighted && `line-height: ${e.lineHeight}px`};
`, z5 = {
  1: 22,
  2: 22,
  3: 18,
  4: 17,
  5: 16,
  6: 13
}, j5 = {
  1: "1rem",
  2: "0.9375rem",
  3: "0.875rem",
  4: "0.8125rem",
  5: "0.75rem",
  6: "0.6rem"
}, G5 = {
  regular: 400,
  medium: 500
};
function Pl({
  children: e,
  paragraph: n = 1,
  weight: i = "regular",
  ellipsed: o,
  width: a = "100%",
  textLight: c = !1,
  lineHeighted: u
}) {
  const h = j5[n], f = G5[i], m = z5[n];
  function g() {
    return /* @__PURE__ */ R(
      W5,
      {
        fontSize: h,
        lineHeight: m,
        textWeight: f,
        ellipsed: o,
        textLight: c,
        lineHeighted: u,
        children: e
      }
    );
  }
  return o ? /* @__PURE__ */ R(N5, { width: a, textLight: c, children: g() }) : g();
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Op = function(e, n) {
  return (Op = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
    i.__proto__ = o;
  } || function(i, o) {
    for (var a in o)
      o.hasOwnProperty(a) && (i[a] = o[a]);
  })(e, n);
}, H5, Yo, q5 = (function(e) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var n = {}.hasOwnProperty;
    function i() {
      for (var o = [], a = 0; a < arguments.length; a++) {
        var c = arguments[a];
        if (c) {
          var u = typeof c;
          if (u === "string" || u === "number")
            o.push(c);
          else if (Array.isArray(c) && c.length) {
            var h = i.apply(null, c);
            h && o.push(h);
          } else if (u === "object")
            for (var f in c)
              n.call(c, f) && c[f] && o.push(f);
        }
      }
      return o.join(" ");
    }
    e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
  })();
}(Yo = { path: H5, exports: {}, require: function(e, n) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(n == null && Yo.path);
} }, Yo.exports), Yo.exports);
function Al(e, n, i) {
  var o, a, c, u, h;
  function f() {
    var g = Date.now() - u;
    g < n && g >= 0 ? o = setTimeout(f, n - g) : (o = null, i || (h = e.apply(c, a), c = a = null));
  }
  n == null && (n = 100);
  var m = function() {
    c = this, a = arguments, u = Date.now();
    var g = i && !o;
    return o || (o = setTimeout(f, n)), g && (h = e.apply(c, a), c = a = null), h;
  };
  return m.clear = function() {
    o && (clearTimeout(o), o = null);
  }, m.flush = function() {
    o && (h = e.apply(c, a), c = a = null, clearTimeout(o), o = null);
  }, m;
}
Al.debounce = Al;
var Y5 = Al;
(function(e, n) {
  n === void 0 && (n = {});
  var i = n.insertAt;
  if (e && typeof document < "u") {
    var o = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.type = "text/css", i === "top" && o.firstChild ? o.insertBefore(a, o.firstChild) : o.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
})(`.indiana-scroll-container {
  overflow: auto; }
  .indiana-scroll-container--dragging {
    scroll-behavior: auto !important; }
    .indiana-scroll-container--dragging > * {
      pointer-events: none;
      cursor: -webkit-grab;
      cursor: grab; }
  .indiana-scroll-container--hide-scrollbars {
    overflow: hidden;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    scrollbar-width: none; }
    .indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {
      display: none !important;
      height: 0 !important;
      width: 0 !important;
      background: transparent !important;
      -webkit-appearance: none !important; }
  .indiana-scroll-container--native-scroll {
    overflow: auto; }

.indiana-dragging {
  cursor: -webkit-grab;
  cursor: grab; }
`);
var ol, K5 = (ol = "indiana-scroll-container", function(e, n) {
  if (!e)
    return ol;
  var i;
  typeof e == "string" ? i = e : n = e;
  var o = ol;
  return i && (o += "__" + i), o + (n ? Object.keys(n).reduce(function(a, c) {
    var u = n[c];
    return u && (a += " " + (typeof u == "boolean" ? o + "--" + c : o + "--" + c + "_" + u)), a;
  }, "") : "");
}), Z5 = function(e) {
  function n(i) {
    var o = e.call(this, i) || this;
    return o.onEndScroll = function() {
      o.scrolling = !1, !o.pressed && o.started && o.processEnd();
    }, o.onScroll = function(a) {
      var c = o.container.current;
      c.scrollLeft === o.scrollLeft && c.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(a), o.onEndScroll());
    }, o.onTouchStart = function(a) {
      var c = o.props.nativeMobileScroll;
      if (o.isDraggable(a.target))
        if (o.internal = !0, c && o.scrolling)
          o.pressed = !0;
        else {
          var u = a.touches[0];
          o.processClick(a, u.clientX, u.clientY), !c && o.props.stopPropagation && a.stopPropagation();
        }
    }, o.onTouchEnd = function(a) {
      var c = o.props.nativeMobileScroll;
      o.pressed && (!o.started || o.scrolling && c ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
    }, o.onTouchMove = function(a) {
      var c = o.props.nativeMobileScroll;
      if (o.pressed && (!c || !o.isMobile)) {
        var u = a.touches[0];
        u && o.processMove(a, u.clientX, u.clientY), a.preventDefault(), o.props.stopPropagation && a.stopPropagation();
      }
    }, o.onMouseDown = function(a) {
      o.isDraggable(a.target) && o.isScrollable() && (o.internal = !0, o.props.buttons.indexOf(a.button) !== -1 && (o.processClick(a, a.clientX, a.clientY), a.preventDefault(), o.props.stopPropagation && a.stopPropagation()));
    }, o.onMouseMove = function(a) {
      o.pressed && (o.processMove(a, a.clientX, a.clientY), a.preventDefault(), o.props.stopPropagation && a.stopPropagation());
    }, o.onMouseUp = function(a) {
      o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(a)), a.preventDefault(), o.props.stopPropagation && a.stopPropagation());
    }, o.container = Ut.createRef(), o.onEndScroll = Y5(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
  }
  return function(i, o) {
    function a() {
      this.constructor = i;
    }
    Op(i, o), i.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
  }(n, e), n.prototype.componentDidMount = function() {
    var i = this.props.nativeMobileScroll, o = this.container.current;
    window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd), o.addEventListener("touchstart", this.onTouchStart, { passive: !1 }), o.addEventListener("mousedown", this.onMouseDown, { passive: !1 }), i && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
  }, n.prototype.componentWillUnmount = function() {
    window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
  }, n.prototype.getElement = function() {
    return this.container.current;
  }, n.prototype.isMobileDevice = function() {
    return window.orientation !== void 0 || navigator.userAgent.indexOf("IEMobile") !== -1;
  }, n.prototype.isDraggable = function(i) {
    var o = this.props.ignoreElements;
    if (o) {
      var a = i.closest(o);
      return a === null || a.contains(this.getElement());
    }
    return !0;
  }, n.prototype.isScrollable = function() {
    var i = this.container.current;
    return i && (i.scrollWidth > i.clientWidth || i.scrollHeight > i.clientHeight);
  }, n.prototype.processClick = function(i, o, a) {
    var c = this.container.current;
    this.scrollLeft = c.scrollLeft, this.scrollTop = c.scrollTop, this.clientX = o, this.clientY = a, this.pressed = !0;
  }, n.prototype.processStart = function(i) {
    i === void 0 && (i = !0);
    var o = this.props.onStartScroll;
    this.started = !0, i && document.body.classList.add("indiana-dragging"), o && o({ external: !this.internal }), this.forceUpdate();
  }, n.prototype.processScroll = function(i) {
    if (this.started) {
      var o = this.props.onScroll;
      o && o({ external: !this.internal });
    } else
      this.processStart(!1);
  }, n.prototype.processMove = function(i, o, a) {
    var c = this.props, u = c.horizontal, h = c.vertical, f = c.activationDistance, m = c.onScroll, g = this.container.current;
    this.started ? (u && (g.scrollLeft -= o - this.clientX), h && (g.scrollTop -= a - this.clientY), m && m({ external: !this.internal }), this.clientX = o, this.clientY = a, this.scrollLeft = g.scrollLeft, this.scrollTop = g.scrollTop) : (u && Math.abs(o - this.clientX) > f || h && Math.abs(a - this.clientY) > f) && (this.clientX = o, this.clientY = a, this.processStart());
  }, n.prototype.processEnd = function() {
    var i = this.props.onEndScroll;
    this.container.current && i && i({ external: !this.internal }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
  }, n.prototype.getRef = function(i) {
    [this.container, this.props.innerRef].forEach(function(o) {
      o && (typeof o == "function" ? o(i) : o.current = i);
    });
  }, n.prototype.render = function() {
    var i = this.props, o = i.children, a = i.draggingClassName, c = i.className, u = i.style, h = i.hideScrollbars, f = i.component;
    return Ut.createElement(f, { className: q5(c, this.pressed && a, K5({ dragging: this.pressed, "hide-scrollbars": h, "native-scroll": this.isMobile })), style: u, ref: this.getRef, onScroll: this.onScroll }, o);
  }, n.defaultProps = { nativeMobileScroll: !0, hideScrollbars: !0, activationDistance: 10, vertical: !0, horizontal: !0, stopPropagation: !1, style: {}, component: "div", buttons: [0] }, n;
}(tx);
const X5 = (e) => /* @__PURE__ */ se.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { d: "M6 11h11M9 7l-4 4 4 4", stroke: "#02191D", strokeWidth: 1.6, strokeLinecap: "square" })), J5 = (e) => /* @__PURE__ */ se.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { d: "M16 11H5M13 7l4 4-4 4", stroke: "#fff", strokeWidth: 1.6, strokeLinecap: "square" })), Q5 = (e) => /* @__PURE__ */ se.createElement("svg", { width: 18, height: 18, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { d: "m13.875 6.75-4.5 4.5-4.5-4.5", stroke: "#02191D", strokeWidth: 1.6, strokeLinecap: "square" })), eC = (e) => /* @__PURE__ */ se.createElement("svg", { width: 152, height: 146, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { opacity: 0.1, d: "M73 130.913c32.253 0 58.4-26.146 58.4-58.4 0-32.253-26.147-58.4-58.4-58.4s-58.4 26.147-58.4 58.4c0 32.254 26.147 58.4 58.4 58.4Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.03, d: "M73 146c40.317 0 73-32.683 73-73S113.317 0 73 0 0 32.683 0 73s32.683 73 73 73Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ se.createElement("rect", { x: 43.313, y: 30.931, width: 60.608, height: 75.447, rx: 7.787, fill: "#fff" })), /* @__PURE__ */ se.createElement("rect", { x: 48.667, y: 40.665, width: 24.333, height: 4.769, rx: 2.385, fill: "#02191D" }), /* @__PURE__ */ se.createElement("rect", { opacity: 0.1, x: 48.667, y: 54.194, width: 48.667, height: 4.769, rx: 2.385, fill: "#02191D" }), /* @__PURE__ */ se.createElement("rect", { opacity: 0.1, x: 48.667, y: 67.723, width: 48.667, height: 4.769, rx: 2.385, fill: "#02191D" }), /* @__PURE__ */ se.createElement("rect", { opacity: 0.1, x: 48.667, y: 81.252, width: 48.667, height: 4.769, rx: 2.385, fill: "#02191D" }), /* @__PURE__ */ se.createElement("rect", { opacity: 0.1, x: 48.667, y: 94.782, width: 48.667, height: 4.769, rx: 2.385, fill: "#02191D" }), /* @__PURE__ */ se.createElement("g", { filter: "url(#b)" }, /* @__PURE__ */ se.createElement("path", { d: "M140.233 22.593h-29.239c-1.363 0-2.467 1.163-2.467 2.597v14.463c0 1.434 1.104 2.596 2.467 2.596h29.239c1.362 0 2.467-1.162 2.467-2.596V25.19c0-1.434-1.105-2.597-2.467-2.597Z", fill: "#fff" })), /* @__PURE__ */ se.createElement("path", { opacity: 0.3, d: "M115.827 35.527a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("rect", { opacity: 0.3, x: 122.64, y: 29.687, width: 15.573, height: 5.84, rx: 2.92, fill: "#02191D" }), /* @__PURE__ */ se.createElement("g", { filter: "url(#c)" }, /* @__PURE__ */ se.createElement("path", { d: "M90.377 105.706c14.703 0 26.623-11.81 26.623-26.38 0-14.568-11.92-26.378-26.623-26.378-14.704 0-26.624 11.81-26.624 26.379s11.92 26.379 26.624 26.379Z", fill: "#fff", fillOpacity: 0.3 })), /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.087 109.774a30.274 30.274 0 0 0 17.752-5.715l18.593 17.606 5.623-6.525-18.004-17.049a30.282 30.282 0 0 0 6.452-18.733c0-16.8-13.618-30.417-30.416-30.417-16.799 0-30.417 13.618-30.417 30.417 0 16.798 13.618 30.416 30.417 30.416Zm25.943-30.416c0 14.222-11.529 25.751-25.75 25.751-14.223 0-25.752-11.53-25.752-25.751 0-14.222 11.53-25.752 25.751-25.752 14.222 0 25.751 11.53 25.751 25.752Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("path", { d: "m93.99 79.327 5.257-5.238a2.729 2.729 0 0 0-.054-3.817 2.764 2.764 0 0 0-3.84-.054l-5.27 5.238-5.258-5.238a2.755 2.755 0 0 0-1.964-.857 2.77 2.77 0 0 0-1.987.801 2.74 2.74 0 0 0-.807 1.976 2.724 2.724 0 0 0 .863 1.951l5.266 5.238-5.266 5.238a2.737 2.737 0 0 0-.863 1.951 2.722 2.722 0 0 0 .807 1.976 2.757 2.757 0 0 0 1.987.801 2.77 2.77 0 0 0 1.964-.857l5.27-5.238 5.27 5.238a2.766 2.766 0 0 0 3.772-.122 2.73 2.73 0 0 0 .11-3.75l-5.258-5.237Z", fill: "var(--brand-color-yellow)" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.8, d: "m126.43 121.666 5.624-6.525.847.809a4.497 4.497 0 0 1 1.368 3.047 4.54 4.54 0 0 1-1.08 3.172 4.103 4.103 0 0 1-2.895 1.44 4.06 4.06 0 0 1-3.014-1.137l-.847-.808-.003.002Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.406 44.37a9.233 9.233 0 0 0-.27-2.098c-.61-2.474-3.335-4.061-6.235-4.435-2.898-.373-5.912.476-7.074 2.628-.664 1.23-.756 2.29-.484 3.184.27.889.912 1.626 1.782 2.2 2.428 1.6 6.68 1.927 8.619 1.258.897-.31 1.773-.683 2.627-1.11-.488 2.796-2.306 5.445-4.733 7.832-5.273 5.188-13.456 9.126-17.913 10.574a.478.478 0 0 0-.298.593.45.45 0 0 0 .569.313c4.544-1.477 12.887-5.498 18.264-10.79 2.778-2.732 4.758-5.809 5.096-9.043 6.28-3.505 11.438-9.863 15.847-15.214a.489.489 0 0 0-.048-.67.442.442 0 0 0-.64.051c-4.23 5.132-9.139 11.237-15.109 14.727Zm-.913.509a8.294 8.294 0 0 0-.237-2.372c-.528-2.14-2.956-3.406-5.466-3.73-1.538-.197-3.12-.034-4.361.545-.78.364-1.423.892-1.81 1.61-.509.941-.619 1.746-.41 2.43.208.688.726 1.24 1.4 1.684 2.213 1.459 6.084 1.769 7.85 1.16a21.37 21.37 0 0 0 3.034-1.327Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("circle", { cx: 138.7, cy: 89.546, r: 2.92, fill: "var(--brand-color-yellow)" }), /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.414 109.692c.52-.195 1.07-.455 1.492-.831.502-.447.707-1.022.844-1.627.176-.778.246-1.607.46-2.386.079-.289.231-.399.296-.447a.695.695 0 0 1 .489-.143.708.708 0 0 1 .61.416.877.877 0 0 1 .076.217c.015.072.025.296.04.389.041.228.075.456.107.686.106.763.166 1.412.5 2.114.453.952.907 1.535 1.523 1.793.596.25 1.307.203 2.217.007.087-.022.172-.041.257-.056.401-.074.784.203.863.623.079.42-.176.83-.573.922-.083.019-.165.038-.246.054-1.23.321-2.652 1.463-3.479 2.464-.255.309-.628 1.171-1.008 1.722-.281.406-.597.673-.862.768a.769.769 0 0 1-.894-.29.913.913 0 0 1-.148-.362 2.834 2.834 0 0 1-.014-.344c-.078-.281-.173-.555-.242-.839-.165-.676-.489-1.104-.873-1.669-.36-.529-.746-.862-1.313-1.127-.073-.019-.668-.172-.878-.26a.957.957 0 0 1-.506-.461.928.928 0 0 1-.081-.514.854.854 0 0 1 .277-.54c.1-.091.248-.18.447-.223.154-.033.562-.053.619-.056Zm3.487-1.102c.028.065.057.13.088.195.664 1.395 1.406 2.174 2.308 2.552l.03.012c-.603.472-1.15.999-1.567 1.504-.172.208-.4.64-.645 1.083-.224-.764-.589-1.304-1.048-1.98-.351-.516-.72-.904-1.171-1.221a5.14 5.14 0 0 0 .977-.67 3.919 3.919 0 0 0 1.028-1.475Z", fill: "var(--brand-color-yellow)" }), /* @__PURE__ */ se.createElement("defs", null, /* @__PURE__ */ se.createElement("filter", { id: "a", x: 28.713, y: 26.064, width: 89.808, height: 104.647, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 9.733 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 7.3 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { values: "0 0 0 0 0.00784314 0 0 0 0 0.0980392 0 0 0 0 0.113725 0 0 0 0.1 0" }), /* @__PURE__ */ se.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_118_4742" }), /* @__PURE__ */ se.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_118_4742", result: "shape" })), /* @__PURE__ */ se.createElement("filter", { id: "b", x: 105.12, y: 18.213, width: 46.827, height: 32.309, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dx: 2.92, dy: 1.947 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 3.163 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0" }), /* @__PURE__ */ se.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_118_4742" }), /* @__PURE__ */ se.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_118_4742", result: "shape" })), /* @__PURE__ */ se.createElement("filter", { id: "c", x: 59.845, y: 49.04, width: 61.063, height: 60.574, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feGaussianBlur", { in: "BackgroundImage", stdDeviation: 1.954 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_118_4742" }), /* @__PURE__ */ se.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_backgroundBlur_118_4742", result: "shape" })))), tC = V.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  strong {
    margin-top: 1rem;
    font-size: 2rem;
  }
  > p {
    margin-top: 5px;
    margin-bottom: 2rem;
  }

  @media (max-width: 1366px) {
    header svg {
      width: 100px;
    }

    strong {
      margin-top: 0rem;
      font-size: 1.4rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;
function nC({
  icon: e = /* @__PURE__ */ R(eC, {}),
  title: n,
  description: i,
  linkTo: o
}) {
  return /* @__PURE__ */ me(tC, { children: [
    /* @__PURE__ */ R("header", { children: e }),
    /* @__PURE__ */ R("strong", { children: n }),
    /* @__PURE__ */ R("p", { children: i }),
    o && /* @__PURE__ */ R("a", { href: "/" + o, children: "Clique aqui para voltar" })
  ] });
}
const rC = (e) => /* @__PURE__ */ se.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { d: "M11 14.668a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75ZM11 9.168a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75ZM11 4.125a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Z", fill: "#02191D" })), Lp = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  outlined: U`
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, iC = V.div`
  position: absolute;
  right: 0;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  visibility: hidden;
  margin-top: 0.6rem;
  padding: 0px 24px;

  .action__badge {
    background: #ffffff;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    ${({ variants: e }) => Lp[e]}
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    width: auto;
    font-weight: 500;
    font-size: 0.8125rem;
    text-transform: lowercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`, oC = V.div`
  border: 1px solid
    ${({ theme: e }) => Pe(0.3, e.monkUiThemes.colors.black)};
  padding: 0.5rem 0rem;
  background: white;
  min-width: 170px;
  margin-top: 0.5rem;
  border-radius: 6px;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 999;
  ${({ variants: e }) => Lp[e]}
`, sC = V.div`
  cursor: pointer;
  border-left: 2px solid transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.7rem;

  span {
    font-family: ${({ theme: e }) => e.monkUiThemes.fontFamily.poppins};
    font-size: 13px;
  }

  &:hover {
    span {
      opacity: 0.5;
    }
  }
`, aC = V.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;

  svg {
    width: 1rem;
    height: 1rem;

    path {
      stroke: #02191d;
    }
  }
`;
function lC({
  title: e = "Ações",
  options: n,
  data: i,
  variants: o = "default"
}) {
  const [a, c] = nt(!1);
  return /* @__PURE__ */ me(iC, { variants: o, id: "action_menu", className: "action__wrapper", children: [
    /* @__PURE__ */ me(
      "div",
      {
        className: "action__badge",
        onClick: () => c(!a),
        children: [
          /* @__PURE__ */ R("span", { children: e }),
          /* @__PURE__ */ R(rC, {})
        ]
      }
    ),
    a && /* @__PURE__ */ R(oC, { className: "action__menu", variants: o, children: n.map((u) => /* @__PURE__ */ me(
      sC,
      {
        onClick: () => {
          u.onClick(u.id, i), c(!1);
        },
        children: [
          /* @__PURE__ */ R(aC, { children: u.icon }),
          /* @__PURE__ */ R("span", { children: u.label })
        ]
      },
      u.id
    )) })
  ] });
}
const Mn = (e) => `${e / 16 + "rem"}`, Rl = ({
  fontSize: e,
  lineHeight: n,
  fontWeight: i,
  fontStyle: o
}) => U`
  font-size: clamp(
    ${e[0] / 16 + "rem"},
    0.6897rem + 0.3448vw,
    ${e[1] / 16 + "rem"}
  );
  line-height: clamp(
    ${((n == null ? void 0 : n.length) && n[0] / 16) + "rem"},
    0.6897rem + 0.3448vw,
    ${((n == null ? void 0 : n.length) && n[1] / 16) + "rem"}
  );
  font-weight: ${i && i || "unset"};
  font-style: ${o && o || "unset"};
`, uC = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.white};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    &:hover {
      background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    }
  `,
  outlined: U`
    background: transparent;
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.black};
    &:hover {
      background: ${({ theme: e }) => Je(0.2, e.monkUiThemes.colors.white)};
    }
  `,
  filled: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    border: ${({ theme: e }) => `1px solid ${e.monkUiThemes.colors.main}`};
    color: ${({ theme: e }) => e.monkUiThemes.colors.white};
    &:hover {
      background: ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.main)};
    }
  `
}, cC = {
  default: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.black};
  `,
  outlined: U`
    background: ${({ theme: e }) => e.monkUiThemes.colors.main};
    border-bottom: 1px solid
      ${({ theme: e }) => Pe(0.1, e.monkUiThemes.colors.black)};
  `,
  filled: U`
    background: ${({ theme: e }) => Je(0.1, e.monkUiThemes.colors.main)};
    border-bottom: 1px solid ${({ theme: e }) => e.monkUiThemes.colors.white};
  `
}, Fp = V.div`
  overflow: hidden;
  position: static;
  width: 100%;
  height: 100%;
  max-width: 1961px;
  /* media query para scrolar o componente da tablea inteiro nao apenas a tabela */
  @media screen and (max-width: 1110px) {
    overflow: unset;
  }
  ${({ border: e }) => e && U`
      border: ${e};
    `}
  ${({ borderRadius: e }) => e && U`
      border-radius: ${e};
    `}
`, Vp = V.div`
  width: 100%;

  inset: 0;
`, Bp = V.div`
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  height: 100%;
  width: 100%;

  padding-bottom: ${(e) => e.hideFooter ? "0rem" : e.tableHeaderComponent ? "11rem" : "3rem"}
    /* //padding para nao tapar os items da tabela q ficam por tras do footer da tabela */
    /* padding-bottom: ${({ tableHeaderComponent: e }) => e ? "11em" : "3em"}; */
    ${({ paddingBottom: e }) => e && U`
        padding-bottom: ${e} !important;
      `};
`, Np = V.table`
  width: 100%;
  border-collapse: collapse;
  word-break: break-all;

  thead {
    height: ${Mn(41)};
    padding: 0 2em;
    position: sticky;
    top: 0;
    left: 0;
    height: 0;
    /* background: #f2f3f3; */
    backdrop-filter: blur(10px);
    ${({ variant: e }) => e && cC[e]};
    /* border-bottom: 1px solid #e9ecec; */
    span {
      color: ${({ theme: e, variant: n }) => n === "default" ? Pe(0.3, e.monkUiThemes.colors.black) : e.monkUiThemes.colors.white};
    }
  }

  tbody tr {
    padding: 0 2em;
    font-family: 'Sora', sans-serif;
    ${({ variant: e }) => e && uC[e]};

    &:hover {
      > .action__wrapper {
        visibility: visible;
      }
      cursor: pointer;
    }

    border-bottom: 1px solid #e9ecec;

    &:last-of-type {
      border-bottom: 0;
    }
  }
  tbody tr td {
    color: ${({ theme: e, variant: n }) => n === "filled" ? e.monkUiThemes.colors.white : e.monkUiThemes.colors.black};
  }
`;
V.th``;
const Qn = V.td`
  text-align: start;
  white-space: nowrap;
  padding: 0 4em 0 0;

  ${Rl({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: [10, 14],
  lineHeight: [11, 16]
})}

  letter-spacing: -0.01em;

  color: rgba(2, 25, 29, 0.8);

  height: ${Mn(56)};

  :first-child {
    padding-left: 2em;
  }

  ${({ strong: e }) => e && U`
      ${Rl({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: [9, 13],
  lineHeight: [11, 16]
})}

      letter-spacing: -0.01em;
      color: #02191d;
      height: ${Mn(41)};
    `}

  ${(e) => e.skeleton && U`
      padding: 0.7rem 0.5rem 0.7rem 0rem;
    `}
`, fC = V.div`
  width: auto;
  height: 3em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e9ecec;
  padding: 0 2em;

  @media screen and (max-width: 540px) {
    > div:first-child {
      display: none !important;
    }
  }
`, hC = V.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-gap: 1em;
    margin-right: 1em;
    color: #02191d;
    opacity: 0.7;
  }
`, dC = V.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 1em;
`, ed = V.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  width: ${Mn(42)};
  height: ${Mn(30)};
  border: 1px solid rgba(2, 25, 26, 0.2);
  font-family: Epilogue;

  svg {
    path {
      stroke: #02191d;
    }
  }

  ${({ emphasis: e }) => e && U`
      background: #02191d;
      opacity: unset;
      svg {
        path {
          stroke: white;
        }
      }
    `}

  &:hover {
    cursor: pointer;
  }

  ${({ numeric: e, selected: n }) => e && n && U`
      color: #02191d !important;
      border: 2px solid #02191d !important;
      border-radius: 30px !important;
      width: ${Mn(30)} !important;
      height: ${Mn(30)} !important;

      span {
        font-weight: 500;
      }

      p {
        ${Rl({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: [10, 14],
  lineHeight: [12, 18]
})}
        letter-spacing: -0.01em;
        color: #02191d;
      }
    `}

  ${({ numeric: e }) => e && U`
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 30px !important;
      width: ${Mn(30)} !important;
      height: ${Mn(30)} !important;
      border: unset;
      letter-spacing: -0.01em;
      font-weight: 400;
      color: rgba(2, 25, 29, 0.7);
    `}
    transition: border 0.1s ease-in-out;
  ${({ hidden: e }) => e && U`
      display: none;
    `}
`, pC = V.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  padding: 1.3125rem 1.875rem;

  div {
    width: 100%;
    height: 50px;
  }
`, mC = (e) => /* @__PURE__ */ se.createElement("svg", { width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ se.createElement("path", { d: "M8 14.666c1.841 0 3.508-.746 4.714-1.952A6.646 6.646 0 0 0 14.667 8c0-1.841-.746-3.508-1.953-4.714A6.646 6.646 0 0 0 8 1.333c-1.84 0-3.508.746-4.714 1.953A6.646 6.646 0 0 0 1.333 8c0 1.84.747 3.507 1.953 4.714A6.646 6.646 0 0 0 8 14.666Z", stroke: "#02191D", strokeWidth: 1.2 }), /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.667a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667Z", fill: "#02191D" }), /* @__PURE__ */ se.createElement("path", { d: "M8.167 11.334V6.667H6.61M7 11.333h2.333", stroke: "#02191D", strokeWidth: 1.2, strokeLinecap: "square" })), gC = V.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 0.55em;
  width: 100%;

  ${({ grow: e }) => e && U`
      flex: ${e};
    `}

  ${({ marginBottom: e }) => e && U`
      margin-bottom: ${e};
    `};

  ${({ column: e }) => e && U`
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    `}

  ${({ justifyend: e }) => e && U`
      justify-content: flex-end !important;
      grid-gap: 0.2em !important;
    `}

    ${({ justifybetween: e }) => e && U`
      justify-content: space-between !important;
    `}

    > label {
    font-family: 'Epilogue';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.01em;
    color: rgba(2, 25, 29, 0.7);
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    grid-gap: 0.5em;

    ${({ dark: e }) => e && U`
        color: rgba(255, 255, 255, 0.7);
      `}

    ${({ dark: e, active: n }) => n && !e && U`
        color: rgba(2, 25, 29, 1);
      `}

        ${({ dark: e, active: n }) => n && e && U`
        color: rgba(255, 255, 255, 1);
      `}

        :hover {
      cursor: pointer;
    }

    white-space: nowrap;
  }
`, vC = V.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 0.75em;
  width: fit-content !important;

  ${({ noGap: e }) => e && U`
      grid-gap: unset !important;
    `}

  &:hover {
    label,
    input {
      cursor: pointer;
    }
  }

  > label {
    font-family: 'Epilogue';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.01em;
    color: rgba(2, 25, 29, 0.7);
    transition: all 0.2s 0s ease, all 0.5s 0s ease;

    ${({ dark: e }) => e && U`
        color: #f6f5fc;
      `}
  }
`, bC = V.input`
  appearance: none;
  width: 1.25em;
  height: 1.25em;
  border: 1px solid #C7C9D9;
  border-radius: .2rem;
  background: #F2F2F5;
  transition: all 0.2s 0s ease, all 0.5s 0s ease;
  position: relative;
  box-sizing: border-box;

  &:checked {
    border-radius: .2rem;
    background-color: ${({ theme: e }) => e.monkUiThemes.colors.main};
    width: 1.25em;
    height: 1.25em;
    padding: 0;
    border: none;
    transition: all 0.2s 0s ease, all 0.5s 0s ease;
  }

  &:checked::before {
    content: '✓';
    box-sizing: border-box;
    position: absolute;
    top: -.075em;
    left: 0.15em;
    color: white;
    font-size: 1rem;
  }

  &:checked ~ label {
    color: #02191d;
    transition: all 0.2s 0s ease, all 0.5s 0s ease;
  }
`, yC = V.label`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 18px;

  > input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  > .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(2, 25, 29, 0.2);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 33.9286px;

    ${({ dark: e }) => e && U`
        background-color: rgba(255, 255, 255, 0.7);
      `}
  }

  > .slider:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 2px;
    top: 2px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0px 1.11111px 2.22222px rgba(0, 0, 0, 0.25);
  }

  > input:checked + .slider {
    background-color: ${({ theme: e }) => e.monkUiThemes.colors.main};
  }

  > input:focus + .slider {
    box-shadow: 0 0 1px ${({ theme: e }) => e.monkUiThemes.colors.main};
  }

  > input:checked + .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
  }
`;
function cs(e) {
  const [n, i] = nt((e == null ? void 0 : e.initialValue) || !1), o = Math.random(), a = () => {
    i((e == null ? void 0 : e.initialValue) || !1);
  }, c = () => {
    i(!n), e.onValueChange && e.onValueChange(!n);
  };
  return mt(() => {
    const u = document.getElementById(e.form);
    return u == null || u.addEventListener("reset", a), () => u == null ? void 0 : u.removeEventListener("click", a);
  }, []), mt(() => {
    e.selected && i(e.selected);
  }, [e.selected]), mt(() => {
    i(e == null ? void 0 : e.initialValue);
  }, [e == null ? void 0 : e.initialValue]), /* @__PURE__ */ me(
    gC,
    {
      column: e == null ? void 0 : e.column,
      grow: e == null ? void 0 : e.grow,
      dark: e == null ? void 0 : e.dark,
      justifyend: e == null ? void 0 : e.justifyend,
      justifybetween: e.justifybetween,
      active: n,
      marginBottom: e == null ? void 0 : e.marginBottom,
      children: [
        e && e.hasOwnProperty("label") && /* @__PURE__ */ me("label", { children: [
          e.label,
          e.hasOwnProperty("tip") && /* @__PURE__ */ R(mC, { title: e.tip })
        ] }),
        /* @__PURE__ */ me(vC, { noGap: e == null ? void 0 : e.noGap, dark: e == null ? void 0 : e.dark, children: [
          e.switch && /* @__PURE__ */ me(yC, { dark: e == null ? void 0 : e.dark, children: [
            /* @__PURE__ */ R(
              "input",
              {
                id: `checkbox_${o}`,
                type: "checkbox",
                checked: n,
                name: e.name,
                onChange: (u) => {
                  c();
                }
              },
              `checkbox_${o}`
            ),
            /* @__PURE__ */ R("span", { className: "slider round" })
          ] }),
          !e.switch && !e.rgbInput && /* @__PURE__ */ R(
            bC,
            {
              id: `checkbox_${o}`,
              type: "checkbox",
              checked: n,
              onChange: () => {
                c();
              },
              ...e
            },
            `checkbox_${o}`
          ),
          /* @__PURE__ */ me("label", { htmlFor: `checkbox_${o}`, children: [
            !e.notCheckedInputLabel && e.inputLabel,
            n && e.notCheckedInputLabel ? e.inputLabel : e.notCheckedInputLabel
          ] })
        ] })
      ]
    }
  );
}
const xC = Ul`
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: -135% 0%;
  }
`, wC = V.div`
  display: inline-block;

  width: 100%;
  height: 100%;

  background: linear-gradient(-90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
  background-size: 400% 400%;

  border-radius: 6px;

  animation: ${xC} 1.2s ease-in-out infinite;
`;
function td({ ...e }) {
  return /* @__PURE__ */ R(wC, { style: e });
}
function kC({
  headers: e,
  selectable: n,
  bordered: i,
  rounded: o,
  tableHeaderComponent: a = !1
}) {
  return /* @__PURE__ */ R(
    Fp,
    {
      border: i ? "1px solid #E9ECEC" : void 0,
      borderRadius: o ? "10px" : void 0,
      children: /* @__PURE__ */ me(Vp, { children: [
        a && /* @__PURE__ */ R(pC, { children: /* @__PURE__ */ R(td, {}) }),
        /* @__PURE__ */ R(Bp, { children: /* @__PURE__ */ me(Np, { children: [
          /* @__PURE__ */ R("thead", { children: /* @__PURE__ */ me("tr", { children: [
            n && /* @__PURE__ */ R(Qn, { children: /* @__PURE__ */ R(cs, { disabled: !0 }) }),
            e.map((c, u) => /* @__PURE__ */ R(Qn, { strong: !0, children: /* @__PURE__ */ R(Pl, { paragraph: 4, weight: "medium", children: c.headerName }) }, u))
          ] }) }),
          /* @__PURE__ */ R("tbody", { children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((c, u) => /* @__PURE__ */ me("tr", { children: [
            n && /* @__PURE__ */ R(Qn, { children: /* @__PURE__ */ R(cs, { disabled: !0 }) }),
            /* @__PURE__ */ R(Qn, { skeleton: !0, colSpan: e.length, children: /* @__PURE__ */ R(td, {}) }, u)
          ] }, u)) })
        ] }) })
      ] })
    }
  );
}
function qC({
  data: e,
  headers: n,
  emptyContainerProps: i,
  dataMenuOptions: o,
  bordered: a,
  rounded: c,
  roundedBottom: u,
  checkboxSelection: h,
  onCheckboxChange: f,
  hideFooter: m = !1,
  scrollHorizontal: g = !1,
  tableHeaderComponent: x,
  loadingData: T,
  getVehicleData: E,
  selectedRows: I,
  next: D,
  prev: W,
  variants: F = "default"
}) {
  nt(0), mt(() => console.log("selected rows", I), [I]);
  function z() {
    return u ? "0px 0px 10px 10px" : c ? "10px" : void 0;
  }
  function L() {
    return /* @__PURE__ */ R(
      nC,
      {
        icon: (i == null ? void 0 : i.icon) ?? /* @__PURE__ */ R(Q5, {}),
        title: (i == null ? void 0 : i.title) ?? "Ops! Sem dados para mostrar.",
        description: (i == null ? void 0 : i.description) ?? "Redefina sua busca com outros valores."
      }
    );
  }
  const G = an(
    function() {
      return /* @__PURE__ */ me(Np, { variant: F, children: [
        /* @__PURE__ */ R("thead", { children: /* @__PURE__ */ me("tr", { children: [
          h && /* @__PURE__ */ R(Qn, { children: /* @__PURE__ */ R(
            cs,
            {
              onValueChange: (Q) => {
                if (Q && f) {
                  e.forEach((fe) => {
                    I != null && I.find(
                      (ge) => JSON.stringify(ge) === JSON.stringify(fe)
                    ) || f(fe, Q);
                  });
                  return;
                }
                !Q && f && f([], Q);
              }
            }
          ) }),
          n.map((Q, fe) => /* @__PURE__ */ R(Qn, { strong: !0, children: /* @__PURE__ */ R(Pl, { paragraph: 4, weight: "medium", children: Q.headerName }) }, fe))
        ] }) }),
        /* @__PURE__ */ R("tbody", { children: e.map((Q, fe) => /* @__PURE__ */ me("tr", { children: [
          h && /* @__PURE__ */ R(Qn, { children: /* @__PURE__ */ R(
            cs,
            {
              checked: I == null ? void 0 : I.includes(Q),
              onValueChange: (ge) => {
                f && f(Q, ge);
              }
            }
          ) }),
          n.map((ge, he) => /* @__PURE__ */ R(Qn, { onClick: () => E(Q), children: ge.renderColumn ? ge.renderColumn(Q) : Q[ge.field] ? String(Q[ge.field]) : "--" }, he)),
          o && /* @__PURE__ */ R(
            lC,
            {
              variants: F,
              options: o,
              data: Q
            }
          )
        ] }, fe)) })
      ] });
    },
    [e, I]
  );
  return T ? /* @__PURE__ */ R(
    kC,
    {
      headers: n,
      selectable: h,
      bordered: a,
      rounded: c,
      tableHeaderComponent: x !== void 0
    }
  ) : !e || !e.length ? L() : /* @__PURE__ */ R(
    Fp,
    {
      border: a ? "1px solid #E9ECEC" : void 0,
      borderRadius: z(),
      children: /* @__PURE__ */ me(Vp, { id: "table_container", children: [
        x,
        /* @__PURE__ */ R(
          Bp,
          {
            hideFooter: m,
            tableHeaderComponent: x,
            children: g ? /* @__PURE__ */ R(Z5, { children: G() }) : G()
          }
        ),
        !m && /* @__PURE__ */ me(fC, { children: [
          /* @__PURE__ */ R(hC, { children: /* @__PURE__ */ me(Pl, { paragraph: 5, children: [
            e.length ?? 0,
            " resultados • registros por página"
          ] }) }),
          /* @__PURE__ */ me(dC, { children: [
            /* @__PURE__ */ R(ed, { type: "button", onClick: () => W && W(), children: /* @__PURE__ */ R(X5, {}) }),
            /* @__PURE__ */ R(ed, { type: "button", onClick: () => D && D(), children: /* @__PURE__ */ R(J5, {}) })
          ] })
        ] })
      ] })
    }
  );
}
function YC({ children: e }) {
  return /* @__PURE__ */ R(nx, { theme: mn, children: e });
}
function KC({ type: e, text: n, duration: i, background: o }) {
  const a = new CustomEvent("addToast", {
    detail: {
      type: e,
      text: n,
      duration: i,
      background: o
    }
  });
  document.dispatchEvent(a);
}
function ZC() {
  const [e, n] = nt([]);
  function i({ field: c, message: u }) {
    e.find((f) => f.field === c) || n((f) => [...f, { field: c, message: u }]);
  }
  function o(c) {
    n(
      (u) => u.filter((h) => h.field !== c)
    );
  }
  function a(c) {
    var u;
    return (u = e.find(({ field: h }) => h === c)) == null ? void 0 : u.message;
  }
  return {
    errors: e,
    setError: i,
    removeError: o,
    getErrorMessageByFieldName: a
  };
}
export {
  $C as AutoComplete,
  EC as Badge,
  PC as Box,
  Wh as Button,
  AC as ColorPicker,
  qC as CustomTable,
  RC as DateRange,
  IC as Filter,
  UC as Flex,
  DC as Form,
  MC as Grid,
  OC as GroupBy,
  rS as List,
  LC as Modal,
  YC as MonkUiProvider,
  FC as NotificationList,
  VC as Radio,
  BC as Select,
  NC as Switch,
  WC as Table,
  zC as TextArea,
  jC as TextInput,
  GC as ToastContainer,
  R5 as ToastMessage,
  HC as Toggle,
  Pl as Typography,
  mn as monkUiThemes,
  KC as toast,
  xs as useClickOutside,
  ZC as useErrors,
  Sl as useInsertUuid,
  Ni as useObjectManager
};
